// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-v4compatibility.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-v4compatibility.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../styles/images/excel-branco.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */
.fa {
  font-family: var(--fa-style-family, "Font Awesome 6 Free");
  font-weight: var(--fa-style, 900);
}
.fas,
.far,
.fab,
.fa-solid,
.fa-regular,
.fa-brands,
.fa {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: var(--fa-display, inline-block);
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}
.fas::before,
.far::before,
.fab::before,
.fa-solid::before,
.fa-regular::before,
.fa-brands::before,
.fa::before {
  content: var(--fa);
}
.fa-classic,
.fas,
.fa-solid,
.far,
.fa-regular {
  font-family: 'Font Awesome 6 Free';
}
.fa-brands,
.fab {
  font-family: 'Font Awesome 6 Brands';
}
.fa-1x {
  font-size: 1em;
}
.fa-2x {
  font-size: 2em;
}
.fa-3x {
  font-size: 3em;
}
.fa-4x {
  font-size: 4em;
}
.fa-5x {
  font-size: 5em;
}
.fa-6x {
  font-size: 6em;
}
.fa-7x {
  font-size: 7em;
}
.fa-8x {
  font-size: 8em;
}
.fa-9x {
  font-size: 9em;
}
.fa-10x {
  font-size: 10em;
}
.fa-2xs {
  font-size: 0.625em;
  line-height: 0.1em;
  vertical-align: 0.225em;
}
.fa-xs {
  font-size: 0.75em;
  line-height: 0.08333em;
  vertical-align: 0.125em;
}
.fa-sm {
  font-size: 0.875em;
  line-height: 0.07143em;
  vertical-align: 0.05357em;
}
.fa-lg {
  font-size: 1.25em;
  line-height: 0.05em;
  vertical-align: -0.075em;
}
.fa-xl {
  font-size: 1.5em;
  line-height: 0.04167em;
  vertical-align: -0.125em;
}
.fa-2xl {
  font-size: 2em;
  line-height: 0.03125em;
  vertical-align: -0.1875em;
}
.fa-fw {
  text-align: center;
  width: 1.25em;
}
.fa-ul {
  list-style-type: none;
  margin-left: var(--fa-li-margin, 2.5em);
  padding-left: 0;
}
.fa-ul > li {
  position: relative;
}
.fa-li {
  left: calc(-1 * var(--fa-li-width, 2em));
  position: absolute;
  text-align: center;
  width: var(--fa-li-width, 2em);
  line-height: inherit;
}
.fa-border {
  border-color: var(--fa-border-color, #eee);
  border-radius: var(--fa-border-radius, 0.1em);
  border-style: var(--fa-border-style, solid);
  border-width: var(--fa-border-width, 0.08em);
  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);
}
.fa-pull-left {
  float: left;
  margin-right: var(--fa-pull-margin, 0.3em);
}
.fa-pull-right {
  float: right;
  margin-left: var(--fa-pull-margin, 0.3em);
}
.fa-beat {
  animation-name: fa-beat;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}
.fa-bounce {
  animation-name: fa-bounce;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));
}
.fa-fade {
  animation-name: fa-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}
.fa-beat-fade {
  animation-name: fa-beat-fade;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));
}
.fa-flip {
  animation-name: fa-flip;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, ease-in-out);
}
.fa-shake {
  animation-name: fa-shake;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}
.fa-spin {
  animation-name: fa-spin;
  animation-delay: var(--fa-animation-delay, 0s);
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 2s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, linear);
}
.fa-spin-reverse {
  --fa-animation-direction: reverse;
}
.fa-pulse,
.fa-spin-pulse {
  animation-name: fa-spin;
  animation-direction: var(--fa-animation-direction, normal);
  animation-duration: var(--fa-animation-duration, 1s);
  animation-iteration-count: var(--fa-animation-iteration-count, infinite);
  animation-timing-function: var(--fa-animation-timing, steps(8));
}
@media (prefers-reduced-motion: reduce) {
  .fa-beat,
  .fa-bounce,
  .fa-fade,
  .fa-beat-fade,
  .fa-flip,
  .fa-pulse,
  .fa-shake,
  .fa-spin,
  .fa-spin-pulse {
    animation-delay: -1ms;
    animation-duration: 1ms;
    animation-iteration-count: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }
}
@keyframes fa-beat {
  0%,
  90% {
    transform: scale(1);
  }
  45% {
    transform: scale(var(--fa-beat-scale, 1.25));
  }
}
@keyframes fa-bounce {
  0% {
    transform: scale(1, 1) translateY(0);
  }
  10% {
    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);
  }
  30% {
    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));
  }
  50% {
    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);
  }
  57% {
    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));
  }
  64% {
    transform: scale(1, 1) translateY(0);
  }
  100% {
    transform: scale(1, 1) translateY(0);
  }
}
@keyframes fa-fade {
  50% {
    opacity: var(--fa-fade-opacity, 0.4);
  }
}
@keyframes fa-beat-fade {
  0%,
  100% {
    opacity: var(--fa-beat-fade-opacity, 0.4);
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(var(--fa-beat-fade-scale, 1.125));
  }
}
@keyframes fa-flip {
  50% {
    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));
  }
}
@keyframes fa-shake {
  0% {
    transform: rotate(-15deg);
  }
  4% {
    transform: rotate(15deg);
  }
  8%,
  24% {
    transform: rotate(-18deg);
  }
  12%,
  28% {
    transform: rotate(18deg);
  }
  16% {
    transform: rotate(-22deg);
  }
  20% {
    transform: rotate(22deg);
  }
  32% {
    transform: rotate(-12deg);
  }
  36% {
    transform: rotate(12deg);
  }
  40%,
  100% {
    transform: rotate(0deg);
  }
}
@keyframes fa-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.fa-rotate-90 {
  transform: rotate(90deg);
}
.fa-rotate-180 {
  transform: rotate(180deg);
}
.fa-rotate-270 {
  transform: rotate(270deg);
}
.fa-flip-horizontal {
  transform: scale(-1, 1);
}
.fa-flip-vertical {
  transform: scale(1, -1);
}
.fa-flip-both,
.fa-flip-horizontal.fa-flip-vertical {
  transform: scale(-1, -1);
}
.fa-rotate-by {
  transform: rotate(var(--fa-rotate-angle, 0));
}
.fa-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em;
}
.fa-stack-1x,
.fa-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%;
  z-index: var(--fa-stack-z-index, auto);
}
.fa-stack-1x {
  line-height: inherit;
}
.fa-stack-2x {
  font-size: 2em;
}
.fa-inverse {
  color: var(--fa-inverse, #fff);
}
/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.fa-0 {
  --fa: "\\30";
}
.fa-1 {
  --fa: "\\31";
}
.fa-2 {
  --fa: "\\32";
}
.fa-3 {
  --fa: "\\33";
}
.fa-4 {
  --fa: "\\34";
}
.fa-5 {
  --fa: "\\35";
}
.fa-6 {
  --fa: "\\36";
}
.fa-7 {
  --fa: "\\37";
}
.fa-8 {
  --fa: "\\38";
}
.fa-9 {
  --fa: "\\39";
}
.fa-fill-drip {
  --fa: "\\f576";
}
.fa-arrows-to-circle {
  --fa: "\\e4bd";
}
.fa-circle-chevron-right {
  --fa: "\\f138";
}
.fa-chevron-circle-right {
  --fa: "\\f138";
}
.fa-at {
  --fa: "\\40";
}
.fa-trash-can {
  --fa: "\\f2ed";
}
.fa-trash-alt {
  --fa: "\\f2ed";
}
.fa-text-height {
  --fa: "\\f034";
}
.fa-user-xmark {
  --fa: "\\f235";
}
.fa-user-times {
  --fa: "\\f235";
}
.fa-stethoscope {
  --fa: "\\f0f1";
}
.fa-message {
  --fa: "\\f27a";
}
.fa-comment-alt {
  --fa: "\\f27a";
}
.fa-info {
  --fa: "\\f129";
}
.fa-down-left-and-up-right-to-center {
  --fa: "\\f422";
}
.fa-compress-alt {
  --fa: "\\f422";
}
.fa-explosion {
  --fa: "\\e4e9";
}
.fa-file-lines {
  --fa: "\\f15c";
}
.fa-file-alt {
  --fa: "\\f15c";
}
.fa-file-text {
  --fa: "\\f15c";
}
.fa-wave-square {
  --fa: "\\f83e";
}
.fa-ring {
  --fa: "\\f70b";
}
.fa-building-un {
  --fa: "\\e4d9";
}
.fa-dice-three {
  --fa: "\\f527";
}
.fa-calendar-days {
  --fa: "\\f073";
}
.fa-calendar-alt {
  --fa: "\\f073";
}
.fa-anchor-circle-check {
  --fa: "\\e4aa";
}
.fa-building-circle-arrow-right {
  --fa: "\\e4d1";
}
.fa-volleyball {
  --fa: "\\f45f";
}
.fa-volleyball-ball {
  --fa: "\\f45f";
}
.fa-arrows-up-to-line {
  --fa: "\\e4c2";
}
.fa-sort-down {
  --fa: "\\f0dd";
}
.fa-sort-desc {
  --fa: "\\f0dd";
}
.fa-circle-minus {
  --fa: "\\f056";
}
.fa-minus-circle {
  --fa: "\\f056";
}
.fa-door-open {
  --fa: "\\f52b";
}
.fa-right-from-bracket {
  --fa: "\\f2f5";
}
.fa-sign-out-alt {
  --fa: "\\f2f5";
}
.fa-atom {
  --fa: "\\f5d2";
}
.fa-soap {
  --fa: "\\e06e";
}
.fa-icons {
  --fa: "\\f86d";
}
.fa-heart-music-camera-bolt {
  --fa: "\\f86d";
}
.fa-microphone-lines-slash {
  --fa: "\\f539";
}
.fa-microphone-alt-slash {
  --fa: "\\f539";
}
.fa-bridge-circle-check {
  --fa: "\\e4c9";
}
.fa-pump-medical {
  --fa: "\\e06a";
}
.fa-fingerprint {
  --fa: "\\f577";
}
.fa-hand-point-right {
  --fa: "\\f0a4";
}
.fa-magnifying-glass-location {
  --fa: "\\f689";
}
.fa-search-location {
  --fa: "\\f689";
}
.fa-forward-step {
  --fa: "\\f051";
}
.fa-step-forward {
  --fa: "\\f051";
}
.fa-face-smile-beam {
  --fa: "\\f5b8";
}
.fa-smile-beam {
  --fa: "\\f5b8";
}
.fa-flag-checkered {
  --fa: "\\f11e";
}
.fa-football {
  --fa: "\\f44e";
}
.fa-football-ball {
  --fa: "\\f44e";
}
.fa-school-circle-exclamation {
  --fa: "\\e56c";
}
.fa-crop {
  --fa: "\\f125";
}
.fa-angles-down {
  --fa: "\\f103";
}
.fa-angle-double-down {
  --fa: "\\f103";
}
.fa-users-rectangle {
  --fa: "\\e594";
}
.fa-people-roof {
  --fa: "\\e537";
}
.fa-people-line {
  --fa: "\\e534";
}
.fa-beer-mug-empty {
  --fa: "\\f0fc";
}
.fa-beer {
  --fa: "\\f0fc";
}
.fa-diagram-predecessor {
  --fa: "\\e477";
}
.fa-arrow-up-long {
  --fa: "\\f176";
}
.fa-long-arrow-up {
  --fa: "\\f176";
}
.fa-fire-flame-simple {
  --fa: "\\f46a";
}
.fa-burn {
  --fa: "\\f46a";
}
.fa-person {
  --fa: "\\f183";
}
.fa-male {
  --fa: "\\f183";
}
.fa-laptop {
  --fa: "\\f109";
}
.fa-file-csv {
  --fa: "\\f6dd";
}
.fa-menorah {
  --fa: "\\f676";
}
.fa-truck-plane {
  --fa: "\\e58f";
}
.fa-record-vinyl {
  --fa: "\\f8d9";
}
.fa-face-grin-stars {
  --fa: "\\f587";
}
.fa-grin-stars {
  --fa: "\\f587";
}
.fa-bong {
  --fa: "\\f55c";
}
.fa-spaghetti-monster-flying {
  --fa: "\\f67b";
}
.fa-pastafarianism {
  --fa: "\\f67b";
}
.fa-arrow-down-up-across-line {
  --fa: "\\e4af";
}
.fa-spoon {
  --fa: "\\f2e5";
}
.fa-utensil-spoon {
  --fa: "\\f2e5";
}
.fa-jar-wheat {
  --fa: "\\e517";
}
.fa-envelopes-bulk {
  --fa: "\\f674";
}
.fa-mail-bulk {
  --fa: "\\f674";
}
.fa-file-circle-exclamation {
  --fa: "\\e4eb";
}
.fa-circle-h {
  --fa: "\\f47e";
}
.fa-hospital-symbol {
  --fa: "\\f47e";
}
.fa-pager {
  --fa: "\\f815";
}
.fa-address-book {
  --fa: "\\f2b9";
}
.fa-contact-book {
  --fa: "\\f2b9";
}
.fa-strikethrough {
  --fa: "\\f0cc";
}
.fa-k {
  --fa: "\\4b";
}
.fa-landmark-flag {
  --fa: "\\e51c";
}
.fa-pencil {
  --fa: "\\f303";
}
.fa-pencil-alt {
  --fa: "\\f303";
}
.fa-backward {
  --fa: "\\f04a";
}
.fa-caret-right {
  --fa: "\\f0da";
}
.fa-comments {
  --fa: "\\f086";
}
.fa-paste {
  --fa: "\\f0ea";
}
.fa-file-clipboard {
  --fa: "\\f0ea";
}
.fa-code-pull-request {
  --fa: "\\e13c";
}
.fa-clipboard-list {
  --fa: "\\f46d";
}
.fa-truck-ramp-box {
  --fa: "\\f4de";
}
.fa-truck-loading {
  --fa: "\\f4de";
}
.fa-user-check {
  --fa: "\\f4fc";
}
.fa-vial-virus {
  --fa: "\\e597";
}
.fa-sheet-plastic {
  --fa: "\\e571";
}
.fa-blog {
  --fa: "\\f781";
}
.fa-user-ninja {
  --fa: "\\f504";
}
.fa-person-arrow-up-from-line {
  --fa: "\\e539";
}
.fa-scroll-torah {
  --fa: "\\f6a0";
}
.fa-torah {
  --fa: "\\f6a0";
}
.fa-broom-ball {
  --fa: "\\f458";
}
.fa-quidditch {
  --fa: "\\f458";
}
.fa-quidditch-broom-ball {
  --fa: "\\f458";
}
.fa-toggle-off {
  --fa: "\\f204";
}
.fa-box-archive {
  --fa: "\\f187";
}
.fa-archive {
  --fa: "\\f187";
}
.fa-person-drowning {
  --fa: "\\e545";
}
.fa-arrow-down-9-1 {
  --fa: "\\f886";
}
.fa-sort-numeric-desc {
  --fa: "\\f886";
}
.fa-sort-numeric-down-alt {
  --fa: "\\f886";
}
.fa-face-grin-tongue-squint {
  --fa: "\\f58a";
}
.fa-grin-tongue-squint {
  --fa: "\\f58a";
}
.fa-spray-can {
  --fa: "\\f5bd";
}
.fa-truck-monster {
  --fa: "\\f63b";
}
.fa-w {
  --fa: "\\57";
}
.fa-earth-africa {
  --fa: "\\f57c";
}
.fa-globe-africa {
  --fa: "\\f57c";
}
.fa-rainbow {
  --fa: "\\f75b";
}
.fa-circle-notch {
  --fa: "\\f1ce";
}
.fa-tablet-screen-button {
  --fa: "\\f3fa";
}
.fa-tablet-alt {
  --fa: "\\f3fa";
}
.fa-paw {
  --fa: "\\f1b0";
}
.fa-cloud {
  --fa: "\\f0c2";
}
.fa-trowel-bricks {
  --fa: "\\e58a";
}
.fa-face-flushed {
  --fa: "\\f579";
}
.fa-flushed {
  --fa: "\\f579";
}
.fa-hospital-user {
  --fa: "\\f80d";
}
.fa-tent-arrow-left-right {
  --fa: "\\e57f";
}
.fa-gavel {
  --fa: "\\f0e3";
}
.fa-legal {
  --fa: "\\f0e3";
}
.fa-binoculars {
  --fa: "\\f1e5";
}
.fa-microphone-slash {
  --fa: "\\f131";
}
.fa-box-tissue {
  --fa: "\\e05b";
}
.fa-motorcycle {
  --fa: "\\f21c";
}
.fa-bell-concierge {
  --fa: "\\f562";
}
.fa-concierge-bell {
  --fa: "\\f562";
}
.fa-pen-ruler {
  --fa: "\\f5ae";
}
.fa-pencil-ruler {
  --fa: "\\f5ae";
}
.fa-people-arrows {
  --fa: "\\e068";
}
.fa-people-arrows-left-right {
  --fa: "\\e068";
}
.fa-mars-and-venus-burst {
  --fa: "\\e523";
}
.fa-square-caret-right {
  --fa: "\\f152";
}
.fa-caret-square-right {
  --fa: "\\f152";
}
.fa-scissors {
  --fa: "\\f0c4";
}
.fa-cut {
  --fa: "\\f0c4";
}
.fa-sun-plant-wilt {
  --fa: "\\e57a";
}
.fa-toilets-portable {
  --fa: "\\e584";
}
.fa-hockey-puck {
  --fa: "\\f453";
}
.fa-table {
  --fa: "\\f0ce";
}
.fa-magnifying-glass-arrow-right {
  --fa: "\\e521";
}
.fa-tachograph-digital {
  --fa: "\\f566";
}
.fa-digital-tachograph {
  --fa: "\\f566";
}
.fa-users-slash {
  --fa: "\\e073";
}
.fa-clover {
  --fa: "\\e139";
}
.fa-reply {
  --fa: "\\f3e5";
}
.fa-mail-reply {
  --fa: "\\f3e5";
}
.fa-star-and-crescent {
  --fa: "\\f699";
}
.fa-house-fire {
  --fa: "\\e50c";
}
.fa-square-minus {
  --fa: "\\f146";
}
.fa-minus-square {
  --fa: "\\f146";
}
.fa-helicopter {
  --fa: "\\f533";
}
.fa-compass {
  --fa: "\\f14e";
}
.fa-square-caret-down {
  --fa: "\\f150";
}
.fa-caret-square-down {
  --fa: "\\f150";
}
.fa-file-circle-question {
  --fa: "\\e4ef";
}
.fa-laptop-code {
  --fa: "\\f5fc";
}
.fa-swatchbook {
  --fa: "\\f5c3";
}
.fa-prescription-bottle {
  --fa: "\\f485";
}
.fa-bars {
  --fa: "\\f0c9";
}
.fa-navicon {
  --fa: "\\f0c9";
}
.fa-people-group {
  --fa: "\\e533";
}
.fa-hourglass-end {
  --fa: "\\f253";
}
.fa-hourglass-3 {
  --fa: "\\f253";
}
.fa-heart-crack {
  --fa: "\\f7a9";
}
.fa-heart-broken {
  --fa: "\\f7a9";
}
.fa-square-up-right {
  --fa: "\\f360";
}
.fa-external-link-square-alt {
  --fa: "\\f360";
}
.fa-face-kiss-beam {
  --fa: "\\f597";
}
.fa-kiss-beam {
  --fa: "\\f597";
}
.fa-film {
  --fa: "\\f008";
}
.fa-ruler-horizontal {
  --fa: "\\f547";
}
.fa-people-robbery {
  --fa: "\\e536";
}
.fa-lightbulb {
  --fa: "\\f0eb";
}
.fa-caret-left {
  --fa: "\\f0d9";
}
.fa-circle-exclamation {
  --fa: "\\f06a";
}
.fa-exclamation-circle {
  --fa: "\\f06a";
}
.fa-school-circle-xmark {
  --fa: "\\e56d";
}
.fa-arrow-right-from-bracket {
  --fa: "\\f08b";
}
.fa-sign-out {
  --fa: "\\f08b";
}
.fa-circle-chevron-down {
  --fa: "\\f13a";
}
.fa-chevron-circle-down {
  --fa: "\\f13a";
}
.fa-unlock-keyhole {
  --fa: "\\f13e";
}
.fa-unlock-alt {
  --fa: "\\f13e";
}
.fa-cloud-showers-heavy {
  --fa: "\\f740";
}
.fa-headphones-simple {
  --fa: "\\f58f";
}
.fa-headphones-alt {
  --fa: "\\f58f";
}
.fa-sitemap {
  --fa: "\\f0e8";
}
.fa-circle-dollar-to-slot {
  --fa: "\\f4b9";
}
.fa-donate {
  --fa: "\\f4b9";
}
.fa-memory {
  --fa: "\\f538";
}
.fa-road-spikes {
  --fa: "\\e568";
}
.fa-fire-burner {
  --fa: "\\e4f1";
}
.fa-flag {
  --fa: "\\f024";
}
.fa-hanukiah {
  --fa: "\\f6e6";
}
.fa-feather {
  --fa: "\\f52d";
}
.fa-volume-low {
  --fa: "\\f027";
}
.fa-volume-down {
  --fa: "\\f027";
}
.fa-comment-slash {
  --fa: "\\f4b3";
}
.fa-cloud-sun-rain {
  --fa: "\\f743";
}
.fa-compress {
  --fa: "\\f066";
}
.fa-wheat-awn {
  --fa: "\\e2cd";
}
.fa-wheat-alt {
  --fa: "\\e2cd";
}
.fa-ankh {
  --fa: "\\f644";
}
.fa-hands-holding-child {
  --fa: "\\e4fa";
}
.fa-asterisk {
  --fa: "\\2a";
}
.fa-square-check {
  --fa: "\\f14a";
}
.fa-check-square {
  --fa: "\\f14a";
}
.fa-peseta-sign {
  --fa: "\\e221";
}
.fa-heading {
  --fa: "\\f1dc";
}
.fa-header {
  --fa: "\\f1dc";
}
.fa-ghost {
  --fa: "\\f6e2";
}
.fa-list {
  --fa: "\\f03a";
}
.fa-list-squares {
  --fa: "\\f03a";
}
.fa-square-phone-flip {
  --fa: "\\f87b";
}
.fa-phone-square-alt {
  --fa: "\\f87b";
}
.fa-cart-plus {
  --fa: "\\f217";
}
.fa-gamepad {
  --fa: "\\f11b";
}
.fa-circle-dot {
  --fa: "\\f192";
}
.fa-dot-circle {
  --fa: "\\f192";
}
.fa-face-dizzy {
  --fa: "\\f567";
}
.fa-dizzy {
  --fa: "\\f567";
}
.fa-egg {
  --fa: "\\f7fb";
}
.fa-house-medical-circle-xmark {
  --fa: "\\e513";
}
.fa-campground {
  --fa: "\\f6bb";
}
.fa-folder-plus {
  --fa: "\\f65e";
}
.fa-futbol {
  --fa: "\\f1e3";
}
.fa-futbol-ball {
  --fa: "\\f1e3";
}
.fa-soccer-ball {
  --fa: "\\f1e3";
}
.fa-paintbrush {
  --fa: "\\f1fc";
}
.fa-paint-brush {
  --fa: "\\f1fc";
}
.fa-lock {
  --fa: "\\f023";
}
.fa-gas-pump {
  --fa: "\\f52f";
}
.fa-hot-tub-person {
  --fa: "\\f593";
}
.fa-hot-tub {
  --fa: "\\f593";
}
.fa-map-location {
  --fa: "\\f59f";
}
.fa-map-marked {
  --fa: "\\f59f";
}
.fa-house-flood-water {
  --fa: "\\e50e";
}
.fa-tree {
  --fa: "\\f1bb";
}
.fa-bridge-lock {
  --fa: "\\e4cc";
}
.fa-sack-dollar {
  --fa: "\\f81d";
}
.fa-pen-to-square {
  --fa: "\\f044";
}
.fa-edit {
  --fa: "\\f044";
}
.fa-car-side {
  --fa: "\\f5e4";
}
.fa-share-nodes {
  --fa: "\\f1e0";
}
.fa-share-alt {
  --fa: "\\f1e0";
}
.fa-heart-circle-minus {
  --fa: "\\e4ff";
}
.fa-hourglass-half {
  --fa: "\\f252";
}
.fa-hourglass-2 {
  --fa: "\\f252";
}
.fa-microscope {
  --fa: "\\f610";
}
.fa-sink {
  --fa: "\\e06d";
}
.fa-bag-shopping {
  --fa: "\\f290";
}
.fa-shopping-bag {
  --fa: "\\f290";
}
.fa-arrow-down-z-a {
  --fa: "\\f881";
}
.fa-sort-alpha-desc {
  --fa: "\\f881";
}
.fa-sort-alpha-down-alt {
  --fa: "\\f881";
}
.fa-mitten {
  --fa: "\\f7b5";
}
.fa-person-rays {
  --fa: "\\e54d";
}
.fa-users {
  --fa: "\\f0c0";
}
.fa-eye-slash {
  --fa: "\\f070";
}
.fa-flask-vial {
  --fa: "\\e4f3";
}
.fa-hand {
  --fa: "\\f256";
}
.fa-hand-paper {
  --fa: "\\f256";
}
.fa-om {
  --fa: "\\f679";
}
.fa-worm {
  --fa: "\\e599";
}
.fa-house-circle-xmark {
  --fa: "\\e50b";
}
.fa-plug {
  --fa: "\\f1e6";
}
.fa-chevron-up {
  --fa: "\\f077";
}
.fa-hand-spock {
  --fa: "\\f259";
}
.fa-stopwatch {
  --fa: "\\f2f2";
}
.fa-face-kiss {
  --fa: "\\f596";
}
.fa-kiss {
  --fa: "\\f596";
}
.fa-bridge-circle-xmark {
  --fa: "\\e4cb";
}
.fa-face-grin-tongue {
  --fa: "\\f589";
}
.fa-grin-tongue {
  --fa: "\\f589";
}
.fa-chess-bishop {
  --fa: "\\f43a";
}
.fa-face-grin-wink {
  --fa: "\\f58c";
}
.fa-grin-wink {
  --fa: "\\f58c";
}
.fa-ear-deaf {
  --fa: "\\f2a4";
}
.fa-deaf {
  --fa: "\\f2a4";
}
.fa-deafness {
  --fa: "\\f2a4";
}
.fa-hard-of-hearing {
  --fa: "\\f2a4";
}
.fa-road-circle-check {
  --fa: "\\e564";
}
.fa-dice-five {
  --fa: "\\f523";
}
.fa-square-rss {
  --fa: "\\f143";
}
.fa-rss-square {
  --fa: "\\f143";
}
.fa-land-mine-on {
  --fa: "\\e51b";
}
.fa-i-cursor {
  --fa: "\\f246";
}
.fa-stamp {
  --fa: "\\f5bf";
}
.fa-stairs {
  --fa: "\\e289";
}
.fa-i {
  --fa: "\\49";
}
.fa-hryvnia-sign {
  --fa: "\\f6f2";
}
.fa-hryvnia {
  --fa: "\\f6f2";
}
.fa-pills {
  --fa: "\\f484";
}
.fa-face-grin-wide {
  --fa: "\\f581";
}
.fa-grin-alt {
  --fa: "\\f581";
}
.fa-tooth {
  --fa: "\\f5c9";
}
.fa-v {
  --fa: "\\56";
}
.fa-bangladeshi-taka-sign {
  --fa: "\\e2e6";
}
.fa-bicycle {
  --fa: "\\f206";
}
.fa-staff-snake {
  --fa: "\\e579";
}
.fa-rod-asclepius {
  --fa: "\\e579";
}
.fa-rod-snake {
  --fa: "\\e579";
}
.fa-staff-aesculapius {
  --fa: "\\e579";
}
.fa-head-side-cough-slash {
  --fa: "\\e062";
}
.fa-truck-medical {
  --fa: "\\f0f9";
}
.fa-ambulance {
  --fa: "\\f0f9";
}
.fa-wheat-awn-circle-exclamation {
  --fa: "\\e598";
}
.fa-snowman {
  --fa: "\\f7d0";
}
.fa-mortar-pestle {
  --fa: "\\f5a7";
}
.fa-road-barrier {
  --fa: "\\e562";
}
.fa-school {
  --fa: "\\f549";
}
.fa-igloo {
  --fa: "\\f7ae";
}
.fa-joint {
  --fa: "\\f595";
}
.fa-angle-right {
  --fa: "\\f105";
}
.fa-horse {
  --fa: "\\f6f0";
}
.fa-q {
  --fa: "\\51";
}
.fa-g {
  --fa: "\\47";
}
.fa-notes-medical {
  --fa: "\\f481";
}
.fa-temperature-half {
  --fa: "\\f2c9";
}
.fa-temperature-2 {
  --fa: "\\f2c9";
}
.fa-thermometer-2 {
  --fa: "\\f2c9";
}
.fa-thermometer-half {
  --fa: "\\f2c9";
}
.fa-dong-sign {
  --fa: "\\e169";
}
.fa-capsules {
  --fa: "\\f46b";
}
.fa-poo-storm {
  --fa: "\\f75a";
}
.fa-poo-bolt {
  --fa: "\\f75a";
}
.fa-face-frown-open {
  --fa: "\\f57a";
}
.fa-frown-open {
  --fa: "\\f57a";
}
.fa-hand-point-up {
  --fa: "\\f0a6";
}
.fa-money-bill {
  --fa: "\\f0d6";
}
.fa-bookmark {
  --fa: "\\f02e";
}
.fa-align-justify {
  --fa: "\\f039";
}
.fa-umbrella-beach {
  --fa: "\\f5ca";
}
.fa-helmet-un {
  --fa: "\\e503";
}
.fa-bullseye {
  --fa: "\\f140";
}
.fa-bacon {
  --fa: "\\f7e5";
}
.fa-hand-point-down {
  --fa: "\\f0a7";
}
.fa-arrow-up-from-bracket {
  --fa: "\\e09a";
}
.fa-folder {
  --fa: "\\f07b";
}
.fa-folder-blank {
  --fa: "\\f07b";
}
.fa-file-waveform {
  --fa: "\\f478";
}
.fa-file-medical-alt {
  --fa: "\\f478";
}
.fa-radiation {
  --fa: "\\f7b9";
}
.fa-chart-simple {
  --fa: "\\e473";
}
.fa-mars-stroke {
  --fa: "\\f229";
}
.fa-vial {
  --fa: "\\f492";
}
.fa-gauge {
  --fa: "\\f624";
}
.fa-dashboard {
  --fa: "\\f624";
}
.fa-gauge-med {
  --fa: "\\f624";
}
.fa-tachometer-alt-average {
  --fa: "\\f624";
}
.fa-wand-magic-sparkles {
  --fa: "\\e2ca";
}
.fa-magic-wand-sparkles {
  --fa: "\\e2ca";
}
.fa-e {
  --fa: "\\45";
}
.fa-pen-clip {
  --fa: "\\f305";
}
.fa-pen-alt {
  --fa: "\\f305";
}
.fa-bridge-circle-exclamation {
  --fa: "\\e4ca";
}
.fa-user {
  --fa: "\\f007";
}
.fa-school-circle-check {
  --fa: "\\e56b";
}
.fa-dumpster {
  --fa: "\\f793";
}
.fa-van-shuttle {
  --fa: "\\f5b6";
}
.fa-shuttle-van {
  --fa: "\\f5b6";
}
.fa-building-user {
  --fa: "\\e4da";
}
.fa-square-caret-left {
  --fa: "\\f191";
}
.fa-caret-square-left {
  --fa: "\\f191";
}
.fa-highlighter {
  --fa: "\\f591";
}
.fa-key {
  --fa: "\\f084";
}
.fa-bullhorn {
  --fa: "\\f0a1";
}
.fa-globe {
  --fa: "\\f0ac";
}
.fa-synagogue {
  --fa: "\\f69b";
}
.fa-person-half-dress {
  --fa: "\\e548";
}
.fa-road-bridge {
  --fa: "\\e563";
}
.fa-location-arrow {
  --fa: "\\f124";
}
.fa-c {
  --fa: "\\43";
}
.fa-tablet-button {
  --fa: "\\f10a";
}
.fa-building-lock {
  --fa: "\\e4d6";
}
.fa-pizza-slice {
  --fa: "\\f818";
}
.fa-money-bill-wave {
  --fa: "\\f53a";
}
.fa-chart-area {
  --fa: "\\f1fe";
}
.fa-area-chart {
  --fa: "\\f1fe";
}
.fa-house-flag {
  --fa: "\\e50d";
}
.fa-person-circle-minus {
  --fa: "\\e540";
}
.fa-ban {
  --fa: "\\f05e";
}
.fa-cancel {
  --fa: "\\f05e";
}
.fa-camera-rotate {
  --fa: "\\e0d8";
}
.fa-spray-can-sparkles {
  --fa: "\\f5d0";
}
.fa-air-freshener {
  --fa: "\\f5d0";
}
.fa-star {
  --fa: "\\f005";
}
.fa-repeat {
  --fa: "\\f363";
}
.fa-cross {
  --fa: "\\f654";
}
.fa-box {
  --fa: "\\f466";
}
.fa-venus-mars {
  --fa: "\\f228";
}
.fa-arrow-pointer {
  --fa: "\\f245";
}
.fa-mouse-pointer {
  --fa: "\\f245";
}
.fa-maximize {
  --fa: "\\f31e";
}
.fa-expand-arrows-alt {
  --fa: "\\f31e";
}
.fa-charging-station {
  --fa: "\\f5e7";
}
.fa-shapes {
  --fa: "\\f61f";
}
.fa-triangle-circle-square {
  --fa: "\\f61f";
}
.fa-shuffle {
  --fa: "\\f074";
}
.fa-random {
  --fa: "\\f074";
}
.fa-person-running {
  --fa: "\\f70c";
}
.fa-running {
  --fa: "\\f70c";
}
.fa-mobile-retro {
  --fa: "\\e527";
}
.fa-grip-lines-vertical {
  --fa: "\\f7a5";
}
.fa-spider {
  --fa: "\\f717";
}
.fa-hands-bound {
  --fa: "\\e4f9";
}
.fa-file-invoice-dollar {
  --fa: "\\f571";
}
.fa-plane-circle-exclamation {
  --fa: "\\e556";
}
.fa-x-ray {
  --fa: "\\f497";
}
.fa-spell-check {
  --fa: "\\f891";
}
.fa-slash {
  --fa: "\\f715";
}
.fa-computer-mouse {
  --fa: "\\f8cc";
}
.fa-mouse {
  --fa: "\\f8cc";
}
.fa-arrow-right-to-bracket {
  --fa: "\\f090";
}
.fa-sign-in {
  --fa: "\\f090";
}
.fa-shop-slash {
  --fa: "\\e070";
}
.fa-store-alt-slash {
  --fa: "\\e070";
}
.fa-server {
  --fa: "\\f233";
}
.fa-virus-covid-slash {
  --fa: "\\e4a9";
}
.fa-shop-lock {
  --fa: "\\e4a5";
}
.fa-hourglass-start {
  --fa: "\\f251";
}
.fa-hourglass-1 {
  --fa: "\\f251";
}
.fa-blender-phone {
  --fa: "\\f6b6";
}
.fa-building-wheat {
  --fa: "\\e4db";
}
.fa-person-breastfeeding {
  --fa: "\\e53a";
}
.fa-right-to-bracket {
  --fa: "\\f2f6";
}
.fa-sign-in-alt {
  --fa: "\\f2f6";
}
.fa-venus {
  --fa: "\\f221";
}
.fa-passport {
  --fa: "\\f5ab";
}
.fa-thumbtack-slash {
  --fa: "\\e68f";
}
.fa-thumb-tack-slash {
  --fa: "\\e68f";
}
.fa-heart-pulse {
  --fa: "\\f21e";
}
.fa-heartbeat {
  --fa: "\\f21e";
}
.fa-people-carry-box {
  --fa: "\\f4ce";
}
.fa-people-carry {
  --fa: "\\f4ce";
}
.fa-temperature-high {
  --fa: "\\f769";
}
.fa-microchip {
  --fa: "\\f2db";
}
.fa-crown {
  --fa: "\\f521";
}
.fa-weight-hanging {
  --fa: "\\f5cd";
}
.fa-xmarks-lines {
  --fa: "\\e59a";
}
.fa-file-prescription {
  --fa: "\\f572";
}
.fa-weight-scale {
  --fa: "\\f496";
}
.fa-weight {
  --fa: "\\f496";
}
.fa-user-group {
  --fa: "\\f500";
}
.fa-user-friends {
  --fa: "\\f500";
}
.fa-arrow-up-a-z {
  --fa: "\\f15e";
}
.fa-sort-alpha-up {
  --fa: "\\f15e";
}
.fa-chess-knight {
  --fa: "\\f441";
}
.fa-face-laugh-squint {
  --fa: "\\f59b";
}
.fa-laugh-squint {
  --fa: "\\f59b";
}
.fa-wheelchair {
  --fa: "\\f193";
}
.fa-circle-arrow-up {
  --fa: "\\f0aa";
}
.fa-arrow-circle-up {
  --fa: "\\f0aa";
}
.fa-toggle-on {
  --fa: "\\f205";
}
.fa-person-walking {
  --fa: "\\f554";
}
.fa-walking {
  --fa: "\\f554";
}
.fa-l {
  --fa: "\\4c";
}
.fa-fire {
  --fa: "\\f06d";
}
.fa-bed-pulse {
  --fa: "\\f487";
}
.fa-procedures {
  --fa: "\\f487";
}
.fa-shuttle-space {
  --fa: "\\f197";
}
.fa-space-shuttle {
  --fa: "\\f197";
}
.fa-face-laugh {
  --fa: "\\f599";
}
.fa-laugh {
  --fa: "\\f599";
}
.fa-folder-open {
  --fa: "\\f07c";
}
.fa-heart-circle-plus {
  --fa: "\\e500";
}
.fa-code-fork {
  --fa: "\\e13b";
}
.fa-city {
  --fa: "\\f64f";
}
.fa-microphone-lines {
  --fa: "\\f3c9";
}
.fa-microphone-alt {
  --fa: "\\f3c9";
}
.fa-pepper-hot {
  --fa: "\\f816";
}
.fa-unlock {
  --fa: "\\f09c";
}
.fa-colon-sign {
  --fa: "\\e140";
}
.fa-headset {
  --fa: "\\f590";
}
.fa-store-slash {
  --fa: "\\e071";
}
.fa-road-circle-xmark {
  --fa: "\\e566";
}
.fa-user-minus {
  --fa: "\\f503";
}
.fa-mars-stroke-up {
  --fa: "\\f22a";
}
.fa-mars-stroke-v {
  --fa: "\\f22a";
}
.fa-champagne-glasses {
  --fa: "\\f79f";
}
.fa-glass-cheers {
  --fa: "\\f79f";
}
.fa-clipboard {
  --fa: "\\f328";
}
.fa-house-circle-exclamation {
  --fa: "\\e50a";
}
.fa-file-arrow-up {
  --fa: "\\f574";
}
.fa-file-upload {
  --fa: "\\f574";
}
.fa-wifi {
  --fa: "\\f1eb";
}
.fa-wifi-3 {
  --fa: "\\f1eb";
}
.fa-wifi-strong {
  --fa: "\\f1eb";
}
.fa-bath {
  --fa: "\\f2cd";
}
.fa-bathtub {
  --fa: "\\f2cd";
}
.fa-underline {
  --fa: "\\f0cd";
}
.fa-user-pen {
  --fa: "\\f4ff";
}
.fa-user-edit {
  --fa: "\\f4ff";
}
.fa-signature {
  --fa: "\\f5b7";
}
.fa-stroopwafel {
  --fa: "\\f551";
}
.fa-bold {
  --fa: "\\f032";
}
.fa-anchor-lock {
  --fa: "\\e4ad";
}
.fa-building-ngo {
  --fa: "\\e4d7";
}
.fa-manat-sign {
  --fa: "\\e1d5";
}
.fa-not-equal {
  --fa: "\\f53e";
}
.fa-border-top-left {
  --fa: "\\f853";
}
.fa-border-style {
  --fa: "\\f853";
}
.fa-map-location-dot {
  --fa: "\\f5a0";
}
.fa-map-marked-alt {
  --fa: "\\f5a0";
}
.fa-jedi {
  --fa: "\\f669";
}
.fa-square-poll-vertical {
  --fa: "\\f681";
}
.fa-poll {
  --fa: "\\f681";
}
.fa-mug-hot {
  --fa: "\\f7b6";
}
.fa-car-battery {
  --fa: "\\f5df";
}
.fa-battery-car {
  --fa: "\\f5df";
}
.fa-gift {
  --fa: "\\f06b";
}
.fa-dice-two {
  --fa: "\\f528";
}
.fa-chess-queen {
  --fa: "\\f445";
}
.fa-glasses {
  --fa: "\\f530";
}
.fa-chess-board {
  --fa: "\\f43c";
}
.fa-building-circle-check {
  --fa: "\\e4d2";
}
.fa-person-chalkboard {
  --fa: "\\e53d";
}
.fa-mars-stroke-right {
  --fa: "\\f22b";
}
.fa-mars-stroke-h {
  --fa: "\\f22b";
}
.fa-hand-back-fist {
  --fa: "\\f255";
}
.fa-hand-rock {
  --fa: "\\f255";
}
.fa-square-caret-up {
  --fa: "\\f151";
}
.fa-caret-square-up {
  --fa: "\\f151";
}
.fa-cloud-showers-water {
  --fa: "\\e4e4";
}
.fa-chart-bar {
  --fa: "\\f080";
}
.fa-bar-chart {
  --fa: "\\f080";
}
.fa-hands-bubbles {
  --fa: "\\e05e";
}
.fa-hands-wash {
  --fa: "\\e05e";
}
.fa-less-than-equal {
  --fa: "\\f537";
}
.fa-train {
  --fa: "\\f238";
}
.fa-eye-low-vision {
  --fa: "\\f2a8";
}
.fa-low-vision {
  --fa: "\\f2a8";
}
.fa-crow {
  --fa: "\\f520";
}
.fa-sailboat {
  --fa: "\\e445";
}
.fa-window-restore {
  --fa: "\\f2d2";
}
.fa-square-plus {
  --fa: "\\f0fe";
}
.fa-plus-square {
  --fa: "\\f0fe";
}
.fa-torii-gate {
  --fa: "\\f6a1";
}
.fa-frog {
  --fa: "\\f52e";
}
.fa-bucket {
  --fa: "\\e4cf";
}
.fa-image {
  --fa: "\\f03e";
}
.fa-microphone {
  --fa: "\\f130";
}
.fa-cow {
  --fa: "\\f6c8";
}
.fa-caret-up {
  --fa: "\\f0d8";
}
.fa-screwdriver {
  --fa: "\\f54a";
}
.fa-folder-closed {
  --fa: "\\e185";
}
.fa-house-tsunami {
  --fa: "\\e515";
}
.fa-square-nfi {
  --fa: "\\e576";
}
.fa-arrow-up-from-ground-water {
  --fa: "\\e4b5";
}
.fa-martini-glass {
  --fa: "\\f57b";
}
.fa-glass-martini-alt {
  --fa: "\\f57b";
}
.fa-square-binary {
  --fa: "\\e69b";
}
.fa-rotate-left {
  --fa: "\\f2ea";
}
.fa-rotate-back {
  --fa: "\\f2ea";
}
.fa-rotate-backward {
  --fa: "\\f2ea";
}
.fa-undo-alt {
  --fa: "\\f2ea";
}
.fa-table-columns {
  --fa: "\\f0db";
}
.fa-columns {
  --fa: "\\f0db";
}
.fa-lemon {
  --fa: "\\f094";
}
.fa-head-side-mask {
  --fa: "\\e063";
}
.fa-handshake {
  --fa: "\\f2b5";
}
.fa-gem {
  --fa: "\\f3a5";
}
.fa-dolly {
  --fa: "\\f472";
}
.fa-dolly-box {
  --fa: "\\f472";
}
.fa-smoking {
  --fa: "\\f48d";
}
.fa-minimize {
  --fa: "\\f78c";
}
.fa-compress-arrows-alt {
  --fa: "\\f78c";
}
.fa-monument {
  --fa: "\\f5a6";
}
.fa-snowplow {
  --fa: "\\f7d2";
}
.fa-angles-right {
  --fa: "\\f101";
}
.fa-angle-double-right {
  --fa: "\\f101";
}
.fa-cannabis {
  --fa: "\\f55f";
}
.fa-circle-play {
  --fa: "\\f144";
}
.fa-play-circle {
  --fa: "\\f144";
}
.fa-tablets {
  --fa: "\\f490";
}
.fa-ethernet {
  --fa: "\\f796";
}
.fa-euro-sign {
  --fa: "\\f153";
}
.fa-eur {
  --fa: "\\f153";
}
.fa-euro {
  --fa: "\\f153";
}
.fa-chair {
  --fa: "\\f6c0";
}
.fa-circle-check {
  --fa: "\\f058";
}
.fa-check-circle {
  --fa: "\\f058";
}
.fa-circle-stop {
  --fa: "\\f28d";
}
.fa-stop-circle {
  --fa: "\\f28d";
}
.fa-compass-drafting {
  --fa: "\\f568";
}
.fa-drafting-compass {
  --fa: "\\f568";
}
.fa-plate-wheat {
  --fa: "\\e55a";
}
.fa-icicles {
  --fa: "\\f7ad";
}
.fa-person-shelter {
  --fa: "\\e54f";
}
.fa-neuter {
  --fa: "\\f22c";
}
.fa-id-badge {
  --fa: "\\f2c1";
}
.fa-marker {
  --fa: "\\f5a1";
}
.fa-face-laugh-beam {
  --fa: "\\f59a";
}
.fa-laugh-beam {
  --fa: "\\f59a";
}
.fa-helicopter-symbol {
  --fa: "\\e502";
}
.fa-universal-access {
  --fa: "\\f29a";
}
.fa-circle-chevron-up {
  --fa: "\\f139";
}
.fa-chevron-circle-up {
  --fa: "\\f139";
}
.fa-lari-sign {
  --fa: "\\e1c8";
}
.fa-volcano {
  --fa: "\\f770";
}
.fa-person-walking-dashed-line-arrow-right {
  --fa: "\\e553";
}
.fa-sterling-sign {
  --fa: "\\f154";
}
.fa-gbp {
  --fa: "\\f154";
}
.fa-pound-sign {
  --fa: "\\f154";
}
.fa-viruses {
  --fa: "\\e076";
}
.fa-square-person-confined {
  --fa: "\\e577";
}
.fa-user-tie {
  --fa: "\\f508";
}
.fa-arrow-down-long {
  --fa: "\\f175";
}
.fa-long-arrow-down {
  --fa: "\\f175";
}
.fa-tent-arrow-down-to-line {
  --fa: "\\e57e";
}
.fa-certificate {
  --fa: "\\f0a3";
}
.fa-reply-all {
  --fa: "\\f122";
}
.fa-mail-reply-all {
  --fa: "\\f122";
}
.fa-suitcase {
  --fa: "\\f0f2";
}
.fa-person-skating {
  --fa: "\\f7c5";
}
.fa-skating {
  --fa: "\\f7c5";
}
.fa-filter-circle-dollar {
  --fa: "\\f662";
}
.fa-funnel-dollar {
  --fa: "\\f662";
}
.fa-camera-retro {
  --fa: "\\f083";
}
.fa-circle-arrow-down {
  --fa: "\\f0ab";
}
.fa-arrow-circle-down {
  --fa: "\\f0ab";
}
.fa-file-import {
  --fa: "\\f56f";
}
.fa-arrow-right-to-file {
  --fa: "\\f56f";
}
.fa-square-arrow-up-right {
  --fa: "\\f14c";
}
.fa-external-link-square {
  --fa: "\\f14c";
}
.fa-box-open {
  --fa: "\\f49e";
}
.fa-scroll {
  --fa: "\\f70e";
}
.fa-spa {
  --fa: "\\f5bb";
}
.fa-location-pin-lock {
  --fa: "\\e51f";
}
.fa-pause {
  --fa: "\\f04c";
}
.fa-hill-avalanche {
  --fa: "\\e507";
}
.fa-temperature-empty {
  --fa: "\\f2cb";
}
.fa-temperature-0 {
  --fa: "\\f2cb";
}
.fa-thermometer-0 {
  --fa: "\\f2cb";
}
.fa-thermometer-empty {
  --fa: "\\f2cb";
}
.fa-bomb {
  --fa: "\\f1e2";
}
.fa-registered {
  --fa: "\\f25d";
}
.fa-address-card {
  --fa: "\\f2bb";
}
.fa-contact-card {
  --fa: "\\f2bb";
}
.fa-vcard {
  --fa: "\\f2bb";
}
.fa-scale-unbalanced-flip {
  --fa: "\\f516";
}
.fa-balance-scale-right {
  --fa: "\\f516";
}
.fa-subscript {
  --fa: "\\f12c";
}
.fa-diamond-turn-right {
  --fa: "\\f5eb";
}
.fa-directions {
  --fa: "\\f5eb";
}
.fa-burst {
  --fa: "\\e4dc";
}
.fa-house-laptop {
  --fa: "\\e066";
}
.fa-laptop-house {
  --fa: "\\e066";
}
.fa-face-tired {
  --fa: "\\f5c8";
}
.fa-tired {
  --fa: "\\f5c8";
}
.fa-money-bills {
  --fa: "\\e1f3";
}
.fa-smog {
  --fa: "\\f75f";
}
.fa-crutch {
  --fa: "\\f7f7";
}
.fa-cloud-arrow-up {
  --fa: "\\f0ee";
}
.fa-cloud-upload {
  --fa: "\\f0ee";
}
.fa-cloud-upload-alt {
  --fa: "\\f0ee";
}
.fa-palette {
  --fa: "\\f53f";
}
.fa-arrows-turn-right {
  --fa: "\\e4c0";
}
.fa-vest {
  --fa: "\\e085";
}
.fa-ferry {
  --fa: "\\e4ea";
}
.fa-arrows-down-to-people {
  --fa: "\\e4b9";
}
.fa-seedling {
  --fa: "\\f4d8";
}
.fa-sprout {
  --fa: "\\f4d8";
}
.fa-left-right {
  --fa: "\\f337";
}
.fa-arrows-alt-h {
  --fa: "\\f337";
}
.fa-boxes-packing {
  --fa: "\\e4c7";
}
.fa-circle-arrow-left {
  --fa: "\\f0a8";
}
.fa-arrow-circle-left {
  --fa: "\\f0a8";
}
.fa-group-arrows-rotate {
  --fa: "\\e4f6";
}
.fa-bowl-food {
  --fa: "\\e4c6";
}
.fa-candy-cane {
  --fa: "\\f786";
}
.fa-arrow-down-wide-short {
  --fa: "\\f160";
}
.fa-sort-amount-asc {
  --fa: "\\f160";
}
.fa-sort-amount-down {
  --fa: "\\f160";
}
.fa-cloud-bolt {
  --fa: "\\f76c";
}
.fa-thunderstorm {
  --fa: "\\f76c";
}
.fa-text-slash {
  --fa: "\\f87d";
}
.fa-remove-format {
  --fa: "\\f87d";
}
.fa-face-smile-wink {
  --fa: "\\f4da";
}
.fa-smile-wink {
  --fa: "\\f4da";
}
.fa-file-word {
  --fa: "\\f1c2";
}
.fa-file-powerpoint {
  --fa: "\\f1c4";
}
.fa-arrows-left-right {
  --fa: "\\f07e";
}
.fa-arrows-h {
  --fa: "\\f07e";
}
.fa-house-lock {
  --fa: "\\e510";
}
.fa-cloud-arrow-down {
  --fa: "\\f0ed";
}
.fa-cloud-download {
  --fa: "\\f0ed";
}
.fa-cloud-download-alt {
  --fa: "\\f0ed";
}
.fa-children {
  --fa: "\\e4e1";
}
.fa-chalkboard {
  --fa: "\\f51b";
}
.fa-blackboard {
  --fa: "\\f51b";
}
.fa-user-large-slash {
  --fa: "\\f4fa";
}
.fa-user-alt-slash {
  --fa: "\\f4fa";
}
.fa-envelope-open {
  --fa: "\\f2b6";
}
.fa-handshake-simple-slash {
  --fa: "\\e05f";
}
.fa-handshake-alt-slash {
  --fa: "\\e05f";
}
.fa-mattress-pillow {
  --fa: "\\e525";
}
.fa-guarani-sign {
  --fa: "\\e19a";
}
.fa-arrows-rotate {
  --fa: "\\f021";
}
.fa-refresh {
  --fa: "\\f021";
}
.fa-sync {
  --fa: "\\f021";
}
.fa-fire-extinguisher {
  --fa: "\\f134";
}
.fa-cruzeiro-sign {
  --fa: "\\e152";
}
.fa-greater-than-equal {
  --fa: "\\f532";
}
.fa-shield-halved {
  --fa: "\\f3ed";
}
.fa-shield-alt {
  --fa: "\\f3ed";
}
.fa-book-atlas {
  --fa: "\\f558";
}
.fa-atlas {
  --fa: "\\f558";
}
.fa-virus {
  --fa: "\\e074";
}
.fa-envelope-circle-check {
  --fa: "\\e4e8";
}
.fa-layer-group {
  --fa: "\\f5fd";
}
.fa-arrows-to-dot {
  --fa: "\\e4be";
}
.fa-archway {
  --fa: "\\f557";
}
.fa-heart-circle-check {
  --fa: "\\e4fd";
}
.fa-house-chimney-crack {
  --fa: "\\f6f1";
}
.fa-house-damage {
  --fa: "\\f6f1";
}
.fa-file-zipper {
  --fa: "\\f1c6";
}
.fa-file-archive {
  --fa: "\\f1c6";
}
.fa-square {
  --fa: "\\f0c8";
}
.fa-martini-glass-empty {
  --fa: "\\f000";
}
.fa-glass-martini {
  --fa: "\\f000";
}
.fa-couch {
  --fa: "\\f4b8";
}
.fa-cedi-sign {
  --fa: "\\e0df";
}
.fa-italic {
  --fa: "\\f033";
}
.fa-table-cells-column-lock {
  --fa: "\\e678";
}
.fa-church {
  --fa: "\\f51d";
}
.fa-comments-dollar {
  --fa: "\\f653";
}
.fa-democrat {
  --fa: "\\f747";
}
.fa-z {
  --fa: "\\5a";
}
.fa-person-skiing {
  --fa: "\\f7c9";
}
.fa-skiing {
  --fa: "\\f7c9";
}
.fa-road-lock {
  --fa: "\\e567";
}
.fa-a {
  --fa: "\\41";
}
.fa-temperature-arrow-down {
  --fa: "\\e03f";
}
.fa-temperature-down {
  --fa: "\\e03f";
}
.fa-feather-pointed {
  --fa: "\\f56b";
}
.fa-feather-alt {
  --fa: "\\f56b";
}
.fa-p {
  --fa: "\\50";
}
.fa-snowflake {
  --fa: "\\f2dc";
}
.fa-newspaper {
  --fa: "\\f1ea";
}
.fa-rectangle-ad {
  --fa: "\\f641";
}
.fa-ad {
  --fa: "\\f641";
}
.fa-circle-arrow-right {
  --fa: "\\f0a9";
}
.fa-arrow-circle-right {
  --fa: "\\f0a9";
}
.fa-filter-circle-xmark {
  --fa: "\\e17b";
}
.fa-locust {
  --fa: "\\e520";
}
.fa-sort {
  --fa: "\\f0dc";
}
.fa-unsorted {
  --fa: "\\f0dc";
}
.fa-list-ol {
  --fa: "\\f0cb";
}
.fa-list-1-2 {
  --fa: "\\f0cb";
}
.fa-list-numeric {
  --fa: "\\f0cb";
}
.fa-person-dress-burst {
  --fa: "\\e544";
}
.fa-money-check-dollar {
  --fa: "\\f53d";
}
.fa-money-check-alt {
  --fa: "\\f53d";
}
.fa-vector-square {
  --fa: "\\f5cb";
}
.fa-bread-slice {
  --fa: "\\f7ec";
}
.fa-language {
  --fa: "\\f1ab";
}
.fa-face-kiss-wink-heart {
  --fa: "\\f598";
}
.fa-kiss-wink-heart {
  --fa: "\\f598";
}
.fa-filter {
  --fa: "\\f0b0";
}
.fa-question {
  --fa: "\\3f";
}
.fa-file-signature {
  --fa: "\\f573";
}
.fa-up-down-left-right {
  --fa: "\\f0b2";
}
.fa-arrows-alt {
  --fa: "\\f0b2";
}
.fa-house-chimney-user {
  --fa: "\\e065";
}
.fa-hand-holding-heart {
  --fa: "\\f4be";
}
.fa-puzzle-piece {
  --fa: "\\f12e";
}
.fa-money-check {
  --fa: "\\f53c";
}
.fa-star-half-stroke {
  --fa: "\\f5c0";
}
.fa-star-half-alt {
  --fa: "\\f5c0";
}
.fa-code {
  --fa: "\\f121";
}
.fa-whiskey-glass {
  --fa: "\\f7a0";
}
.fa-glass-whiskey {
  --fa: "\\f7a0";
}
.fa-building-circle-exclamation {
  --fa: "\\e4d3";
}
.fa-magnifying-glass-chart {
  --fa: "\\e522";
}
.fa-arrow-up-right-from-square {
  --fa: "\\f08e";
}
.fa-external-link {
  --fa: "\\f08e";
}
.fa-cubes-stacked {
  --fa: "\\e4e6";
}
.fa-won-sign {
  --fa: "\\f159";
}
.fa-krw {
  --fa: "\\f159";
}
.fa-won {
  --fa: "\\f159";
}
.fa-virus-covid {
  --fa: "\\e4a8";
}
.fa-austral-sign {
  --fa: "\\e0a9";
}
.fa-f {
  --fa: "\\46";
}
.fa-leaf {
  --fa: "\\f06c";
}
.fa-road {
  --fa: "\\f018";
}
.fa-taxi {
  --fa: "\\f1ba";
}
.fa-cab {
  --fa: "\\f1ba";
}
.fa-person-circle-plus {
  --fa: "\\e541";
}
.fa-chart-pie {
  --fa: "\\f200";
}
.fa-pie-chart {
  --fa: "\\f200";
}
.fa-bolt-lightning {
  --fa: "\\e0b7";
}
.fa-sack-xmark {
  --fa: "\\e56a";
}
.fa-file-excel {
  --fa: "\\f1c3";
}
.fa-file-contract {
  --fa: "\\f56c";
}
.fa-fish-fins {
  --fa: "\\e4f2";
}
.fa-building-flag {
  --fa: "\\e4d5";
}
.fa-face-grin-beam {
  --fa: "\\f582";
}
.fa-grin-beam {
  --fa: "\\f582";
}
.fa-object-ungroup {
  --fa: "\\f248";
}
.fa-poop {
  --fa: "\\f619";
}
.fa-location-pin {
  --fa: "\\f041";
}
.fa-map-marker {
  --fa: "\\f041";
}
.fa-kaaba {
  --fa: "\\f66b";
}
.fa-toilet-paper {
  --fa: "\\f71e";
}
.fa-helmet-safety {
  --fa: "\\f807";
}
.fa-hard-hat {
  --fa: "\\f807";
}
.fa-hat-hard {
  --fa: "\\f807";
}
.fa-eject {
  --fa: "\\f052";
}
.fa-circle-right {
  --fa: "\\f35a";
}
.fa-arrow-alt-circle-right {
  --fa: "\\f35a";
}
.fa-plane-circle-check {
  --fa: "\\e555";
}
.fa-face-rolling-eyes {
  --fa: "\\f5a5";
}
.fa-meh-rolling-eyes {
  --fa: "\\f5a5";
}
.fa-object-group {
  --fa: "\\f247";
}
.fa-chart-line {
  --fa: "\\f201";
}
.fa-line-chart {
  --fa: "\\f201";
}
.fa-mask-ventilator {
  --fa: "\\e524";
}
.fa-arrow-right {
  --fa: "\\f061";
}
.fa-signs-post {
  --fa: "\\f277";
}
.fa-map-signs {
  --fa: "\\f277";
}
.fa-cash-register {
  --fa: "\\f788";
}
.fa-person-circle-question {
  --fa: "\\e542";
}
.fa-h {
  --fa: "\\48";
}
.fa-tarp {
  --fa: "\\e57b";
}
.fa-screwdriver-wrench {
  --fa: "\\f7d9";
}
.fa-tools {
  --fa: "\\f7d9";
}
.fa-arrows-to-eye {
  --fa: "\\e4bf";
}
.fa-plug-circle-bolt {
  --fa: "\\e55b";
}
.fa-heart {
  --fa: "\\f004";
}
.fa-mars-and-venus {
  --fa: "\\f224";
}
.fa-house-user {
  --fa: "\\e1b0";
}
.fa-home-user {
  --fa: "\\e1b0";
}
.fa-dumpster-fire {
  --fa: "\\f794";
}
.fa-house-crack {
  --fa: "\\e3b1";
}
.fa-martini-glass-citrus {
  --fa: "\\f561";
}
.fa-cocktail {
  --fa: "\\f561";
}
.fa-face-surprise {
  --fa: "\\f5c2";
}
.fa-surprise {
  --fa: "\\f5c2";
}
.fa-bottle-water {
  --fa: "\\e4c5";
}
.fa-circle-pause {
  --fa: "\\f28b";
}
.fa-pause-circle {
  --fa: "\\f28b";
}
.fa-toilet-paper-slash {
  --fa: "\\e072";
}
.fa-apple-whole {
  --fa: "\\f5d1";
}
.fa-apple-alt {
  --fa: "\\f5d1";
}
.fa-kitchen-set {
  --fa: "\\e51a";
}
.fa-r {
  --fa: "\\52";
}
.fa-temperature-quarter {
  --fa: "\\f2ca";
}
.fa-temperature-1 {
  --fa: "\\f2ca";
}
.fa-thermometer-1 {
  --fa: "\\f2ca";
}
.fa-thermometer-quarter {
  --fa: "\\f2ca";
}
.fa-cube {
  --fa: "\\f1b2";
}
.fa-bitcoin-sign {
  --fa: "\\e0b4";
}
.fa-shield-dog {
  --fa: "\\e573";
}
.fa-solar-panel {
  --fa: "\\f5ba";
}
.fa-lock-open {
  --fa: "\\f3c1";
}
.fa-elevator {
  --fa: "\\e16d";
}
.fa-money-bill-transfer {
  --fa: "\\e528";
}
.fa-money-bill-trend-up {
  --fa: "\\e529";
}
.fa-house-flood-water-circle-arrow-right {
  --fa: "\\e50f";
}
.fa-square-poll-horizontal {
  --fa: "\\f682";
}
.fa-poll-h {
  --fa: "\\f682";
}
.fa-circle {
  --fa: "\\f111";
}
.fa-backward-fast {
  --fa: "\\f049";
}
.fa-fast-backward {
  --fa: "\\f049";
}
.fa-recycle {
  --fa: "\\f1b8";
}
.fa-user-astronaut {
  --fa: "\\f4fb";
}
.fa-plane-slash {
  --fa: "\\e069";
}
.fa-trademark {
  --fa: "\\f25c";
}
.fa-basketball {
  --fa: "\\f434";
}
.fa-basketball-ball {
  --fa: "\\f434";
}
.fa-satellite-dish {
  --fa: "\\f7c0";
}
.fa-circle-up {
  --fa: "\\f35b";
}
.fa-arrow-alt-circle-up {
  --fa: "\\f35b";
}
.fa-mobile-screen-button {
  --fa: "\\f3cd";
}
.fa-mobile-alt {
  --fa: "\\f3cd";
}
.fa-volume-high {
  --fa: "\\f028";
}
.fa-volume-up {
  --fa: "\\f028";
}
.fa-users-rays {
  --fa: "\\e593";
}
.fa-wallet {
  --fa: "\\f555";
}
.fa-clipboard-check {
  --fa: "\\f46c";
}
.fa-file-audio {
  --fa: "\\f1c7";
}
.fa-burger {
  --fa: "\\f805";
}
.fa-hamburger {
  --fa: "\\f805";
}
.fa-wrench {
  --fa: "\\f0ad";
}
.fa-bugs {
  --fa: "\\e4d0";
}
.fa-rupee-sign {
  --fa: "\\f156";
}
.fa-rupee {
  --fa: "\\f156";
}
.fa-file-image {
  --fa: "\\f1c5";
}
.fa-circle-question {
  --fa: "\\f059";
}
.fa-question-circle {
  --fa: "\\f059";
}
.fa-plane-departure {
  --fa: "\\f5b0";
}
.fa-handshake-slash {
  --fa: "\\e060";
}
.fa-book-bookmark {
  --fa: "\\e0bb";
}
.fa-code-branch {
  --fa: "\\f126";
}
.fa-hat-cowboy {
  --fa: "\\f8c0";
}
.fa-bridge {
  --fa: "\\e4c8";
}
.fa-phone-flip {
  --fa: "\\f879";
}
.fa-phone-alt {
  --fa: "\\f879";
}
.fa-truck-front {
  --fa: "\\e2b7";
}
.fa-cat {
  --fa: "\\f6be";
}
.fa-anchor-circle-exclamation {
  --fa: "\\e4ab";
}
.fa-truck-field {
  --fa: "\\e58d";
}
.fa-route {
  --fa: "\\f4d7";
}
.fa-clipboard-question {
  --fa: "\\e4e3";
}
.fa-panorama {
  --fa: "\\e209";
}
.fa-comment-medical {
  --fa: "\\f7f5";
}
.fa-teeth-open {
  --fa: "\\f62f";
}
.fa-file-circle-minus {
  --fa: "\\e4ed";
}
.fa-tags {
  --fa: "\\f02c";
}
.fa-wine-glass {
  --fa: "\\f4e3";
}
.fa-forward-fast {
  --fa: "\\f050";
}
.fa-fast-forward {
  --fa: "\\f050";
}
.fa-face-meh-blank {
  --fa: "\\f5a4";
}
.fa-meh-blank {
  --fa: "\\f5a4";
}
.fa-square-parking {
  --fa: "\\f540";
}
.fa-parking {
  --fa: "\\f540";
}
.fa-house-signal {
  --fa: "\\e012";
}
.fa-bars-progress {
  --fa: "\\f828";
}
.fa-tasks-alt {
  --fa: "\\f828";
}
.fa-faucet-drip {
  --fa: "\\e006";
}
.fa-cart-flatbed {
  --fa: "\\f474";
}
.fa-dolly-flatbed {
  --fa: "\\f474";
}
.fa-ban-smoking {
  --fa: "\\f54d";
}
.fa-smoking-ban {
  --fa: "\\f54d";
}
.fa-terminal {
  --fa: "\\f120";
}
.fa-mobile-button {
  --fa: "\\f10b";
}
.fa-house-medical-flag {
  --fa: "\\e514";
}
.fa-basket-shopping {
  --fa: "\\f291";
}
.fa-shopping-basket {
  --fa: "\\f291";
}
.fa-tape {
  --fa: "\\f4db";
}
.fa-bus-simple {
  --fa: "\\f55e";
}
.fa-bus-alt {
  --fa: "\\f55e";
}
.fa-eye {
  --fa: "\\f06e";
}
.fa-face-sad-cry {
  --fa: "\\f5b3";
}
.fa-sad-cry {
  --fa: "\\f5b3";
}
.fa-audio-description {
  --fa: "\\f29e";
}
.fa-person-military-to-person {
  --fa: "\\e54c";
}
.fa-file-shield {
  --fa: "\\e4f0";
}
.fa-user-slash {
  --fa: "\\f506";
}
.fa-pen {
  --fa: "\\f304";
}
.fa-tower-observation {
  --fa: "\\e586";
}
.fa-file-code {
  --fa: "\\f1c9";
}
.fa-signal {
  --fa: "\\f012";
}
.fa-signal-5 {
  --fa: "\\f012";
}
.fa-signal-perfect {
  --fa: "\\f012";
}
.fa-bus {
  --fa: "\\f207";
}
.fa-heart-circle-xmark {
  --fa: "\\e501";
}
.fa-house-chimney {
  --fa: "\\e3af";
}
.fa-home-lg {
  --fa: "\\e3af";
}
.fa-window-maximize {
  --fa: "\\f2d0";
}
.fa-face-frown {
  --fa: "\\f119";
}
.fa-frown {
  --fa: "\\f119";
}
.fa-prescription {
  --fa: "\\f5b1";
}
.fa-shop {
  --fa: "\\f54f";
}
.fa-store-alt {
  --fa: "\\f54f";
}
.fa-floppy-disk {
  --fa: "\\f0c7";
}
.fa-save {
  --fa: "\\f0c7";
}
.fa-vihara {
  --fa: "\\f6a7";
}
.fa-scale-unbalanced {
  --fa: "\\f515";
}
.fa-balance-scale-left {
  --fa: "\\f515";
}
.fa-sort-up {
  --fa: "\\f0de";
}
.fa-sort-asc {
  --fa: "\\f0de";
}
.fa-comment-dots {
  --fa: "\\f4ad";
}
.fa-commenting {
  --fa: "\\f4ad";
}
.fa-plant-wilt {
  --fa: "\\e5aa";
}
.fa-diamond {
  --fa: "\\f219";
}
.fa-face-grin-squint {
  --fa: "\\f585";
}
.fa-grin-squint {
  --fa: "\\f585";
}
.fa-hand-holding-dollar {
  --fa: "\\f4c0";
}
.fa-hand-holding-usd {
  --fa: "\\f4c0";
}
.fa-chart-diagram {
  --fa: "\\e695";
}
.fa-bacterium {
  --fa: "\\e05a";
}
.fa-hand-pointer {
  --fa: "\\f25a";
}
.fa-drum-steelpan {
  --fa: "\\f56a";
}
.fa-hand-scissors {
  --fa: "\\f257";
}
.fa-hands-praying {
  --fa: "\\f684";
}
.fa-praying-hands {
  --fa: "\\f684";
}
.fa-arrow-rotate-right {
  --fa: "\\f01e";
}
.fa-arrow-right-rotate {
  --fa: "\\f01e";
}
.fa-arrow-rotate-forward {
  --fa: "\\f01e";
}
.fa-redo {
  --fa: "\\f01e";
}
.fa-biohazard {
  --fa: "\\f780";
}
.fa-location-crosshairs {
  --fa: "\\f601";
}
.fa-location {
  --fa: "\\f601";
}
.fa-mars-double {
  --fa: "\\f227";
}
.fa-child-dress {
  --fa: "\\e59c";
}
.fa-users-between-lines {
  --fa: "\\e591";
}
.fa-lungs-virus {
  --fa: "\\e067";
}
.fa-face-grin-tears {
  --fa: "\\f588";
}
.fa-grin-tears {
  --fa: "\\f588";
}
.fa-phone {
  --fa: "\\f095";
}
.fa-calendar-xmark {
  --fa: "\\f273";
}
.fa-calendar-times {
  --fa: "\\f273";
}
.fa-child-reaching {
  --fa: "\\e59d";
}
.fa-head-side-virus {
  --fa: "\\e064";
}
.fa-user-gear {
  --fa: "\\f4fe";
}
.fa-user-cog {
  --fa: "\\f4fe";
}
.fa-arrow-up-1-9 {
  --fa: "\\f163";
}
.fa-sort-numeric-up {
  --fa: "\\f163";
}
.fa-door-closed {
  --fa: "\\f52a";
}
.fa-shield-virus {
  --fa: "\\e06c";
}
.fa-dice-six {
  --fa: "\\f526";
}
.fa-mosquito-net {
  --fa: "\\e52c";
}
.fa-file-fragment {
  --fa: "\\e697";
}
.fa-bridge-water {
  --fa: "\\e4ce";
}
.fa-person-booth {
  --fa: "\\f756";
}
.fa-text-width {
  --fa: "\\f035";
}
.fa-hat-wizard {
  --fa: "\\f6e8";
}
.fa-pen-fancy {
  --fa: "\\f5ac";
}
.fa-person-digging {
  --fa: "\\f85e";
}
.fa-digging {
  --fa: "\\f85e";
}
.fa-trash {
  --fa: "\\f1f8";
}
.fa-gauge-simple {
  --fa: "\\f629";
}
.fa-gauge-simple-med {
  --fa: "\\f629";
}
.fa-tachometer-average {
  --fa: "\\f629";
}
.fa-book-medical {
  --fa: "\\f7e6";
}
.fa-poo {
  --fa: "\\f2fe";
}
.fa-quote-right {
  --fa: "\\f10e";
}
.fa-quote-right-alt {
  --fa: "\\f10e";
}
.fa-shirt {
  --fa: "\\f553";
}
.fa-t-shirt {
  --fa: "\\f553";
}
.fa-tshirt {
  --fa: "\\f553";
}
.fa-cubes {
  --fa: "\\f1b3";
}
.fa-divide {
  --fa: "\\f529";
}
.fa-tenge-sign {
  --fa: "\\f7d7";
}
.fa-tenge {
  --fa: "\\f7d7";
}
.fa-headphones {
  --fa: "\\f025";
}
.fa-hands-holding {
  --fa: "\\f4c2";
}
.fa-hands-clapping {
  --fa: "\\e1a8";
}
.fa-republican {
  --fa: "\\f75e";
}
.fa-arrow-left {
  --fa: "\\f060";
}
.fa-person-circle-xmark {
  --fa: "\\e543";
}
.fa-ruler {
  --fa: "\\f545";
}
.fa-align-left {
  --fa: "\\f036";
}
.fa-dice-d6 {
  --fa: "\\f6d1";
}
.fa-restroom {
  --fa: "\\f7bd";
}
.fa-j {
  --fa: "\\4a";
}
.fa-users-viewfinder {
  --fa: "\\e595";
}
.fa-file-video {
  --fa: "\\f1c8";
}
.fa-up-right-from-square {
  --fa: "\\f35d";
}
.fa-external-link-alt {
  --fa: "\\f35d";
}
.fa-table-cells {
  --fa: "\\f00a";
}
.fa-th {
  --fa: "\\f00a";
}
.fa-file-pdf {
  --fa: "\\f1c1";
}
.fa-book-bible {
  --fa: "\\f647";
}
.fa-bible {
  --fa: "\\f647";
}
.fa-o {
  --fa: "\\4f";
}
.fa-suitcase-medical {
  --fa: "\\f0fa";
}
.fa-medkit {
  --fa: "\\f0fa";
}
.fa-user-secret {
  --fa: "\\f21b";
}
.fa-otter {
  --fa: "\\f700";
}
.fa-person-dress {
  --fa: "\\f182";
}
.fa-female {
  --fa: "\\f182";
}
.fa-comment-dollar {
  --fa: "\\f651";
}
.fa-business-time {
  --fa: "\\f64a";
}
.fa-briefcase-clock {
  --fa: "\\f64a";
}
.fa-table-cells-large {
  --fa: "\\f009";
}
.fa-th-large {
  --fa: "\\f009";
}
.fa-book-tanakh {
  --fa: "\\f827";
}
.fa-tanakh {
  --fa: "\\f827";
}
.fa-phone-volume {
  --fa: "\\f2a0";
}
.fa-volume-control-phone {
  --fa: "\\f2a0";
}
.fa-hat-cowboy-side {
  --fa: "\\f8c1";
}
.fa-clipboard-user {
  --fa: "\\f7f3";
}
.fa-child {
  --fa: "\\f1ae";
}
.fa-lira-sign {
  --fa: "\\f195";
}
.fa-satellite {
  --fa: "\\f7bf";
}
.fa-plane-lock {
  --fa: "\\e558";
}
.fa-tag {
  --fa: "\\f02b";
}
.fa-comment {
  --fa: "\\f075";
}
.fa-cake-candles {
  --fa: "\\f1fd";
}
.fa-birthday-cake {
  --fa: "\\f1fd";
}
.fa-cake {
  --fa: "\\f1fd";
}
.fa-envelope {
  --fa: "\\f0e0";
}
.fa-angles-up {
  --fa: "\\f102";
}
.fa-angle-double-up {
  --fa: "\\f102";
}
.fa-paperclip {
  --fa: "\\f0c6";
}
.fa-arrow-right-to-city {
  --fa: "\\e4b3";
}
.fa-ribbon {
  --fa: "\\f4d6";
}
.fa-lungs {
  --fa: "\\f604";
}
.fa-arrow-up-9-1 {
  --fa: "\\f887";
}
.fa-sort-numeric-up-alt {
  --fa: "\\f887";
}
.fa-litecoin-sign {
  --fa: "\\e1d3";
}
.fa-border-none {
  --fa: "\\f850";
}
.fa-circle-nodes {
  --fa: "\\e4e2";
}
.fa-parachute-box {
  --fa: "\\f4cd";
}
.fa-indent {
  --fa: "\\f03c";
}
.fa-truck-field-un {
  --fa: "\\e58e";
}
.fa-hourglass {
  --fa: "\\f254";
}
.fa-hourglass-empty {
  --fa: "\\f254";
}
.fa-mountain {
  --fa: "\\f6fc";
}
.fa-user-doctor {
  --fa: "\\f0f0";
}
.fa-user-md {
  --fa: "\\f0f0";
}
.fa-circle-info {
  --fa: "\\f05a";
}
.fa-info-circle {
  --fa: "\\f05a";
}
.fa-cloud-meatball {
  --fa: "\\f73b";
}
.fa-camera {
  --fa: "\\f030";
}
.fa-camera-alt {
  --fa: "\\f030";
}
.fa-square-virus {
  --fa: "\\e578";
}
.fa-meteor {
  --fa: "\\f753";
}
.fa-car-on {
  --fa: "\\e4dd";
}
.fa-sleigh {
  --fa: "\\f7cc";
}
.fa-arrow-down-1-9 {
  --fa: "\\f162";
}
.fa-sort-numeric-asc {
  --fa: "\\f162";
}
.fa-sort-numeric-down {
  --fa: "\\f162";
}
.fa-hand-holding-droplet {
  --fa: "\\f4c1";
}
.fa-hand-holding-water {
  --fa: "\\f4c1";
}
.fa-water {
  --fa: "\\f773";
}
.fa-calendar-check {
  --fa: "\\f274";
}
.fa-braille {
  --fa: "\\f2a1";
}
.fa-prescription-bottle-medical {
  --fa: "\\f486";
}
.fa-prescription-bottle-alt {
  --fa: "\\f486";
}
.fa-landmark {
  --fa: "\\f66f";
}
.fa-truck {
  --fa: "\\f0d1";
}
.fa-crosshairs {
  --fa: "\\f05b";
}
.fa-person-cane {
  --fa: "\\e53c";
}
.fa-tent {
  --fa: "\\e57d";
}
.fa-vest-patches {
  --fa: "\\e086";
}
.fa-check-double {
  --fa: "\\f560";
}
.fa-arrow-down-a-z {
  --fa: "\\f15d";
}
.fa-sort-alpha-asc {
  --fa: "\\f15d";
}
.fa-sort-alpha-down {
  --fa: "\\f15d";
}
.fa-money-bill-wheat {
  --fa: "\\e52a";
}
.fa-cookie {
  --fa: "\\f563";
}
.fa-arrow-rotate-left {
  --fa: "\\f0e2";
}
.fa-arrow-left-rotate {
  --fa: "\\f0e2";
}
.fa-arrow-rotate-back {
  --fa: "\\f0e2";
}
.fa-arrow-rotate-backward {
  --fa: "\\f0e2";
}
.fa-undo {
  --fa: "\\f0e2";
}
.fa-hard-drive {
  --fa: "\\f0a0";
}
.fa-hdd {
  --fa: "\\f0a0";
}
.fa-face-grin-squint-tears {
  --fa: "\\f586";
}
.fa-grin-squint-tears {
  --fa: "\\f586";
}
.fa-dumbbell {
  --fa: "\\f44b";
}
.fa-rectangle-list {
  --fa: "\\f022";
}
.fa-list-alt {
  --fa: "\\f022";
}
.fa-tarp-droplet {
  --fa: "\\e57c";
}
.fa-house-medical-circle-check {
  --fa: "\\e511";
}
.fa-person-skiing-nordic {
  --fa: "\\f7ca";
}
.fa-skiing-nordic {
  --fa: "\\f7ca";
}
.fa-calendar-plus {
  --fa: "\\f271";
}
.fa-plane-arrival {
  --fa: "\\f5af";
}
.fa-circle-left {
  --fa: "\\f359";
}
.fa-arrow-alt-circle-left {
  --fa: "\\f359";
}
.fa-train-subway {
  --fa: "\\f239";
}
.fa-subway {
  --fa: "\\f239";
}
.fa-chart-gantt {
  --fa: "\\e0e4";
}
.fa-indian-rupee-sign {
  --fa: "\\e1bc";
}
.fa-indian-rupee {
  --fa: "\\e1bc";
}
.fa-inr {
  --fa: "\\e1bc";
}
.fa-crop-simple {
  --fa: "\\f565";
}
.fa-crop-alt {
  --fa: "\\f565";
}
.fa-money-bill-1 {
  --fa: "\\f3d1";
}
.fa-money-bill-alt {
  --fa: "\\f3d1";
}
.fa-left-long {
  --fa: "\\f30a";
}
.fa-long-arrow-alt-left {
  --fa: "\\f30a";
}
.fa-dna {
  --fa: "\\f471";
}
.fa-virus-slash {
  --fa: "\\e075";
}
.fa-minus {
  --fa: "\\f068";
}
.fa-subtract {
  --fa: "\\f068";
}
.fa-chess {
  --fa: "\\f439";
}
.fa-arrow-left-long {
  --fa: "\\f177";
}
.fa-long-arrow-left {
  --fa: "\\f177";
}
.fa-plug-circle-check {
  --fa: "\\e55c";
}
.fa-street-view {
  --fa: "\\f21d";
}
.fa-franc-sign {
  --fa: "\\e18f";
}
.fa-volume-off {
  --fa: "\\f026";
}
.fa-hands-asl-interpreting {
  --fa: "\\f2a3";
}
.fa-american-sign-language-interpreting {
  --fa: "\\f2a3";
}
.fa-asl-interpreting {
  --fa: "\\f2a3";
}
.fa-hands-american-sign-language-interpreting {
  --fa: "\\f2a3";
}
.fa-gear {
  --fa: "\\f013";
}
.fa-cog {
  --fa: "\\f013";
}
.fa-droplet-slash {
  --fa: "\\f5c7";
}
.fa-tint-slash {
  --fa: "\\f5c7";
}
.fa-mosque {
  --fa: "\\f678";
}
.fa-mosquito {
  --fa: "\\e52b";
}
.fa-star-of-david {
  --fa: "\\f69a";
}
.fa-person-military-rifle {
  --fa: "\\e54b";
}
.fa-cart-shopping {
  --fa: "\\f07a";
}
.fa-shopping-cart {
  --fa: "\\f07a";
}
.fa-vials {
  --fa: "\\f493";
}
.fa-plug-circle-plus {
  --fa: "\\e55f";
}
.fa-place-of-worship {
  --fa: "\\f67f";
}
.fa-grip-vertical {
  --fa: "\\f58e";
}
.fa-hexagon-nodes {
  --fa: "\\e699";
}
.fa-arrow-turn-up {
  --fa: "\\f148";
}
.fa-level-up {
  --fa: "\\f148";
}
.fa-u {
  --fa: "\\55";
}
.fa-square-root-variable {
  --fa: "\\f698";
}
.fa-square-root-alt {
  --fa: "\\f698";
}
.fa-clock {
  --fa: "\\f017";
}
.fa-clock-four {
  --fa: "\\f017";
}
.fa-backward-step {
  --fa: "\\f048";
}
.fa-step-backward {
  --fa: "\\f048";
}
.fa-pallet {
  --fa: "\\f482";
}
.fa-faucet {
  --fa: "\\e005";
}
.fa-baseball-bat-ball {
  --fa: "\\f432";
}
.fa-s {
  --fa: "\\53";
}
.fa-timeline {
  --fa: "\\e29c";
}
.fa-keyboard {
  --fa: "\\f11c";
}
.fa-caret-down {
  --fa: "\\f0d7";
}
.fa-house-chimney-medical {
  --fa: "\\f7f2";
}
.fa-clinic-medical {
  --fa: "\\f7f2";
}
.fa-temperature-three-quarters {
  --fa: "\\f2c8";
}
.fa-temperature-3 {
  --fa: "\\f2c8";
}
.fa-thermometer-3 {
  --fa: "\\f2c8";
}
.fa-thermometer-three-quarters {
  --fa: "\\f2c8";
}
.fa-mobile-screen {
  --fa: "\\f3cf";
}
.fa-mobile-android-alt {
  --fa: "\\f3cf";
}
.fa-plane-up {
  --fa: "\\e22d";
}
.fa-piggy-bank {
  --fa: "\\f4d3";
}
.fa-battery-half {
  --fa: "\\f242";
}
.fa-battery-3 {
  --fa: "\\f242";
}
.fa-mountain-city {
  --fa: "\\e52e";
}
.fa-coins {
  --fa: "\\f51e";
}
.fa-khanda {
  --fa: "\\f66d";
}
.fa-sliders {
  --fa: "\\f1de";
}
.fa-sliders-h {
  --fa: "\\f1de";
}
.fa-folder-tree {
  --fa: "\\f802";
}
.fa-network-wired {
  --fa: "\\f6ff";
}
.fa-map-pin {
  --fa: "\\f276";
}
.fa-hamsa {
  --fa: "\\f665";
}
.fa-cent-sign {
  --fa: "\\e3f5";
}
.fa-flask {
  --fa: "\\f0c3";
}
.fa-person-pregnant {
  --fa: "\\e31e";
}
.fa-wand-sparkles {
  --fa: "\\f72b";
}
.fa-ellipsis-vertical {
  --fa: "\\f142";
}
.fa-ellipsis-v {
  --fa: "\\f142";
}
.fa-ticket {
  --fa: "\\f145";
}
.fa-power-off {
  --fa: "\\f011";
}
.fa-right-long {
  --fa: "\\f30b";
}
.fa-long-arrow-alt-right {
  --fa: "\\f30b";
}
.fa-flag-usa {
  --fa: "\\f74d";
}
.fa-laptop-file {
  --fa: "\\e51d";
}
.fa-tty {
  --fa: "\\f1e4";
}
.fa-teletype {
  --fa: "\\f1e4";
}
.fa-diagram-next {
  --fa: "\\e476";
}
.fa-person-rifle {
  --fa: "\\e54e";
}
.fa-house-medical-circle-exclamation {
  --fa: "\\e512";
}
.fa-closed-captioning {
  --fa: "\\f20a";
}
.fa-person-hiking {
  --fa: "\\f6ec";
}
.fa-hiking {
  --fa: "\\f6ec";
}
.fa-venus-double {
  --fa: "\\f226";
}
.fa-images {
  --fa: "\\f302";
}
.fa-calculator {
  --fa: "\\f1ec";
}
.fa-people-pulling {
  --fa: "\\e535";
}
.fa-n {
  --fa: "\\4e";
}
.fa-cable-car {
  --fa: "\\f7da";
}
.fa-tram {
  --fa: "\\f7da";
}
.fa-cloud-rain {
  --fa: "\\f73d";
}
.fa-building-circle-xmark {
  --fa: "\\e4d4";
}
.fa-ship {
  --fa: "\\f21a";
}
.fa-arrows-down-to-line {
  --fa: "\\e4b8";
}
.fa-download {
  --fa: "\\f019";
}
.fa-face-grin {
  --fa: "\\f580";
}
.fa-grin {
  --fa: "\\f580";
}
.fa-delete-left {
  --fa: "\\f55a";
}
.fa-backspace {
  --fa: "\\f55a";
}
.fa-eye-dropper {
  --fa: "\\f1fb";
}
.fa-eye-dropper-empty {
  --fa: "\\f1fb";
}
.fa-eyedropper {
  --fa: "\\f1fb";
}
.fa-file-circle-check {
  --fa: "\\e5a0";
}
.fa-forward {
  --fa: "\\f04e";
}
.fa-mobile {
  --fa: "\\f3ce";
}
.fa-mobile-android {
  --fa: "\\f3ce";
}
.fa-mobile-phone {
  --fa: "\\f3ce";
}
.fa-face-meh {
  --fa: "\\f11a";
}
.fa-meh {
  --fa: "\\f11a";
}
.fa-align-center {
  --fa: "\\f037";
}
.fa-book-skull {
  --fa: "\\f6b7";
}
.fa-book-dead {
  --fa: "\\f6b7";
}
.fa-id-card {
  --fa: "\\f2c2";
}
.fa-drivers-license {
  --fa: "\\f2c2";
}
.fa-outdent {
  --fa: "\\f03b";
}
.fa-dedent {
  --fa: "\\f03b";
}
.fa-heart-circle-exclamation {
  --fa: "\\e4fe";
}
.fa-house {
  --fa: "\\f015";
}
.fa-home {
  --fa: "\\f015";
}
.fa-home-alt {
  --fa: "\\f015";
}
.fa-home-lg-alt {
  --fa: "\\f015";
}
.fa-calendar-week {
  --fa: "\\f784";
}
.fa-laptop-medical {
  --fa: "\\f812";
}
.fa-b {
  --fa: "\\42";
}
.fa-file-medical {
  --fa: "\\f477";
}
.fa-dice-one {
  --fa: "\\f525";
}
.fa-kiwi-bird {
  --fa: "\\f535";
}
.fa-arrow-right-arrow-left {
  --fa: "\\f0ec";
}
.fa-exchange {
  --fa: "\\f0ec";
}
.fa-rotate-right {
  --fa: "\\f2f9";
}
.fa-redo-alt {
  --fa: "\\f2f9";
}
.fa-rotate-forward {
  --fa: "\\f2f9";
}
.fa-utensils {
  --fa: "\\f2e7";
}
.fa-cutlery {
  --fa: "\\f2e7";
}
.fa-arrow-up-wide-short {
  --fa: "\\f161";
}
.fa-sort-amount-up {
  --fa: "\\f161";
}
.fa-mill-sign {
  --fa: "\\e1ed";
}
.fa-bowl-rice {
  --fa: "\\e2eb";
}
.fa-skull {
  --fa: "\\f54c";
}
.fa-tower-broadcast {
  --fa: "\\f519";
}
.fa-broadcast-tower {
  --fa: "\\f519";
}
.fa-truck-pickup {
  --fa: "\\f63c";
}
.fa-up-long {
  --fa: "\\f30c";
}
.fa-long-arrow-alt-up {
  --fa: "\\f30c";
}
.fa-stop {
  --fa: "\\f04d";
}
.fa-code-merge {
  --fa: "\\f387";
}
.fa-upload {
  --fa: "\\f093";
}
.fa-hurricane {
  --fa: "\\f751";
}
.fa-mound {
  --fa: "\\e52d";
}
.fa-toilet-portable {
  --fa: "\\e583";
}
.fa-compact-disc {
  --fa: "\\f51f";
}
.fa-file-arrow-down {
  --fa: "\\f56d";
}
.fa-file-download {
  --fa: "\\f56d";
}
.fa-caravan {
  --fa: "\\f8ff";
}
.fa-shield-cat {
  --fa: "\\e572";
}
.fa-bolt {
  --fa: "\\f0e7";
}
.fa-zap {
  --fa: "\\f0e7";
}
.fa-glass-water {
  --fa: "\\e4f4";
}
.fa-oil-well {
  --fa: "\\e532";
}
.fa-vault {
  --fa: "\\e2c5";
}
.fa-mars {
  --fa: "\\f222";
}
.fa-toilet {
  --fa: "\\f7d8";
}
.fa-plane-circle-xmark {
  --fa: "\\e557";
}
.fa-yen-sign {
  --fa: "\\f157";
}
.fa-cny {
  --fa: "\\f157";
}
.fa-jpy {
  --fa: "\\f157";
}
.fa-rmb {
  --fa: "\\f157";
}
.fa-yen {
  --fa: "\\f157";
}
.fa-ruble-sign {
  --fa: "\\f158";
}
.fa-rouble {
  --fa: "\\f158";
}
.fa-rub {
  --fa: "\\f158";
}
.fa-ruble {
  --fa: "\\f158";
}
.fa-sun {
  --fa: "\\f185";
}
.fa-guitar {
  --fa: "\\f7a6";
}
.fa-face-laugh-wink {
  --fa: "\\f59c";
}
.fa-laugh-wink {
  --fa: "\\f59c";
}
.fa-horse-head {
  --fa: "\\f7ab";
}
.fa-bore-hole {
  --fa: "\\e4c3";
}
.fa-industry {
  --fa: "\\f275";
}
.fa-circle-down {
  --fa: "\\f358";
}
.fa-arrow-alt-circle-down {
  --fa: "\\f358";
}
.fa-arrows-turn-to-dots {
  --fa: "\\e4c1";
}
.fa-florin-sign {
  --fa: "\\e184";
}
.fa-arrow-down-short-wide {
  --fa: "\\f884";
}
.fa-sort-amount-desc {
  --fa: "\\f884";
}
.fa-sort-amount-down-alt {
  --fa: "\\f884";
}
.fa-less-than {
  --fa: "\\3c";
}
.fa-angle-down {
  --fa: "\\f107";
}
.fa-car-tunnel {
  --fa: "\\e4de";
}
.fa-head-side-cough {
  --fa: "\\e061";
}
.fa-grip-lines {
  --fa: "\\f7a4";
}
.fa-thumbs-down {
  --fa: "\\f165";
}
.fa-user-lock {
  --fa: "\\f502";
}
.fa-arrow-right-long {
  --fa: "\\f178";
}
.fa-long-arrow-right {
  --fa: "\\f178";
}
.fa-anchor-circle-xmark {
  --fa: "\\e4ac";
}
.fa-ellipsis {
  --fa: "\\f141";
}
.fa-ellipsis-h {
  --fa: "\\f141";
}
.fa-chess-pawn {
  --fa: "\\f443";
}
.fa-kit-medical {
  --fa: "\\f479";
}
.fa-first-aid {
  --fa: "\\f479";
}
.fa-person-through-window {
  --fa: "\\e5a9";
}
.fa-toolbox {
  --fa: "\\f552";
}
.fa-hands-holding-circle {
  --fa: "\\e4fb";
}
.fa-bug {
  --fa: "\\f188";
}
.fa-credit-card {
  --fa: "\\f09d";
}
.fa-credit-card-alt {
  --fa: "\\f09d";
}
.fa-car {
  --fa: "\\f1b9";
}
.fa-automobile {
  --fa: "\\f1b9";
}
.fa-hand-holding-hand {
  --fa: "\\e4f7";
}
.fa-book-open-reader {
  --fa: "\\f5da";
}
.fa-book-reader {
  --fa: "\\f5da";
}
.fa-mountain-sun {
  --fa: "\\e52f";
}
.fa-arrows-left-right-to-line {
  --fa: "\\e4ba";
}
.fa-dice-d20 {
  --fa: "\\f6cf";
}
.fa-truck-droplet {
  --fa: "\\e58c";
}
.fa-file-circle-xmark {
  --fa: "\\e5a1";
}
.fa-temperature-arrow-up {
  --fa: "\\e040";
}
.fa-temperature-up {
  --fa: "\\e040";
}
.fa-medal {
  --fa: "\\f5a2";
}
.fa-bed {
  --fa: "\\f236";
}
.fa-square-h {
  --fa: "\\f0fd";
}
.fa-h-square {
  --fa: "\\f0fd";
}
.fa-podcast {
  --fa: "\\f2ce";
}
.fa-temperature-full {
  --fa: "\\f2c7";
}
.fa-temperature-4 {
  --fa: "\\f2c7";
}
.fa-thermometer-4 {
  --fa: "\\f2c7";
}
.fa-thermometer-full {
  --fa: "\\f2c7";
}
.fa-bell {
  --fa: "\\f0f3";
}
.fa-superscript {
  --fa: "\\f12b";
}
.fa-plug-circle-xmark {
  --fa: "\\e560";
}
.fa-star-of-life {
  --fa: "\\f621";
}
.fa-phone-slash {
  --fa: "\\f3dd";
}
.fa-paint-roller {
  --fa: "\\f5aa";
}
.fa-handshake-angle {
  --fa: "\\f4c4";
}
.fa-hands-helping {
  --fa: "\\f4c4";
}
.fa-location-dot {
  --fa: "\\f3c5";
}
.fa-map-marker-alt {
  --fa: "\\f3c5";
}
.fa-file {
  --fa: "\\f15b";
}
.fa-greater-than {
  --fa: "\\3e";
}
.fa-person-swimming {
  --fa: "\\f5c4";
}
.fa-swimmer {
  --fa: "\\f5c4";
}
.fa-arrow-down {
  --fa: "\\f063";
}
.fa-droplet {
  --fa: "\\f043";
}
.fa-tint {
  --fa: "\\f043";
}
.fa-eraser {
  --fa: "\\f12d";
}
.fa-earth-americas {
  --fa: "\\f57d";
}
.fa-earth {
  --fa: "\\f57d";
}
.fa-earth-america {
  --fa: "\\f57d";
}
.fa-globe-americas {
  --fa: "\\f57d";
}
.fa-person-burst {
  --fa: "\\e53b";
}
.fa-dove {
  --fa: "\\f4ba";
}
.fa-battery-empty {
  --fa: "\\f244";
}
.fa-battery-0 {
  --fa: "\\f244";
}
.fa-socks {
  --fa: "\\f696";
}
.fa-inbox {
  --fa: "\\f01c";
}
.fa-section {
  --fa: "\\e447";
}
.fa-gauge-high {
  --fa: "\\f625";
}
.fa-tachometer-alt {
  --fa: "\\f625";
}
.fa-tachometer-alt-fast {
  --fa: "\\f625";
}
.fa-envelope-open-text {
  --fa: "\\f658";
}
.fa-hospital {
  --fa: "\\f0f8";
}
.fa-hospital-alt {
  --fa: "\\f0f8";
}
.fa-hospital-wide {
  --fa: "\\f0f8";
}
.fa-wine-bottle {
  --fa: "\\f72f";
}
.fa-chess-rook {
  --fa: "\\f447";
}
.fa-bars-staggered {
  --fa: "\\f550";
}
.fa-reorder {
  --fa: "\\f550";
}
.fa-stream {
  --fa: "\\f550";
}
.fa-dharmachakra {
  --fa: "\\f655";
}
.fa-hotdog {
  --fa: "\\f80f";
}
.fa-person-walking-with-cane {
  --fa: "\\f29d";
}
.fa-blind {
  --fa: "\\f29d";
}
.fa-drum {
  --fa: "\\f569";
}
.fa-ice-cream {
  --fa: "\\f810";
}
.fa-heart-circle-bolt {
  --fa: "\\e4fc";
}
.fa-fax {
  --fa: "\\f1ac";
}
.fa-paragraph {
  --fa: "\\f1dd";
}
.fa-check-to-slot {
  --fa: "\\f772";
}
.fa-vote-yea {
  --fa: "\\f772";
}
.fa-star-half {
  --fa: "\\f089";
}
.fa-boxes-stacked {
  --fa: "\\f468";
}
.fa-boxes {
  --fa: "\\f468";
}
.fa-boxes-alt {
  --fa: "\\f468";
}
.fa-link {
  --fa: "\\f0c1";
}
.fa-chain {
  --fa: "\\f0c1";
}
.fa-ear-listen {
  --fa: "\\f2a2";
}
.fa-assistive-listening-systems {
  --fa: "\\f2a2";
}
.fa-tree-city {
  --fa: "\\e587";
}
.fa-play {
  --fa: "\\f04b";
}
.fa-font {
  --fa: "\\f031";
}
.fa-table-cells-row-lock {
  --fa: "\\e67a";
}
.fa-rupiah-sign {
  --fa: "\\e23d";
}
.fa-magnifying-glass {
  --fa: "\\f002";
}
.fa-search {
  --fa: "\\f002";
}
.fa-table-tennis-paddle-ball {
  --fa: "\\f45d";
}
.fa-ping-pong-paddle-ball {
  --fa: "\\f45d";
}
.fa-table-tennis {
  --fa: "\\f45d";
}
.fa-person-dots-from-line {
  --fa: "\\f470";
}
.fa-diagnoses {
  --fa: "\\f470";
}
.fa-trash-can-arrow-up {
  --fa: "\\f82a";
}
.fa-trash-restore-alt {
  --fa: "\\f82a";
}
.fa-naira-sign {
  --fa: "\\e1f6";
}
.fa-cart-arrow-down {
  --fa: "\\f218";
}
.fa-walkie-talkie {
  --fa: "\\f8ef";
}
.fa-file-pen {
  --fa: "\\f31c";
}
.fa-file-edit {
  --fa: "\\f31c";
}
.fa-receipt {
  --fa: "\\f543";
}
.fa-square-pen {
  --fa: "\\f14b";
}
.fa-pen-square {
  --fa: "\\f14b";
}
.fa-pencil-square {
  --fa: "\\f14b";
}
.fa-suitcase-rolling {
  --fa: "\\f5c1";
}
.fa-person-circle-exclamation {
  --fa: "\\e53f";
}
.fa-chevron-down {
  --fa: "\\f078";
}
.fa-battery-full {
  --fa: "\\f240";
}
.fa-battery {
  --fa: "\\f240";
}
.fa-battery-5 {
  --fa: "\\f240";
}
.fa-skull-crossbones {
  --fa: "\\f714";
}
.fa-code-compare {
  --fa: "\\e13a";
}
.fa-list-ul {
  --fa: "\\f0ca";
}
.fa-list-dots {
  --fa: "\\f0ca";
}
.fa-school-lock {
  --fa: "\\e56f";
}
.fa-tower-cell {
  --fa: "\\e585";
}
.fa-down-long {
  --fa: "\\f309";
}
.fa-long-arrow-alt-down {
  --fa: "\\f309";
}
.fa-ranking-star {
  --fa: "\\e561";
}
.fa-chess-king {
  --fa: "\\f43f";
}
.fa-person-harassing {
  --fa: "\\e549";
}
.fa-brazilian-real-sign {
  --fa: "\\e46c";
}
.fa-landmark-dome {
  --fa: "\\f752";
}
.fa-landmark-alt {
  --fa: "\\f752";
}
.fa-arrow-up {
  --fa: "\\f062";
}
.fa-tv {
  --fa: "\\f26c";
}
.fa-television {
  --fa: "\\f26c";
}
.fa-tv-alt {
  --fa: "\\f26c";
}
.fa-shrimp {
  --fa: "\\e448";
}
.fa-list-check {
  --fa: "\\f0ae";
}
.fa-tasks {
  --fa: "\\f0ae";
}
.fa-jug-detergent {
  --fa: "\\e519";
}
.fa-circle-user {
  --fa: "\\f2bd";
}
.fa-user-circle {
  --fa: "\\f2bd";
}
.fa-user-shield {
  --fa: "\\f505";
}
.fa-wind {
  --fa: "\\f72e";
}
.fa-car-burst {
  --fa: "\\f5e1";
}
.fa-car-crash {
  --fa: "\\f5e1";
}
.fa-y {
  --fa: "\\59";
}
.fa-person-snowboarding {
  --fa: "\\f7ce";
}
.fa-snowboarding {
  --fa: "\\f7ce";
}
.fa-truck-fast {
  --fa: "\\f48b";
}
.fa-shipping-fast {
  --fa: "\\f48b";
}
.fa-fish {
  --fa: "\\f578";
}
.fa-user-graduate {
  --fa: "\\f501";
}
.fa-circle-half-stroke {
  --fa: "\\f042";
}
.fa-adjust {
  --fa: "\\f042";
}
.fa-clapperboard {
  --fa: "\\e131";
}
.fa-circle-radiation {
  --fa: "\\f7ba";
}
.fa-radiation-alt {
  --fa: "\\f7ba";
}
.fa-baseball {
  --fa: "\\f433";
}
.fa-baseball-ball {
  --fa: "\\f433";
}
.fa-jet-fighter-up {
  --fa: "\\e518";
}
.fa-diagram-project {
  --fa: "\\f542";
}
.fa-project-diagram {
  --fa: "\\f542";
}
.fa-copy {
  --fa: "\\f0c5";
}
.fa-volume-xmark {
  --fa: "\\f6a9";
}
.fa-volume-mute {
  --fa: "\\f6a9";
}
.fa-volume-times {
  --fa: "\\f6a9";
}
.fa-hand-sparkles {
  --fa: "\\e05d";
}
.fa-grip {
  --fa: "\\f58d";
}
.fa-grip-horizontal {
  --fa: "\\f58d";
}
.fa-share-from-square {
  --fa: "\\f14d";
}
.fa-share-square {
  --fa: "\\f14d";
}
.fa-child-combatant {
  --fa: "\\e4e0";
}
.fa-child-rifle {
  --fa: "\\e4e0";
}
.fa-gun {
  --fa: "\\e19b";
}
.fa-square-phone {
  --fa: "\\f098";
}
.fa-phone-square {
  --fa: "\\f098";
}
.fa-plus {
  --fa: "\\2b";
}
.fa-add {
  --fa: "\\2b";
}
.fa-expand {
  --fa: "\\f065";
}
.fa-computer {
  --fa: "\\e4e5";
}
.fa-xmark {
  --fa: "\\f00d";
}
.fa-close {
  --fa: "\\f00d";
}
.fa-multiply {
  --fa: "\\f00d";
}
.fa-remove {
  --fa: "\\f00d";
}
.fa-times {
  --fa: "\\f00d";
}
.fa-arrows-up-down-left-right {
  --fa: "\\f047";
}
.fa-arrows {
  --fa: "\\f047";
}
.fa-chalkboard-user {
  --fa: "\\f51c";
}
.fa-chalkboard-teacher {
  --fa: "\\f51c";
}
.fa-peso-sign {
  --fa: "\\e222";
}
.fa-building-shield {
  --fa: "\\e4d8";
}
.fa-baby {
  --fa: "\\f77c";
}
.fa-users-line {
  --fa: "\\e592";
}
.fa-quote-left {
  --fa: "\\f10d";
}
.fa-quote-left-alt {
  --fa: "\\f10d";
}
.fa-tractor {
  --fa: "\\f722";
}
.fa-trash-arrow-up {
  --fa: "\\f829";
}
.fa-trash-restore {
  --fa: "\\f829";
}
.fa-arrow-down-up-lock {
  --fa: "\\e4b0";
}
.fa-lines-leaning {
  --fa: "\\e51e";
}
.fa-ruler-combined {
  --fa: "\\f546";
}
.fa-copyright {
  --fa: "\\f1f9";
}
.fa-equals {
  --fa: "\\3d";
}
.fa-blender {
  --fa: "\\f517";
}
.fa-teeth {
  --fa: "\\f62e";
}
.fa-shekel-sign {
  --fa: "\\f20b";
}
.fa-ils {
  --fa: "\\f20b";
}
.fa-shekel {
  --fa: "\\f20b";
}
.fa-sheqel {
  --fa: "\\f20b";
}
.fa-sheqel-sign {
  --fa: "\\f20b";
}
.fa-map {
  --fa: "\\f279";
}
.fa-rocket {
  --fa: "\\f135";
}
.fa-photo-film {
  --fa: "\\f87c";
}
.fa-photo-video {
  --fa: "\\f87c";
}
.fa-folder-minus {
  --fa: "\\f65d";
}
.fa-hexagon-nodes-bolt {
  --fa: "\\e69a";
}
.fa-store {
  --fa: "\\f54e";
}
.fa-arrow-trend-up {
  --fa: "\\e098";
}
.fa-plug-circle-minus {
  --fa: "\\e55e";
}
.fa-sign-hanging {
  --fa: "\\f4d9";
}
.fa-sign {
  --fa: "\\f4d9";
}
.fa-bezier-curve {
  --fa: "\\f55b";
}
.fa-bell-slash {
  --fa: "\\f1f6";
}
.fa-tablet {
  --fa: "\\f3fb";
}
.fa-tablet-android {
  --fa: "\\f3fb";
}
.fa-school-flag {
  --fa: "\\e56e";
}
.fa-fill {
  --fa: "\\f575";
}
.fa-angle-up {
  --fa: "\\f106";
}
.fa-drumstick-bite {
  --fa: "\\f6d7";
}
.fa-holly-berry {
  --fa: "\\f7aa";
}
.fa-chevron-left {
  --fa: "\\f053";
}
.fa-bacteria {
  --fa: "\\e059";
}
.fa-hand-lizard {
  --fa: "\\f258";
}
.fa-notdef {
  --fa: "\\e1fe";
}
.fa-disease {
  --fa: "\\f7fa";
}
.fa-briefcase-medical {
  --fa: "\\f469";
}
.fa-genderless {
  --fa: "\\f22d";
}
.fa-chevron-right {
  --fa: "\\f054";
}
.fa-retweet {
  --fa: "\\f079";
}
.fa-car-rear {
  --fa: "\\f5de";
}
.fa-car-alt {
  --fa: "\\f5de";
}
.fa-pump-soap {
  --fa: "\\e06b";
}
.fa-video-slash {
  --fa: "\\f4e2";
}
.fa-battery-quarter {
  --fa: "\\f243";
}
.fa-battery-2 {
  --fa: "\\f243";
}
.fa-radio {
  --fa: "\\f8d7";
}
.fa-baby-carriage {
  --fa: "\\f77d";
}
.fa-carriage-baby {
  --fa: "\\f77d";
}
.fa-traffic-light {
  --fa: "\\f637";
}
.fa-thermometer {
  --fa: "\\f491";
}
.fa-vr-cardboard {
  --fa: "\\f729";
}
.fa-hand-middle-finger {
  --fa: "\\f806";
}
.fa-percent {
  --fa: "\\25";
}
.fa-percentage {
  --fa: "\\25";
}
.fa-truck-moving {
  --fa: "\\f4df";
}
.fa-glass-water-droplet {
  --fa: "\\e4f5";
}
.fa-display {
  --fa: "\\e163";
}
.fa-face-smile {
  --fa: "\\f118";
}
.fa-smile {
  --fa: "\\f118";
}
.fa-thumbtack {
  --fa: "\\f08d";
}
.fa-thumb-tack {
  --fa: "\\f08d";
}
.fa-trophy {
  --fa: "\\f091";
}
.fa-person-praying {
  --fa: "\\f683";
}
.fa-pray {
  --fa: "\\f683";
}
.fa-hammer {
  --fa: "\\f6e3";
}
.fa-hand-peace {
  --fa: "\\f25b";
}
.fa-rotate {
  --fa: "\\f2f1";
}
.fa-sync-alt {
  --fa: "\\f2f1";
}
.fa-spinner {
  --fa: "\\f110";
}
.fa-robot {
  --fa: "\\f544";
}
.fa-peace {
  --fa: "\\f67c";
}
.fa-gears {
  --fa: "\\f085";
}
.fa-cogs {
  --fa: "\\f085";
}
.fa-warehouse {
  --fa: "\\f494";
}
.fa-arrow-up-right-dots {
  --fa: "\\e4b7";
}
.fa-splotch {
  --fa: "\\f5bc";
}
.fa-face-grin-hearts {
  --fa: "\\f584";
}
.fa-grin-hearts {
  --fa: "\\f584";
}
.fa-dice-four {
  --fa: "\\f524";
}
.fa-sim-card {
  --fa: "\\f7c4";
}
.fa-transgender {
  --fa: "\\f225";
}
.fa-transgender-alt {
  --fa: "\\f225";
}
.fa-mercury {
  --fa: "\\f223";
}
.fa-arrow-turn-down {
  --fa: "\\f149";
}
.fa-level-down {
  --fa: "\\f149";
}
.fa-person-falling-burst {
  --fa: "\\e547";
}
.fa-award {
  --fa: "\\f559";
}
.fa-ticket-simple {
  --fa: "\\f3ff";
}
.fa-ticket-alt {
  --fa: "\\f3ff";
}
.fa-building {
  --fa: "\\f1ad";
}
.fa-angles-left {
  --fa: "\\f100";
}
.fa-angle-double-left {
  --fa: "\\f100";
}
.fa-qrcode {
  --fa: "\\f029";
}
.fa-clock-rotate-left {
  --fa: "\\f1da";
}
.fa-history {
  --fa: "\\f1da";
}
.fa-face-grin-beam-sweat {
  --fa: "\\f583";
}
.fa-grin-beam-sweat {
  --fa: "\\f583";
}
.fa-file-export {
  --fa: "\\f56e";
}
.fa-arrow-right-from-file {
  --fa: "\\f56e";
}
.fa-shield {
  --fa: "\\f132";
}
.fa-shield-blank {
  --fa: "\\f132";
}
.fa-arrow-up-short-wide {
  --fa: "\\f885";
}
.fa-sort-amount-up-alt {
  --fa: "\\f885";
}
.fa-comment-nodes {
  --fa: "\\e696";
}
.fa-house-medical {
  --fa: "\\e3b2";
}
.fa-golf-ball-tee {
  --fa: "\\f450";
}
.fa-golf-ball {
  --fa: "\\f450";
}
.fa-circle-chevron-left {
  --fa: "\\f137";
}
.fa-chevron-circle-left {
  --fa: "\\f137";
}
.fa-house-chimney-window {
  --fa: "\\e00d";
}
.fa-pen-nib {
  --fa: "\\f5ad";
}
.fa-tent-arrow-turn-left {
  --fa: "\\e580";
}
.fa-tents {
  --fa: "\\e582";
}
.fa-wand-magic {
  --fa: "\\f0d0";
}
.fa-magic {
  --fa: "\\f0d0";
}
.fa-dog {
  --fa: "\\f6d3";
}
.fa-carrot {
  --fa: "\\f787";
}
.fa-moon {
  --fa: "\\f186";
}
.fa-wine-glass-empty {
  --fa: "\\f5ce";
}
.fa-wine-glass-alt {
  --fa: "\\f5ce";
}
.fa-cheese {
  --fa: "\\f7ef";
}
.fa-yin-yang {
  --fa: "\\f6ad";
}
.fa-music {
  --fa: "\\f001";
}
.fa-code-commit {
  --fa: "\\f386";
}
.fa-temperature-low {
  --fa: "\\f76b";
}
.fa-person-biking {
  --fa: "\\f84a";
}
.fa-biking {
  --fa: "\\f84a";
}
.fa-broom {
  --fa: "\\f51a";
}
.fa-shield-heart {
  --fa: "\\e574";
}
.fa-gopuram {
  --fa: "\\f664";
}
.fa-earth-oceania {
  --fa: "\\e47b";
}
.fa-globe-oceania {
  --fa: "\\e47b";
}
.fa-square-xmark {
  --fa: "\\f2d3";
}
.fa-times-square {
  --fa: "\\f2d3";
}
.fa-xmark-square {
  --fa: "\\f2d3";
}
.fa-hashtag {
  --fa: "\\23";
}
.fa-up-right-and-down-left-from-center {
  --fa: "\\f424";
}
.fa-expand-alt {
  --fa: "\\f424";
}
.fa-oil-can {
  --fa: "\\f613";
}
.fa-t {
  --fa: "\\54";
}
.fa-hippo {
  --fa: "\\f6ed";
}
.fa-chart-column {
  --fa: "\\e0e3";
}
.fa-infinity {
  --fa: "\\f534";
}
.fa-vial-circle-check {
  --fa: "\\e596";
}
.fa-person-arrow-down-to-line {
  --fa: "\\e538";
}
.fa-voicemail {
  --fa: "\\f897";
}
.fa-fan {
  --fa: "\\f863";
}
.fa-person-walking-luggage {
  --fa: "\\e554";
}
.fa-up-down {
  --fa: "\\f338";
}
.fa-arrows-alt-v {
  --fa: "\\f338";
}
.fa-cloud-moon-rain {
  --fa: "\\f73c";
}
.fa-calendar {
  --fa: "\\f133";
}
.fa-trailer {
  --fa: "\\e041";
}
.fa-bahai {
  --fa: "\\f666";
}
.fa-haykal {
  --fa: "\\f666";
}
.fa-sd-card {
  --fa: "\\f7c2";
}
.fa-dragon {
  --fa: "\\f6d5";
}
.fa-shoe-prints {
  --fa: "\\f54b";
}
.fa-circle-plus {
  --fa: "\\f055";
}
.fa-plus-circle {
  --fa: "\\f055";
}
.fa-face-grin-tongue-wink {
  --fa: "\\f58b";
}
.fa-grin-tongue-wink {
  --fa: "\\f58b";
}
.fa-hand-holding {
  --fa: "\\f4bd";
}
.fa-plug-circle-exclamation {
  --fa: "\\e55d";
}
.fa-link-slash {
  --fa: "\\f127";
}
.fa-chain-broken {
  --fa: "\\f127";
}
.fa-chain-slash {
  --fa: "\\f127";
}
.fa-unlink {
  --fa: "\\f127";
}
.fa-clone {
  --fa: "\\f24d";
}
.fa-person-walking-arrow-loop-left {
  --fa: "\\e551";
}
.fa-arrow-up-z-a {
  --fa: "\\f882";
}
.fa-sort-alpha-up-alt {
  --fa: "\\f882";
}
.fa-fire-flame-curved {
  --fa: "\\f7e4";
}
.fa-fire-alt {
  --fa: "\\f7e4";
}
.fa-tornado {
  --fa: "\\f76f";
}
.fa-file-circle-plus {
  --fa: "\\e494";
}
.fa-book-quran {
  --fa: "\\f687";
}
.fa-quran {
  --fa: "\\f687";
}
.fa-anchor {
  --fa: "\\f13d";
}
.fa-border-all {
  --fa: "\\f84c";
}
.fa-face-angry {
  --fa: "\\f556";
}
.fa-angry {
  --fa: "\\f556";
}
.fa-cookie-bite {
  --fa: "\\f564";
}
.fa-arrow-trend-down {
  --fa: "\\e097";
}
.fa-rss {
  --fa: "\\f09e";
}
.fa-feed {
  --fa: "\\f09e";
}
.fa-draw-polygon {
  --fa: "\\f5ee";
}
.fa-scale-balanced {
  --fa: "\\f24e";
}
.fa-balance-scale {
  --fa: "\\f24e";
}
.fa-gauge-simple-high {
  --fa: "\\f62a";
}
.fa-tachometer {
  --fa: "\\f62a";
}
.fa-tachometer-fast {
  --fa: "\\f62a";
}
.fa-shower {
  --fa: "\\f2cc";
}
.fa-desktop {
  --fa: "\\f390";
}
.fa-desktop-alt {
  --fa: "\\f390";
}
.fa-m {
  --fa: "\\4d";
}
.fa-table-list {
  --fa: "\\f00b";
}
.fa-th-list {
  --fa: "\\f00b";
}
.fa-comment-sms {
  --fa: "\\f7cd";
}
.fa-sms {
  --fa: "\\f7cd";
}
.fa-book {
  --fa: "\\f02d";
}
.fa-user-plus {
  --fa: "\\f234";
}
.fa-check {
  --fa: "\\f00c";
}
.fa-battery-three-quarters {
  --fa: "\\f241";
}
.fa-battery-4 {
  --fa: "\\f241";
}
.fa-house-circle-check {
  --fa: "\\e509";
}
.fa-angle-left {
  --fa: "\\f104";
}
.fa-diagram-successor {
  --fa: "\\e47a";
}
.fa-truck-arrow-right {
  --fa: "\\e58b";
}
.fa-arrows-split-up-and-left {
  --fa: "\\e4bc";
}
.fa-hand-fist {
  --fa: "\\f6de";
}
.fa-fist-raised {
  --fa: "\\f6de";
}
.fa-cloud-moon {
  --fa: "\\f6c3";
}
.fa-briefcase {
  --fa: "\\f0b1";
}
.fa-person-falling {
  --fa: "\\e546";
}
.fa-image-portrait {
  --fa: "\\f3e0";
}
.fa-portrait {
  --fa: "\\f3e0";
}
.fa-user-tag {
  --fa: "\\f507";
}
.fa-rug {
  --fa: "\\e569";
}
.fa-earth-europe {
  --fa: "\\f7a2";
}
.fa-globe-europe {
  --fa: "\\f7a2";
}
.fa-cart-flatbed-suitcase {
  --fa: "\\f59d";
}
.fa-luggage-cart {
  --fa: "\\f59d";
}
.fa-rectangle-xmark {
  --fa: "\\f410";
}
.fa-rectangle-times {
  --fa: "\\f410";
}
.fa-times-rectangle {
  --fa: "\\f410";
}
.fa-window-close {
  --fa: "\\f410";
}
.fa-baht-sign {
  --fa: "\\e0ac";
}
.fa-book-open {
  --fa: "\\f518";
}
.fa-book-journal-whills {
  --fa: "\\f66a";
}
.fa-journal-whills {
  --fa: "\\f66a";
}
.fa-handcuffs {
  --fa: "\\e4f8";
}
.fa-triangle-exclamation {
  --fa: "\\f071";
}
.fa-exclamation-triangle {
  --fa: "\\f071";
}
.fa-warning {
  --fa: "\\f071";
}
.fa-database {
  --fa: "\\f1c0";
}
.fa-share {
  --fa: "\\f064";
}
.fa-mail-forward {
  --fa: "\\f064";
}
.fa-bottle-droplet {
  --fa: "\\e4c4";
}
.fa-mask-face {
  --fa: "\\e1d7";
}
.fa-hill-rockslide {
  --fa: "\\e508";
}
.fa-right-left {
  --fa: "\\f362";
}
.fa-exchange-alt {
  --fa: "\\f362";
}
.fa-paper-plane {
  --fa: "\\f1d8";
}
.fa-road-circle-exclamation {
  --fa: "\\e565";
}
.fa-dungeon {
  --fa: "\\f6d9";
}
.fa-align-right {
  --fa: "\\f038";
}
.fa-money-bill-1-wave {
  --fa: "\\f53b";
}
.fa-money-bill-wave-alt {
  --fa: "\\f53b";
}
.fa-life-ring {
  --fa: "\\f1cd";
}
.fa-hands {
  --fa: "\\f2a7";
}
.fa-sign-language {
  --fa: "\\f2a7";
}
.fa-signing {
  --fa: "\\f2a7";
}
.fa-calendar-day {
  --fa: "\\f783";
}
.fa-water-ladder {
  --fa: "\\f5c5";
}
.fa-ladder-water {
  --fa: "\\f5c5";
}
.fa-swimming-pool {
  --fa: "\\f5c5";
}
.fa-arrows-up-down {
  --fa: "\\f07d";
}
.fa-arrows-v {
  --fa: "\\f07d";
}
.fa-face-grimace {
  --fa: "\\f57f";
}
.fa-grimace {
  --fa: "\\f57f";
}
.fa-wheelchair-move {
  --fa: "\\e2ce";
}
.fa-wheelchair-alt {
  --fa: "\\e2ce";
}
.fa-turn-down {
  --fa: "\\f3be";
}
.fa-level-down-alt {
  --fa: "\\f3be";
}
.fa-person-walking-arrow-right {
  --fa: "\\e552";
}
.fa-square-envelope {
  --fa: "\\f199";
}
.fa-envelope-square {
  --fa: "\\f199";
}
.fa-dice {
  --fa: "\\f522";
}
.fa-bowling-ball {
  --fa: "\\f436";
}
.fa-brain {
  --fa: "\\f5dc";
}
.fa-bandage {
  --fa: "\\f462";
}
.fa-band-aid {
  --fa: "\\f462";
}
.fa-calendar-minus {
  --fa: "\\f272";
}
.fa-circle-xmark {
  --fa: "\\f057";
}
.fa-times-circle {
  --fa: "\\f057";
}
.fa-xmark-circle {
  --fa: "\\f057";
}
.fa-gifts {
  --fa: "\\f79c";
}
.fa-hotel {
  --fa: "\\f594";
}
.fa-earth-asia {
  --fa: "\\f57e";
}
.fa-globe-asia {
  --fa: "\\f57e";
}
.fa-id-card-clip {
  --fa: "\\f47f";
}
.fa-id-card-alt {
  --fa: "\\f47f";
}
.fa-magnifying-glass-plus {
  --fa: "\\f00e";
}
.fa-search-plus {
  --fa: "\\f00e";
}
.fa-thumbs-up {
  --fa: "\\f164";
}
.fa-user-clock {
  --fa: "\\f4fd";
}
.fa-hand-dots {
  --fa: "\\f461";
}
.fa-allergies {
  --fa: "\\f461";
}
.fa-file-invoice {
  --fa: "\\f570";
}
.fa-window-minimize {
  --fa: "\\f2d1";
}
.fa-mug-saucer {
  --fa: "\\f0f4";
}
.fa-coffee {
  --fa: "\\f0f4";
}
.fa-brush {
  --fa: "\\f55d";
}
.fa-file-half-dashed {
  --fa: "\\e698";
}
.fa-mask {
  --fa: "\\f6fa";
}
.fa-magnifying-glass-minus {
  --fa: "\\f010";
}
.fa-search-minus {
  --fa: "\\f010";
}
.fa-ruler-vertical {
  --fa: "\\f548";
}
.fa-user-large {
  --fa: "\\f406";
}
.fa-user-alt {
  --fa: "\\f406";
}
.fa-train-tram {
  --fa: "\\e5b4";
}
.fa-user-nurse {
  --fa: "\\f82f";
}
.fa-syringe {
  --fa: "\\f48e";
}
.fa-cloud-sun {
  --fa: "\\f6c4";
}
.fa-stopwatch-20 {
  --fa: "\\e06f";
}
.fa-square-full {
  --fa: "\\f45c";
}
.fa-magnet {
  --fa: "\\f076";
}
.fa-jar {
  --fa: "\\e516";
}
.fa-note-sticky {
  --fa: "\\f249";
}
.fa-sticky-note {
  --fa: "\\f249";
}
.fa-bug-slash {
  --fa: "\\e490";
}
.fa-arrow-up-from-water-pump {
  --fa: "\\e4b6";
}
.fa-bone {
  --fa: "\\f5d7";
}
.fa-table-cells-row-unlock {
  --fa: "\\e691";
}
.fa-user-injured {
  --fa: "\\f728";
}
.fa-face-sad-tear {
  --fa: "\\f5b4";
}
.fa-sad-tear {
  --fa: "\\f5b4";
}
.fa-plane {
  --fa: "\\f072";
}
.fa-tent-arrows-down {
  --fa: "\\e581";
}
.fa-exclamation {
  --fa: "\\21";
}
.fa-arrows-spin {
  --fa: "\\e4bb";
}
.fa-print {
  --fa: "\\f02f";
}
.fa-turkish-lira-sign {
  --fa: "\\e2bb";
}
.fa-try {
  --fa: "\\e2bb";
}
.fa-turkish-lira {
  --fa: "\\e2bb";
}
.fa-dollar-sign {
  --fa: "\\24";
}
.fa-dollar {
  --fa: "\\24";
}
.fa-usd {
  --fa: "\\24";
}
.fa-x {
  --fa: "\\58";
}
.fa-magnifying-glass-dollar {
  --fa: "\\f688";
}
.fa-search-dollar {
  --fa: "\\f688";
}
.fa-users-gear {
  --fa: "\\f509";
}
.fa-users-cog {
  --fa: "\\f509";
}
.fa-person-military-pointing {
  --fa: "\\e54a";
}
.fa-building-columns {
  --fa: "\\f19c";
}
.fa-bank {
  --fa: "\\f19c";
}
.fa-institution {
  --fa: "\\f19c";
}
.fa-museum {
  --fa: "\\f19c";
}
.fa-university {
  --fa: "\\f19c";
}
.fa-umbrella {
  --fa: "\\f0e9";
}
.fa-trowel {
  --fa: "\\e589";
}
.fa-d {
  --fa: "\\44";
}
.fa-stapler {
  --fa: "\\e5af";
}
.fa-masks-theater {
  --fa: "\\f630";
}
.fa-theater-masks {
  --fa: "\\f630";
}
.fa-kip-sign {
  --fa: "\\e1c4";
}
.fa-hand-point-left {
  --fa: "\\f0a5";
}
.fa-handshake-simple {
  --fa: "\\f4c6";
}
.fa-handshake-alt {
  --fa: "\\f4c6";
}
.fa-jet-fighter {
  --fa: "\\f0fb";
}
.fa-fighter-jet {
  --fa: "\\f0fb";
}
.fa-square-share-nodes {
  --fa: "\\f1e1";
}
.fa-share-alt-square {
  --fa: "\\f1e1";
}
.fa-barcode {
  --fa: "\\f02a";
}
.fa-plus-minus {
  --fa: "\\e43c";
}
.fa-video {
  --fa: "\\f03d";
}
.fa-video-camera {
  --fa: "\\f03d";
}
.fa-graduation-cap {
  --fa: "\\f19d";
}
.fa-mortar-board {
  --fa: "\\f19d";
}
.fa-hand-holding-medical {
  --fa: "\\e05c";
}
.fa-person-circle-check {
  --fa: "\\e53e";
}
.fa-turn-up {
  --fa: "\\f3bf";
}
.fa-level-up-alt {
  --fa: "\\f3bf";
}
.sr-only,
.fa-sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.sr-only-focusable:not(:focus),
.fa-sr-only-focusable:not(:focus) {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
:root,
:host {
  --fa-style-family-brands: 'Font Awesome 6 Brands';
  --fa-font-brands: normal 400 1em/1 'Font Awesome 6 Brands';
}
@font-face {
  font-family: 'Font Awesome 6 Brands';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
.fab,
.fa-brands {
  font-weight: 400;
}
.fa-monero {
  --fa: "\\f3d0";
}
.fa-hooli {
  --fa: "\\f427";
}
.fa-yelp {
  --fa: "\\f1e9";
}
.fa-cc-visa {
  --fa: "\\f1f0";
}
.fa-lastfm {
  --fa: "\\f202";
}
.fa-shopware {
  --fa: "\\f5b5";
}
.fa-creative-commons-nc {
  --fa: "\\f4e8";
}
.fa-aws {
  --fa: "\\f375";
}
.fa-redhat {
  --fa: "\\f7bc";
}
.fa-yoast {
  --fa: "\\f2b1";
}
.fa-cloudflare {
  --fa: "\\e07d";
}
.fa-ups {
  --fa: "\\f7e0";
}
.fa-pixiv {
  --fa: "\\e640";
}
.fa-wpexplorer {
  --fa: "\\f2de";
}
.fa-dyalog {
  --fa: "\\f399";
}
.fa-bity {
  --fa: "\\f37a";
}
.fa-stackpath {
  --fa: "\\f842";
}
.fa-buysellads {
  --fa: "\\f20d";
}
.fa-first-order {
  --fa: "\\f2b0";
}
.fa-modx {
  --fa: "\\f285";
}
.fa-guilded {
  --fa: "\\e07e";
}
.fa-vnv {
  --fa: "\\f40b";
}
.fa-square-js {
  --fa: "\\f3b9";
}
.fa-js-square {
  --fa: "\\f3b9";
}
.fa-microsoft {
  --fa: "\\f3ca";
}
.fa-qq {
  --fa: "\\f1d6";
}
.fa-orcid {
  --fa: "\\f8d2";
}
.fa-java {
  --fa: "\\f4e4";
}
.fa-invision {
  --fa: "\\f7b0";
}
.fa-creative-commons-pd-alt {
  --fa: "\\f4ed";
}
.fa-centercode {
  --fa: "\\f380";
}
.fa-glide-g {
  --fa: "\\f2a6";
}
.fa-drupal {
  --fa: "\\f1a9";
}
.fa-jxl {
  --fa: "\\e67b";
}
.fa-dart-lang {
  --fa: "\\e693";
}
.fa-hire-a-helper {
  --fa: "\\f3b0";
}
.fa-creative-commons-by {
  --fa: "\\f4e7";
}
.fa-unity {
  --fa: "\\e049";
}
.fa-whmcs {
  --fa: "\\f40d";
}
.fa-rocketchat {
  --fa: "\\f3e8";
}
.fa-vk {
  --fa: "\\f189";
}
.fa-untappd {
  --fa: "\\f405";
}
.fa-mailchimp {
  --fa: "\\f59e";
}
.fa-css3-alt {
  --fa: "\\f38b";
}
.fa-square-reddit {
  --fa: "\\f1a2";
}
.fa-reddit-square {
  --fa: "\\f1a2";
}
.fa-vimeo-v {
  --fa: "\\f27d";
}
.fa-contao {
  --fa: "\\f26d";
}
.fa-square-font-awesome {
  --fa: "\\e5ad";
}
.fa-deskpro {
  --fa: "\\f38f";
}
.fa-brave {
  --fa: "\\e63c";
}
.fa-sistrix {
  --fa: "\\f3ee";
}
.fa-square-instagram {
  --fa: "\\e055";
}
.fa-instagram-square {
  --fa: "\\e055";
}
.fa-battle-net {
  --fa: "\\f835";
}
.fa-the-red-yeti {
  --fa: "\\f69d";
}
.fa-square-hacker-news {
  --fa: "\\f3af";
}
.fa-hacker-news-square {
  --fa: "\\f3af";
}
.fa-edge {
  --fa: "\\f282";
}
.fa-threads {
  --fa: "\\e618";
}
.fa-napster {
  --fa: "\\f3d2";
}
.fa-square-snapchat {
  --fa: "\\f2ad";
}
.fa-snapchat-square {
  --fa: "\\f2ad";
}
.fa-google-plus-g {
  --fa: "\\f0d5";
}
.fa-artstation {
  --fa: "\\f77a";
}
.fa-markdown {
  --fa: "\\f60f";
}
.fa-sourcetree {
  --fa: "\\f7d3";
}
.fa-google-plus {
  --fa: "\\f2b3";
}
.fa-diaspora {
  --fa: "\\f791";
}
.fa-foursquare {
  --fa: "\\f180";
}
.fa-stack-overflow {
  --fa: "\\f16c";
}
.fa-github-alt {
  --fa: "\\f113";
}
.fa-phoenix-squadron {
  --fa: "\\f511";
}
.fa-pagelines {
  --fa: "\\f18c";
}
.fa-algolia {
  --fa: "\\f36c";
}
.fa-red-river {
  --fa: "\\f3e3";
}
.fa-creative-commons-sa {
  --fa: "\\f4ef";
}
.fa-safari {
  --fa: "\\f267";
}
.fa-google {
  --fa: "\\f1a0";
}
.fa-square-font-awesome-stroke {
  --fa: "\\f35c";
}
.fa-font-awesome-alt {
  --fa: "\\f35c";
}
.fa-atlassian {
  --fa: "\\f77b";
}
.fa-linkedin-in {
  --fa: "\\f0e1";
}
.fa-digital-ocean {
  --fa: "\\f391";
}
.fa-nimblr {
  --fa: "\\f5a8";
}
.fa-chromecast {
  --fa: "\\f838";
}
.fa-evernote {
  --fa: "\\f839";
}
.fa-hacker-news {
  --fa: "\\f1d4";
}
.fa-creative-commons-sampling {
  --fa: "\\f4f0";
}
.fa-adversal {
  --fa: "\\f36a";
}
.fa-creative-commons {
  --fa: "\\f25e";
}
.fa-watchman-monitoring {
  --fa: "\\e087";
}
.fa-fonticons {
  --fa: "\\f280";
}
.fa-weixin {
  --fa: "\\f1d7";
}
.fa-shirtsinbulk {
  --fa: "\\f214";
}
.fa-codepen {
  --fa: "\\f1cb";
}
.fa-git-alt {
  --fa: "\\f841";
}
.fa-lyft {
  --fa: "\\f3c3";
}
.fa-rev {
  --fa: "\\f5b2";
}
.fa-windows {
  --fa: "\\f17a";
}
.fa-wizards-of-the-coast {
  --fa: "\\f730";
}
.fa-square-viadeo {
  --fa: "\\f2aa";
}
.fa-viadeo-square {
  --fa: "\\f2aa";
}
.fa-meetup {
  --fa: "\\f2e0";
}
.fa-centos {
  --fa: "\\f789";
}
.fa-adn {
  --fa: "\\f170";
}
.fa-cloudsmith {
  --fa: "\\f384";
}
.fa-opensuse {
  --fa: "\\e62b";
}
.fa-pied-piper-alt {
  --fa: "\\f1a8";
}
.fa-square-dribbble {
  --fa: "\\f397";
}
.fa-dribbble-square {
  --fa: "\\f397";
}
.fa-codiepie {
  --fa: "\\f284";
}
.fa-node {
  --fa: "\\f419";
}
.fa-mix {
  --fa: "\\f3cb";
}
.fa-steam {
  --fa: "\\f1b6";
}
.fa-cc-apple-pay {
  --fa: "\\f416";
}
.fa-scribd {
  --fa: "\\f28a";
}
.fa-debian {
  --fa: "\\e60b";
}
.fa-openid {
  --fa: "\\f19b";
}
.fa-instalod {
  --fa: "\\e081";
}
.fa-files-pinwheel {
  --fa: "\\e69f";
}
.fa-expeditedssl {
  --fa: "\\f23e";
}
.fa-sellcast {
  --fa: "\\f2da";
}
.fa-square-twitter {
  --fa: "\\f081";
}
.fa-twitter-square {
  --fa: "\\f081";
}
.fa-r-project {
  --fa: "\\f4f7";
}
.fa-delicious {
  --fa: "\\f1a5";
}
.fa-freebsd {
  --fa: "\\f3a4";
}
.fa-vuejs {
  --fa: "\\f41f";
}
.fa-accusoft {
  --fa: "\\f369";
}
.fa-ioxhost {
  --fa: "\\f208";
}
.fa-fonticons-fi {
  --fa: "\\f3a2";
}
.fa-app-store {
  --fa: "\\f36f";
}
.fa-cc-mastercard {
  --fa: "\\f1f1";
}
.fa-itunes-note {
  --fa: "\\f3b5";
}
.fa-golang {
  --fa: "\\e40f";
}
.fa-kickstarter {
  --fa: "\\f3bb";
}
.fa-square-kickstarter {
  --fa: "\\f3bb";
}
.fa-grav {
  --fa: "\\f2d6";
}
.fa-weibo {
  --fa: "\\f18a";
}
.fa-uncharted {
  --fa: "\\e084";
}
.fa-firstdraft {
  --fa: "\\f3a1";
}
.fa-square-youtube {
  --fa: "\\f431";
}
.fa-youtube-square {
  --fa: "\\f431";
}
.fa-wikipedia-w {
  --fa: "\\f266";
}
.fa-wpressr {
  --fa: "\\f3e4";
}
.fa-rendact {
  --fa: "\\f3e4";
}
.fa-angellist {
  --fa: "\\f209";
}
.fa-galactic-republic {
  --fa: "\\f50c";
}
.fa-nfc-directional {
  --fa: "\\e530";
}
.fa-skype {
  --fa: "\\f17e";
}
.fa-joget {
  --fa: "\\f3b7";
}
.fa-fedora {
  --fa: "\\f798";
}
.fa-stripe-s {
  --fa: "\\f42a";
}
.fa-meta {
  --fa: "\\e49b";
}
.fa-laravel {
  --fa: "\\f3bd";
}
.fa-hotjar {
  --fa: "\\f3b1";
}
.fa-bluetooth-b {
  --fa: "\\f294";
}
.fa-square-letterboxd {
  --fa: "\\e62e";
}
.fa-sticker-mule {
  --fa: "\\f3f7";
}
.fa-creative-commons-zero {
  --fa: "\\f4f3";
}
.fa-hips {
  --fa: "\\f452";
}
.fa-css {
  --fa: "\\e6a2";
}
.fa-behance {
  --fa: "\\f1b4";
}
.fa-reddit {
  --fa: "\\f1a1";
}
.fa-discord {
  --fa: "\\f392";
}
.fa-chrome {
  --fa: "\\f268";
}
.fa-app-store-ios {
  --fa: "\\f370";
}
.fa-cc-discover {
  --fa: "\\f1f2";
}
.fa-wpbeginner {
  --fa: "\\f297";
}
.fa-confluence {
  --fa: "\\f78d";
}
.fa-shoelace {
  --fa: "\\e60c";
}
.fa-mdb {
  --fa: "\\f8ca";
}
.fa-dochub {
  --fa: "\\f394";
}
.fa-accessible-icon {
  --fa: "\\f368";
}
.fa-ebay {
  --fa: "\\f4f4";
}
.fa-amazon {
  --fa: "\\f270";
}
.fa-unsplash {
  --fa: "\\e07c";
}
.fa-yarn {
  --fa: "\\f7e3";
}
.fa-square-steam {
  --fa: "\\f1b7";
}
.fa-steam-square {
  --fa: "\\f1b7";
}
.fa-500px {
  --fa: "\\f26e";
}
.fa-square-vimeo {
  --fa: "\\f194";
}
.fa-vimeo-square {
  --fa: "\\f194";
}
.fa-asymmetrik {
  --fa: "\\f372";
}
.fa-font-awesome {
  --fa: "\\f2b4";
}
.fa-font-awesome-flag {
  --fa: "\\f2b4";
}
.fa-font-awesome-logo-full {
  --fa: "\\f2b4";
}
.fa-gratipay {
  --fa: "\\f184";
}
.fa-apple {
  --fa: "\\f179";
}
.fa-hive {
  --fa: "\\e07f";
}
.fa-gitkraken {
  --fa: "\\f3a6";
}
.fa-keybase {
  --fa: "\\f4f5";
}
.fa-apple-pay {
  --fa: "\\f415";
}
.fa-padlet {
  --fa: "\\e4a0";
}
.fa-amazon-pay {
  --fa: "\\f42c";
}
.fa-square-github {
  --fa: "\\f092";
}
.fa-github-square {
  --fa: "\\f092";
}
.fa-stumbleupon {
  --fa: "\\f1a4";
}
.fa-fedex {
  --fa: "\\f797";
}
.fa-phoenix-framework {
  --fa: "\\f3dc";
}
.fa-shopify {
  --fa: "\\e057";
}
.fa-neos {
  --fa: "\\f612";
}
.fa-square-threads {
  --fa: "\\e619";
}
.fa-hackerrank {
  --fa: "\\f5f7";
}
.fa-researchgate {
  --fa: "\\f4f8";
}
.fa-swift {
  --fa: "\\f8e1";
}
.fa-angular {
  --fa: "\\f420";
}
.fa-speakap {
  --fa: "\\f3f3";
}
.fa-angrycreative {
  --fa: "\\f36e";
}
.fa-y-combinator {
  --fa: "\\f23b";
}
.fa-empire {
  --fa: "\\f1d1";
}
.fa-envira {
  --fa: "\\f299";
}
.fa-google-scholar {
  --fa: "\\e63b";
}
.fa-square-gitlab {
  --fa: "\\e5ae";
}
.fa-gitlab-square {
  --fa: "\\e5ae";
}
.fa-studiovinari {
  --fa: "\\f3f8";
}
.fa-pied-piper {
  --fa: "\\f2ae";
}
.fa-wordpress {
  --fa: "\\f19a";
}
.fa-product-hunt {
  --fa: "\\f288";
}
.fa-firefox {
  --fa: "\\f269";
}
.fa-linode {
  --fa: "\\f2b8";
}
.fa-goodreads {
  --fa: "\\f3a8";
}
.fa-square-odnoklassniki {
  --fa: "\\f264";
}
.fa-odnoklassniki-square {
  --fa: "\\f264";
}
.fa-jsfiddle {
  --fa: "\\f1cc";
}
.fa-sith {
  --fa: "\\f512";
}
.fa-themeisle {
  --fa: "\\f2b2";
}
.fa-page4 {
  --fa: "\\f3d7";
}
.fa-hashnode {
  --fa: "\\e499";
}
.fa-react {
  --fa: "\\f41b";
}
.fa-cc-paypal {
  --fa: "\\f1f4";
}
.fa-squarespace {
  --fa: "\\f5be";
}
.fa-cc-stripe {
  --fa: "\\f1f5";
}
.fa-creative-commons-share {
  --fa: "\\f4f2";
}
.fa-bitcoin {
  --fa: "\\f379";
}
.fa-keycdn {
  --fa: "\\f3ba";
}
.fa-opera {
  --fa: "\\f26a";
}
.fa-itch-io {
  --fa: "\\f83a";
}
.fa-umbraco {
  --fa: "\\f8e8";
}
.fa-galactic-senate {
  --fa: "\\f50d";
}
.fa-ubuntu {
  --fa: "\\f7df";
}
.fa-draft2digital {
  --fa: "\\f396";
}
.fa-stripe {
  --fa: "\\f429";
}
.fa-houzz {
  --fa: "\\f27c";
}
.fa-gg {
  --fa: "\\f260";
}
.fa-dhl {
  --fa: "\\f790";
}
.fa-square-pinterest {
  --fa: "\\f0d3";
}
.fa-pinterest-square {
  --fa: "\\f0d3";
}
.fa-xing {
  --fa: "\\f168";
}
.fa-blackberry {
  --fa: "\\f37b";
}
.fa-creative-commons-pd {
  --fa: "\\f4ec";
}
.fa-playstation {
  --fa: "\\f3df";
}
.fa-quinscape {
  --fa: "\\f459";
}
.fa-less {
  --fa: "\\f41d";
}
.fa-blogger-b {
  --fa: "\\f37d";
}
.fa-opencart {
  --fa: "\\f23d";
}
.fa-vine {
  --fa: "\\f1ca";
}
.fa-signal-messenger {
  --fa: "\\e663";
}
.fa-paypal {
  --fa: "\\f1ed";
}
.fa-gitlab {
  --fa: "\\f296";
}
.fa-typo3 {
  --fa: "\\f42b";
}
.fa-reddit-alien {
  --fa: "\\f281";
}
.fa-yahoo {
  --fa: "\\f19e";
}
.fa-dailymotion {
  --fa: "\\e052";
}
.fa-affiliatetheme {
  --fa: "\\f36b";
}
.fa-pied-piper-pp {
  --fa: "\\f1a7";
}
.fa-bootstrap {
  --fa: "\\f836";
}
.fa-odnoklassniki {
  --fa: "\\f263";
}
.fa-nfc-symbol {
  --fa: "\\e531";
}
.fa-mintbit {
  --fa: "\\e62f";
}
.fa-ethereum {
  --fa: "\\f42e";
}
.fa-speaker-deck {
  --fa: "\\f83c";
}
.fa-creative-commons-nc-eu {
  --fa: "\\f4e9";
}
.fa-patreon {
  --fa: "\\f3d9";
}
.fa-avianex {
  --fa: "\\f374";
}
.fa-ello {
  --fa: "\\f5f1";
}
.fa-gofore {
  --fa: "\\f3a7";
}
.fa-bimobject {
  --fa: "\\f378";
}
.fa-brave-reverse {
  --fa: "\\e63d";
}
.fa-facebook-f {
  --fa: "\\f39e";
}
.fa-square-google-plus {
  --fa: "\\f0d4";
}
.fa-google-plus-square {
  --fa: "\\f0d4";
}
.fa-web-awesome {
  --fa: "\\e682";
}
.fa-mandalorian {
  --fa: "\\f50f";
}
.fa-first-order-alt {
  --fa: "\\f50a";
}
.fa-osi {
  --fa: "\\f41a";
}
.fa-google-wallet {
  --fa: "\\f1ee";
}
.fa-d-and-d-beyond {
  --fa: "\\f6ca";
}
.fa-periscope {
  --fa: "\\f3da";
}
.fa-fulcrum {
  --fa: "\\f50b";
}
.fa-cloudscale {
  --fa: "\\f383";
}
.fa-forumbee {
  --fa: "\\f211";
}
.fa-mizuni {
  --fa: "\\f3cc";
}
.fa-schlix {
  --fa: "\\f3ea";
}
.fa-square-xing {
  --fa: "\\f169";
}
.fa-xing-square {
  --fa: "\\f169";
}
.fa-bandcamp {
  --fa: "\\f2d5";
}
.fa-wpforms {
  --fa: "\\f298";
}
.fa-cloudversify {
  --fa: "\\f385";
}
.fa-usps {
  --fa: "\\f7e1";
}
.fa-megaport {
  --fa: "\\f5a3";
}
.fa-magento {
  --fa: "\\f3c4";
}
.fa-spotify {
  --fa: "\\f1bc";
}
.fa-optin-monster {
  --fa: "\\f23c";
}
.fa-fly {
  --fa: "\\f417";
}
.fa-square-bluesky {
  --fa: "\\e6a3";
}
.fa-aviato {
  --fa: "\\f421";
}
.fa-itunes {
  --fa: "\\f3b4";
}
.fa-cuttlefish {
  --fa: "\\f38c";
}
.fa-blogger {
  --fa: "\\f37c";
}
.fa-flickr {
  --fa: "\\f16e";
}
.fa-viber {
  --fa: "\\f409";
}
.fa-soundcloud {
  --fa: "\\f1be";
}
.fa-digg {
  --fa: "\\f1a6";
}
.fa-tencent-weibo {
  --fa: "\\f1d5";
}
.fa-letterboxd {
  --fa: "\\e62d";
}
.fa-symfony {
  --fa: "\\f83d";
}
.fa-maxcdn {
  --fa: "\\f136";
}
.fa-etsy {
  --fa: "\\f2d7";
}
.fa-facebook-messenger {
  --fa: "\\f39f";
}
.fa-audible {
  --fa: "\\f373";
}
.fa-think-peaks {
  --fa: "\\f731";
}
.fa-bilibili {
  --fa: "\\e3d9";
}
.fa-erlang {
  --fa: "\\f39d";
}
.fa-x-twitter {
  --fa: "\\e61b";
}
.fa-cotton-bureau {
  --fa: "\\f89e";
}
.fa-dashcube {
  --fa: "\\f210";
}
.fa-42-group {
  --fa: "\\e080";
}
.fa-innosoft {
  --fa: "\\e080";
}
.fa-stack-exchange {
  --fa: "\\f18d";
}
.fa-elementor {
  --fa: "\\f430";
}
.fa-square-pied-piper {
  --fa: "\\e01e";
}
.fa-pied-piper-square {
  --fa: "\\e01e";
}
.fa-creative-commons-nd {
  --fa: "\\f4eb";
}
.fa-palfed {
  --fa: "\\f3d8";
}
.fa-superpowers {
  --fa: "\\f2dd";
}
.fa-resolving {
  --fa: "\\f3e7";
}
.fa-xbox {
  --fa: "\\f412";
}
.fa-square-web-awesome-stroke {
  --fa: "\\e684";
}
.fa-searchengin {
  --fa: "\\f3eb";
}
.fa-tiktok {
  --fa: "\\e07b";
}
.fa-square-facebook {
  --fa: "\\f082";
}
.fa-facebook-square {
  --fa: "\\f082";
}
.fa-renren {
  --fa: "\\f18b";
}
.fa-linux {
  --fa: "\\f17c";
}
.fa-glide {
  --fa: "\\f2a5";
}
.fa-linkedin {
  --fa: "\\f08c";
}
.fa-hubspot {
  --fa: "\\f3b2";
}
.fa-deploydog {
  --fa: "\\f38e";
}
.fa-twitch {
  --fa: "\\f1e8";
}
.fa-flutter {
  --fa: "\\e694";
}
.fa-ravelry {
  --fa: "\\f2d9";
}
.fa-mixer {
  --fa: "\\e056";
}
.fa-square-lastfm {
  --fa: "\\f203";
}
.fa-lastfm-square {
  --fa: "\\f203";
}
.fa-vimeo {
  --fa: "\\f40a";
}
.fa-mendeley {
  --fa: "\\f7b3";
}
.fa-uniregistry {
  --fa: "\\f404";
}
.fa-figma {
  --fa: "\\f799";
}
.fa-creative-commons-remix {
  --fa: "\\f4ee";
}
.fa-cc-amazon-pay {
  --fa: "\\f42d";
}
.fa-dropbox {
  --fa: "\\f16b";
}
.fa-instagram {
  --fa: "\\f16d";
}
.fa-cmplid {
  --fa: "\\e360";
}
.fa-upwork {
  --fa: "\\e641";
}
.fa-facebook {
  --fa: "\\f09a";
}
.fa-gripfire {
  --fa: "\\f3ac";
}
.fa-jedi-order {
  --fa: "\\f50e";
}
.fa-uikit {
  --fa: "\\f403";
}
.fa-fort-awesome-alt {
  --fa: "\\f3a3";
}
.fa-phabricator {
  --fa: "\\f3db";
}
.fa-ussunnah {
  --fa: "\\f407";
}
.fa-earlybirds {
  --fa: "\\f39a";
}
.fa-trade-federation {
  --fa: "\\f513";
}
.fa-autoprefixer {
  --fa: "\\f41c";
}
.fa-whatsapp {
  --fa: "\\f232";
}
.fa-square-upwork {
  --fa: "\\e67c";
}
.fa-slideshare {
  --fa: "\\f1e7";
}
.fa-google-play {
  --fa: "\\f3ab";
}
.fa-viadeo {
  --fa: "\\f2a9";
}
.fa-line {
  --fa: "\\f3c0";
}
.fa-google-drive {
  --fa: "\\f3aa";
}
.fa-servicestack {
  --fa: "\\f3ec";
}
.fa-simplybuilt {
  --fa: "\\f215";
}
.fa-bitbucket {
  --fa: "\\f171";
}
.fa-imdb {
  --fa: "\\f2d8";
}
.fa-deezer {
  --fa: "\\e077";
}
.fa-raspberry-pi {
  --fa: "\\f7bb";
}
.fa-jira {
  --fa: "\\f7b1";
}
.fa-docker {
  --fa: "\\f395";
}
.fa-screenpal {
  --fa: "\\e570";
}
.fa-bluetooth {
  --fa: "\\f293";
}
.fa-gitter {
  --fa: "\\f426";
}
.fa-d-and-d {
  --fa: "\\f38d";
}
.fa-microblog {
  --fa: "\\e01a";
}
.fa-cc-diners-club {
  --fa: "\\f24c";
}
.fa-gg-circle {
  --fa: "\\f261";
}
.fa-pied-piper-hat {
  --fa: "\\f4e5";
}
.fa-kickstarter-k {
  --fa: "\\f3bc";
}
.fa-yandex {
  --fa: "\\f413";
}
.fa-readme {
  --fa: "\\f4d5";
}
.fa-html5 {
  --fa: "\\f13b";
}
.fa-sellsy {
  --fa: "\\f213";
}
.fa-square-web-awesome {
  --fa: "\\e683";
}
.fa-sass {
  --fa: "\\f41e";
}
.fa-wirsindhandwerk {
  --fa: "\\e2d0";
}
.fa-wsh {
  --fa: "\\e2d0";
}
.fa-buromobelexperte {
  --fa: "\\f37f";
}
.fa-salesforce {
  --fa: "\\f83b";
}
.fa-octopus-deploy {
  --fa: "\\e082";
}
.fa-medapps {
  --fa: "\\f3c6";
}
.fa-ns8 {
  --fa: "\\f3d5";
}
.fa-pinterest-p {
  --fa: "\\f231";
}
.fa-apper {
  --fa: "\\f371";
}
.fa-fort-awesome {
  --fa: "\\f286";
}
.fa-waze {
  --fa: "\\f83f";
}
.fa-bluesky {
  --fa: "\\e671";
}
.fa-cc-jcb {
  --fa: "\\f24b";
}
.fa-snapchat {
  --fa: "\\f2ab";
}
.fa-snapchat-ghost {
  --fa: "\\f2ab";
}
.fa-fantasy-flight-games {
  --fa: "\\f6dc";
}
.fa-rust {
  --fa: "\\e07a";
}
.fa-wix {
  --fa: "\\f5cf";
}
.fa-square-behance {
  --fa: "\\f1b5";
}
.fa-behance-square {
  --fa: "\\f1b5";
}
.fa-supple {
  --fa: "\\f3f9";
}
.fa-webflow {
  --fa: "\\e65c";
}
.fa-rebel {
  --fa: "\\f1d0";
}
.fa-css3 {
  --fa: "\\f13c";
}
.fa-staylinked {
  --fa: "\\f3f5";
}
.fa-kaggle {
  --fa: "\\f5fa";
}
.fa-space-awesome {
  --fa: "\\e5ac";
}
.fa-deviantart {
  --fa: "\\f1bd";
}
.fa-cpanel {
  --fa: "\\f388";
}
.fa-goodreads-g {
  --fa: "\\f3a9";
}
.fa-square-git {
  --fa: "\\f1d2";
}
.fa-git-square {
  --fa: "\\f1d2";
}
.fa-square-tumblr {
  --fa: "\\f174";
}
.fa-tumblr-square {
  --fa: "\\f174";
}
.fa-trello {
  --fa: "\\f181";
}
.fa-creative-commons-nc-jp {
  --fa: "\\f4ea";
}
.fa-get-pocket {
  --fa: "\\f265";
}
.fa-perbyte {
  --fa: "\\e083";
}
.fa-grunt {
  --fa: "\\f3ad";
}
.fa-weebly {
  --fa: "\\f5cc";
}
.fa-connectdevelop {
  --fa: "\\f20e";
}
.fa-leanpub {
  --fa: "\\f212";
}
.fa-black-tie {
  --fa: "\\f27e";
}
.fa-themeco {
  --fa: "\\f5c6";
}
.fa-python {
  --fa: "\\f3e2";
}
.fa-android {
  --fa: "\\f17b";
}
.fa-bots {
  --fa: "\\e340";
}
.fa-free-code-camp {
  --fa: "\\f2c5";
}
.fa-hornbill {
  --fa: "\\f592";
}
.fa-js {
  --fa: "\\f3b8";
}
.fa-ideal {
  --fa: "\\e013";
}
.fa-git {
  --fa: "\\f1d3";
}
.fa-dev {
  --fa: "\\f6cc";
}
.fa-sketch {
  --fa: "\\f7c6";
}
.fa-yandex-international {
  --fa: "\\f414";
}
.fa-cc-amex {
  --fa: "\\f1f3";
}
.fa-uber {
  --fa: "\\f402";
}
.fa-github {
  --fa: "\\f09b";
}
.fa-php {
  --fa: "\\f457";
}
.fa-alipay {
  --fa: "\\f642";
}
.fa-youtube {
  --fa: "\\f167";
}
.fa-skyatlas {
  --fa: "\\f216";
}
.fa-firefox-browser {
  --fa: "\\e007";
}
.fa-replyd {
  --fa: "\\f3e6";
}
.fa-suse {
  --fa: "\\f7d6";
}
.fa-jenkins {
  --fa: "\\f3b6";
}
.fa-twitter {
  --fa: "\\f099";
}
.fa-rockrms {
  --fa: "\\f3e9";
}
.fa-pinterest {
  --fa: "\\f0d2";
}
.fa-buffer {
  --fa: "\\f837";
}
.fa-npm {
  --fa: "\\f3d4";
}
.fa-yammer {
  --fa: "\\f840";
}
.fa-btc {
  --fa: "\\f15a";
}
.fa-dribbble {
  --fa: "\\f17d";
}
.fa-stumbleupon-circle {
  --fa: "\\f1a3";
}
.fa-internet-explorer {
  --fa: "\\f26b";
}
.fa-stubber {
  --fa: "\\e5c7";
}
.fa-telegram {
  --fa: "\\f2c6";
}
.fa-telegram-plane {
  --fa: "\\f2c6";
}
.fa-old-republic {
  --fa: "\\f510";
}
.fa-odysee {
  --fa: "\\e5c6";
}
.fa-square-whatsapp {
  --fa: "\\f40c";
}
.fa-whatsapp-square {
  --fa: "\\f40c";
}
.fa-node-js {
  --fa: "\\f3d3";
}
.fa-edge-legacy {
  --fa: "\\e078";
}
.fa-slack {
  --fa: "\\f198";
}
.fa-slack-hash {
  --fa: "\\f198";
}
.fa-medrt {
  --fa: "\\f3c8";
}
.fa-usb {
  --fa: "\\f287";
}
.fa-tumblr {
  --fa: "\\f173";
}
.fa-vaadin {
  --fa: "\\f408";
}
.fa-quora {
  --fa: "\\f2c4";
}
.fa-square-x-twitter {
  --fa: "\\e61a";
}
.fa-reacteurope {
  --fa: "\\f75d";
}
.fa-medium {
  --fa: "\\f23a";
}
.fa-medium-m {
  --fa: "\\f23a";
}
.fa-amilia {
  --fa: "\\f36d";
}
.fa-mixcloud {
  --fa: "\\f289";
}
.fa-flipboard {
  --fa: "\\f44d";
}
.fa-viacoin {
  --fa: "\\f237";
}
.fa-critical-role {
  --fa: "\\f6c9";
}
.fa-sitrox {
  --fa: "\\e44a";
}
.fa-discourse {
  --fa: "\\f393";
}
.fa-joomla {
  --fa: "\\f1aa";
}
.fa-mastodon {
  --fa: "\\f4f6";
}
.fa-airbnb {
  --fa: "\\f834";
}
.fa-wolf-pack-battalion {
  --fa: "\\f514";
}
.fa-buy-n-large {
  --fa: "\\f8a6";
}
.fa-gulp {
  --fa: "\\f3ae";
}
.fa-creative-commons-sampling-plus {
  --fa: "\\f4f1";
}
.fa-strava {
  --fa: "\\f428";
}
.fa-ember {
  --fa: "\\f423";
}
.fa-canadian-maple-leaf {
  --fa: "\\f785";
}
.fa-teamspeak {
  --fa: "\\f4f9";
}
.fa-pushed {
  --fa: "\\f3e1";
}
.fa-wordpress-simple {
  --fa: "\\f411";
}
.fa-nutritionix {
  --fa: "\\f3d6";
}
.fa-wodu {
  --fa: "\\e088";
}
.fa-google-pay {
  --fa: "\\e079";
}
.fa-intercom {
  --fa: "\\f7af";
}
.fa-zhihu {
  --fa: "\\f63f";
}
.fa-korvue {
  --fa: "\\f42f";
}
.fa-pix {
  --fa: "\\e43a";
}
.fa-steam-symbol {
  --fa: "\\f3f6";
}
:root,
:host {
  --fa-style-family-classic: 'Font Awesome 6 Free';
  --fa-font-regular: normal 400 1em/1 'Font Awesome 6 Free';
}
@font-face {
  font-family: 'Font Awesome 6 Free';
  font-style: normal;
  font-weight: 400;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
.far,
.fa-regular {
  font-weight: 400;
}
:root,
:host {
  --fa-style-family-classic: 'Font Awesome 6 Free';
  --fa-font-solid: normal 900 1em/1 'Font Awesome 6 Free';
}
@font-face {
  font-family: 'Font Awesome 6 Free';
  font-style: normal;
  font-weight: 900;
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
.fas,
.fa-solid {
  font-weight: 900;
}
@font-face {
  font-family: 'Font Awesome 5 Brands';
  font-display: block;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: 'Font Awesome 5 Free';
  font-display: block;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: 'Font Awesome 5 Free';
  font-display: block;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: 'FontAwesome';
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: 'FontAwesome';
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: 'FontAwesome';
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  unicode-range: U+F003, U+F006, U+F014, U+F016-F017, U+F01A-F01B, U+F01D, U+F022, U+F03E, U+F044, U+F046, U+F05C-F05D, U+F06E, U+F070, U+F087-F088, U+F08A, U+F094, U+F096-F097, U+F09D, U+F0A0, U+F0A2, U+F0A4-F0A7, U+F0C5, U+F0C7, U+F0E5-F0E6, U+F0EB, U+F0F6-F0F8, U+F10C, U+F114-F115, U+F118-F11A, U+F11C-F11D, U+F133, U+F147, U+F14E, U+F150-F152, U+F185-F186, U+F18E, U+F190-F192, U+F196, U+F1C1-F1C9, U+F1D9, U+F1DB, U+F1E3, U+F1EA, U+F1F7, U+F1F9, U+F20A, U+F247-F248, U+F24A, U+F24D, U+F255-F25B, U+F25D, U+F271-F274, U+F278, U+F27B, U+F28C, U+F28E, U+F29C, U+F2B5, U+F2B7, U+F2BA, U+F2BC, U+F2BE, U+F2C0-F2C1, U+F2C3, U+F2D0, U+F2D2, U+F2D4, U+F2DC;
}
@font-face {
  font-family: 'FontAwesome';
  font-display: block;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  unicode-range: U+F041, U+F047, U+F065-F066, U+F07D-F07E, U+F080, U+F08B, U+F08E, U+F090, U+F09A, U+F0AC, U+F0AE, U+F0B2, U+F0D0, U+F0D6, U+F0E4, U+F0EC, U+F10A-F10B, U+F123, U+F13E, U+F148-F149, U+F14C, U+F156, U+F15E, U+F160-F161, U+F163, U+F175-F178, U+F195, U+F1F8, U+F219, U+F27A;
}
html {
  font-size: 14px;
}
.text-larger {
  font-size: larger;
}
@media (min-width: 640px) {
  .text-larger\\@s {
    font-size: larger;
  }
}
@media (min-width: 960px) {
  html {
    font-size: 0.75rem;
  }
  .text-larger\\@m {
    font-size: larger;
  }
}
@media (min-width: 1200px) {
  .text-larger\\@l {
    font-size: larger;
  }
}
@media (min-width: 1600px) {
  html {
    font-size: 1rem;
  }
  .text-larger\\@xl {
    font-size: larger;
  }
}
.site-header {
  height: 70px;
}
.site-header .site-header-logo img {
  max-height: 60px;
  padding: 0;
  margin-left: 15px;
}
.site-header .site-header-logo h1 {
  display: inline-block;
  margin: 0;
  margin-left: 10px;
  color: #003768;
  font-size: 1.8em;
}
.site-header .uk-navbar-container:not(.uk-navbar-transparent) {
  background-color: #ffffff;
}
.site-header .uk-navbar-nav > li > a {
  min-height: 70px;
}
.site-header .icone-offcanvas {
  margin-left: 15px;
  margin-right: -5px;
}
.site-header .uk-offcanvas-bar .uk-navbar-dropdown-nav > li > a,
.site-header .uk-offcanvas-bar .uk-nav.uk-nav-parent-icon a {
  color: black;
}
.site-header .uk-offcanvas-bar .uk-navbar-nav > li > a {
  color: black;
}
.site-header .uk-offcanvas-bar .uk-nav-default .uk-nav-sub li.uk-active > a {
  color: black;
  background: #e1e1e1;
}
.site-header .site-header-usuario {
  margin-top: 20px;
}
.site-header .site-header-usuario .uk-subnav > * > :first-child {
  text-transform: none;
}
.site-header .site-header-usuario .uk-dropdown {
  padding: 10px 20px;
  min-width: 150px;
}
.site-header .site-header-usuario .uk-dropdown a {
  justify-content: flex-end;
  text-transform: none;
}
@media (max-width: 1199px) {
  .site-header {
    height: auto;
  }
  .site-header > nav > [uk-navbar] {
    gap: 8px;
  }
  .site-header .uk-navbar-left {
    flex-shrink: 0;
  }
  .site-header .site-header-usuario {
    flex: 1 1 0;
    min-width: 0;
    margin-top: 0;
    margin-right: 12px !important;
  }
  .site-header .site-header-usuario nav {
    width: 100%;
    min-width: 0;
  }
  .site-header .site-header-usuario .uk-subnav {
    margin: 0;
    gap: 8px;
    flex-wrap: nowrap;
    justify-content: flex-end;
  }
  .site-header .site-header-usuario .uk-subnav > li {
    min-width: 0;
    padding-left: 0;
  }
  .site-header .site-header-usuario .uk-subnav > li:last-child {
    flex: 0 1 auto;
  }
  .site-header .site-header-usuario .uk-subnav > li > a {
    display: block;
    white-space: normal;
    overflow-wrap: anywhere;
    text-align: right;
  }
  .site-header .site-header-usuario .uk-subnav > li > a .uk-icon {
    flex-shrink: 0;
  }
}
.side-menu {
  position: fixed;
  top: 70px;
  z-index: 999;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: thin;
  padding: 15px;
  transition: all 0.1s linear;
}
.side-menu .uk-nav-default,
.side-menu .uk-nav-default .uk-nav-sub {
  font-size: 14px;
}
.side-menu .uk-nav.uk-nav-divider > :not(.uk-nav-header,.uk-nav-divider) + :not(.uk-nav-header,.uk-nav-divider) {
  margin-top: 0;
  padding-top: 0;
  border-top: 1px solid #e5e5e5;
}
.side-menu .uk-nav .uk-nav-divider {
  margin-top: 0;
  padding-top: 0;
}
.side-menu .uk-nav-default > li > a,
.side-menu .uk-nav-default .uk-nav-sub a {
  color: black;
  line-height: 30px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.side-menu .uk-nav-default .uk-nav-sub a {
  padding-left: 10px;
}
.side-menu .uk-nav-default > li > a:hover,
.side-menu .uk-nav-default .uk-nav-sub a:hover {
  background-color: #e1e1e1;
}
.side-menu .uk-nav-default > li.uk-active > a,
.side-menu .uk-nav-default .uk-nav-sub li.uk-active > a {
  background-color: #003768;
  color: white;
}
.side-menu .uk-nav-default.uk-nav-divider.uk-nav {
  margin-top: 0;
  margin-bottom: 0;
}
.side-menu .uk-nav .uk-nav-divider {
  margin-bottom: 0;
}
.side-menu .uk-nav-sub.uk-nav {
  padding-left: 55px;
}
.side-menu .side-menu-icone {
  line-height: 20px;
}
.side-menu .side-menu-descricao {
  display: block;
  margin-left: 5px;
  text-overflow: ellipsis;
  line-height: 20px;
}
.side-menu .side-menu-icone-parent {
  display: block;
  line-height: 20px;
}
.side-menu .uk-nav-sub {
  display: block;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
}
.side-menu li > a {
  justify-content: left;
}
.side-menu .side-menu-logo {
  border-top: 1px solid #e5e5e5;
  display: none;
  margin-left: -15px;
  margin-top: 5px;
  padding: 20px;
  text-align: center;
}
.side-menu .side-menu-logo img {
  display: block;
  height: auto;
  margin: 0 auto;
  max-height: 180px;
  max-width: 100%;
  object-fit: contain;
}
.side-menu-fixed .side-menu .side-menu-logo {
  display: block;
}
@media (min-width: 1200px) {
  .side-menu-fixed .side-menu {
    width: 250px;
  }
  .side-menu-fixed .side-menu .side-menu-descricao {
    max-width: 150px;
  }
  .side-menu-fixed .side-menu-margin {
    margin-left: 250px;
  }
}
@media (min-width: 1600px) {
  .side-menu-fixed .side-menu {
    width: 250px;
  }
  .side-menu-fixed .side-menu .side-menu-descricao {
    max-width: 190px;
  }
  .side-menu-fixed .side-menu-margin {
    margin-left: 250px;
  }
}
.side-menu-auto .side-menu {
  width: 50px;
  transition: all 0.1s linear;
  text-align: center;
}
.side-menu-auto .side-menu .side-menu-descricao {
  display: none;
}
.side-menu-auto .side-menu .side-menu-icone-parent {
  display: none;
}
.side-menu-auto .side-menu .uk-nav-sub {
  display: none;
}
.side-menu-auto .side-menu li > a {
  justify-content: center;
}
.side-menu-auto .side-menu-margin {
  margin-left: 50px;
}
.side-menu-auto .side-menu:hover {
  text-align: left;
}
.side-menu-auto .side-menu:hover .side-menu-descricao {
  display: block;
}
.side-menu-auto .side-menu:hover .side-menu-icone-parent {
  display: block;
}
.side-menu-auto .side-menu:hover .uk-nav-sub {
  display: block;
}
.side-menu-auto .side-menu:hover li > a {
  justify-content: left;
}
.side-menu-auto .side-menu:hover .side-menu-logo {
  display: block;
}
.side-menu-auto .side-menu:hover .uk-nav-sub {
  display: block;
}
@media (min-width: 1200px) {
  .side-menu-auto .side-menu:hover {
    width: 250px;
  }
  .side-menu-auto .side-menu:hover .side-menu-descricao {
    max-width: 150px;
  }
}
@media (min-width: 1600px) {
  .side-menu-auto .side-menu:hover {
    width: 250px;
  }
  .side-menu-auto .side-menu:hover .side-menu-descricao {
    max-width: 190px;
  }
}
@media (max-width: 1199px) {
  .side-menu-margin {
    margin-left: 0 !important;
  }
}
@media (max-width: 960px) {
  .height-auto {
    height: auto;
  }
}
@media (min-width: 640px) {
  .margin-small-left\\@s {
    margin-left: 10px !important;
  }
  .margin-remove-top\\@s {
    margin-top: 0 !important;
  }
  .margin-remove\\@s {
    margin: 0 !important;
  }
}
@media (min-width: 960px) {
  .margin-remove-top\\@m {
    margin-top: 0 !important;
  }
  .margin-remove\\@m {
    margin: 0 !important;
  }
}
@media (min-width: 1200px) {
  .margin-remove-top\\@l {
    margin-top: 0 !important;
  }
  .margin-remove\\@l {
    margin: 0 !important;
  }
}
@media (min-width: 1600px) {
  .margin-remove-top\\@xl {
    margin-top: 0 !important;
  }
  .margin-remove\\@xl {
    margin: 0 !important;
  }
}
.padding-remove {
  padding: 0 0 0 0;
}
.padding-remove-top {
  padding-top: 0;
}
.padding-nano {
  padding: 5px 5px 5px 5px;
}
.padding-nano-top {
  padding: 5px 0 0 0;
}
.padding-nano-right {
  padding: 0 5px 0 0;
}
.padding-nano-bottom {
  padding: 0 0 5px 0;
}
.padding-nano-left {
  padding: 0 0 0 5px;
}
.padding-nano-vertical {
  padding: 5px 0;
}
.padding-nano-horizontal {
  padding: 0 5px;
}
.padding-micro {
  padding: 10px 10px 10px 10px;
}
.padding-micro-top {
  padding: 10px 0 0 0;
}
.padding-micro-right {
  padding: 0 10px 0 0;
}
.padding-micro-bottom {
  padding: 0 0 10px 0;
}
.padding-micro-left {
  padding: 0 0 0 10px;
}
.padding-micro-vertical {
  padding: 10px 0;
}
.padding-micro-horizontal {
  padding: 0 10px;
}
.padding-small {
  padding: 15px 15px 15px 15px;
}
.padding-small-top {
  padding: 15px 0 0 0;
}
.padding-small-right {
  padding: 0 15px 0 0;
}
.padding-small-bottom {
  padding: 0 0 15px 0;
}
.padding-small-left {
  padding: 0 0 0 15px;
}
.padding-small-vertical {
  padding: 15px 0;
}
.padding-small-horizontal {
  padding: 0 15px;
}
.padding-medium {
  padding: 30px 30px 30px 30px;
}
.padding-medium-top {
  padding: 30px 0 0 0;
}
.padding-medium-right {
  padding: 0 30px 0 0;
}
.padding-medium-bottom {
  padding: 0 0 30px 0;
}
.padding-medium-left {
  padding: 0 0 0 30px;
}
.padding-medium-vertical {
  padding: 30px 0;
}
.padding-medium-horizontal {
  padding: 0 30px;
}
.padding-large {
  padding: 50px 50px 50px 50px;
}
.padding-large-top {
  padding: 50px 0 0 0;
}
.padding-large-right {
  padding: 0 50px 0 0;
}
.padding-large-bottom {
  padding: 0 0 50px 0;
}
.padding-large-left {
  padding: 0 0 0 50px;
}
.padding-large-vertical {
  padding: 50px 0;
}
.padding-large-horizontal {
  padding: 0 50px;
}
.padding-letter-top {
  padding-top: 21px;
}
@media (min-width: 435px) {
  .padding-remove\\@xs {
    padding: 0 0 0 0;
  }
  .padding-nano\\@xs {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@xs {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@xs {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@xs {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@xs {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@xs {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@xs {
    padding: 0 5px;
  }
  .padding-micro\\@xs {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@xs {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@xs {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@xs {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@xs {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@xs {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@xs {
    padding: 0 10px;
  }
  .padding-small\\@xs {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@xs {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@xs {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@xs {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@xs {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@xs {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@xs {
    padding: 0 15px;
  }
  .padding-medium\\@xs {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@xs {
    padding: 30px 0 0 0;
  }
  .padding-medium-right\\@xs {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@xs {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@xs {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@xs {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@xs {
    padding: 0 30px;
  }
  .padding-large\\@xs {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@xs {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@xs {
    padding: 0 50px 0 0;
  }
  .padding-large-bottom\\@xs {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@xs {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@xs {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@xs {
    padding: 0 50px;
  }
}
@media (min-width: 640px) {
  .padding-remove\\@s {
    padding: 0 0 0 0;
  }
  .padding-nano\\@s {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@s {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@s {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@s {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@s {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@s {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@s {
    padding: 0 5px;
  }
  .padding-micro\\@s {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@s {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@s {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@s {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@s {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@s {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@s {
    padding: 0 10px;
  }
  .padding-small\\@s {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@s {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@s {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@s {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@s {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@s {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@s {
    padding: 0 15px;
  }
  .padding-medium\\@s {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@s {
    padding: 30px 0 0 0;
  }
  .padding-medium-right\\@s {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@s {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@s {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@s {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@s {
    padding: 0 30px;
  }
  .padding-large\\@s {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@s {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@s {
    padding: 0 50px 0 0;
  }
  .padding-large-bottom\\@s {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@s {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@s {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@s {
    padding: 0 50px;
  }
}
@media (min-width: 960px) {
  .padding-remove\\@m {
    padding: 0 0 0 0;
  }
  .padding-nano\\@m {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@m {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@m {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@m {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@m {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@m {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@m {
    padding: 0 5px;
  }
  .padding-micro\\@m {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@m {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@m {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@m {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@m {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@m {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@m {
    padding: 0 10px;
  }
  .padding-small\\@m {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@m {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@m {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@m {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@m {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@m {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@m {
    padding: 0 15px;
  }
  .padding-medium\\@m {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@m {
    padding: 30px 0 0 0;
  }
  .padding-medium-right\\@m {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@m {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@m {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@m {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@m {
    padding: 0 30px;
  }
  .padding-large\\@m {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@m {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@m {
    padding: 0 50px 0 0;
  }
  .padding-large-bottom\\@m {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@m {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@m {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@m {
    padding: 0 50px;
  }
  .padding-letter-top {
    padding-top: 18px;
  }
}
@media (min-width: 1200px) {
  .padding-remove\\@l {
    padding: 0 0 0 0;
  }
  .padding-nano\\@l {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@l {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@l {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@l {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@l {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@l {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@l {
    padding: 0 5px;
  }
  .padding-micro\\@l {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@l {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@l {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@l {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@l {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@l {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@l {
    padding: 0 10px;
  }
  .padding-small\\@l {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@l {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@l {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@l {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@l {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@l {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@l {
    padding: 0 15px;
  }
  .padding-medium\\@l {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@l {
    padding: 30px 0 0 0;
  }
  .padding-medium-right\\@l {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@l {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@l {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@l {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@l {
    padding: 0 30px;
  }
  .padding-large\\@l {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@l {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@l {
    padding: 0 50px 0 0;
  }
  .padding-large-bottom\\@l {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@l {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@l {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@l {
    padding: 0 50px;
  }
}
@media (min-width: 1600px) {
  .padding-remove\\@xl {
    padding: 0 0 0 0;
  }
  .padding-nano\\@xl {
    padding: 5px 5px 5px 5px;
  }
  .padding-nano-top\\@xl {
    padding: 5px 0 0 0;
  }
  .padding-nano-right\\@xl {
    padding: 0 5px 0 0;
  }
  .padding-nano-bottom\\@xl {
    padding: 0 0 5px 0;
  }
  .padding-nano-left\\@xl {
    padding: 0 0 0 5px;
  }
  .padding-nano-vertical\\@xl {
    padding: 5px 0;
  }
  .padding-nano-horizontal\\@xl {
    padding: 0 5px;
  }
  .padding-micro\\@xl {
    padding: 10px 10px 10px 10px;
  }
  .padding-micro-top\\@xl {
    padding: 10px 0 0 0;
  }
  .padding-micro-right\\@xl {
    padding: 0 10px 0 0;
  }
  .padding-micro-bottom\\@xl {
    padding: 0 0 10px 0;
  }
  .padding-micro-left\\@xl {
    padding: 0 0 0 10px;
  }
  .padding-micro-vertical\\@xl {
    padding: 10px 0;
  }
  .padding-micro-horizontal\\@xl {
    padding: 0 10px;
  }
  .padding-small\\@xl {
    padding: 15px 15px 15px 15px;
  }
  .padding-small-top\\@xl {
    padding: 15px 0 0 0;
  }
  .padding-small-right\\@xl {
    padding: 0 15px 0 0;
  }
  .padding-small-bottom\\@xl {
    padding: 0 0 15px 0;
  }
  .padding-small-left\\@xl {
    padding: 0 0 0 15px;
  }
  .padding-small-vertical\\@xl {
    padding: 15px 0;
  }
  .padding-small-horizontal\\@xl {
    padding: 0 15px;
  }
  .padding-medium\\@xl {
    padding: 30px 30px 30px 30px;
  }
  .padding-medium-top\\@xl {
    padding: 30px 0 0 0;
  }
  .padding-medium-right\\@xl {
    padding: 0 30px 0 0;
  }
  .padding-medium-bottom\\@xl {
    padding: 0 0 30px 0;
  }
  .padding-medium-left\\@xl {
    padding: 0 0 0 30px;
  }
  .padding-medium-vertical\\@xl {
    padding: 30px 0;
  }
  .padding-medium-horizontal\\@xl {
    padding: 0 30px;
  }
  .padding-large\\@xl {
    padding: 50px 50px 50px 50px;
  }
  .padding-large-top\\@xl {
    padding: 50px 0 0 0;
  }
  .padding-large-right\\@xl {
    padding: 0 50px 0 0;
  }
  .padding-large-bottom\\@xl {
    padding: 0 0 50px 0;
  }
  .padding-large-left\\@xl {
    padding: 0 0 0 50px;
  }
  .padding-large-vertical\\@xl {
    padding: 50px 0;
  }
  .padding-large-horizontal\\@xl {
    padding: 0 50px;
  }
  .padding-letter-top {
    padding-top: 24px;
  }
}
.switch-micro {
  width: 30px;
  height: 15px;
  position: relative;
  display: inline-block;
  border-radius: calc(15px / 2);
}
.switch-micro input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-micro .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: calc(15px / 2);
}
.switch-micro .slider:before {
  position: absolute;
  content: "";
  height: calc(15px - 8px);
  width: calc(15px - 8px);
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
.switch-micro input:checked + .slider {
  background-color: #10be2d;
}
.switch-micro input:focus + .slider {
  box-shadow: 0 0 1px #10be2d;
}
.switch-micro input:checked + .slider:before {
  transform: translateX(15px);
}
.switch-small {
  width: 40px;
  height: 20px;
  position: relative;
  display: inline-block;
  border-radius: calc(20px / 2);
}
.switch-small input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-small .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: calc(20px / 2);
}
.switch-small .slider:before {
  position: absolute;
  content: "";
  height: calc(20px - 8px);
  width: calc(20px - 8px);
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
.switch-small input:checked + .slider {
  background-color: #10be2d;
}
.switch-small input:focus + .slider {
  box-shadow: 0 0 1px #10be2d;
}
.switch-small input:checked + .slider:before {
  transform: translateX(20px);
}
.switch-medium {
  width: 60px;
  height: 34px;
  position: relative;
  display: inline-block;
  border-radius: calc(34px / 2);
}
.switch-medium input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-medium .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: calc(34px / 2);
}
.switch-medium .slider:before {
  position: absolute;
  content: "";
  height: calc(34px - 8px);
  width: calc(34px - 8px);
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
.switch-medium input:checked + .slider {
  background-color: #10be2d;
}
.switch-medium input:focus + .slider {
  box-shadow: 0 0 1px #10be2d;
}
.switch-medium input:checked + .slider:before {
  transform: translateX(26px);
}
.switch-large {
  width: 80px;
  height: 44px;
  position: relative;
  display: inline-block;
  border-radius: calc(44px / 2);
}
.switch-large input {
  opacity: 0;
  width: 0;
  height: 0;
}
.switch-large .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: calc(44px / 2);
}
.switch-large .slider:before {
  position: absolute;
  content: "";
  height: calc(44px - 8px);
  width: calc(44px - 8px);
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}
.switch-large input:checked + .slider {
  background-color: #10be2d;
}
.switch-large input:focus + .slider {
  box-shadow: 0 0 1px #10be2d;
}
.switch-large input:checked + .slider:before {
  transform: translateX(36px);
}
.width-small-medium {
  width: 200;
}
.width-micro {
  width: 100px;
}
.width-nano {
  width: 50px;
}
@media (min-width: 960px) {
  .width-large\\@m {
    width: 338px;
  }
  .width-medium\\@m {
    width: 225px;
  }
  .width-small-medium\\@m {
    width: 150px;
  }
  .width-small\\@m {
    width: 112px;
  }
  .width-micro\\@m {
    width: 75px;
  }
  .width-nano\\@m {
    width: 38px;
  }
}
@media (min-width: 1600px) {
  .width-large\\@m {
    width: 450px;
  }
  .width-medium\\@m {
    width: 300px;
  }
  .width-small-medium\\@m {
    width: 200px;
  }
  .width-small\\@m {
    width: 150px;
  }
  .width-micro\\@m {
    width: 100px;
  }
  .width-nano\\@m {
    width: 50px;
  }
}
.width-25 {
  width: 25px;
}
.width-50 {
  width: 50px;
}
.width-75 {
  width: 75px;
}
.width-100 {
  width: 100px;
}
.width-125 {
  width: 125px;
}
.width-150 {
  width: 150px;
}
.width-175 {
  width: 175px;
}
.width-185 {
  width: 185px;
}
.width-200 {
  width: 200px;
}
.width-250 {
  width: 250px;
}
.width-275 {
  width: 275px;
}
.width-300 {
  width: 300px;
}
.width-350 {
  width: 350px;
}
.width-400 {
  width: 400px;
}
@media (min-width: 640px) {
  .width-25\\@s {
    width: 25px;
  }
  .width-50\\@s {
    width: 50px;
  }
  .width-75\\@s {
    width: 75px;
  }
  .width-100\\@s {
    width: 100px;
  }
  .width-125\\@s {
    width: 125px;
  }
  .width-150\\@s {
    width: 150px;
  }
  .width-175\\@s {
    width: 175px;
  }
  .width-200\\@s {
    width: 200px;
  }
  .width-250\\@s {
    width: 250px;
  }
  .width-275\\@s {
    width: 275px;
  }
  .width-300\\@s {
    width: 300px;
  }
  .width-350\\@s {
    width: 350px;
  }
  .width-400\\@s {
    width: 400px;
  }
}
@media (min-width: 640px) {
  .width-25\\@s {
    width: 25px;
  }
  .width-50\\@s {
    width: 50px;
  }
  .width-75\\@s {
    width: 75px;
  }
  .width-100\\@s {
    width: 100px;
  }
  .width-125\\@s {
    width: 125px;
  }
  .width-150\\@s {
    width: 150px;
  }
  .width-175\\@s {
    width: 175px;
  }
  .width-185\\@s {
    width: 185px;
  }
  .width-200\\@s {
    width: 200px;
  }
  .width-250\\@s {
    width: 250px;
  }
  .width-300\\@s {
    width: 300px;
  }
}
@media (min-width: 960px) {
  .width-25\\@m {
    width: 25px;
  }
  .width-50\\@m {
    width: 50px;
  }
  .width-75\\@m {
    width: 75px;
  }
  .width-100\\@m {
    width: 100px;
  }
  .width-125\\@m {
    width: 125px;
  }
  .width-150\\@m {
    width: 150px;
  }
  .width-175\\@m {
    width: 175px;
  }
  .width-185\\@m {
    width: 185px;
  }
  .width-200\\@m {
    width: 200px;
  }
  .width-250\\@m {
    width: 250px;
  }
  .width-275\\@m {
    width: 275px;
  }
  .width-300\\@m {
    width: 300px;
  }
  .width-350\\@m {
    width: 350px;
  }
  .width-400\\@m {
    width: 400px;
  }
}
@media (min-width: 1200px) {
  .width-25\\@l {
    width: 25px;
  }
  .width-50\\@l {
    width: 50px;
  }
  .width-75\\@l {
    width: 75px;
  }
  .width-100\\@l {
    width: 100px;
  }
  .width-110\\@l {
    width: 110px;
  }
  .width-125\\@l {
    width: 125px;
  }
  .width-150\\@l {
    width: 150px;
  }
  .width-175\\@l {
    width: 175px;
  }
  .width-185\\@l {
    width: 185px;
  }
  .width-200\\@l {
    width: 200px;
  }
  .width-250\\@l {
    width: 250px;
  }
  .width-275\\@l {
    width: 275px;
  }
  .width-300\\@l {
    width: 300px;
  }
  .width-350\\@l {
    width: 350px;
  }
  .width-400\\@l {
    width: 400px;
  }
}
@media (min-width: 1600px) {
  .width-25\\@xl {
    width: 25px;
  }
  .width-50\\@xl {
    width: 50px;
  }
  .width-75\\@xl {
    width: 75px;
  }
  .width-100\\@xl {
    width: 100px;
  }
  .width-125\\@xl {
    width: 125px;
  }
  .width-150\\@xl {
    width: 150px;
  }
  .width-175\\@xl {
    width: 175px;
  }
  .width-185\\@xl {
    width: 185px;
  }
  .width-200\\@xl {
    width: 200px;
  }
  .width-250\\@xl {
    width: 250px;
  }
  .width-275\\@xl {
    width: 275px;
  }
  .width-300\\@xl {
    width: 300px;
  }
  .width-350\\@xl {
    width: 350px;
  }
  .width-400\\@xl {
    width: 400px;
  }
}
.width-12-12 {
  width: 100%;
}
.width-11-12 {
  width: 91.66666667%;
}
.width-10-12 {
  width: 83.33333333%;
}
.width-9-12 {
  width: 75%;
}
.width-8-12 {
  width: 66.66666667%;
}
.width-7-12 {
  width: 58.33333333%;
}
.width-6-12 {
  width: 50%;
}
.width-5-12 {
  width: 41.66666667%;
}
.width-4-12 {
  width: 33.33333333%;
}
.width-3-12 {
  width: 25%;
}
.width-2-12 {
  width: 16.66666667%;
}
.width-1-12 {
  width: 8.33333333%;
}
@media (min-width: 640px) {
  .width-12-12\\@s {
    width: 100%;
  }
  .width-11-12\\@s {
    width: 91.66666667%;
  }
  .width-10-12\\@s {
    width: 83.33333333%;
  }
  .width-9-12\\@s {
    width: 75%;
  }
  .width-8-12\\@s {
    width: 66.66666667%;
  }
  .width-7-12\\@s {
    width: 58.33333333%;
  }
  .width-6-12\\@s {
    width: 50%;
  }
  .width-5-12\\@s {
    width: 41.66666667%;
  }
  .width-4-12\\@s {
    width: 33.33333333%;
  }
  .width-3-12\\@s {
    width: 25%;
  }
  .width-2-12\\@s {
    width: 16.66666667%;
  }
  .width-1-12\\@s {
    width: 8.33333333%;
  }
}
@media (min-width: 960px) {
  .width-12-12\\@m {
    width: 100%;
  }
  .width-11-12\\@m {
    width: 91.66666667%;
  }
  .width-10-12\\@m {
    width: 83.33333333%;
  }
  .width-9-12\\@m {
    width: 75%;
  }
  .width-8-12\\@m {
    width: 66.66666667%;
  }
  .width-7-12\\@m {
    width: 58.33333333%;
  }
  .width-6-12\\@m {
    width: 50%;
  }
  .width-5-12\\@m {
    width: 41.66666667%;
  }
  .width-4-12\\@m {
    width: 33.33333333%;
  }
  .width-3-12\\@m {
    width: 25%;
  }
  .width-2-12\\@m {
    width: 16.66666667%;
  }
  .width-1-12\\@m {
    width: 8.33333333%;
  }
}
@media (min-width: 1200px) {
  .width-12-12\\@l {
    width: 100%;
  }
  .width-11-12\\@l {
    width: 91.66666667%;
  }
  .width-10-12\\@l {
    width: 83.33333333%;
  }
  .width-9-12\\@l {
    width: 75%;
  }
  .width-8-12\\@l {
    width: 66.66666667%;
  }
  .width-7-12\\@l {
    width: 58.33333333%;
  }
  .width-6-12\\@l {
    width: 50%;
  }
  .width-5-12\\@l {
    width: 41.66666667%;
  }
  .width-4-12\\@l {
    width: 33.33333333%;
  }
  .width-3-12\\@l {
    width: 25%;
  }
  .width-2-12\\@l {
    width: 16.66666667%;
  }
  .width-1-12\\@l {
    width: 8.33333333%;
  }
}
@media (min-width: 1600px) {
  .width-12-12\\@xl {
    width: 100%;
  }
  .width-11-12\\@xl {
    width: 91.66666667%;
  }
  .width-10-12\\@xl {
    width: 83.33333333%;
  }
  .width-9-12\\@xl {
    width: 75%;
  }
  .width-8-12\\@xl {
    width: 66.66666667%;
  }
  .width-7-12\\@xl {
    width: 58.33333333%;
  }
  .width-6-12\\@xl {
    width: 50%;
  }
  .width-5-12\\@xl {
    width: 41.66666667%;
  }
  .width-4-12\\@xl {
    width: 33.33333333%;
  }
  .width-3-12\\@xl {
    width: 25%;
  }
  .width-2-12\\@xl {
    width: 16.66666667%;
  }
  .width-1-12\\@xl {
    width: 8.33333333%;
  }
}
.width-20-20 {
  width: 100%;
}
.width-19-20 {
  width: 95%;
}
.width-18-20 {
  width: 90%;
}
.width-17-20 {
  width: 85%;
}
.width-16-20 {
  width: 80%;
}
.width-15-20 {
  width: 75%;
}
.width-14-20 {
  width: 70%;
}
.width-13-20 {
  width: 65%;
}
.width-12-20 {
  width: 60%;
}
.width-11-20 {
  width: 55%;
}
.width-10-20 {
  width: 50%;
}
.width-9-20 {
  width: 45%;
}
.width-8-20 {
  width: 40%;
}
.width-7-20 {
  width: 35%;
}
.width-6-20 {
  width: 30%;
}
.width-5-20 {
  width: 25%;
}
.width-4-20 {
  width: 20%;
}
.width-3-20 {
  width: 15%;
}
.width-2-20 {
  width: 10%;
}
.width-1-20 {
  width: 5%;
}
@media (min-width: 640px) {
  .width-20-20\\@s {
    width: 100%;
  }
  .width-19-20\\@s {
    width: 95%;
  }
  .width-18-20\\@s {
    width: 90%;
  }
  .width-17-20\\@s {
    width: 85%;
  }
  .width-16-20\\@s {
    width: 80%;
  }
  .width-15-20\\@s {
    width: 75%;
  }
  .width-14-20\\@s {
    width: 70%;
  }
  .width-13-20\\@s {
    width: 65%;
  }
  .width-12-20\\@s {
    width: 60%;
  }
  .width-11-20\\@s {
    width: 55%;
  }
  .width-10-20\\@s {
    width: 50%;
  }
  .width-9-20\\@s {
    width: 45%;
  }
  .width-8-20\\@s {
    width: 40%;
  }
  .width-7-20\\@s {
    width: 35%;
  }
  .width-6-20\\@s {
    width: 30%;
  }
  .width-5-20\\@s {
    width: 25%;
  }
  .width-4-20\\@s {
    width: 20%;
  }
  .width-3-20\\@s {
    width: 15%;
  }
  .width-2-20\\@s {
    width: 10%;
  }
  .width-1-20\\@s {
    width: 5%;
  }
}
@media (min-width: 960px) {
  .width-20-20\\@m {
    width: 100%;
  }
  .width-19-20\\@m {
    width: 95%;
  }
  .width-18-20\\@m {
    width: 90%;
  }
  .width-17-20\\@m {
    width: 85%;
  }
  .width-16-20\\@m {
    width: 80%;
  }
  .width-15-20\\@m {
    width: 75%;
  }
  .width-14-20\\@m {
    width: 70%;
  }
  .width-13-20\\@m {
    width: 65%;
  }
  .width-12-20\\@m {
    width: 60%;
  }
  .width-11-20\\@m {
    width: 55%;
  }
  .width-10-20\\@m {
    width: 50%;
  }
  .width-9-20\\@m {
    width: 45%;
  }
  .width-8-20\\@m {
    width: 40%;
  }
  .width-7-20\\@m {
    width: 35%;
  }
  .width-6-20\\@m {
    width: 30%;
  }
  .width-5-20\\@m {
    width: 25%;
  }
  .width-4-20\\@m {
    width: 20%;
  }
  .width-3-20\\@m {
    width: 15%;
  }
  .width-2-20\\@m {
    width: 10%;
  }
  .width-1-20\\@m {
    width: 5%;
  }
}
@media (min-width: 1200px) {
  .width-20-20\\@l {
    width: 100%;
  }
  .width-19-20\\@l {
    width: 95%;
  }
  .width-18-20\\@l {
    width: 90%;
  }
  .width-17-20\\@l {
    width: 85%;
  }
  .width-16-20\\@l {
    width: 80%;
  }
  .width-15-20\\@l {
    width: 75%;
  }
  .width-14-20\\@l {
    width: 70%;
  }
  .width-13-20\\@l {
    width: 65%;
  }
  .width-12-20\\@l {
    width: 60%;
  }
  .width-11-20\\@l {
    width: 55%;
  }
  .width-10-20\\@l {
    width: 50%;
  }
  .width-9-20\\@l {
    width: 45%;
  }
  .width-8-20\\@l {
    width: 40%;
  }
  .width-7-20\\@l {
    width: 35%;
  }
  .width-6-20\\@l {
    width: 30%;
  }
  .width-5-20\\@l {
    width: 25%;
  }
  .width-4-20\\@l {
    width: 20%;
  }
  .width-3-20\\@l {
    width: 15%;
  }
  .width-2-20\\@l {
    width: 10%;
  }
  .width-1-20\\@l {
    width: 5%;
  }
}
@media (min-width: 1600px) {
  .width-20-20\\@xl {
    width: 100%;
  }
  .width-19-20\\@xl {
    width: 95%;
  }
  .width-18-20\\@xl {
    width: 90%;
  }
  .width-17-20\\@xl {
    width: 85%;
  }
  .width-16-20\\@xl {
    width: 80%;
  }
  .width-15-20\\@xl {
    width: 75%;
  }
  .width-14-20\\@xl {
    width: 70%;
  }
  .width-13-20\\@xl {
    width: 65%;
  }
  .width-12-20\\@xl {
    width: 60%;
  }
  .width-11-20\\@xl {
    width: 55%;
  }
  .width-10-20\\@xl {
    width: 50%;
  }
  .width-9-20\\@xl {
    width: 45%;
  }
  .width-8-20\\@xl {
    width: 40%;
  }
  .width-7-20\\@xl {
    width: 35%;
  }
  .width-6-20\\@xl {
    width: 30%;
  }
  .width-5-20\\@xl {
    width: 25%;
  }
  .width-4-20\\@xl {
    width: 20%;
  }
  .width-3-20\\@xl {
    width: 15%;
  }
  .width-2-20\\@xl {
    width: 10%;
  }
  .width-1-20\\@xl {
    width: 5%;
  }
}
.botao-excel {
  background-color: #007F00 !important;
  white-space: nowrap;
  color: white !important;
}
.botao-excel:hover {
  background-color: #33a033 !important;
}
.botao-excel .icone-excel {
  display: inline-block;
  width: 17px !important;
  height: 17px !important;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) !important;
  margin-right: 5px;
  float: left;
}
.botao-pdf {
  background-color: #B30B00 !important;
  white-space: nowrap;
  color: white !important;
}
.botao-pdf:hover {
  background-color: #c7160a !important;
}
.botao-pdf .icone-pdf {
  font-size: 0.9em;
  margin-right: 2px;
}
.ghost {
  opacity: 0.4;
  background-color: #f0f0f0;
  border: 1px dashed #ccc;
}
.dragging {
  opacity: 0;
}
.button-ia {
  padding: 4px 6px !important;
  margin: 0 5px 2px 5px;
  font-size: 0.75rem !important;
  line-height: 1 !important;
  min-height: auto !important;
  border-radius: 3px !important;
  background-color: #222 !important;
  color: white;
  border: 1px solid transparent;
  opacity: 0.5;
}
.button-ia:hover {
  opacity: 1;
}
.button-ia {
  padding: 4px 6px !important;
  margin: 0 5px 2px 5px;
  font-size: 0.75rem !important;
  line-height: 1 !important;
  min-height: auto !important;
  border-radius: 3px !important;
  background-color: #222 !important;
  color: white;
  border: 1px solid transparent;
  opacity: 0.5;
}
.options-menu {
  max-width: 125px !important;
  min-width: 125px !important;
  width: 125px !important;
}
html {
  color: black;
}
body {
  background-color: #F2F2F2;
}
.uk-form-controls.error > .uk-icon {
  padding-bottom: 18px;
}
.banner-ambiente {
  position: fixed;
  top: 0;
  background-color: #003768;
  color: white;
  padding: 5px 10px;
  font-weight: bold;
  font-size: 12px;
  width: 25%;
  border-radius: 0 0 25px 25px;
}
.banner-ambiente .uk-icon {
  color: white;
}
@media (max-width: 1199px) {
  .banner-ambiente {
    position: static;
    box-sizing: border-box;
    border-radius: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
}
.info-container.uk-navbar-right {
  gap: 0;
}
.info-container .info-data-text {
  font-weight: bold;
}
.uk-button-primary {
  background-color: #003768;
}
.uk-button-primary:hover,
.uk-button-primary:active {
  background-color: #003768;
}
.uk-button-secundary {
  color: white;
  background-color: #b4b4b4;
}
.uk-button-secundary:hover,
.uk-button-secundary:active {
  background-color: #969696;
}
.chart-button {
  background-color: #ff9d53;
}
.chart-button:hover,
.chart-button:active {
  background-color: #d88647;
}
.uk-offcanvas-bar .uk-nav {
  z-index: 2;
}
.uk-heading-divider {
  border-bottom: 1.5px solid #003768;
}
.border-vertical {
  border-bottom: 1px solid #e5e5e5;
  border-top: 1px solid #e5e5e5;
}
.esfera-alerta {
  width: 10px;
  height: 10px;
  background-color: #ff0066;
  border-radius: 50%;
  display: inline-block;
}
.border-bottom {
  border-bottom: 1px solid #e5e5e5;
}
.label-muted {
  background-color: #f8f8f8;
  color: #666;
}
.scroll-up {
  position: fixed;
  bottom: 5%;
  right: 5%;
  z-index: 9999;
}
.uk-tab > li > a {
  padding-bottom: 13px;
}
.uk-subnav-pill > .uk-active > a {
  background-color: #003768;
  color: #fff;
  font-weight: bolder;
}
.uk-subnav-pill > * > :first-child {
  padding: 5px 10px;
  background: 0 0;
  color: #666;
  border-color: #b2b2b2;
}
.uk-button-height {
  line-height: 25px;
  border-color: #b2b2b2;
  color: #666;
}
.uk-button-height:hover {
  background-color: #f8f8f8;
  color: #666;
}
.label-neutral {
  background-color: #b2b2b2;
  color: #fff;
}
.ui-datepicker {
  z-index: 1000 !important;
}
.uk-tab > .uk-active > a {
  border-color: #003768;
}
.botao-danger {
  background-color: transparent !important;
  color: #f0506e !important;
  border: 1px solid #f0506e !important;
}
@media (max-width: 400px) {
  .response-button-inputs > div {
    width: 100%;
    padding-bottom: 3px;
  }
  .response-button-inputs > div > * {
    width: 100%;
  }
  .text-nowrap\\@s {
    white-space: normal !important;
  }
}
@media (min-width: 640px) {
  .padding-small-right\\@s {
    padding-right: 15px;
  }
}
@media (max-width: 680px) {
  .uk-container {
    padding: 0 !important;
  }
  .response-button-inputs > div {
    padding-bottom: 3px;
  }
}
@media (min-width: 960px) {
  .padding-small-left\\@m {
    padding-left: 30px;
  }
}
@media (min-width: 1200px) {
  .uk-text-normal\\@l {
    font-weight: 400;
  }
  .padding-large-left\\@l {
    padding-left: 50px;
  }
  .padding-large-right\\@l {
    padding-right: 50px;
  }
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.spin {
  animation: spin 1s linear infinite;
}
a[disabled] {
  pointer-events: none;
  cursor: default;
  color: #999;
}
.uk-modal-title {
  font-size: 22px;
}
select[readonly] {
  background: #f8f8f8;
  pointer-events: none;
  touch-action: none;
}
input[readonly] {
  background: #f8f8f8;
}
.uk-form-label,
.uk-description-list > dt {
  font-weight: 700;
  color: #003768;
}
.uk-table th {
  font-weight: 700;
  color: #003768;
  text-transform: none;
}
.uk-card-title,
.uk-card-default,
.uk-tab > .uk-active > a,
.uk-subnav > * > :first-child,
.uk-input,
.uk-select,
.uk-textarea,
.uk-select:not([multiple]):not([size]) option,
.uk-input:disabled,
.uk-select:disabled,
.uk-textarea:disabled,
.uk-input:focus,
.uk-select:focus,
.uk-textarea:focus {
  color: black;
}
.uk-tab > * > a {
  color: #303030;
}
.uk-description-list > dt {
  color: #003768;
  font-size: 1rem;
  font-weight: 500;
  text-transform: none;
  margin-bottom: 4px;
}
.uk-description-list > dd {
  color: black;
  background-color: #fbfbfb;
  border: 1px solid #e5e5e5;
  padding: 10px;
}
.uk-dropdown-nav > li > a {
  color: black;
}
.uk-dropdown-nav > li:hover > a {
  color: #003768;
}
.uk-notification {
  z-index: 99999;
}
.uk-form-label,
.uk-description-list > dt {
  font-weight: 700;
  color: #003768;
}
.uk-table th {
  font-weight: 700;
  color: #003768;
  text-transform: none;
}
.uk-card-title,
.uk-card-default,
.uk-tab > .uk-active > a,
.uk-subnav > * > :first-child,
.uk-input,
.uk-select,
.uk-textarea,
.uk-select:not([multiple]):not([size]) option,
.uk-input:disabled,
.uk-select:disabled,
.uk-textarea:disabled,
.uk-input:focus,
.uk-select:focus,
.uk-textarea:focus {
  color: black;
}
.uk-tab > * > a {
  color: #303030;
}
.uk-description-list > dt {
  color: #003768;
  font-size: 1rem;
  font-weight: 500;
  text-transform: none;
  margin-bottom: 4px;
}
.uk-description-list > dd {
  color: black;
  background-color: #fbfbfb;
  border: 1px solid #e5e5e5;
  padding: 10px;
}
.uk-dropdown-nav > li > a {
  color: black;
}
.uk-dropdown-nav > li:hover > a {
  color: #003768;
}
/*
.logo-tf {
    height: 140px;
    width: 173px;
    background-image: url(./images/logo.gif);
    background-size: 100%;
    background-repeat: no-repeat;
    background-position: 50%;
}
*/
`, "",{"version":3,"sources":["webpack://./src/pages/home/index.less","webpack://./node_modules/@fortawesome/fontawesome-free/css/all.css","webpack://./src/styles/font.less","webpack://./src/styles/header.less","webpack://./src/styles/height.less","webpack://./src/styles/margin.less","webpack://./src/styles/padding.less","webpack://./src/styles/switch.less","webpack://./src/styles/width.less","webpack://./src/styles/icones.less","webpack://./src/styles/drag-drop.less","webpack://./src/styles/buttons.less","webpack://./src/styles/button-ia.less","webpack://./src/styles/options-menu.less","webpack://./src/styles/index.less"],"names":[],"mappings":"AAAA;;;;EAIE;ACCF;EACE,0DAAA;EACA,iCAAA;ADCF;ACCA;;;;;;;EAOE,kCAAA;EACA,mCAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;ADCF;ACCA;;;;;;;EAOE,kBAAA;ADCF;ACCA;;;;;EAKE,kCAAA;ADCF;ACCA;;EAEE,oCAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,cAAA;ADCF;ACCA;EACE,eAAA;ADCF;ACCA;EACE,kBAAA;EACA,kBAAA;EACA,uBAAA;ADCF;ACCA;EACE,iBAAA;EACA,sBAAA;EACA,uBAAA;ADCF;ACCA;EACE,kBAAA;EACA,sBAAA;EACA,yBAAA;ADCF;ACCA;EACE,iBAAA;EACA,mBAAA;EACA,wBAAA;ADCF;ACCA;EACE,gBAAA;EACA,sBAAA;EACA,wBAAA;ADCF;ACCA;EACE,cAAA;EACA,sBAAA;EACA,yBAAA;ADCF;ACCA;EACE,kBAAA;EACA,aAAA;ADCF;ACCA;EACE,qBAAA;EACA,uCAAA;EACA,eAAA;ADCF;ACAE;EACE,kBAAA;ADEJ;ACAA;EACE,wCAAA;EACA,kBAAA;EACA,kBAAA;EACA,8BAAA;EACA,oBAAA;ADEF;ACAA;EACE,0CAAA;EACA,6CAAA;EACA,2CAAA;EACA,4CAAA;EACA,sDAAA;ADEF;ACAA;EACE,WAAA;EACA,0CAAA;ADEF;ACAA;EACE,YAAA;EACA,yCAAA;ADEF;ACAA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;ADEF;ACAA;EACE,yBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,wFAAA;ADEF;ACAA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;ADEF;ACAA;EACE,4BAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,mFAAA;ADEF;ACAA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,kEAAA;ADEF;ACAA;EACE,wBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;ADEF;ACAA;EACE,uBAAA;EACA,8CAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,6DAAA;ADEF;ACAA;EACE,iCAAA;ADEF;ACAA;;EAEE,uBAAA;EACA,0DAAA;EACA,oDAAA;EACA,wEAAA;EACA,+DAAA;ADEF;ACAA;EACE;;;;;;;;;IASE,qBAAA;IACA,uBAAA;IACA,4BAAA;IACA,oBAAA;IACA,uBAAA;EDEF;AACF;ACDA;EACE;;IACE,mBAAA;EDIF;ECHA;IACE,4CAAA;EDKF;AACF;ACJA;EACE;IACE,oCAAA;EDMF;ECLA;IACE,wGAAA;EDOF;ECNA;IACE,oIAAA;EDQF;ECPA;IACE,wGAAA;EDSF;ECRA;IACE,qEAAA;EDUF;ECTA;IACE,oCAAA;EDWF;ECVA;IACE,oCAAA;EDYF;AACF;ACXA;EACE;IACE,oCAAA;EDaF;AACF;ACZA;EACE;;IACE,yCAAA;IACA,mBAAA;EDeF;ECdA;IACE,UAAA;IACA,kDAAA;EDgBF;AACF;ACfA;EACE;IACE,iHAAA;EDiBF;AACF;AChBA;EACE;IACE,yBAAA;EDkBF;ECjBA;IACE,wBAAA;EDmBF;EClBA;;IACE,yBAAA;EDqBF;ECpBA;;IACE,wBAAA;EDuBF;ECtBA;IACE,yBAAA;EDwBF;ECvBA;IACE,wBAAA;EDyBF;ECxBA;IACE,yBAAA;ED0BF;ECzBA;IACE,wBAAA;ED2BF;EC1BA;;IACE,uBAAA;ED6BF;AACF;AC5BA;EACE;IACE,uBAAA;ED8BF;EC7BA;IACE,yBAAA;ED+BF;AACF;AC9BA;EACE,wBAAA;ADgCF;AC9BA;EACE,yBAAA;ADgCF;AC9BA;EACE,yBAAA;ADgCF;AC9BA;EACE,uBAAA;ADgCF;AC9BA;EACE,uBAAA;ADgCF;AC9BA;;EAEE,wBAAA;ADgCF;AC9BA;EACE,4CAAA;ADgCF;AC9BA;EACE,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;ADgCF;AC9BA;;EAEE,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,sCAAA;ADgCF;AC9BA;EACE,oBAAA;ADgCF;AC9BA;EACE,cAAA;ADgCF;AC9BA;EACE,8BAAA;ADgCF;AACA;gEACgE;AC7BhE;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,WAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;EACE,aAAA;AD+BF;AC7BA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AD+BF;AC7BA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,eAAA;AD+BF;AC9BA;;EACE,iDAAA;EACA,0DAAA;ADiCF;AC/BA;EACE,oCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wHAAA;ADiCF;AC/BA;;EAEE,gBAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AC/BA;EACE,aAAA;ADiCF;AChCA;;EACE,gDAAA;EACA,yDAAA;ADmCF;ACjCA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wHAAA;ADmCF;ACjCA;;EAEE,gBAAA;ADmCF;AClCA;;EACE,gDAAA;EACA,uDAAA;ADqCF;ACnCA;EACE,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,wHAAA;ADqCF;ACnCA;;EAEE,gBAAA;ADqCF;ACpCA;EACE,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,wHAAA;ADsCF;ACpCA;EACE,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,wHAAA;ADsCF;ACpCA;EACE,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,wHAAA;ADsCF;ACrCA;EACE,0BAAA;EACA,mBAAA;EACA,wHAAA;ADuCF;ACrCA;EACE,0BAAA;EACA,mBAAA;EACA,wHAAA;ADuCF;ACrCA;EACE,0BAAA;EACA,mBAAA;EACA,wHAAA;EACA,4oBAAA;ADuCF;ACrCA;EACE,0BAAA;EACA,mBAAA;EACA,wHAAA;EACA,2RAAA;ADuCF;AE7wPA;EACI,eAAA;AF+wPJ;AE5wPA;EACI,iBAAA;AF8wPJ;AE3wPA;EACI;IACI,iBAAA;EF6wPN;AACF;AE1wPA;EACI;IACI,kBAAA;EF4wPN;EEzwPE;IACI,iBAAA;EF2wPN;AACF;AExwPA;EACI;IACI,iBAAA;EF0wPN;AACF;AEvwPA;EACI;IACI,eAAA;EFywPN;EEtwPE;IACI,iBAAA;EFwwPN;AACF;AG3yPA;EACI,YAAA;AH6yPJ;AG9yPA;EAKY,gBAAA;EACA,UAAA;EACA,iBAAA;AH4yPZ;AGnzPA;EAWY,qBAAA;EACA,SAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AH2yPZ;AG1zPA;EAoBQ,yBAAA;AHyyPR;AG7zPA;EAwBQ,gBAAA;AHwyPR;AGh0PA;EA4BQ,iBAAA;EACA,kBAAA;AHuyPR;AGp0PA;;EAmCY,YAAA;AHqyPZ;AGx0PA;EAuCY,YAAA;AHoyPZ;AG30PA;EA4CY,YAAA;EACA,mBAAA;AHkyPZ;AG/0PA;EAiDQ,gBAAA;AHiyPR;AGl1PA;EAoDY,oBAAA;AHiyPZ;AGr1PA;EAwDY,kBAAA;EACA,gBAAA;AHgyPZ;AGz1PA;EA4DgB,yBAAA;EACA,oBAAA;AHgyPhB;AG3xPI;EAAA;IAEI,YAAA;EH6xPN;EG/xPE;IAKQ,QAAA;EH6xPV;EGlyPE;IASQ,cAAA;EH4xPV;EGryPE;IAaQ,WAAA;IACA,YAAA;IACA,aAAA;IACA,6BAAA;EH2xPV;EG3yPE;IAmBY,WAAA;IACA,YAAA;EH2xPd;EG/yPE;IAwBY,SAAA;IACA,QAAA;IACA,iBAAA;IACA,yBAAA;EH0xPd;EGrzPE;IA8BgB,YAAA;IACA,eAAA;EH0xPlB;EGzzPE;IAmCgB,cAAA;EHyxPlB;EG5zPE;IAuCgB,cAAA;IACA,mBAAA;IACA,uBAAA;IACA,iBAAA;EHwxPlB;EGl0PE;IA6CoB,cAAA;EHwxPtB;AACF;AGjxPA;EACI,eAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,2BAAA;AHmxPJ;AG5xPA;;EAYQ,eAAA;AHoxPR;AGhyPA;EAgBQ,aAAA;EACA,cAAA;EACA,6BAAA;AHmxPR;AGryPA;EAsBQ,aAAA;EACA,cAAA;AHkxPR;AGzyPA;;EA2BQ,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;AHkxPR;AGhzPA;EAkCQ,kBAAA;AHixPR;AGnzPA;;EAsCY,yBAAA;AHixPZ;AGvzPA;;EA0CQ,yBAAA;EACA,YAAA;AHixPR;AG5zPA;EA+CQ,aAAA;EACA,gBAAA;AHgxPR;AGh0PA;EAoDQ,gBAAA;AH+wPR;AGn0PA;EAwDQ,kBAAA;AH8wPR;AGt0PA;EA4DQ,iBAAA;AH6wPR;AGz0PA;EAgEQ,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AH4wPR;AG/0PA;EAuEQ,cAAA;EACA,iBAAA;AH2wPR;AGn1PA;EA4EQ,cAAA;EACA,2BAAA;EACA,4BAAA;AH0wPR;AGx1PA;EAkFQ,qBAAA;AHywPR;AG31PA;EAsFQ,6BAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;AHwwPR;AGn2PA;EA8FY,cAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;AHwwPZ;AGnwPA;EAIY,cAAA;AHkwPZ;AG9vPI;EAAA;IAEQ,YAAA;EHgwPV;EGlwPE;IAKY,gBAAA;EHgwPd;EGrwPE;IAUQ,kBAAA;EH8vPV;AACF;AG3vPI;EAAA;IAEQ,YAAA;EH6vPV;EG/vPE;IAKY,gBAAA;EH6vPd;EGlwPE;IAUQ,kBAAA;EH2vPV;AACF;AGvvPA;EAGQ,WAAA;EACA,2BAAA;EACA,kBAAA;AHuvPR;AG5vPA;EAQY,aAAA;AHuvPZ;AG/vPA;EAYY,aAAA;AHsvPZ;AGlwPA;EAgBY,aAAA;AHqvPZ;AGrwPA;EAoBY,uBAAA;AHovPZ;AGxwPA;EAyBQ,iBAAA;AHkvPR;AG3wPA;EA6BQ,gBAAA;AHivPR;AG9wPA;EAgCY,cAAA;AHivPZ;AGjxPA;EAoCY,cAAA;AHgvPZ;AGpxPA;EAwCY,cAAA;AH+uPZ;AGvxPA;EA4CY,qBAAA;AH8uPZ;AG1xPA;EAgDY,cAAA;AH6uPZ;AG7xPA;EAoDY,cAAA;AH4uPZ;AGxuPI;EAAA;IAEQ,YAAA;EH0uPV;EG5uPE;IAKY,gBAAA;EH0uPd;AACF;AGtuPI;EAAA;IAEQ,YAAA;EHwuPV;EG1uPE;IAKY,gBAAA;EHwuPd;AACF;AGnuPA;EACI;IACI,yBAAA;EHquPN;AACF;AI7jQA;EACI;IACI,YAAA;EJ+jQN;AACF;AKlkQA;EACI;IACI,4BAAA;ELokQN;EKlkQE;IACI,wBAAA;ELokQN;EKlkQE;IACI,oBAAA;ELokQN;AACF;AKjkQA;EACI;IACI,wBAAA;ELmkQN;EKjkQE;IACI,oBAAA;ELmkQN;AACF;AKhkQA;EACI;IACI,wBAAA;ELkkQN;EKhkQE;IACI,oBAAA;ELkkQN;AACF;AK/jQA;EACI;IACI,wBAAA;ELikQN;EK/jQE;IACI,oBAAA;ELikQN;AACF;AMvjQA;EA7CI,gBAAA;ANumQJ;AMzjQA;EAAsB,cAAA;AN4jQtB;AM3jQA;EA/CI,wBAAA;AN6mQJ;AM7jQA;EAhDI,kBAAA;ANgnQJ;AM/jQA;EAjDI,kBAAA;ANmnQJ;AMjkQA;EAlDI,kBAAA;ANsnQJ;AMnkQA;EAnDI,kBAAA;ANynQJ;AMrkQA;EApDI,cAAA;AN4nQJ;AMvkQA;EArDI,cAAA;AN+nQJ;AMxkQA;EAvDI,4BAAA;ANkoQJ;AM1kQA;EAxDI,mBAAA;ANqoQJ;AM5kQA;EAzDI,mBAAA;ANwoQJ;AM9kQA;EA1DI,mBAAA;AN2oQJ;AMhlQA;EA3DI,mBAAA;AN8oQJ;AMllQA;EA5DI,eAAA;ANipQJ;AMplQA;EA7DI,eAAA;ANopQJ;AMrlQA;EA/DI,4BAAA;ANupQJ;AMvlQA;EAhEI,mBAAA;AN0pQJ;AMzlQA;EAjEI,mBAAA;AN6pQJ;AM3lQA;EAlEI,mBAAA;ANgqQJ;AM7lQA;EAnEI,mBAAA;ANmqQJ;AM/lQA;EApEI,eAAA;ANsqQJ;AMjmQA;EArEI,eAAA;ANyqQJ;AMlmQA;EAvEI,4BAAA;AN4qQJ;AMpmQA;EAxEI,mBAAA;AN+qQJ;AMtmQA;EAzEI,mBAAA;ANkrQJ;AMxmQA;EA1EI,mBAAA;ANqrQJ;AM1mQA;EA3EI,mBAAA;ANwrQJ;AM5mQA;EA5EI,eAAA;AN2rQJ;AM9mQA;EA7EI,eAAA;AN8rQJ;AM/mQA;EA/EI,4BAAA;ANisQJ;AMjnQA;EAhFI,mBAAA;ANosQJ;AMnnQA;EAjFI,mBAAA;ANusQJ;AMrnQA;EAlFI,mBAAA;AN0sQJ;AMvnQA;EAnFI,mBAAA;AN6sQJ;AMznQA;EApFI,eAAA;ANgtQJ;AM3nQA;EArFI,eAAA;ANmtQJ;AM5nQA;EACI,iBAAA;AN8nQJ;AM3nQA;EACI;IA5FA,gBAAA;EN0tQF;EM7nQE;IA7FA,wBAAA;EN6tQF;EM/nQE;IA9FA,kBAAA;ENguQF;EMjoQE;IA/FA,kBAAA;ENmuQF;EMnoQE;IAhGA,kBAAA;ENsuQF;EMroQE;IAjGA,kBAAA;ENyuQF;EMvoQE;IAlGA,cAAA;EN4uQF;EMzoQE;IAnGA,cAAA;EN+uQF;EM1oQE;IArGA,4BAAA;ENkvQF;EM5oQE;IAtGA,mBAAA;ENqvQF;EM9oQE;IAvGA,mBAAA;ENwvQF;EMhpQE;IAxGA,mBAAA;EN2vQF;EMlpQE;IAzGA,mBAAA;EN8vQF;EMppQE;IA1GA,eAAA;ENiwQF;EMtpQE;IA3GA,eAAA;ENowQF;EMvpQE;IA7GA,4BAAA;ENuwQF;EMzpQE;IA9GA,mBAAA;EN0wQF;EM3pQE;IA/GA,mBAAA;EN6wQF;EM7pQE;IAhHA,mBAAA;ENgxQF;EM/pQE;IAjHA,mBAAA;ENmxQF;EMjqQE;IAlHA,eAAA;ENsxQF;EMnqQE;IAnHA,eAAA;ENyxQF;EMpqQE;IArHA,4BAAA;EN4xQF;EMtqQE;IAtHA,mBAAA;EN+xQF;EMxqQE;IAvHA,mBAAA;ENkyQF;EM1qQE;IAxHA,mBAAA;ENqyQF;EM5qQE;IAzHA,mBAAA;ENwyQF;EM9qQE;IA1HA,eAAA;EN2yQF;EMhrQE;IA3HA,eAAA;EN8yQF;EMjrQE;IA7HA,4BAAA;ENizQF;EMnrQE;IA9HA,mBAAA;ENozQF;EMrrQE;IA/HA,mBAAA;ENuzQF;EMvrQE;IAhIA,mBAAA;EN0zQF;EMzrQE;IAjIA,mBAAA;EN6zQF;EM3rQE;IAlIA,eAAA;ENg0QF;EM7rQE;IAnIA,eAAA;ENm0QF;AACF;AM9rQA;EACI;IAvIA,gBAAA;ENw0QF;EMhsQE;IAxIA,wBAAA;EN20QF;EMlsQE;IAzIA,kBAAA;EN80QF;EMpsQE;IA1IA,kBAAA;ENi1QF;EMtsQE;IA3IA,kBAAA;ENo1QF;EMxsQE;IA5IA,kBAAA;ENu1QF;EM1sQE;IA7IA,cAAA;EN01QF;EM5sQE;IA9IA,cAAA;EN61QF;EM7sQE;IAhJA,4BAAA;ENg2QF;EM/sQE;IAjJA,mBAAA;ENm2QF;EMjtQE;IAlJA,mBAAA;ENs2QF;EMntQE;IAnJA,mBAAA;ENy2QF;EMrtQE;IApJA,mBAAA;EN42QF;EMvtQE;IArJA,eAAA;EN+2QF;EMztQE;IAtJA,eAAA;ENk3QF;EM1tQE;IAxJA,4BAAA;ENq3QF;EM5tQE;IAzJA,mBAAA;ENw3QF;EM9tQE;IA1JA,mBAAA;EN23QF;EMhuQE;IA3JA,mBAAA;EN83QF;EMluQE;IA5JA,mBAAA;ENi4QF;EMpuQE;IA7JA,eAAA;ENo4QF;EMtuQE;IA9JA,eAAA;ENu4QF;EMvuQE;IAhKA,4BAAA;EN04QF;EMzuQE;IAjKA,mBAAA;EN64QF;EM3uQE;IAlKA,mBAAA;ENg5QF;EM7uQE;IAnKA,mBAAA;ENm5QF;EM/uQE;IApKA,mBAAA;ENs5QF;EMjvQE;IArKA,eAAA;ENy5QF;EMnvQE;IAtKA,eAAA;EN45QF;EMpvQE;IAxKA,4BAAA;EN+5QF;EMtvQE;IAzKA,mBAAA;ENk6QF;EMxvQE;IA1KA,mBAAA;ENq6QF;EM1vQE;IA3KA,mBAAA;ENw6QF;EM5vQE;IA5KA,mBAAA;EN26QF;EM9vQE;IA7KA,eAAA;EN86QF;EMhwQE;IA9KA,eAAA;ENi7QF;AACF;AMjwQA;EACI;IAlLA,gBAAA;ENs7QF;EMnwQE;IAnLA,wBAAA;ENy7QF;EMrwQE;IApLA,kBAAA;EN47QF;EMvwQE;IArLA,kBAAA;EN+7QF;EMzwQE;IAtLA,kBAAA;ENk8QF;EM3wQE;IAvLA,kBAAA;ENq8QF;EM7wQE;IAxLA,cAAA;ENw8QF;EM/wQE;IAzLA,cAAA;EN28QF;EMhxQE;IA3LA,4BAAA;EN88QF;EMlxQE;IA5LA,mBAAA;ENi9QF;EMpxQE;IA7LA,mBAAA;ENo9QF;EMtxQE;IA9LA,mBAAA;ENu9QF;EMxxQE;IA/LA,mBAAA;EN09QF;EM1xQE;IAhMA,eAAA;EN69QF;EM5xQE;IAjMA,eAAA;ENg+QF;EM7xQE;IAnMA,4BAAA;ENm+QF;EM/xQE;IApMA,mBAAA;ENs+QF;EMjyQE;IArMA,mBAAA;ENy+QF;EMnyQE;IAtMA,mBAAA;EN4+QF;EMryQE;IAvMA,mBAAA;EN++QF;EMvyQE;IAxMA,eAAA;ENk/QF;EMzyQE;IAzMA,eAAA;ENq/QF;EM1yQE;IA3MA,4BAAA;ENw/QF;EM5yQE;IA5MA,mBAAA;EN2/QF;EM9yQE;IA7MA,mBAAA;EN8/QF;EMhzQE;IA9MA,mBAAA;ENigRF;EMlzQE;IA/MA,mBAAA;ENogRF;EMpzQE;IAhNA,eAAA;ENugRF;EMtzQE;IAjNA,eAAA;EN0gRF;EMvzQE;IAnNA,4BAAA;EN6gRF;EMzzQE;IApNA,mBAAA;ENghRF;EM3zQE;IArNA,mBAAA;ENmhRF;EM7zQE;IAtNA,mBAAA;ENshRF;EM/zQE;IAvNA,mBAAA;ENyhRF;EMj0QE;IAxNA,eAAA;EN4hRF;EMn0QE;IAzNA,eAAA;EN+hRF;EMp0QE;IACI,iBAAA;ENs0QN;AACF;AMn0QA;EACI;IAjOA,gBAAA;ENuiRF;EMr0QE;IAlOA,wBAAA;EN0iRF;EMv0QE;IAnOA,kBAAA;EN6iRF;EMz0QE;IApOA,kBAAA;ENgjRF;EM30QE;IArOA,kBAAA;ENmjRF;EM70QE;IAtOA,kBAAA;ENsjRF;EM/0QE;IAvOA,cAAA;ENyjRF;EMj1QE;IAxOA,cAAA;EN4jRF;EMl1QE;IA1OA,4BAAA;EN+jRF;EMp1QE;IA3OA,mBAAA;ENkkRF;EMt1QE;IA5OA,mBAAA;ENqkRF;EMx1QE;IA7OA,mBAAA;ENwkRF;EM11QE;IA9OA,mBAAA;EN2kRF;EM51QE;IA/OA,eAAA;EN8kRF;EM91QE;IAhPA,eAAA;ENilRF;EM/1QE;IAlPA,4BAAA;ENolRF;EMj2QE;IAnPA,mBAAA;ENulRF;EMn2QE;IApPA,mBAAA;EN0lRF;EMr2QE;IArPA,mBAAA;EN6lRF;EMv2QE;IAtPA,mBAAA;ENgmRF;EMz2QE;IAvPA,eAAA;ENmmRF;EM32QE;IAxPA,eAAA;ENsmRF;EM52QE;IA1PA,4BAAA;ENymRF;EM92QE;IA3PA,mBAAA;EN4mRF;EMh3QE;IA5PA,mBAAA;EN+mRF;EMl3QE;IA7PA,mBAAA;ENknRF;EMp3QE;IA9PA,mBAAA;ENqnRF;EMt3QE;IA/PA,eAAA;ENwnRF;EMx3QE;IAhQA,eAAA;EN2nRF;EMz3QE;IAlQA,4BAAA;EN8nRF;EM33QE;IAnQA,mBAAA;ENioRF;EM73QE;IApQA,mBAAA;ENooRF;EM/3QE;IArQA,mBAAA;ENuoRF;EMj4QE;IAtQA,mBAAA;EN0oRF;EMn4QE;IAvQA,eAAA;EN6oRF;EMr4QE;IAxQA,eAAA;ENgpRF;AACF;AMt4QA;EACI;IA5QA,gBAAA;ENqpRF;EMx4QE;IA7QA,wBAAA;ENwpRF;EM14QE;IA9QA,kBAAA;EN2pRF;EM54QE;IA/QA,kBAAA;EN8pRF;EM94QE;IAhRA,kBAAA;ENiqRF;EMh5QE;IAjRA,kBAAA;ENoqRF;EMl5QE;IAlRA,cAAA;ENuqRF;EMp5QE;IAnRA,cAAA;EN0qRF;EMr5QE;IArRA,4BAAA;EN6qRF;EMv5QE;IAtRA,mBAAA;ENgrRF;EMz5QE;IAvRA,mBAAA;ENmrRF;EM35QE;IAxRA,mBAAA;ENsrRF;EM75QE;IAzRA,mBAAA;ENyrRF;EM/5QE;IA1RA,eAAA;EN4rRF;EMj6QE;IA3RA,eAAA;EN+rRF;EMl6QE;IA7RA,4BAAA;ENksRF;EMp6QE;IA9RA,mBAAA;ENqsRF;EMt6QE;IA/RA,mBAAA;ENwsRF;EMx6QE;IAhSA,mBAAA;EN2sRF;EM16QE;IAjSA,mBAAA;EN8sRF;EM56QE;IAlSA,eAAA;ENitRF;EM96QE;IAnSA,eAAA;ENotRF;EM/6QE;IArSA,4BAAA;ENutRF;EMj7QE;IAtSA,mBAAA;EN0tRF;EMn7QE;IAvSA,mBAAA;EN6tRF;EMr7QE;IAxSA,mBAAA;ENguRF;EMv7QE;IAzSA,mBAAA;ENmuRF;EMz7QE;IA1SA,eAAA;ENsuRF;EM37QE;IA3SA,eAAA;ENyuRF;EM57QE;IA7SA,4BAAA;EN4uRF;EM97QE;IA9SA,mBAAA;EN+uRF;EMh8QE;IA/SA,mBAAA;ENkvRF;EMl8QE;IAhTA,mBAAA;ENqvRF;EMp8QE;IAjTA,mBAAA;ENwvRF;EMt8QE;IAlTA,eAAA;EN2vRF;EMx8QE;IAnTA,eAAA;EN8vRF;EMz8QE;IACI,iBAAA;EN28QN;AACF;AOjtRA;EAjDI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;APqwRJ;AOxtRA;EA1CQ,UAAA;EACA,QAAA;EACA,SAAA;APqwRR;AO7tRA;EApCQ,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;APowRR;AOlwRQ;EACI,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;APowRZ;AOnvRA;EAZQ,yBAAA;APkwRR;AOtvRA;EARQ,2BAAA;APiwRR;AOzvRA;EAJQ,2BAAA;APgwRR;AOxvRA;EArDI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;APgzRJ;AO/vRA;EA9CQ,UAAA;EACA,QAAA;EACA,SAAA;APgzRR;AOpwRA;EAxCQ,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;AP+yRR;AO7yRQ;EACI,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AP+yRZ;AO1xRA;EAhBQ,yBAAA;AP6yRR;AO7xRA;EAZQ,2BAAA;AP4yRR;AOhyRA;EARQ,2BAAA;AP2yRR;AO/xRA;EAzDI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;AP21RJ;AOtyRA;EAlDQ,UAAA;EACA,QAAA;EACA,SAAA;AP21RR;AO3yRA;EA5CQ,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;AP01RR;AOx1RQ;EACI,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AP01RZ;AOj0RA;EApBQ,yBAAA;APw1RR;AOp0RA;EAhBQ,2BAAA;APu1RR;AOv0RA;EAZQ,2BAAA;APs1RR;AOt0RA;EA7DI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,6BAAA;APs4RJ;AO70RA;EAtDQ,UAAA;EACA,QAAA;EACA,SAAA;APs4RR;AOl1RA;EAhDQ,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,gBAAA;EACA,6BAAA;APq4RR;AOn4RQ;EACI,kBAAA;EACA,WAAA;EACA,wBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;APq4RZ;AOx2RA;EAxBQ,yBAAA;APm4RR;AO32RA;EApBQ,2BAAA;APk4RR;AO92RA;EAhBQ,2BAAA;APi4RR;AQ/6RA;EAAsB,UAAA;ARk7RtB;AQj7RA;EAAe,YAAA;ARo7Rf;AQn7RA;EAAc,WAAA;ARs7Rd;AQp7RA;EACI;IAAkB,YAAA;ERu7RpB;EQt7RE;IAAmB,YAAA;ERy7RrB;EQx7RE;IAAyB,YAAA;ER27R3B;EQ17RE;IAAkB,YAAA;ER67RpB;EQ57RE;IAAkB,WAAA;ER+7RpB;EQ97RE;IAAiB,WAAA;ERi8RnB;AACF;AQ/7RA;EACI;IAAkB,YAAA;ERk8RpB;EQj8RE;IAAmB,YAAA;ERo8RrB;EQn8RE;IAAwB,YAAA;ERs8R1B;EQr8RE;IAAkB,YAAA;ERw8RpB;EQv8RE;IAAkB,YAAA;ER08RpB;EQz8RE;IAAiB,WAAA;ER48RnB;AACF;AQr8RA;EAHI,WAAA;AR28RJ;AQv8RA;EAJI,WAAA;AR88RJ;AQz8RA;EALI,WAAA;ARi9RJ;AQ38RA;EANI,YAAA;ARo9RJ;AQ78RA;EAPI,YAAA;ARu9RJ;AQ/8RA;EARI,YAAA;AR09RJ;AQj9RA;EATI,YAAA;AR69RJ;AQn9RA;EAVI,YAAA;ARg+RJ;AQr9RA;EAXI,YAAA;ARm+RJ;AQv9RA;EAZI,YAAA;ARs+RJ;AQz9RA;EAbI,YAAA;ARy+RJ;AQ39RA;EAdI,YAAA;AR4+RJ;AQ79RA;EAfI,YAAA;AR++RJ;AQ/9RA;EAhBI,YAAA;ARk/RJ;AQh+RA;EACI;IAnBA,WAAA;ERs/RF;EQl+RE;IApBA,WAAA;ERy/RF;EQp+RE;IArBA,WAAA;ER4/RF;EQt+RE;IAtBA,YAAA;ER+/RF;EQx+RE;IAvBA,YAAA;ERkgSF;EQ1+RE;IAxBA,YAAA;ERqgSF;EQ5+RE;IAzBA,YAAA;ERwgSF;EQ9+RE;IA1BA,YAAA;ER2gSF;EQh/RE;IA3BA,YAAA;ER8gSF;EQl/RE;IA5BA,YAAA;ERihSF;EQp/RE;IA7BA,YAAA;ERohSF;EQt/RE;IA9BA,YAAA;ERuhSF;EQx/RE;IA/BA,YAAA;ER0hSF;AACF;AQz/RA;EACI;IAnCA,WAAA;ER+hSF;EQ3/RE;IApCA,WAAA;ERkiSF;EQ7/RE;IArCA,WAAA;ERqiSF;EQ//RE;IAtCA,YAAA;ERwiSF;EQjgSE;IAvCA,YAAA;ER2iSF;EQngSE;IAxCA,YAAA;ER8iSF;EQrgSE;IAzCA,YAAA;ERijSF;EQvgSE;IA1CA,YAAA;ERojSF;EQzgSE;IA3CA,YAAA;ERujSF;EQ3gSE;IA5CA,YAAA;ER0jSF;EQ7gSE;IA7CA,YAAA;ER6jSF;AACF;AQ9gSA;EACI;IAjDA,WAAA;ERkkSF;EQhhSE;IAlDA,WAAA;ERqkSF;EQlhSE;IAnDA,WAAA;ERwkSF;EQphSE;IApDA,YAAA;ER2kSF;EQthSE;IArDA,YAAA;ER8kSF;EQxhSE;IAtDA,YAAA;ERilSF;EQ1hSE;IAvDA,YAAA;ERolSF;EQ5hSE;IAxDA,YAAA;ERulSF;EQ9hSE;IAzDA,YAAA;ER0lSF;EQhiSE;IA1DA,YAAA;ER6lSF;EQliSE;IA3DA,YAAA;ERgmSF;EQpiSE;IA5DA,YAAA;ERmmSF;EQtiSE;IA7DA,YAAA;ERsmSF;EQxiSE;IA9DA,YAAA;ERymSF;AACF;AQziSA;EACI;IAlEA,WAAA;ER8mSF;EQ3iSE;IAnEA,WAAA;ERinSF;EQ7iSE;IApEA,WAAA;ERonSF;EQ/iSE;IArEA,YAAA;ERunSF;EQjjSE;IAtEA,YAAA;ER0nSF;EQnjSE;IAvEA,YAAA;ER6nSF;EQrjSE;IAxEA,YAAA;ERgoSF;EQvjSE;IAzEA,YAAA;ERmoSF;EQzjSE;IA1EA,YAAA;ERsoSF;EQ3jSE;IA3EA,YAAA;ERyoSF;EQ7jSE;IA5EA,YAAA;ER4oSF;EQ/jSE;IA7EA,YAAA;ER+oSF;EQjkSE;IA9EA,YAAA;ERkpSF;EQnkSE;IA/EA,YAAA;ERqpSF;EQrkSE;IAhFA,YAAA;ERwpSF;AACF;AQtkSA;EACI;IApFA,WAAA;ER6pSF;EQxkSE;IArFA,WAAA;ERgqSF;EQ1kSE;IAtFA,WAAA;ERmqSF;EQ5kSE;IAvFA,YAAA;ERsqSF;EQ9kSE;IAxFA,YAAA;ERyqSF;EQhlSE;IAzFA,YAAA;ER4qSF;EQllSE;IA1FA,YAAA;ER+qSF;EQplSE;IA3FA,YAAA;ERkrSF;EQtlSE;IA5FA,YAAA;ERqrSF;EQxlSE;IA7FA,YAAA;ERwrSF;EQ1lSE;IA9FA,YAAA;ER2rSF;EQ5lSE;IA/FA,YAAA;ER8rSF;EQ9lSE;IAhGA,YAAA;ERisSF;EQhmSE;IAjGA,YAAA;ERosSF;AACF;AQ9lSS;EACG,WAAA;ARgmSZ;AQjmSS;EACG,mBAAA;ARmmSZ;AQpmSS;EACG,mBAAA;ARsmSZ;AQvmSS;EACG,UAAA;ARymSZ;AQ1mSS;EACG,mBAAA;AR4mSZ;AQ7mSS;EACG,mBAAA;AR+mSZ;AQhnSS;EACG,UAAA;ARknSZ;AQnnSS;EACG,mBAAA;ARqnSZ;AQtnSS;EACG,mBAAA;ARwnSZ;AQznSS;EACG,UAAA;AR2nSZ;AQ5nSS;EACG,mBAAA;AR8nSZ;AQ/nSS;EACG,kBAAA;ARioSZ;AQ3mSA;EAXS;IACG,WAAA;ERynSV;EQ1nSO;IACG,mBAAA;ER4nSV;EQ7nSO;IACG,mBAAA;ER+nSV;EQhoSO;IACG,UAAA;ERkoSV;EQnoSO;IACG,mBAAA;ERqoSV;EQtoSO;IACG,mBAAA;ERwoSV;EQzoSO;IACG,UAAA;ER2oSV;EQ5oSO;IACG,mBAAA;ER8oSV;EQ/oSO;IACG,mBAAA;ERipSV;EQlpSO;IACG,UAAA;ERopSV;EQrpSO;IACG,mBAAA;ERupSV;EQxpSO;IACG,kBAAA;ER0pSV;AACF;AQhpSA;EAZS;IACG,WAAA;ER+pSV;EQhqSO;IACG,mBAAA;ERkqSV;EQnqSO;IACG,mBAAA;ERqqSV;EQtqSO;IACG,UAAA;ERwqSV;EQzqSO;IACG,mBAAA;ER2qSV;EQ5qSO;IACG,mBAAA;ER8qSV;EQ/qSO;IACG,UAAA;ERirSV;EQlrSO;IACG,mBAAA;ERorSV;EQrrSO;IACG,mBAAA;ERurSV;EQxrSO;IACG,UAAA;ER0rSV;EQ3rSO;IACG,mBAAA;ER6rSV;EQ9rSO;IACG,kBAAA;ERgsSV;AACF;AQrrSA;EAbS;IACG,WAAA;ERqsSV;EQtsSO;IACG,mBAAA;ERwsSV;EQzsSO;IACG,mBAAA;ER2sSV;EQ5sSO;IACG,UAAA;ER8sSV;EQ/sSO;IACG,mBAAA;ERitSV;EQltSO;IACG,mBAAA;ERotSV;EQrtSO;IACG,UAAA;ERutSV;EQxtSO;IACG,mBAAA;ER0tSV;EQ3tSO;IACG,mBAAA;ER6tSV;EQ9tSO;IACG,UAAA;ERguSV;EQjuSO;IACG,mBAAA;ERmuSV;EQpuSO;IACG,kBAAA;ERsuSV;AACF;AQ1tSA;EAdS;IACG,WAAA;ER2uSV;EQ5uSO;IACG,mBAAA;ER8uSV;EQ/uSO;IACG,mBAAA;ERivSV;EQlvSO;IACG,UAAA;ERovSV;EQrvSO;IACG,mBAAA;ERuvSV;EQxvSO;IACG,mBAAA;ER0vSV;EQ3vSO;IACG,UAAA;ER6vSV;EQ9vSO;IACG,mBAAA;ERgwSV;EQjwSO;IACG,mBAAA;ERmwSV;EQpwSO;IACG,UAAA;ERswSV;EQvwSO;IACG,mBAAA;ERywSV;EQ1wSO;IACG,kBAAA;ER4wSV;AACF;AQ1xSS;EACG,WAAA;AR4xSZ;AQ7xSS;EACG,UAAA;AR+xSZ;AQhySS;EACG,UAAA;ARkySZ;AQnySS;EACG,UAAA;ARqySZ;AQtySS;EACG,UAAA;ARwySZ;AQzySS;EACG,UAAA;AR2ySZ;AQ5ySS;EACG,UAAA;AR8ySZ;AQ/ySS;EACG,UAAA;ARizSZ;AQlzSS;EACG,UAAA;ARozSZ;AQrzSS;EACG,UAAA;ARuzSZ;AQxzSS;EACG,UAAA;AR0zSZ;AQ3zSS;EACG,UAAA;AR6zSZ;AQ9zSS;EACG,UAAA;ARg0SZ;AQj0SS;EACG,UAAA;ARm0SZ;AQp0SS;EACG,UAAA;ARs0SZ;AQv0SS;EACG,UAAA;ARy0SZ;AQ10SS;EACG,UAAA;AR40SZ;AQ70SS;EACG,UAAA;AR+0SZ;AQh1SS;EACG,UAAA;ARk1SZ;AQn1SS;EACG,SAAA;ARq1SZ;AQzzSA;EAjBS;IACG,WAAA;ER60SV;EQ90SO;IACG,UAAA;ERg1SV;EQj1SO;IACG,UAAA;ERm1SV;EQp1SO;IACG,UAAA;ERs1SV;EQv1SO;IACG,UAAA;ERy1SV;EQ11SO;IACG,UAAA;ER41SV;EQ71SO;IACG,UAAA;ER+1SV;EQh2SO;IACG,UAAA;ERk2SV;EQn2SO;IACG,UAAA;ERq2SV;EQt2SO;IACG,UAAA;ERw2SV;EQz2SO;IACG,UAAA;ER22SV;EQ52SO;IACG,UAAA;ER82SV;EQ/2SO;IACG,UAAA;ERi3SV;EQl3SO;IACG,UAAA;ERo3SV;EQr3SO;IACG,UAAA;ERu3SV;EQx3SO;IACG,UAAA;ER03SV;EQ33SO;IACG,UAAA;ER63SV;EQ93SO;IACG,UAAA;ERg4SV;EQj4SO;IACG,UAAA;ERm4SV;EQp4SO;IACG,SAAA;ERs4SV;AACF;AQt3SA;EAlBS;IACG,WAAA;ER24SV;EQ54SO;IACG,UAAA;ER84SV;EQ/4SO;IACG,UAAA;ERi5SV;EQl5SO;IACG,UAAA;ERo5SV;EQr5SO;IACG,UAAA;ERu5SV;EQx5SO;IACG,UAAA;ER05SV;EQ35SO;IACG,UAAA;ER65SV;EQ95SO;IACG,UAAA;ERg6SV;EQj6SO;IACG,UAAA;ERm6SV;EQp6SO;IACG,UAAA;ERs6SV;EQv6SO;IACG,UAAA;ERy6SV;EQ16SO;IACG,UAAA;ER46SV;EQ76SO;IACG,UAAA;ER+6SV;EQh7SO;IACG,UAAA;ERk7SV;EQn7SO;IACG,UAAA;ERq7SV;EQt7SO;IACG,UAAA;ERw7SV;EQz7SO;IACG,UAAA;ER27SV;EQ57SO;IACG,UAAA;ER87SV;EQ/7SO;IACG,UAAA;ERi8SV;EQl8SO;IACG,SAAA;ERo8SV;AACF;AQn7SA;EAnBS;IACG,WAAA;ERy8SV;EQ18SO;IACG,UAAA;ER48SV;EQ78SO;IACG,UAAA;ER+8SV;EQh9SO;IACG,UAAA;ERk9SV;EQn9SO;IACG,UAAA;ERq9SV;EQt9SO;IACG,UAAA;ERw9SV;EQz9SO;IACG,UAAA;ER29SV;EQ59SO;IACG,UAAA;ER89SV;EQ/9SO;IACG,UAAA;ERi+SV;EQl+SO;IACG,UAAA;ERo+SV;EQr+SO;IACG,UAAA;ERu+SV;EQx+SO;IACG,UAAA;ER0+SV;EQ3+SO;IACG,UAAA;ER6+SV;EQ9+SO;IACG,UAAA;ERg/SV;EQj/SO;IACG,UAAA;ERm/SV;EQp/SO;IACG,UAAA;ERs/SV;EQv/SO;IACG,UAAA;ERy/SV;EQ1/SO;IACG,UAAA;ER4/SV;EQ7/SO;IACG,UAAA;ER+/SV;EQhgTO;IACG,SAAA;ERkgTV;AACF;AQh/SA;EApBS;IACG,WAAA;ERugTV;EQxgTO;IACG,UAAA;ER0gTV;EQ3gTO;IACG,UAAA;ER6gTV;EQ9gTO;IACG,UAAA;ERghTV;EQjhTO;IACG,UAAA;ERmhTV;EQphTO;IACG,UAAA;ERshTV;EQvhTO;IACG,UAAA;ERyhTV;EQ1hTO;IACG,UAAA;ER4hTV;EQ7hTO;IACG,UAAA;ER+hTV;EQhiTO;IACG,UAAA;ERkiTV;EQniTO;IACG,UAAA;ERqiTV;EQtiTO;IACG,UAAA;ERwiTV;EQziTO;IACG,UAAA;ER2iTV;EQ5iTO;IACG,UAAA;ER8iTV;EQ/iTO;IACG,UAAA;ERijTV;EQljTO;IACG,UAAA;ERojTV;EQrjTO;IACG,UAAA;ERujTV;EQxjTO;IACG,UAAA;ER0jTV;EQ3jTO;IACG,UAAA;ER6jTV;EQ9jTO;IACG,SAAA;ERgkTV;AACF;AS7sTA;EACI,oCAAA;EACA,mBAAA;EACA,uBAAA;AT+sTJ;AS7sTI;EACI,oCAAA;AT+sTR;ASrtTA;EAUQ,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,2BAAA;EACA,oEAAA;EACA,iBAAA;EACA,WAAA;AT8sTR;AS1sTA;EACI,oCAAA;EACA,mBAAA;EACA,uBAAA;AT4sTJ;AS1sTI;EACI,oCAAA;AT4sTR;ASltTA;EAUQ,gBAAA;EACA,iBAAA;AT2sTR;AU5uTA;EACI,YAAA;EACA,yBAAA;EACA,uBAAA;AV8uTJ;AU3uTA;EACI,UAAA;AV6uTJ;AWpvTA;EACI,2BAAA;EACA,qBAAA;EACA,6BAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,iCAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;AXsvTJ;AWpvTI;EACI,UAAA;AXsvTR;AYhwTA;EACI,2BAAA;EACA,qBAAA;EACA,6BAAA;EACA,yBAAA;EACA,2BAAA;EACA,6BAAA;EACA,iCAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;AZkwTJ;Aa/wTA;EACI,2BAAA;EACA,2BAAA;EACA,uBAAA;AbixTJ;Ac9vTA;EACI,YAAA;AdgwTJ;Ac7vTA;EACI,yBAAA;Ad+vTJ;Ac5vTA;EACI,oBAAA;Ad8vTJ;Ac3vTA;EACI,eAAA;EACA,MAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,4BAAA;Ad6vTJ;Ac3vTI;EACI,YAAA;Ad6vTR;Ac1vTI;EAAA;IAEI,gBAAA;IACA,sBAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;Ed4vTN;AACF;AcxvTI;EACI,MAAA;Ad0vTR;Ac5vTA;EAMQ,iBAAA;AdyvTR;AcrvTA;EACI,yBAAA;AduvTJ;AcrvTI;;EAEI,yBAAA;AduvTR;AcnvTA;EACI,YAAA;EACA,yBAAA;AdqvTJ;AcnvTI;;EAEI,yBAAA;AdqvTR;AcjvTA;EACI,yBAAA;AdmvTJ;AcjvTI;;EAEI,yBAAA;AdmvTR;Ac9uTI;EACI,UAAA;AdgvTR;Ac5uTA;EACI,kCAAA;Ad8uTJ;Ac3uTA;EACI,gCAAA;EACA,6BAAA;Ad6uTJ;Ac1uTA;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;Ad4uTJ;AczuTA;EACI,gCAAA;Ad2uTJ;AcxuTA;EACI,yBAAA;EACA,WAAA;Ad0uTJ;AcvuTA;EACI,eAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AdyuTJ;ActuTA;EACI,oBAAA;AdwuTJ;AcruTA;EACI,yBAAA;EACA,WAAA;EACA,mBAAA;AduuTJ;AcpuTA;EACI,iBAAA;EACA,eAAA;EACA,WAAA;EACA,qBAAA;AdsuTJ;AcnuTA;EACI,iBAAA;EACA,qBAAA;EACA,WAAA;AdquTJ;AcnuTI;EACI,yBAAA;EACA,WAAA;AdquTR;AcjuTA;EACI,yBAAA;EACA,WAAA;AdmuTJ;AchuTA;EACI,wBAAA;AdkuTJ;Ac/tTA;EACI,qBAAA;AdiuTJ;Ac9tTA;EACI,wCAAA;EACA,yBAAA;EACA,oCAAA;AdguTJ;Ac7tTA;EACI;IACI,WAAA;IACA,mBAAA;Ed+tTN;Ec5tTE;IACI,WAAA;Ed8tTN;Ec3tTE;IACI,8BAAA;Ed6tTN;AACF;Ac1tTA;EACI;IACI,mBAAA;Ed4tTN;AACF;AcztTA;EACI;IACI,qBAAA;Ed2tTN;EcxtTE;IACI,mBAAA;Ed0tTN;AACF;AcvtTA;EACI;IACI,kBAAA;EdytTN;AACF;ActtTA;EACI;IACI,gBAAA;EdwtTN;EcrtTE;IACI,kBAAA;EdutTN;EcptTE;IACI,mBAAA;EdstTN;AACF;AcntTA;EACI;IACI,uBAAA;EdqtTN;EcltTE;IACI,yBAAA;EdotTN;AACF;AcjtTA;EACI,kCAAA;AdmtTJ;AchtTA;EACI,oBAAA;EACA,eAAA;EACA,WAAA;AdktTJ;Ac/sTA;EACI,eAAA;AditTJ;Ac9sTA;EACI,mBAAA;EACA,oBAAA;EACA,kBAAA;AdgtTJ;Ac7sTA;EACI,mBAAA;Ad+sTJ;Ac5sTA;;EAEI,gBAAA;EACA,cAAA;Ad8sTJ;Ac3sTA;EACI,gBAAA;EACA,cAAA;EACA,oBAAA;Ad6sTJ;Ac1sTA;;;;;;;;;;;;;;EAQI,YAAA;AdktTJ;Ac/sTA;EACI,cAAA;AditTJ;Ac9sTA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;AdgtTJ;Ac7sTA;EACI,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;Ad+sTJ;Ac5sTA;EACI,YAAA;Ad8sTJ;Ac3sTA;EAEI,cAAA;Ad4sTJ;AczsTA;EACI,cAAA;Ad2sTJ;AcxsTA;;EAEI,gBAAA;EACA,cAAA;Ad0sTJ;AcvsTA;EACI,gBAAA;EACA,cAAA;EACA,oBAAA;AdysTJ;ActsTA;;;;;;;;;;;;;;EAQI,YAAA;Ad8sTJ;Ac3sTA;EACI,cAAA;Ad6sTJ;Ac1sTA;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,kBAAA;Ad4sTJ;AczsTA;EACI,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;Ad2sTJ;AcxsTA;EACI,YAAA;Ad0sTJ;AcvsTA;EAEI,cAAA;AdwsTJ;AACA;;;;;;;;;CASC","sourcesContent":["/*!\n * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n.fa {\n  font-family: var(--fa-style-family, \"Font Awesome 6 Free\");\n  font-weight: var(--fa-style, 900);\n}\n.fas,\n.far,\n.fab,\n.fa-solid,\n.fa-regular,\n.fa-brands,\n.fa {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--fa-display, inline-block);\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto;\n}\n.fas::before,\n.far::before,\n.fab::before,\n.fa-solid::before,\n.fa-regular::before,\n.fa-brands::before,\n.fa::before {\n  content: var(--fa);\n}\n.fa-classic,\n.fas,\n.fa-solid,\n.far,\n.fa-regular {\n  font-family: 'Font Awesome 6 Free';\n}\n.fa-brands,\n.fab {\n  font-family: 'Font Awesome 6 Brands';\n}\n.fa-1x {\n  font-size: 1em;\n}\n.fa-2x {\n  font-size: 2em;\n}\n.fa-3x {\n  font-size: 3em;\n}\n.fa-4x {\n  font-size: 4em;\n}\n.fa-5x {\n  font-size: 5em;\n}\n.fa-6x {\n  font-size: 6em;\n}\n.fa-7x {\n  font-size: 7em;\n}\n.fa-8x {\n  font-size: 8em;\n}\n.fa-9x {\n  font-size: 9em;\n}\n.fa-10x {\n  font-size: 10em;\n}\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.08333em;\n  vertical-align: 0.125em;\n}\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.07143em;\n  vertical-align: 0.05357em;\n}\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.04167em;\n  vertical-align: -0.125em;\n}\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n  .fa-bounce,\n  .fa-fade,\n  .fa-beat-fade,\n  .fa-flip,\n  .fa-pulse,\n  .fa-shake,\n  .fa-spin,\n  .fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%,\n  90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%,\n  100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%,\n  24% {\n    transform: rotate(-18deg);\n  }\n  12%,\n  28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%,\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--fa-stack-z-index, auto);\n}\n.fa-stack-1x {\n  line-height: inherit;\n}\n.fa-stack-2x {\n  font-size: 2em;\n}\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n.fa-0 {\n  --fa: \"\\30\";\n}\n.fa-1 {\n  --fa: \"\\31\";\n}\n.fa-2 {\n  --fa: \"\\32\";\n}\n.fa-3 {\n  --fa: \"\\33\";\n}\n.fa-4 {\n  --fa: \"\\34\";\n}\n.fa-5 {\n  --fa: \"\\35\";\n}\n.fa-6 {\n  --fa: \"\\36\";\n}\n.fa-7 {\n  --fa: \"\\37\";\n}\n.fa-8 {\n  --fa: \"\\38\";\n}\n.fa-9 {\n  --fa: \"\\39\";\n}\n.fa-fill-drip {\n  --fa: \"\\f576\";\n}\n.fa-arrows-to-circle {\n  --fa: \"\\e4bd\";\n}\n.fa-circle-chevron-right {\n  --fa: \"\\f138\";\n}\n.fa-chevron-circle-right {\n  --fa: \"\\f138\";\n}\n.fa-at {\n  --fa: \"\\40\";\n}\n.fa-trash-can {\n  --fa: \"\\f2ed\";\n}\n.fa-trash-alt {\n  --fa: \"\\f2ed\";\n}\n.fa-text-height {\n  --fa: \"\\f034\";\n}\n.fa-user-xmark {\n  --fa: \"\\f235\";\n}\n.fa-user-times {\n  --fa: \"\\f235\";\n}\n.fa-stethoscope {\n  --fa: \"\\f0f1\";\n}\n.fa-message {\n  --fa: \"\\f27a\";\n}\n.fa-comment-alt {\n  --fa: \"\\f27a\";\n}\n.fa-info {\n  --fa: \"\\f129\";\n}\n.fa-down-left-and-up-right-to-center {\n  --fa: \"\\f422\";\n}\n.fa-compress-alt {\n  --fa: \"\\f422\";\n}\n.fa-explosion {\n  --fa: \"\\e4e9\";\n}\n.fa-file-lines {\n  --fa: \"\\f15c\";\n}\n.fa-file-alt {\n  --fa: \"\\f15c\";\n}\n.fa-file-text {\n  --fa: \"\\f15c\";\n}\n.fa-wave-square {\n  --fa: \"\\f83e\";\n}\n.fa-ring {\n  --fa: \"\\f70b\";\n}\n.fa-building-un {\n  --fa: \"\\e4d9\";\n}\n.fa-dice-three {\n  --fa: \"\\f527\";\n}\n.fa-calendar-days {\n  --fa: \"\\f073\";\n}\n.fa-calendar-alt {\n  --fa: \"\\f073\";\n}\n.fa-anchor-circle-check {\n  --fa: \"\\e4aa\";\n}\n.fa-building-circle-arrow-right {\n  --fa: \"\\e4d1\";\n}\n.fa-volleyball {\n  --fa: \"\\f45f\";\n}\n.fa-volleyball-ball {\n  --fa: \"\\f45f\";\n}\n.fa-arrows-up-to-line {\n  --fa: \"\\e4c2\";\n}\n.fa-sort-down {\n  --fa: \"\\f0dd\";\n}\n.fa-sort-desc {\n  --fa: \"\\f0dd\";\n}\n.fa-circle-minus {\n  --fa: \"\\f056\";\n}\n.fa-minus-circle {\n  --fa: \"\\f056\";\n}\n.fa-door-open {\n  --fa: \"\\f52b\";\n}\n.fa-right-from-bracket {\n  --fa: \"\\f2f5\";\n}\n.fa-sign-out-alt {\n  --fa: \"\\f2f5\";\n}\n.fa-atom {\n  --fa: \"\\f5d2\";\n}\n.fa-soap {\n  --fa: \"\\e06e\";\n}\n.fa-icons {\n  --fa: \"\\f86d\";\n}\n.fa-heart-music-camera-bolt {\n  --fa: \"\\f86d\";\n}\n.fa-microphone-lines-slash {\n  --fa: \"\\f539\";\n}\n.fa-microphone-alt-slash {\n  --fa: \"\\f539\";\n}\n.fa-bridge-circle-check {\n  --fa: \"\\e4c9\";\n}\n.fa-pump-medical {\n  --fa: \"\\e06a\";\n}\n.fa-fingerprint {\n  --fa: \"\\f577\";\n}\n.fa-hand-point-right {\n  --fa: \"\\f0a4\";\n}\n.fa-magnifying-glass-location {\n  --fa: \"\\f689\";\n}\n.fa-search-location {\n  --fa: \"\\f689\";\n}\n.fa-forward-step {\n  --fa: \"\\f051\";\n}\n.fa-step-forward {\n  --fa: \"\\f051\";\n}\n.fa-face-smile-beam {\n  --fa: \"\\f5b8\";\n}\n.fa-smile-beam {\n  --fa: \"\\f5b8\";\n}\n.fa-flag-checkered {\n  --fa: \"\\f11e\";\n}\n.fa-football {\n  --fa: \"\\f44e\";\n}\n.fa-football-ball {\n  --fa: \"\\f44e\";\n}\n.fa-school-circle-exclamation {\n  --fa: \"\\e56c\";\n}\n.fa-crop {\n  --fa: \"\\f125\";\n}\n.fa-angles-down {\n  --fa: \"\\f103\";\n}\n.fa-angle-double-down {\n  --fa: \"\\f103\";\n}\n.fa-users-rectangle {\n  --fa: \"\\e594\";\n}\n.fa-people-roof {\n  --fa: \"\\e537\";\n}\n.fa-people-line {\n  --fa: \"\\e534\";\n}\n.fa-beer-mug-empty {\n  --fa: \"\\f0fc\";\n}\n.fa-beer {\n  --fa: \"\\f0fc\";\n}\n.fa-diagram-predecessor {\n  --fa: \"\\e477\";\n}\n.fa-arrow-up-long {\n  --fa: \"\\f176\";\n}\n.fa-long-arrow-up {\n  --fa: \"\\f176\";\n}\n.fa-fire-flame-simple {\n  --fa: \"\\f46a\";\n}\n.fa-burn {\n  --fa: \"\\f46a\";\n}\n.fa-person {\n  --fa: \"\\f183\";\n}\n.fa-male {\n  --fa: \"\\f183\";\n}\n.fa-laptop {\n  --fa: \"\\f109\";\n}\n.fa-file-csv {\n  --fa: \"\\f6dd\";\n}\n.fa-menorah {\n  --fa: \"\\f676\";\n}\n.fa-truck-plane {\n  --fa: \"\\e58f\";\n}\n.fa-record-vinyl {\n  --fa: \"\\f8d9\";\n}\n.fa-face-grin-stars {\n  --fa: \"\\f587\";\n}\n.fa-grin-stars {\n  --fa: \"\\f587\";\n}\n.fa-bong {\n  --fa: \"\\f55c\";\n}\n.fa-spaghetti-monster-flying {\n  --fa: \"\\f67b\";\n}\n.fa-pastafarianism {\n  --fa: \"\\f67b\";\n}\n.fa-arrow-down-up-across-line {\n  --fa: \"\\e4af\";\n}\n.fa-spoon {\n  --fa: \"\\f2e5\";\n}\n.fa-utensil-spoon {\n  --fa: \"\\f2e5\";\n}\n.fa-jar-wheat {\n  --fa: \"\\e517\";\n}\n.fa-envelopes-bulk {\n  --fa: \"\\f674\";\n}\n.fa-mail-bulk {\n  --fa: \"\\f674\";\n}\n.fa-file-circle-exclamation {\n  --fa: \"\\e4eb\";\n}\n.fa-circle-h {\n  --fa: \"\\f47e\";\n}\n.fa-hospital-symbol {\n  --fa: \"\\f47e\";\n}\n.fa-pager {\n  --fa: \"\\f815\";\n}\n.fa-address-book {\n  --fa: \"\\f2b9\";\n}\n.fa-contact-book {\n  --fa: \"\\f2b9\";\n}\n.fa-strikethrough {\n  --fa: \"\\f0cc\";\n}\n.fa-k {\n  --fa: \"\\4b\";\n}\n.fa-landmark-flag {\n  --fa: \"\\e51c\";\n}\n.fa-pencil {\n  --fa: \"\\f303\";\n}\n.fa-pencil-alt {\n  --fa: \"\\f303\";\n}\n.fa-backward {\n  --fa: \"\\f04a\";\n}\n.fa-caret-right {\n  --fa: \"\\f0da\";\n}\n.fa-comments {\n  --fa: \"\\f086\";\n}\n.fa-paste {\n  --fa: \"\\f0ea\";\n}\n.fa-file-clipboard {\n  --fa: \"\\f0ea\";\n}\n.fa-code-pull-request {\n  --fa: \"\\e13c\";\n}\n.fa-clipboard-list {\n  --fa: \"\\f46d\";\n}\n.fa-truck-ramp-box {\n  --fa: \"\\f4de\";\n}\n.fa-truck-loading {\n  --fa: \"\\f4de\";\n}\n.fa-user-check {\n  --fa: \"\\f4fc\";\n}\n.fa-vial-virus {\n  --fa: \"\\e597\";\n}\n.fa-sheet-plastic {\n  --fa: \"\\e571\";\n}\n.fa-blog {\n  --fa: \"\\f781\";\n}\n.fa-user-ninja {\n  --fa: \"\\f504\";\n}\n.fa-person-arrow-up-from-line {\n  --fa: \"\\e539\";\n}\n.fa-scroll-torah {\n  --fa: \"\\f6a0\";\n}\n.fa-torah {\n  --fa: \"\\f6a0\";\n}\n.fa-broom-ball {\n  --fa: \"\\f458\";\n}\n.fa-quidditch {\n  --fa: \"\\f458\";\n}\n.fa-quidditch-broom-ball {\n  --fa: \"\\f458\";\n}\n.fa-toggle-off {\n  --fa: \"\\f204\";\n}\n.fa-box-archive {\n  --fa: \"\\f187\";\n}\n.fa-archive {\n  --fa: \"\\f187\";\n}\n.fa-person-drowning {\n  --fa: \"\\e545\";\n}\n.fa-arrow-down-9-1 {\n  --fa: \"\\f886\";\n}\n.fa-sort-numeric-desc {\n  --fa: \"\\f886\";\n}\n.fa-sort-numeric-down-alt {\n  --fa: \"\\f886\";\n}\n.fa-face-grin-tongue-squint {\n  --fa: \"\\f58a\";\n}\n.fa-grin-tongue-squint {\n  --fa: \"\\f58a\";\n}\n.fa-spray-can {\n  --fa: \"\\f5bd\";\n}\n.fa-truck-monster {\n  --fa: \"\\f63b\";\n}\n.fa-w {\n  --fa: \"\\57\";\n}\n.fa-earth-africa {\n  --fa: \"\\f57c\";\n}\n.fa-globe-africa {\n  --fa: \"\\f57c\";\n}\n.fa-rainbow {\n  --fa: \"\\f75b\";\n}\n.fa-circle-notch {\n  --fa: \"\\f1ce\";\n}\n.fa-tablet-screen-button {\n  --fa: \"\\f3fa\";\n}\n.fa-tablet-alt {\n  --fa: \"\\f3fa\";\n}\n.fa-paw {\n  --fa: \"\\f1b0\";\n}\n.fa-cloud {\n  --fa: \"\\f0c2\";\n}\n.fa-trowel-bricks {\n  --fa: \"\\e58a\";\n}\n.fa-face-flushed {\n  --fa: \"\\f579\";\n}\n.fa-flushed {\n  --fa: \"\\f579\";\n}\n.fa-hospital-user {\n  --fa: \"\\f80d\";\n}\n.fa-tent-arrow-left-right {\n  --fa: \"\\e57f\";\n}\n.fa-gavel {\n  --fa: \"\\f0e3\";\n}\n.fa-legal {\n  --fa: \"\\f0e3\";\n}\n.fa-binoculars {\n  --fa: \"\\f1e5\";\n}\n.fa-microphone-slash {\n  --fa: \"\\f131\";\n}\n.fa-box-tissue {\n  --fa: \"\\e05b\";\n}\n.fa-motorcycle {\n  --fa: \"\\f21c\";\n}\n.fa-bell-concierge {\n  --fa: \"\\f562\";\n}\n.fa-concierge-bell {\n  --fa: \"\\f562\";\n}\n.fa-pen-ruler {\n  --fa: \"\\f5ae\";\n}\n.fa-pencil-ruler {\n  --fa: \"\\f5ae\";\n}\n.fa-people-arrows {\n  --fa: \"\\e068\";\n}\n.fa-people-arrows-left-right {\n  --fa: \"\\e068\";\n}\n.fa-mars-and-venus-burst {\n  --fa: \"\\e523\";\n}\n.fa-square-caret-right {\n  --fa: \"\\f152\";\n}\n.fa-caret-square-right {\n  --fa: \"\\f152\";\n}\n.fa-scissors {\n  --fa: \"\\f0c4\";\n}\n.fa-cut {\n  --fa: \"\\f0c4\";\n}\n.fa-sun-plant-wilt {\n  --fa: \"\\e57a\";\n}\n.fa-toilets-portable {\n  --fa: \"\\e584\";\n}\n.fa-hockey-puck {\n  --fa: \"\\f453\";\n}\n.fa-table {\n  --fa: \"\\f0ce\";\n}\n.fa-magnifying-glass-arrow-right {\n  --fa: \"\\e521\";\n}\n.fa-tachograph-digital {\n  --fa: \"\\f566\";\n}\n.fa-digital-tachograph {\n  --fa: \"\\f566\";\n}\n.fa-users-slash {\n  --fa: \"\\e073\";\n}\n.fa-clover {\n  --fa: \"\\e139\";\n}\n.fa-reply {\n  --fa: \"\\f3e5\";\n}\n.fa-mail-reply {\n  --fa: \"\\f3e5\";\n}\n.fa-star-and-crescent {\n  --fa: \"\\f699\";\n}\n.fa-house-fire {\n  --fa: \"\\e50c\";\n}\n.fa-square-minus {\n  --fa: \"\\f146\";\n}\n.fa-minus-square {\n  --fa: \"\\f146\";\n}\n.fa-helicopter {\n  --fa: \"\\f533\";\n}\n.fa-compass {\n  --fa: \"\\f14e\";\n}\n.fa-square-caret-down {\n  --fa: \"\\f150\";\n}\n.fa-caret-square-down {\n  --fa: \"\\f150\";\n}\n.fa-file-circle-question {\n  --fa: \"\\e4ef\";\n}\n.fa-laptop-code {\n  --fa: \"\\f5fc\";\n}\n.fa-swatchbook {\n  --fa: \"\\f5c3\";\n}\n.fa-prescription-bottle {\n  --fa: \"\\f485\";\n}\n.fa-bars {\n  --fa: \"\\f0c9\";\n}\n.fa-navicon {\n  --fa: \"\\f0c9\";\n}\n.fa-people-group {\n  --fa: \"\\e533\";\n}\n.fa-hourglass-end {\n  --fa: \"\\f253\";\n}\n.fa-hourglass-3 {\n  --fa: \"\\f253\";\n}\n.fa-heart-crack {\n  --fa: \"\\f7a9\";\n}\n.fa-heart-broken {\n  --fa: \"\\f7a9\";\n}\n.fa-square-up-right {\n  --fa: \"\\f360\";\n}\n.fa-external-link-square-alt {\n  --fa: \"\\f360\";\n}\n.fa-face-kiss-beam {\n  --fa: \"\\f597\";\n}\n.fa-kiss-beam {\n  --fa: \"\\f597\";\n}\n.fa-film {\n  --fa: \"\\f008\";\n}\n.fa-ruler-horizontal {\n  --fa: \"\\f547\";\n}\n.fa-people-robbery {\n  --fa: \"\\e536\";\n}\n.fa-lightbulb {\n  --fa: \"\\f0eb\";\n}\n.fa-caret-left {\n  --fa: \"\\f0d9\";\n}\n.fa-circle-exclamation {\n  --fa: \"\\f06a\";\n}\n.fa-exclamation-circle {\n  --fa: \"\\f06a\";\n}\n.fa-school-circle-xmark {\n  --fa: \"\\e56d\";\n}\n.fa-arrow-right-from-bracket {\n  --fa: \"\\f08b\";\n}\n.fa-sign-out {\n  --fa: \"\\f08b\";\n}\n.fa-circle-chevron-down {\n  --fa: \"\\f13a\";\n}\n.fa-chevron-circle-down {\n  --fa: \"\\f13a\";\n}\n.fa-unlock-keyhole {\n  --fa: \"\\f13e\";\n}\n.fa-unlock-alt {\n  --fa: \"\\f13e\";\n}\n.fa-cloud-showers-heavy {\n  --fa: \"\\f740\";\n}\n.fa-headphones-simple {\n  --fa: \"\\f58f\";\n}\n.fa-headphones-alt {\n  --fa: \"\\f58f\";\n}\n.fa-sitemap {\n  --fa: \"\\f0e8\";\n}\n.fa-circle-dollar-to-slot {\n  --fa: \"\\f4b9\";\n}\n.fa-donate {\n  --fa: \"\\f4b9\";\n}\n.fa-memory {\n  --fa: \"\\f538\";\n}\n.fa-road-spikes {\n  --fa: \"\\e568\";\n}\n.fa-fire-burner {\n  --fa: \"\\e4f1\";\n}\n.fa-flag {\n  --fa: \"\\f024\";\n}\n.fa-hanukiah {\n  --fa: \"\\f6e6\";\n}\n.fa-feather {\n  --fa: \"\\f52d\";\n}\n.fa-volume-low {\n  --fa: \"\\f027\";\n}\n.fa-volume-down {\n  --fa: \"\\f027\";\n}\n.fa-comment-slash {\n  --fa: \"\\f4b3\";\n}\n.fa-cloud-sun-rain {\n  --fa: \"\\f743\";\n}\n.fa-compress {\n  --fa: \"\\f066\";\n}\n.fa-wheat-awn {\n  --fa: \"\\e2cd\";\n}\n.fa-wheat-alt {\n  --fa: \"\\e2cd\";\n}\n.fa-ankh {\n  --fa: \"\\f644\";\n}\n.fa-hands-holding-child {\n  --fa: \"\\e4fa\";\n}\n.fa-asterisk {\n  --fa: \"\\2a\";\n}\n.fa-square-check {\n  --fa: \"\\f14a\";\n}\n.fa-check-square {\n  --fa: \"\\f14a\";\n}\n.fa-peseta-sign {\n  --fa: \"\\e221\";\n}\n.fa-heading {\n  --fa: \"\\f1dc\";\n}\n.fa-header {\n  --fa: \"\\f1dc\";\n}\n.fa-ghost {\n  --fa: \"\\f6e2\";\n}\n.fa-list {\n  --fa: \"\\f03a\";\n}\n.fa-list-squares {\n  --fa: \"\\f03a\";\n}\n.fa-square-phone-flip {\n  --fa: \"\\f87b\";\n}\n.fa-phone-square-alt {\n  --fa: \"\\f87b\";\n}\n.fa-cart-plus {\n  --fa: \"\\f217\";\n}\n.fa-gamepad {\n  --fa: \"\\f11b\";\n}\n.fa-circle-dot {\n  --fa: \"\\f192\";\n}\n.fa-dot-circle {\n  --fa: \"\\f192\";\n}\n.fa-face-dizzy {\n  --fa: \"\\f567\";\n}\n.fa-dizzy {\n  --fa: \"\\f567\";\n}\n.fa-egg {\n  --fa: \"\\f7fb\";\n}\n.fa-house-medical-circle-xmark {\n  --fa: \"\\e513\";\n}\n.fa-campground {\n  --fa: \"\\f6bb\";\n}\n.fa-folder-plus {\n  --fa: \"\\f65e\";\n}\n.fa-futbol {\n  --fa: \"\\f1e3\";\n}\n.fa-futbol-ball {\n  --fa: \"\\f1e3\";\n}\n.fa-soccer-ball {\n  --fa: \"\\f1e3\";\n}\n.fa-paintbrush {\n  --fa: \"\\f1fc\";\n}\n.fa-paint-brush {\n  --fa: \"\\f1fc\";\n}\n.fa-lock {\n  --fa: \"\\f023\";\n}\n.fa-gas-pump {\n  --fa: \"\\f52f\";\n}\n.fa-hot-tub-person {\n  --fa: \"\\f593\";\n}\n.fa-hot-tub {\n  --fa: \"\\f593\";\n}\n.fa-map-location {\n  --fa: \"\\f59f\";\n}\n.fa-map-marked {\n  --fa: \"\\f59f\";\n}\n.fa-house-flood-water {\n  --fa: \"\\e50e\";\n}\n.fa-tree {\n  --fa: \"\\f1bb\";\n}\n.fa-bridge-lock {\n  --fa: \"\\e4cc\";\n}\n.fa-sack-dollar {\n  --fa: \"\\f81d\";\n}\n.fa-pen-to-square {\n  --fa: \"\\f044\";\n}\n.fa-edit {\n  --fa: \"\\f044\";\n}\n.fa-car-side {\n  --fa: \"\\f5e4\";\n}\n.fa-share-nodes {\n  --fa: \"\\f1e0\";\n}\n.fa-share-alt {\n  --fa: \"\\f1e0\";\n}\n.fa-heart-circle-minus {\n  --fa: \"\\e4ff\";\n}\n.fa-hourglass-half {\n  --fa: \"\\f252\";\n}\n.fa-hourglass-2 {\n  --fa: \"\\f252\";\n}\n.fa-microscope {\n  --fa: \"\\f610\";\n}\n.fa-sink {\n  --fa: \"\\e06d\";\n}\n.fa-bag-shopping {\n  --fa: \"\\f290\";\n}\n.fa-shopping-bag {\n  --fa: \"\\f290\";\n}\n.fa-arrow-down-z-a {\n  --fa: \"\\f881\";\n}\n.fa-sort-alpha-desc {\n  --fa: \"\\f881\";\n}\n.fa-sort-alpha-down-alt {\n  --fa: \"\\f881\";\n}\n.fa-mitten {\n  --fa: \"\\f7b5\";\n}\n.fa-person-rays {\n  --fa: \"\\e54d\";\n}\n.fa-users {\n  --fa: \"\\f0c0\";\n}\n.fa-eye-slash {\n  --fa: \"\\f070\";\n}\n.fa-flask-vial {\n  --fa: \"\\e4f3\";\n}\n.fa-hand {\n  --fa: \"\\f256\";\n}\n.fa-hand-paper {\n  --fa: \"\\f256\";\n}\n.fa-om {\n  --fa: \"\\f679\";\n}\n.fa-worm {\n  --fa: \"\\e599\";\n}\n.fa-house-circle-xmark {\n  --fa: \"\\e50b\";\n}\n.fa-plug {\n  --fa: \"\\f1e6\";\n}\n.fa-chevron-up {\n  --fa: \"\\f077\";\n}\n.fa-hand-spock {\n  --fa: \"\\f259\";\n}\n.fa-stopwatch {\n  --fa: \"\\f2f2\";\n}\n.fa-face-kiss {\n  --fa: \"\\f596\";\n}\n.fa-kiss {\n  --fa: \"\\f596\";\n}\n.fa-bridge-circle-xmark {\n  --fa: \"\\e4cb\";\n}\n.fa-face-grin-tongue {\n  --fa: \"\\f589\";\n}\n.fa-grin-tongue {\n  --fa: \"\\f589\";\n}\n.fa-chess-bishop {\n  --fa: \"\\f43a\";\n}\n.fa-face-grin-wink {\n  --fa: \"\\f58c\";\n}\n.fa-grin-wink {\n  --fa: \"\\f58c\";\n}\n.fa-ear-deaf {\n  --fa: \"\\f2a4\";\n}\n.fa-deaf {\n  --fa: \"\\f2a4\";\n}\n.fa-deafness {\n  --fa: \"\\f2a4\";\n}\n.fa-hard-of-hearing {\n  --fa: \"\\f2a4\";\n}\n.fa-road-circle-check {\n  --fa: \"\\e564\";\n}\n.fa-dice-five {\n  --fa: \"\\f523\";\n}\n.fa-square-rss {\n  --fa: \"\\f143\";\n}\n.fa-rss-square {\n  --fa: \"\\f143\";\n}\n.fa-land-mine-on {\n  --fa: \"\\e51b\";\n}\n.fa-i-cursor {\n  --fa: \"\\f246\";\n}\n.fa-stamp {\n  --fa: \"\\f5bf\";\n}\n.fa-stairs {\n  --fa: \"\\e289\";\n}\n.fa-i {\n  --fa: \"\\49\";\n}\n.fa-hryvnia-sign {\n  --fa: \"\\f6f2\";\n}\n.fa-hryvnia {\n  --fa: \"\\f6f2\";\n}\n.fa-pills {\n  --fa: \"\\f484\";\n}\n.fa-face-grin-wide {\n  --fa: \"\\f581\";\n}\n.fa-grin-alt {\n  --fa: \"\\f581\";\n}\n.fa-tooth {\n  --fa: \"\\f5c9\";\n}\n.fa-v {\n  --fa: \"\\56\";\n}\n.fa-bangladeshi-taka-sign {\n  --fa: \"\\e2e6\";\n}\n.fa-bicycle {\n  --fa: \"\\f206\";\n}\n.fa-staff-snake {\n  --fa: \"\\e579\";\n}\n.fa-rod-asclepius {\n  --fa: \"\\e579\";\n}\n.fa-rod-snake {\n  --fa: \"\\e579\";\n}\n.fa-staff-aesculapius {\n  --fa: \"\\e579\";\n}\n.fa-head-side-cough-slash {\n  --fa: \"\\e062\";\n}\n.fa-truck-medical {\n  --fa: \"\\f0f9\";\n}\n.fa-ambulance {\n  --fa: \"\\f0f9\";\n}\n.fa-wheat-awn-circle-exclamation {\n  --fa: \"\\e598\";\n}\n.fa-snowman {\n  --fa: \"\\f7d0\";\n}\n.fa-mortar-pestle {\n  --fa: \"\\f5a7\";\n}\n.fa-road-barrier {\n  --fa: \"\\e562\";\n}\n.fa-school {\n  --fa: \"\\f549\";\n}\n.fa-igloo {\n  --fa: \"\\f7ae\";\n}\n.fa-joint {\n  --fa: \"\\f595\";\n}\n.fa-angle-right {\n  --fa: \"\\f105\";\n}\n.fa-horse {\n  --fa: \"\\f6f0\";\n}\n.fa-q {\n  --fa: \"\\51\";\n}\n.fa-g {\n  --fa: \"\\47\";\n}\n.fa-notes-medical {\n  --fa: \"\\f481\";\n}\n.fa-temperature-half {\n  --fa: \"\\f2c9\";\n}\n.fa-temperature-2 {\n  --fa: \"\\f2c9\";\n}\n.fa-thermometer-2 {\n  --fa: \"\\f2c9\";\n}\n.fa-thermometer-half {\n  --fa: \"\\f2c9\";\n}\n.fa-dong-sign {\n  --fa: \"\\e169\";\n}\n.fa-capsules {\n  --fa: \"\\f46b\";\n}\n.fa-poo-storm {\n  --fa: \"\\f75a\";\n}\n.fa-poo-bolt {\n  --fa: \"\\f75a\";\n}\n.fa-face-frown-open {\n  --fa: \"\\f57a\";\n}\n.fa-frown-open {\n  --fa: \"\\f57a\";\n}\n.fa-hand-point-up {\n  --fa: \"\\f0a6\";\n}\n.fa-money-bill {\n  --fa: \"\\f0d6\";\n}\n.fa-bookmark {\n  --fa: \"\\f02e\";\n}\n.fa-align-justify {\n  --fa: \"\\f039\";\n}\n.fa-umbrella-beach {\n  --fa: \"\\f5ca\";\n}\n.fa-helmet-un {\n  --fa: \"\\e503\";\n}\n.fa-bullseye {\n  --fa: \"\\f140\";\n}\n.fa-bacon {\n  --fa: \"\\f7e5\";\n}\n.fa-hand-point-down {\n  --fa: \"\\f0a7\";\n}\n.fa-arrow-up-from-bracket {\n  --fa: \"\\e09a\";\n}\n.fa-folder {\n  --fa: \"\\f07b\";\n}\n.fa-folder-blank {\n  --fa: \"\\f07b\";\n}\n.fa-file-waveform {\n  --fa: \"\\f478\";\n}\n.fa-file-medical-alt {\n  --fa: \"\\f478\";\n}\n.fa-radiation {\n  --fa: \"\\f7b9\";\n}\n.fa-chart-simple {\n  --fa: \"\\e473\";\n}\n.fa-mars-stroke {\n  --fa: \"\\f229\";\n}\n.fa-vial {\n  --fa: \"\\f492\";\n}\n.fa-gauge {\n  --fa: \"\\f624\";\n}\n.fa-dashboard {\n  --fa: \"\\f624\";\n}\n.fa-gauge-med {\n  --fa: \"\\f624\";\n}\n.fa-tachometer-alt-average {\n  --fa: \"\\f624\";\n}\n.fa-wand-magic-sparkles {\n  --fa: \"\\e2ca\";\n}\n.fa-magic-wand-sparkles {\n  --fa: \"\\e2ca\";\n}\n.fa-e {\n  --fa: \"\\45\";\n}\n.fa-pen-clip {\n  --fa: \"\\f305\";\n}\n.fa-pen-alt {\n  --fa: \"\\f305\";\n}\n.fa-bridge-circle-exclamation {\n  --fa: \"\\e4ca\";\n}\n.fa-user {\n  --fa: \"\\f007\";\n}\n.fa-school-circle-check {\n  --fa: \"\\e56b\";\n}\n.fa-dumpster {\n  --fa: \"\\f793\";\n}\n.fa-van-shuttle {\n  --fa: \"\\f5b6\";\n}\n.fa-shuttle-van {\n  --fa: \"\\f5b6\";\n}\n.fa-building-user {\n  --fa: \"\\e4da\";\n}\n.fa-square-caret-left {\n  --fa: \"\\f191\";\n}\n.fa-caret-square-left {\n  --fa: \"\\f191\";\n}\n.fa-highlighter {\n  --fa: \"\\f591\";\n}\n.fa-key {\n  --fa: \"\\f084\";\n}\n.fa-bullhorn {\n  --fa: \"\\f0a1\";\n}\n.fa-globe {\n  --fa: \"\\f0ac\";\n}\n.fa-synagogue {\n  --fa: \"\\f69b\";\n}\n.fa-person-half-dress {\n  --fa: \"\\e548\";\n}\n.fa-road-bridge {\n  --fa: \"\\e563\";\n}\n.fa-location-arrow {\n  --fa: \"\\f124\";\n}\n.fa-c {\n  --fa: \"\\43\";\n}\n.fa-tablet-button {\n  --fa: \"\\f10a\";\n}\n.fa-building-lock {\n  --fa: \"\\e4d6\";\n}\n.fa-pizza-slice {\n  --fa: \"\\f818\";\n}\n.fa-money-bill-wave {\n  --fa: \"\\f53a\";\n}\n.fa-chart-area {\n  --fa: \"\\f1fe\";\n}\n.fa-area-chart {\n  --fa: \"\\f1fe\";\n}\n.fa-house-flag {\n  --fa: \"\\e50d\";\n}\n.fa-person-circle-minus {\n  --fa: \"\\e540\";\n}\n.fa-ban {\n  --fa: \"\\f05e\";\n}\n.fa-cancel {\n  --fa: \"\\f05e\";\n}\n.fa-camera-rotate {\n  --fa: \"\\e0d8\";\n}\n.fa-spray-can-sparkles {\n  --fa: \"\\f5d0\";\n}\n.fa-air-freshener {\n  --fa: \"\\f5d0\";\n}\n.fa-star {\n  --fa: \"\\f005\";\n}\n.fa-repeat {\n  --fa: \"\\f363\";\n}\n.fa-cross {\n  --fa: \"\\f654\";\n}\n.fa-box {\n  --fa: \"\\f466\";\n}\n.fa-venus-mars {\n  --fa: \"\\f228\";\n}\n.fa-arrow-pointer {\n  --fa: \"\\f245\";\n}\n.fa-mouse-pointer {\n  --fa: \"\\f245\";\n}\n.fa-maximize {\n  --fa: \"\\f31e\";\n}\n.fa-expand-arrows-alt {\n  --fa: \"\\f31e\";\n}\n.fa-charging-station {\n  --fa: \"\\f5e7\";\n}\n.fa-shapes {\n  --fa: \"\\f61f\";\n}\n.fa-triangle-circle-square {\n  --fa: \"\\f61f\";\n}\n.fa-shuffle {\n  --fa: \"\\f074\";\n}\n.fa-random {\n  --fa: \"\\f074\";\n}\n.fa-person-running {\n  --fa: \"\\f70c\";\n}\n.fa-running {\n  --fa: \"\\f70c\";\n}\n.fa-mobile-retro {\n  --fa: \"\\e527\";\n}\n.fa-grip-lines-vertical {\n  --fa: \"\\f7a5\";\n}\n.fa-spider {\n  --fa: \"\\f717\";\n}\n.fa-hands-bound {\n  --fa: \"\\e4f9\";\n}\n.fa-file-invoice-dollar {\n  --fa: \"\\f571\";\n}\n.fa-plane-circle-exclamation {\n  --fa: \"\\e556\";\n}\n.fa-x-ray {\n  --fa: \"\\f497\";\n}\n.fa-spell-check {\n  --fa: \"\\f891\";\n}\n.fa-slash {\n  --fa: \"\\f715\";\n}\n.fa-computer-mouse {\n  --fa: \"\\f8cc\";\n}\n.fa-mouse {\n  --fa: \"\\f8cc\";\n}\n.fa-arrow-right-to-bracket {\n  --fa: \"\\f090\";\n}\n.fa-sign-in {\n  --fa: \"\\f090\";\n}\n.fa-shop-slash {\n  --fa: \"\\e070\";\n}\n.fa-store-alt-slash {\n  --fa: \"\\e070\";\n}\n.fa-server {\n  --fa: \"\\f233\";\n}\n.fa-virus-covid-slash {\n  --fa: \"\\e4a9\";\n}\n.fa-shop-lock {\n  --fa: \"\\e4a5\";\n}\n.fa-hourglass-start {\n  --fa: \"\\f251\";\n}\n.fa-hourglass-1 {\n  --fa: \"\\f251\";\n}\n.fa-blender-phone {\n  --fa: \"\\f6b6\";\n}\n.fa-building-wheat {\n  --fa: \"\\e4db\";\n}\n.fa-person-breastfeeding {\n  --fa: \"\\e53a\";\n}\n.fa-right-to-bracket {\n  --fa: \"\\f2f6\";\n}\n.fa-sign-in-alt {\n  --fa: \"\\f2f6\";\n}\n.fa-venus {\n  --fa: \"\\f221\";\n}\n.fa-passport {\n  --fa: \"\\f5ab\";\n}\n.fa-thumbtack-slash {\n  --fa: \"\\e68f\";\n}\n.fa-thumb-tack-slash {\n  --fa: \"\\e68f\";\n}\n.fa-heart-pulse {\n  --fa: \"\\f21e\";\n}\n.fa-heartbeat {\n  --fa: \"\\f21e\";\n}\n.fa-people-carry-box {\n  --fa: \"\\f4ce\";\n}\n.fa-people-carry {\n  --fa: \"\\f4ce\";\n}\n.fa-temperature-high {\n  --fa: \"\\f769\";\n}\n.fa-microchip {\n  --fa: \"\\f2db\";\n}\n.fa-crown {\n  --fa: \"\\f521\";\n}\n.fa-weight-hanging {\n  --fa: \"\\f5cd\";\n}\n.fa-xmarks-lines {\n  --fa: \"\\e59a\";\n}\n.fa-file-prescription {\n  --fa: \"\\f572\";\n}\n.fa-weight-scale {\n  --fa: \"\\f496\";\n}\n.fa-weight {\n  --fa: \"\\f496\";\n}\n.fa-user-group {\n  --fa: \"\\f500\";\n}\n.fa-user-friends {\n  --fa: \"\\f500\";\n}\n.fa-arrow-up-a-z {\n  --fa: \"\\f15e\";\n}\n.fa-sort-alpha-up {\n  --fa: \"\\f15e\";\n}\n.fa-chess-knight {\n  --fa: \"\\f441\";\n}\n.fa-face-laugh-squint {\n  --fa: \"\\f59b\";\n}\n.fa-laugh-squint {\n  --fa: \"\\f59b\";\n}\n.fa-wheelchair {\n  --fa: \"\\f193\";\n}\n.fa-circle-arrow-up {\n  --fa: \"\\f0aa\";\n}\n.fa-arrow-circle-up {\n  --fa: \"\\f0aa\";\n}\n.fa-toggle-on {\n  --fa: \"\\f205\";\n}\n.fa-person-walking {\n  --fa: \"\\f554\";\n}\n.fa-walking {\n  --fa: \"\\f554\";\n}\n.fa-l {\n  --fa: \"\\4c\";\n}\n.fa-fire {\n  --fa: \"\\f06d\";\n}\n.fa-bed-pulse {\n  --fa: \"\\f487\";\n}\n.fa-procedures {\n  --fa: \"\\f487\";\n}\n.fa-shuttle-space {\n  --fa: \"\\f197\";\n}\n.fa-space-shuttle {\n  --fa: \"\\f197\";\n}\n.fa-face-laugh {\n  --fa: \"\\f599\";\n}\n.fa-laugh {\n  --fa: \"\\f599\";\n}\n.fa-folder-open {\n  --fa: \"\\f07c\";\n}\n.fa-heart-circle-plus {\n  --fa: \"\\e500\";\n}\n.fa-code-fork {\n  --fa: \"\\e13b\";\n}\n.fa-city {\n  --fa: \"\\f64f\";\n}\n.fa-microphone-lines {\n  --fa: \"\\f3c9\";\n}\n.fa-microphone-alt {\n  --fa: \"\\f3c9\";\n}\n.fa-pepper-hot {\n  --fa: \"\\f816\";\n}\n.fa-unlock {\n  --fa: \"\\f09c\";\n}\n.fa-colon-sign {\n  --fa: \"\\e140\";\n}\n.fa-headset {\n  --fa: \"\\f590\";\n}\n.fa-store-slash {\n  --fa: \"\\e071\";\n}\n.fa-road-circle-xmark {\n  --fa: \"\\e566\";\n}\n.fa-user-minus {\n  --fa: \"\\f503\";\n}\n.fa-mars-stroke-up {\n  --fa: \"\\f22a\";\n}\n.fa-mars-stroke-v {\n  --fa: \"\\f22a\";\n}\n.fa-champagne-glasses {\n  --fa: \"\\f79f\";\n}\n.fa-glass-cheers {\n  --fa: \"\\f79f\";\n}\n.fa-clipboard {\n  --fa: \"\\f328\";\n}\n.fa-house-circle-exclamation {\n  --fa: \"\\e50a\";\n}\n.fa-file-arrow-up {\n  --fa: \"\\f574\";\n}\n.fa-file-upload {\n  --fa: \"\\f574\";\n}\n.fa-wifi {\n  --fa: \"\\f1eb\";\n}\n.fa-wifi-3 {\n  --fa: \"\\f1eb\";\n}\n.fa-wifi-strong {\n  --fa: \"\\f1eb\";\n}\n.fa-bath {\n  --fa: \"\\f2cd\";\n}\n.fa-bathtub {\n  --fa: \"\\f2cd\";\n}\n.fa-underline {\n  --fa: \"\\f0cd\";\n}\n.fa-user-pen {\n  --fa: \"\\f4ff\";\n}\n.fa-user-edit {\n  --fa: \"\\f4ff\";\n}\n.fa-signature {\n  --fa: \"\\f5b7\";\n}\n.fa-stroopwafel {\n  --fa: \"\\f551\";\n}\n.fa-bold {\n  --fa: \"\\f032\";\n}\n.fa-anchor-lock {\n  --fa: \"\\e4ad\";\n}\n.fa-building-ngo {\n  --fa: \"\\e4d7\";\n}\n.fa-manat-sign {\n  --fa: \"\\e1d5\";\n}\n.fa-not-equal {\n  --fa: \"\\f53e\";\n}\n.fa-border-top-left {\n  --fa: \"\\f853\";\n}\n.fa-border-style {\n  --fa: \"\\f853\";\n}\n.fa-map-location-dot {\n  --fa: \"\\f5a0\";\n}\n.fa-map-marked-alt {\n  --fa: \"\\f5a0\";\n}\n.fa-jedi {\n  --fa: \"\\f669\";\n}\n.fa-square-poll-vertical {\n  --fa: \"\\f681\";\n}\n.fa-poll {\n  --fa: \"\\f681\";\n}\n.fa-mug-hot {\n  --fa: \"\\f7b6\";\n}\n.fa-car-battery {\n  --fa: \"\\f5df\";\n}\n.fa-battery-car {\n  --fa: \"\\f5df\";\n}\n.fa-gift {\n  --fa: \"\\f06b\";\n}\n.fa-dice-two {\n  --fa: \"\\f528\";\n}\n.fa-chess-queen {\n  --fa: \"\\f445\";\n}\n.fa-glasses {\n  --fa: \"\\f530\";\n}\n.fa-chess-board {\n  --fa: \"\\f43c\";\n}\n.fa-building-circle-check {\n  --fa: \"\\e4d2\";\n}\n.fa-person-chalkboard {\n  --fa: \"\\e53d\";\n}\n.fa-mars-stroke-right {\n  --fa: \"\\f22b\";\n}\n.fa-mars-stroke-h {\n  --fa: \"\\f22b\";\n}\n.fa-hand-back-fist {\n  --fa: \"\\f255\";\n}\n.fa-hand-rock {\n  --fa: \"\\f255\";\n}\n.fa-square-caret-up {\n  --fa: \"\\f151\";\n}\n.fa-caret-square-up {\n  --fa: \"\\f151\";\n}\n.fa-cloud-showers-water {\n  --fa: \"\\e4e4\";\n}\n.fa-chart-bar {\n  --fa: \"\\f080\";\n}\n.fa-bar-chart {\n  --fa: \"\\f080\";\n}\n.fa-hands-bubbles {\n  --fa: \"\\e05e\";\n}\n.fa-hands-wash {\n  --fa: \"\\e05e\";\n}\n.fa-less-than-equal {\n  --fa: \"\\f537\";\n}\n.fa-train {\n  --fa: \"\\f238\";\n}\n.fa-eye-low-vision {\n  --fa: \"\\f2a8\";\n}\n.fa-low-vision {\n  --fa: \"\\f2a8\";\n}\n.fa-crow {\n  --fa: \"\\f520\";\n}\n.fa-sailboat {\n  --fa: \"\\e445\";\n}\n.fa-window-restore {\n  --fa: \"\\f2d2\";\n}\n.fa-square-plus {\n  --fa: \"\\f0fe\";\n}\n.fa-plus-square {\n  --fa: \"\\f0fe\";\n}\n.fa-torii-gate {\n  --fa: \"\\f6a1\";\n}\n.fa-frog {\n  --fa: \"\\f52e\";\n}\n.fa-bucket {\n  --fa: \"\\e4cf\";\n}\n.fa-image {\n  --fa: \"\\f03e\";\n}\n.fa-microphone {\n  --fa: \"\\f130\";\n}\n.fa-cow {\n  --fa: \"\\f6c8\";\n}\n.fa-caret-up {\n  --fa: \"\\f0d8\";\n}\n.fa-screwdriver {\n  --fa: \"\\f54a\";\n}\n.fa-folder-closed {\n  --fa: \"\\e185\";\n}\n.fa-house-tsunami {\n  --fa: \"\\e515\";\n}\n.fa-square-nfi {\n  --fa: \"\\e576\";\n}\n.fa-arrow-up-from-ground-water {\n  --fa: \"\\e4b5\";\n}\n.fa-martini-glass {\n  --fa: \"\\f57b\";\n}\n.fa-glass-martini-alt {\n  --fa: \"\\f57b\";\n}\n.fa-square-binary {\n  --fa: \"\\e69b\";\n}\n.fa-rotate-left {\n  --fa: \"\\f2ea\";\n}\n.fa-rotate-back {\n  --fa: \"\\f2ea\";\n}\n.fa-rotate-backward {\n  --fa: \"\\f2ea\";\n}\n.fa-undo-alt {\n  --fa: \"\\f2ea\";\n}\n.fa-table-columns {\n  --fa: \"\\f0db\";\n}\n.fa-columns {\n  --fa: \"\\f0db\";\n}\n.fa-lemon {\n  --fa: \"\\f094\";\n}\n.fa-head-side-mask {\n  --fa: \"\\e063\";\n}\n.fa-handshake {\n  --fa: \"\\f2b5\";\n}\n.fa-gem {\n  --fa: \"\\f3a5\";\n}\n.fa-dolly {\n  --fa: \"\\f472\";\n}\n.fa-dolly-box {\n  --fa: \"\\f472\";\n}\n.fa-smoking {\n  --fa: \"\\f48d\";\n}\n.fa-minimize {\n  --fa: \"\\f78c\";\n}\n.fa-compress-arrows-alt {\n  --fa: \"\\f78c\";\n}\n.fa-monument {\n  --fa: \"\\f5a6\";\n}\n.fa-snowplow {\n  --fa: \"\\f7d2\";\n}\n.fa-angles-right {\n  --fa: \"\\f101\";\n}\n.fa-angle-double-right {\n  --fa: \"\\f101\";\n}\n.fa-cannabis {\n  --fa: \"\\f55f\";\n}\n.fa-circle-play {\n  --fa: \"\\f144\";\n}\n.fa-play-circle {\n  --fa: \"\\f144\";\n}\n.fa-tablets {\n  --fa: \"\\f490\";\n}\n.fa-ethernet {\n  --fa: \"\\f796\";\n}\n.fa-euro-sign {\n  --fa: \"\\f153\";\n}\n.fa-eur {\n  --fa: \"\\f153\";\n}\n.fa-euro {\n  --fa: \"\\f153\";\n}\n.fa-chair {\n  --fa: \"\\f6c0\";\n}\n.fa-circle-check {\n  --fa: \"\\f058\";\n}\n.fa-check-circle {\n  --fa: \"\\f058\";\n}\n.fa-circle-stop {\n  --fa: \"\\f28d\";\n}\n.fa-stop-circle {\n  --fa: \"\\f28d\";\n}\n.fa-compass-drafting {\n  --fa: \"\\f568\";\n}\n.fa-drafting-compass {\n  --fa: \"\\f568\";\n}\n.fa-plate-wheat {\n  --fa: \"\\e55a\";\n}\n.fa-icicles {\n  --fa: \"\\f7ad\";\n}\n.fa-person-shelter {\n  --fa: \"\\e54f\";\n}\n.fa-neuter {\n  --fa: \"\\f22c\";\n}\n.fa-id-badge {\n  --fa: \"\\f2c1\";\n}\n.fa-marker {\n  --fa: \"\\f5a1\";\n}\n.fa-face-laugh-beam {\n  --fa: \"\\f59a\";\n}\n.fa-laugh-beam {\n  --fa: \"\\f59a\";\n}\n.fa-helicopter-symbol {\n  --fa: \"\\e502\";\n}\n.fa-universal-access {\n  --fa: \"\\f29a\";\n}\n.fa-circle-chevron-up {\n  --fa: \"\\f139\";\n}\n.fa-chevron-circle-up {\n  --fa: \"\\f139\";\n}\n.fa-lari-sign {\n  --fa: \"\\e1c8\";\n}\n.fa-volcano {\n  --fa: \"\\f770\";\n}\n.fa-person-walking-dashed-line-arrow-right {\n  --fa: \"\\e553\";\n}\n.fa-sterling-sign {\n  --fa: \"\\f154\";\n}\n.fa-gbp {\n  --fa: \"\\f154\";\n}\n.fa-pound-sign {\n  --fa: \"\\f154\";\n}\n.fa-viruses {\n  --fa: \"\\e076\";\n}\n.fa-square-person-confined {\n  --fa: \"\\e577\";\n}\n.fa-user-tie {\n  --fa: \"\\f508\";\n}\n.fa-arrow-down-long {\n  --fa: \"\\f175\";\n}\n.fa-long-arrow-down {\n  --fa: \"\\f175\";\n}\n.fa-tent-arrow-down-to-line {\n  --fa: \"\\e57e\";\n}\n.fa-certificate {\n  --fa: \"\\f0a3\";\n}\n.fa-reply-all {\n  --fa: \"\\f122\";\n}\n.fa-mail-reply-all {\n  --fa: \"\\f122\";\n}\n.fa-suitcase {\n  --fa: \"\\f0f2\";\n}\n.fa-person-skating {\n  --fa: \"\\f7c5\";\n}\n.fa-skating {\n  --fa: \"\\f7c5\";\n}\n.fa-filter-circle-dollar {\n  --fa: \"\\f662\";\n}\n.fa-funnel-dollar {\n  --fa: \"\\f662\";\n}\n.fa-camera-retro {\n  --fa: \"\\f083\";\n}\n.fa-circle-arrow-down {\n  --fa: \"\\f0ab\";\n}\n.fa-arrow-circle-down {\n  --fa: \"\\f0ab\";\n}\n.fa-file-import {\n  --fa: \"\\f56f\";\n}\n.fa-arrow-right-to-file {\n  --fa: \"\\f56f\";\n}\n.fa-square-arrow-up-right {\n  --fa: \"\\f14c\";\n}\n.fa-external-link-square {\n  --fa: \"\\f14c\";\n}\n.fa-box-open {\n  --fa: \"\\f49e\";\n}\n.fa-scroll {\n  --fa: \"\\f70e\";\n}\n.fa-spa {\n  --fa: \"\\f5bb\";\n}\n.fa-location-pin-lock {\n  --fa: \"\\e51f\";\n}\n.fa-pause {\n  --fa: \"\\f04c\";\n}\n.fa-hill-avalanche {\n  --fa: \"\\e507\";\n}\n.fa-temperature-empty {\n  --fa: \"\\f2cb\";\n}\n.fa-temperature-0 {\n  --fa: \"\\f2cb\";\n}\n.fa-thermometer-0 {\n  --fa: \"\\f2cb\";\n}\n.fa-thermometer-empty {\n  --fa: \"\\f2cb\";\n}\n.fa-bomb {\n  --fa: \"\\f1e2\";\n}\n.fa-registered {\n  --fa: \"\\f25d\";\n}\n.fa-address-card {\n  --fa: \"\\f2bb\";\n}\n.fa-contact-card {\n  --fa: \"\\f2bb\";\n}\n.fa-vcard {\n  --fa: \"\\f2bb\";\n}\n.fa-scale-unbalanced-flip {\n  --fa: \"\\f516\";\n}\n.fa-balance-scale-right {\n  --fa: \"\\f516\";\n}\n.fa-subscript {\n  --fa: \"\\f12c\";\n}\n.fa-diamond-turn-right {\n  --fa: \"\\f5eb\";\n}\n.fa-directions {\n  --fa: \"\\f5eb\";\n}\n.fa-burst {\n  --fa: \"\\e4dc\";\n}\n.fa-house-laptop {\n  --fa: \"\\e066\";\n}\n.fa-laptop-house {\n  --fa: \"\\e066\";\n}\n.fa-face-tired {\n  --fa: \"\\f5c8\";\n}\n.fa-tired {\n  --fa: \"\\f5c8\";\n}\n.fa-money-bills {\n  --fa: \"\\e1f3\";\n}\n.fa-smog {\n  --fa: \"\\f75f\";\n}\n.fa-crutch {\n  --fa: \"\\f7f7\";\n}\n.fa-cloud-arrow-up {\n  --fa: \"\\f0ee\";\n}\n.fa-cloud-upload {\n  --fa: \"\\f0ee\";\n}\n.fa-cloud-upload-alt {\n  --fa: \"\\f0ee\";\n}\n.fa-palette {\n  --fa: \"\\f53f\";\n}\n.fa-arrows-turn-right {\n  --fa: \"\\e4c0\";\n}\n.fa-vest {\n  --fa: \"\\e085\";\n}\n.fa-ferry {\n  --fa: \"\\e4ea\";\n}\n.fa-arrows-down-to-people {\n  --fa: \"\\e4b9\";\n}\n.fa-seedling {\n  --fa: \"\\f4d8\";\n}\n.fa-sprout {\n  --fa: \"\\f4d8\";\n}\n.fa-left-right {\n  --fa: \"\\f337\";\n}\n.fa-arrows-alt-h {\n  --fa: \"\\f337\";\n}\n.fa-boxes-packing {\n  --fa: \"\\e4c7\";\n}\n.fa-circle-arrow-left {\n  --fa: \"\\f0a8\";\n}\n.fa-arrow-circle-left {\n  --fa: \"\\f0a8\";\n}\n.fa-group-arrows-rotate {\n  --fa: \"\\e4f6\";\n}\n.fa-bowl-food {\n  --fa: \"\\e4c6\";\n}\n.fa-candy-cane {\n  --fa: \"\\f786\";\n}\n.fa-arrow-down-wide-short {\n  --fa: \"\\f160\";\n}\n.fa-sort-amount-asc {\n  --fa: \"\\f160\";\n}\n.fa-sort-amount-down {\n  --fa: \"\\f160\";\n}\n.fa-cloud-bolt {\n  --fa: \"\\f76c\";\n}\n.fa-thunderstorm {\n  --fa: \"\\f76c\";\n}\n.fa-text-slash {\n  --fa: \"\\f87d\";\n}\n.fa-remove-format {\n  --fa: \"\\f87d\";\n}\n.fa-face-smile-wink {\n  --fa: \"\\f4da\";\n}\n.fa-smile-wink {\n  --fa: \"\\f4da\";\n}\n.fa-file-word {\n  --fa: \"\\f1c2\";\n}\n.fa-file-powerpoint {\n  --fa: \"\\f1c4\";\n}\n.fa-arrows-left-right {\n  --fa: \"\\f07e\";\n}\n.fa-arrows-h {\n  --fa: \"\\f07e\";\n}\n.fa-house-lock {\n  --fa: \"\\e510\";\n}\n.fa-cloud-arrow-down {\n  --fa: \"\\f0ed\";\n}\n.fa-cloud-download {\n  --fa: \"\\f0ed\";\n}\n.fa-cloud-download-alt {\n  --fa: \"\\f0ed\";\n}\n.fa-children {\n  --fa: \"\\e4e1\";\n}\n.fa-chalkboard {\n  --fa: \"\\f51b\";\n}\n.fa-blackboard {\n  --fa: \"\\f51b\";\n}\n.fa-user-large-slash {\n  --fa: \"\\f4fa\";\n}\n.fa-user-alt-slash {\n  --fa: \"\\f4fa\";\n}\n.fa-envelope-open {\n  --fa: \"\\f2b6\";\n}\n.fa-handshake-simple-slash {\n  --fa: \"\\e05f\";\n}\n.fa-handshake-alt-slash {\n  --fa: \"\\e05f\";\n}\n.fa-mattress-pillow {\n  --fa: \"\\e525\";\n}\n.fa-guarani-sign {\n  --fa: \"\\e19a\";\n}\n.fa-arrows-rotate {\n  --fa: \"\\f021\";\n}\n.fa-refresh {\n  --fa: \"\\f021\";\n}\n.fa-sync {\n  --fa: \"\\f021\";\n}\n.fa-fire-extinguisher {\n  --fa: \"\\f134\";\n}\n.fa-cruzeiro-sign {\n  --fa: \"\\e152\";\n}\n.fa-greater-than-equal {\n  --fa: \"\\f532\";\n}\n.fa-shield-halved {\n  --fa: \"\\f3ed\";\n}\n.fa-shield-alt {\n  --fa: \"\\f3ed\";\n}\n.fa-book-atlas {\n  --fa: \"\\f558\";\n}\n.fa-atlas {\n  --fa: \"\\f558\";\n}\n.fa-virus {\n  --fa: \"\\e074\";\n}\n.fa-envelope-circle-check {\n  --fa: \"\\e4e8\";\n}\n.fa-layer-group {\n  --fa: \"\\f5fd\";\n}\n.fa-arrows-to-dot {\n  --fa: \"\\e4be\";\n}\n.fa-archway {\n  --fa: \"\\f557\";\n}\n.fa-heart-circle-check {\n  --fa: \"\\e4fd\";\n}\n.fa-house-chimney-crack {\n  --fa: \"\\f6f1\";\n}\n.fa-house-damage {\n  --fa: \"\\f6f1\";\n}\n.fa-file-zipper {\n  --fa: \"\\f1c6\";\n}\n.fa-file-archive {\n  --fa: \"\\f1c6\";\n}\n.fa-square {\n  --fa: \"\\f0c8\";\n}\n.fa-martini-glass-empty {\n  --fa: \"\\f000\";\n}\n.fa-glass-martini {\n  --fa: \"\\f000\";\n}\n.fa-couch {\n  --fa: \"\\f4b8\";\n}\n.fa-cedi-sign {\n  --fa: \"\\e0df\";\n}\n.fa-italic {\n  --fa: \"\\f033\";\n}\n.fa-table-cells-column-lock {\n  --fa: \"\\e678\";\n}\n.fa-church {\n  --fa: \"\\f51d\";\n}\n.fa-comments-dollar {\n  --fa: \"\\f653\";\n}\n.fa-democrat {\n  --fa: \"\\f747\";\n}\n.fa-z {\n  --fa: \"\\5a\";\n}\n.fa-person-skiing {\n  --fa: \"\\f7c9\";\n}\n.fa-skiing {\n  --fa: \"\\f7c9\";\n}\n.fa-road-lock {\n  --fa: \"\\e567\";\n}\n.fa-a {\n  --fa: \"\\41\";\n}\n.fa-temperature-arrow-down {\n  --fa: \"\\e03f\";\n}\n.fa-temperature-down {\n  --fa: \"\\e03f\";\n}\n.fa-feather-pointed {\n  --fa: \"\\f56b\";\n}\n.fa-feather-alt {\n  --fa: \"\\f56b\";\n}\n.fa-p {\n  --fa: \"\\50\";\n}\n.fa-snowflake {\n  --fa: \"\\f2dc\";\n}\n.fa-newspaper {\n  --fa: \"\\f1ea\";\n}\n.fa-rectangle-ad {\n  --fa: \"\\f641\";\n}\n.fa-ad {\n  --fa: \"\\f641\";\n}\n.fa-circle-arrow-right {\n  --fa: \"\\f0a9\";\n}\n.fa-arrow-circle-right {\n  --fa: \"\\f0a9\";\n}\n.fa-filter-circle-xmark {\n  --fa: \"\\e17b\";\n}\n.fa-locust {\n  --fa: \"\\e520\";\n}\n.fa-sort {\n  --fa: \"\\f0dc\";\n}\n.fa-unsorted {\n  --fa: \"\\f0dc\";\n}\n.fa-list-ol {\n  --fa: \"\\f0cb\";\n}\n.fa-list-1-2 {\n  --fa: \"\\f0cb\";\n}\n.fa-list-numeric {\n  --fa: \"\\f0cb\";\n}\n.fa-person-dress-burst {\n  --fa: \"\\e544\";\n}\n.fa-money-check-dollar {\n  --fa: \"\\f53d\";\n}\n.fa-money-check-alt {\n  --fa: \"\\f53d\";\n}\n.fa-vector-square {\n  --fa: \"\\f5cb\";\n}\n.fa-bread-slice {\n  --fa: \"\\f7ec\";\n}\n.fa-language {\n  --fa: \"\\f1ab\";\n}\n.fa-face-kiss-wink-heart {\n  --fa: \"\\f598\";\n}\n.fa-kiss-wink-heart {\n  --fa: \"\\f598\";\n}\n.fa-filter {\n  --fa: \"\\f0b0\";\n}\n.fa-question {\n  --fa: \"\\3f\";\n}\n.fa-file-signature {\n  --fa: \"\\f573\";\n}\n.fa-up-down-left-right {\n  --fa: \"\\f0b2\";\n}\n.fa-arrows-alt {\n  --fa: \"\\f0b2\";\n}\n.fa-house-chimney-user {\n  --fa: \"\\e065\";\n}\n.fa-hand-holding-heart {\n  --fa: \"\\f4be\";\n}\n.fa-puzzle-piece {\n  --fa: \"\\f12e\";\n}\n.fa-money-check {\n  --fa: \"\\f53c\";\n}\n.fa-star-half-stroke {\n  --fa: \"\\f5c0\";\n}\n.fa-star-half-alt {\n  --fa: \"\\f5c0\";\n}\n.fa-code {\n  --fa: \"\\f121\";\n}\n.fa-whiskey-glass {\n  --fa: \"\\f7a0\";\n}\n.fa-glass-whiskey {\n  --fa: \"\\f7a0\";\n}\n.fa-building-circle-exclamation {\n  --fa: \"\\e4d3\";\n}\n.fa-magnifying-glass-chart {\n  --fa: \"\\e522\";\n}\n.fa-arrow-up-right-from-square {\n  --fa: \"\\f08e\";\n}\n.fa-external-link {\n  --fa: \"\\f08e\";\n}\n.fa-cubes-stacked {\n  --fa: \"\\e4e6\";\n}\n.fa-won-sign {\n  --fa: \"\\f159\";\n}\n.fa-krw {\n  --fa: \"\\f159\";\n}\n.fa-won {\n  --fa: \"\\f159\";\n}\n.fa-virus-covid {\n  --fa: \"\\e4a8\";\n}\n.fa-austral-sign {\n  --fa: \"\\e0a9\";\n}\n.fa-f {\n  --fa: \"\\46\";\n}\n.fa-leaf {\n  --fa: \"\\f06c\";\n}\n.fa-road {\n  --fa: \"\\f018\";\n}\n.fa-taxi {\n  --fa: \"\\f1ba\";\n}\n.fa-cab {\n  --fa: \"\\f1ba\";\n}\n.fa-person-circle-plus {\n  --fa: \"\\e541\";\n}\n.fa-chart-pie {\n  --fa: \"\\f200\";\n}\n.fa-pie-chart {\n  --fa: \"\\f200\";\n}\n.fa-bolt-lightning {\n  --fa: \"\\e0b7\";\n}\n.fa-sack-xmark {\n  --fa: \"\\e56a\";\n}\n.fa-file-excel {\n  --fa: \"\\f1c3\";\n}\n.fa-file-contract {\n  --fa: \"\\f56c\";\n}\n.fa-fish-fins {\n  --fa: \"\\e4f2\";\n}\n.fa-building-flag {\n  --fa: \"\\e4d5\";\n}\n.fa-face-grin-beam {\n  --fa: \"\\f582\";\n}\n.fa-grin-beam {\n  --fa: \"\\f582\";\n}\n.fa-object-ungroup {\n  --fa: \"\\f248\";\n}\n.fa-poop {\n  --fa: \"\\f619\";\n}\n.fa-location-pin {\n  --fa: \"\\f041\";\n}\n.fa-map-marker {\n  --fa: \"\\f041\";\n}\n.fa-kaaba {\n  --fa: \"\\f66b\";\n}\n.fa-toilet-paper {\n  --fa: \"\\f71e\";\n}\n.fa-helmet-safety {\n  --fa: \"\\f807\";\n}\n.fa-hard-hat {\n  --fa: \"\\f807\";\n}\n.fa-hat-hard {\n  --fa: \"\\f807\";\n}\n.fa-eject {\n  --fa: \"\\f052\";\n}\n.fa-circle-right {\n  --fa: \"\\f35a\";\n}\n.fa-arrow-alt-circle-right {\n  --fa: \"\\f35a\";\n}\n.fa-plane-circle-check {\n  --fa: \"\\e555\";\n}\n.fa-face-rolling-eyes {\n  --fa: \"\\f5a5\";\n}\n.fa-meh-rolling-eyes {\n  --fa: \"\\f5a5\";\n}\n.fa-object-group {\n  --fa: \"\\f247\";\n}\n.fa-chart-line {\n  --fa: \"\\f201\";\n}\n.fa-line-chart {\n  --fa: \"\\f201\";\n}\n.fa-mask-ventilator {\n  --fa: \"\\e524\";\n}\n.fa-arrow-right {\n  --fa: \"\\f061\";\n}\n.fa-signs-post {\n  --fa: \"\\f277\";\n}\n.fa-map-signs {\n  --fa: \"\\f277\";\n}\n.fa-cash-register {\n  --fa: \"\\f788\";\n}\n.fa-person-circle-question {\n  --fa: \"\\e542\";\n}\n.fa-h {\n  --fa: \"\\48\";\n}\n.fa-tarp {\n  --fa: \"\\e57b\";\n}\n.fa-screwdriver-wrench {\n  --fa: \"\\f7d9\";\n}\n.fa-tools {\n  --fa: \"\\f7d9\";\n}\n.fa-arrows-to-eye {\n  --fa: \"\\e4bf\";\n}\n.fa-plug-circle-bolt {\n  --fa: \"\\e55b\";\n}\n.fa-heart {\n  --fa: \"\\f004\";\n}\n.fa-mars-and-venus {\n  --fa: \"\\f224\";\n}\n.fa-house-user {\n  --fa: \"\\e1b0\";\n}\n.fa-home-user {\n  --fa: \"\\e1b0\";\n}\n.fa-dumpster-fire {\n  --fa: \"\\f794\";\n}\n.fa-house-crack {\n  --fa: \"\\e3b1\";\n}\n.fa-martini-glass-citrus {\n  --fa: \"\\f561\";\n}\n.fa-cocktail {\n  --fa: \"\\f561\";\n}\n.fa-face-surprise {\n  --fa: \"\\f5c2\";\n}\n.fa-surprise {\n  --fa: \"\\f5c2\";\n}\n.fa-bottle-water {\n  --fa: \"\\e4c5\";\n}\n.fa-circle-pause {\n  --fa: \"\\f28b\";\n}\n.fa-pause-circle {\n  --fa: \"\\f28b\";\n}\n.fa-toilet-paper-slash {\n  --fa: \"\\e072\";\n}\n.fa-apple-whole {\n  --fa: \"\\f5d1\";\n}\n.fa-apple-alt {\n  --fa: \"\\f5d1\";\n}\n.fa-kitchen-set {\n  --fa: \"\\e51a\";\n}\n.fa-r {\n  --fa: \"\\52\";\n}\n.fa-temperature-quarter {\n  --fa: \"\\f2ca\";\n}\n.fa-temperature-1 {\n  --fa: \"\\f2ca\";\n}\n.fa-thermometer-1 {\n  --fa: \"\\f2ca\";\n}\n.fa-thermometer-quarter {\n  --fa: \"\\f2ca\";\n}\n.fa-cube {\n  --fa: \"\\f1b2\";\n}\n.fa-bitcoin-sign {\n  --fa: \"\\e0b4\";\n}\n.fa-shield-dog {\n  --fa: \"\\e573\";\n}\n.fa-solar-panel {\n  --fa: \"\\f5ba\";\n}\n.fa-lock-open {\n  --fa: \"\\f3c1\";\n}\n.fa-elevator {\n  --fa: \"\\e16d\";\n}\n.fa-money-bill-transfer {\n  --fa: \"\\e528\";\n}\n.fa-money-bill-trend-up {\n  --fa: \"\\e529\";\n}\n.fa-house-flood-water-circle-arrow-right {\n  --fa: \"\\e50f\";\n}\n.fa-square-poll-horizontal {\n  --fa: \"\\f682\";\n}\n.fa-poll-h {\n  --fa: \"\\f682\";\n}\n.fa-circle {\n  --fa: \"\\f111\";\n}\n.fa-backward-fast {\n  --fa: \"\\f049\";\n}\n.fa-fast-backward {\n  --fa: \"\\f049\";\n}\n.fa-recycle {\n  --fa: \"\\f1b8\";\n}\n.fa-user-astronaut {\n  --fa: \"\\f4fb\";\n}\n.fa-plane-slash {\n  --fa: \"\\e069\";\n}\n.fa-trademark {\n  --fa: \"\\f25c\";\n}\n.fa-basketball {\n  --fa: \"\\f434\";\n}\n.fa-basketball-ball {\n  --fa: \"\\f434\";\n}\n.fa-satellite-dish {\n  --fa: \"\\f7c0\";\n}\n.fa-circle-up {\n  --fa: \"\\f35b\";\n}\n.fa-arrow-alt-circle-up {\n  --fa: \"\\f35b\";\n}\n.fa-mobile-screen-button {\n  --fa: \"\\f3cd\";\n}\n.fa-mobile-alt {\n  --fa: \"\\f3cd\";\n}\n.fa-volume-high {\n  --fa: \"\\f028\";\n}\n.fa-volume-up {\n  --fa: \"\\f028\";\n}\n.fa-users-rays {\n  --fa: \"\\e593\";\n}\n.fa-wallet {\n  --fa: \"\\f555\";\n}\n.fa-clipboard-check {\n  --fa: \"\\f46c\";\n}\n.fa-file-audio {\n  --fa: \"\\f1c7\";\n}\n.fa-burger {\n  --fa: \"\\f805\";\n}\n.fa-hamburger {\n  --fa: \"\\f805\";\n}\n.fa-wrench {\n  --fa: \"\\f0ad\";\n}\n.fa-bugs {\n  --fa: \"\\e4d0\";\n}\n.fa-rupee-sign {\n  --fa: \"\\f156\";\n}\n.fa-rupee {\n  --fa: \"\\f156\";\n}\n.fa-file-image {\n  --fa: \"\\f1c5\";\n}\n.fa-circle-question {\n  --fa: \"\\f059\";\n}\n.fa-question-circle {\n  --fa: \"\\f059\";\n}\n.fa-plane-departure {\n  --fa: \"\\f5b0\";\n}\n.fa-handshake-slash {\n  --fa: \"\\e060\";\n}\n.fa-book-bookmark {\n  --fa: \"\\e0bb\";\n}\n.fa-code-branch {\n  --fa: \"\\f126\";\n}\n.fa-hat-cowboy {\n  --fa: \"\\f8c0\";\n}\n.fa-bridge {\n  --fa: \"\\e4c8\";\n}\n.fa-phone-flip {\n  --fa: \"\\f879\";\n}\n.fa-phone-alt {\n  --fa: \"\\f879\";\n}\n.fa-truck-front {\n  --fa: \"\\e2b7\";\n}\n.fa-cat {\n  --fa: \"\\f6be\";\n}\n.fa-anchor-circle-exclamation {\n  --fa: \"\\e4ab\";\n}\n.fa-truck-field {\n  --fa: \"\\e58d\";\n}\n.fa-route {\n  --fa: \"\\f4d7\";\n}\n.fa-clipboard-question {\n  --fa: \"\\e4e3\";\n}\n.fa-panorama {\n  --fa: \"\\e209\";\n}\n.fa-comment-medical {\n  --fa: \"\\f7f5\";\n}\n.fa-teeth-open {\n  --fa: \"\\f62f\";\n}\n.fa-file-circle-minus {\n  --fa: \"\\e4ed\";\n}\n.fa-tags {\n  --fa: \"\\f02c\";\n}\n.fa-wine-glass {\n  --fa: \"\\f4e3\";\n}\n.fa-forward-fast {\n  --fa: \"\\f050\";\n}\n.fa-fast-forward {\n  --fa: \"\\f050\";\n}\n.fa-face-meh-blank {\n  --fa: \"\\f5a4\";\n}\n.fa-meh-blank {\n  --fa: \"\\f5a4\";\n}\n.fa-square-parking {\n  --fa: \"\\f540\";\n}\n.fa-parking {\n  --fa: \"\\f540\";\n}\n.fa-house-signal {\n  --fa: \"\\e012\";\n}\n.fa-bars-progress {\n  --fa: \"\\f828\";\n}\n.fa-tasks-alt {\n  --fa: \"\\f828\";\n}\n.fa-faucet-drip {\n  --fa: \"\\e006\";\n}\n.fa-cart-flatbed {\n  --fa: \"\\f474\";\n}\n.fa-dolly-flatbed {\n  --fa: \"\\f474\";\n}\n.fa-ban-smoking {\n  --fa: \"\\f54d\";\n}\n.fa-smoking-ban {\n  --fa: \"\\f54d\";\n}\n.fa-terminal {\n  --fa: \"\\f120\";\n}\n.fa-mobile-button {\n  --fa: \"\\f10b\";\n}\n.fa-house-medical-flag {\n  --fa: \"\\e514\";\n}\n.fa-basket-shopping {\n  --fa: \"\\f291\";\n}\n.fa-shopping-basket {\n  --fa: \"\\f291\";\n}\n.fa-tape {\n  --fa: \"\\f4db\";\n}\n.fa-bus-simple {\n  --fa: \"\\f55e\";\n}\n.fa-bus-alt {\n  --fa: \"\\f55e\";\n}\n.fa-eye {\n  --fa: \"\\f06e\";\n}\n.fa-face-sad-cry {\n  --fa: \"\\f5b3\";\n}\n.fa-sad-cry {\n  --fa: \"\\f5b3\";\n}\n.fa-audio-description {\n  --fa: \"\\f29e\";\n}\n.fa-person-military-to-person {\n  --fa: \"\\e54c\";\n}\n.fa-file-shield {\n  --fa: \"\\e4f0\";\n}\n.fa-user-slash {\n  --fa: \"\\f506\";\n}\n.fa-pen {\n  --fa: \"\\f304\";\n}\n.fa-tower-observation {\n  --fa: \"\\e586\";\n}\n.fa-file-code {\n  --fa: \"\\f1c9\";\n}\n.fa-signal {\n  --fa: \"\\f012\";\n}\n.fa-signal-5 {\n  --fa: \"\\f012\";\n}\n.fa-signal-perfect {\n  --fa: \"\\f012\";\n}\n.fa-bus {\n  --fa: \"\\f207\";\n}\n.fa-heart-circle-xmark {\n  --fa: \"\\e501\";\n}\n.fa-house-chimney {\n  --fa: \"\\e3af\";\n}\n.fa-home-lg {\n  --fa: \"\\e3af\";\n}\n.fa-window-maximize {\n  --fa: \"\\f2d0\";\n}\n.fa-face-frown {\n  --fa: \"\\f119\";\n}\n.fa-frown {\n  --fa: \"\\f119\";\n}\n.fa-prescription {\n  --fa: \"\\f5b1\";\n}\n.fa-shop {\n  --fa: \"\\f54f\";\n}\n.fa-store-alt {\n  --fa: \"\\f54f\";\n}\n.fa-floppy-disk {\n  --fa: \"\\f0c7\";\n}\n.fa-save {\n  --fa: \"\\f0c7\";\n}\n.fa-vihara {\n  --fa: \"\\f6a7\";\n}\n.fa-scale-unbalanced {\n  --fa: \"\\f515\";\n}\n.fa-balance-scale-left {\n  --fa: \"\\f515\";\n}\n.fa-sort-up {\n  --fa: \"\\f0de\";\n}\n.fa-sort-asc {\n  --fa: \"\\f0de\";\n}\n.fa-comment-dots {\n  --fa: \"\\f4ad\";\n}\n.fa-commenting {\n  --fa: \"\\f4ad\";\n}\n.fa-plant-wilt {\n  --fa: \"\\e5aa\";\n}\n.fa-diamond {\n  --fa: \"\\f219\";\n}\n.fa-face-grin-squint {\n  --fa: \"\\f585\";\n}\n.fa-grin-squint {\n  --fa: \"\\f585\";\n}\n.fa-hand-holding-dollar {\n  --fa: \"\\f4c0\";\n}\n.fa-hand-holding-usd {\n  --fa: \"\\f4c0\";\n}\n.fa-chart-diagram {\n  --fa: \"\\e695\";\n}\n.fa-bacterium {\n  --fa: \"\\e05a\";\n}\n.fa-hand-pointer {\n  --fa: \"\\f25a\";\n}\n.fa-drum-steelpan {\n  --fa: \"\\f56a\";\n}\n.fa-hand-scissors {\n  --fa: \"\\f257\";\n}\n.fa-hands-praying {\n  --fa: \"\\f684\";\n}\n.fa-praying-hands {\n  --fa: \"\\f684\";\n}\n.fa-arrow-rotate-right {\n  --fa: \"\\f01e\";\n}\n.fa-arrow-right-rotate {\n  --fa: \"\\f01e\";\n}\n.fa-arrow-rotate-forward {\n  --fa: \"\\f01e\";\n}\n.fa-redo {\n  --fa: \"\\f01e\";\n}\n.fa-biohazard {\n  --fa: \"\\f780\";\n}\n.fa-location-crosshairs {\n  --fa: \"\\f601\";\n}\n.fa-location {\n  --fa: \"\\f601\";\n}\n.fa-mars-double {\n  --fa: \"\\f227\";\n}\n.fa-child-dress {\n  --fa: \"\\e59c\";\n}\n.fa-users-between-lines {\n  --fa: \"\\e591\";\n}\n.fa-lungs-virus {\n  --fa: \"\\e067\";\n}\n.fa-face-grin-tears {\n  --fa: \"\\f588\";\n}\n.fa-grin-tears {\n  --fa: \"\\f588\";\n}\n.fa-phone {\n  --fa: \"\\f095\";\n}\n.fa-calendar-xmark {\n  --fa: \"\\f273\";\n}\n.fa-calendar-times {\n  --fa: \"\\f273\";\n}\n.fa-child-reaching {\n  --fa: \"\\e59d\";\n}\n.fa-head-side-virus {\n  --fa: \"\\e064\";\n}\n.fa-user-gear {\n  --fa: \"\\f4fe\";\n}\n.fa-user-cog {\n  --fa: \"\\f4fe\";\n}\n.fa-arrow-up-1-9 {\n  --fa: \"\\f163\";\n}\n.fa-sort-numeric-up {\n  --fa: \"\\f163\";\n}\n.fa-door-closed {\n  --fa: \"\\f52a\";\n}\n.fa-shield-virus {\n  --fa: \"\\e06c\";\n}\n.fa-dice-six {\n  --fa: \"\\f526\";\n}\n.fa-mosquito-net {\n  --fa: \"\\e52c\";\n}\n.fa-file-fragment {\n  --fa: \"\\e697\";\n}\n.fa-bridge-water {\n  --fa: \"\\e4ce\";\n}\n.fa-person-booth {\n  --fa: \"\\f756\";\n}\n.fa-text-width {\n  --fa: \"\\f035\";\n}\n.fa-hat-wizard {\n  --fa: \"\\f6e8\";\n}\n.fa-pen-fancy {\n  --fa: \"\\f5ac\";\n}\n.fa-person-digging {\n  --fa: \"\\f85e\";\n}\n.fa-digging {\n  --fa: \"\\f85e\";\n}\n.fa-trash {\n  --fa: \"\\f1f8\";\n}\n.fa-gauge-simple {\n  --fa: \"\\f629\";\n}\n.fa-gauge-simple-med {\n  --fa: \"\\f629\";\n}\n.fa-tachometer-average {\n  --fa: \"\\f629\";\n}\n.fa-book-medical {\n  --fa: \"\\f7e6\";\n}\n.fa-poo {\n  --fa: \"\\f2fe\";\n}\n.fa-quote-right {\n  --fa: \"\\f10e\";\n}\n.fa-quote-right-alt {\n  --fa: \"\\f10e\";\n}\n.fa-shirt {\n  --fa: \"\\f553\";\n}\n.fa-t-shirt {\n  --fa: \"\\f553\";\n}\n.fa-tshirt {\n  --fa: \"\\f553\";\n}\n.fa-cubes {\n  --fa: \"\\f1b3\";\n}\n.fa-divide {\n  --fa: \"\\f529\";\n}\n.fa-tenge-sign {\n  --fa: \"\\f7d7\";\n}\n.fa-tenge {\n  --fa: \"\\f7d7\";\n}\n.fa-headphones {\n  --fa: \"\\f025\";\n}\n.fa-hands-holding {\n  --fa: \"\\f4c2\";\n}\n.fa-hands-clapping {\n  --fa: \"\\e1a8\";\n}\n.fa-republican {\n  --fa: \"\\f75e\";\n}\n.fa-arrow-left {\n  --fa: \"\\f060\";\n}\n.fa-person-circle-xmark {\n  --fa: \"\\e543\";\n}\n.fa-ruler {\n  --fa: \"\\f545\";\n}\n.fa-align-left {\n  --fa: \"\\f036\";\n}\n.fa-dice-d6 {\n  --fa: \"\\f6d1\";\n}\n.fa-restroom {\n  --fa: \"\\f7bd\";\n}\n.fa-j {\n  --fa: \"\\4a\";\n}\n.fa-users-viewfinder {\n  --fa: \"\\e595\";\n}\n.fa-file-video {\n  --fa: \"\\f1c8\";\n}\n.fa-up-right-from-square {\n  --fa: \"\\f35d\";\n}\n.fa-external-link-alt {\n  --fa: \"\\f35d\";\n}\n.fa-table-cells {\n  --fa: \"\\f00a\";\n}\n.fa-th {\n  --fa: \"\\f00a\";\n}\n.fa-file-pdf {\n  --fa: \"\\f1c1\";\n}\n.fa-book-bible {\n  --fa: \"\\f647\";\n}\n.fa-bible {\n  --fa: \"\\f647\";\n}\n.fa-o {\n  --fa: \"\\4f\";\n}\n.fa-suitcase-medical {\n  --fa: \"\\f0fa\";\n}\n.fa-medkit {\n  --fa: \"\\f0fa\";\n}\n.fa-user-secret {\n  --fa: \"\\f21b\";\n}\n.fa-otter {\n  --fa: \"\\f700\";\n}\n.fa-person-dress {\n  --fa: \"\\f182\";\n}\n.fa-female {\n  --fa: \"\\f182\";\n}\n.fa-comment-dollar {\n  --fa: \"\\f651\";\n}\n.fa-business-time {\n  --fa: \"\\f64a\";\n}\n.fa-briefcase-clock {\n  --fa: \"\\f64a\";\n}\n.fa-table-cells-large {\n  --fa: \"\\f009\";\n}\n.fa-th-large {\n  --fa: \"\\f009\";\n}\n.fa-book-tanakh {\n  --fa: \"\\f827\";\n}\n.fa-tanakh {\n  --fa: \"\\f827\";\n}\n.fa-phone-volume {\n  --fa: \"\\f2a0\";\n}\n.fa-volume-control-phone {\n  --fa: \"\\f2a0\";\n}\n.fa-hat-cowboy-side {\n  --fa: \"\\f8c1\";\n}\n.fa-clipboard-user {\n  --fa: \"\\f7f3\";\n}\n.fa-child {\n  --fa: \"\\f1ae\";\n}\n.fa-lira-sign {\n  --fa: \"\\f195\";\n}\n.fa-satellite {\n  --fa: \"\\f7bf\";\n}\n.fa-plane-lock {\n  --fa: \"\\e558\";\n}\n.fa-tag {\n  --fa: \"\\f02b\";\n}\n.fa-comment {\n  --fa: \"\\f075\";\n}\n.fa-cake-candles {\n  --fa: \"\\f1fd\";\n}\n.fa-birthday-cake {\n  --fa: \"\\f1fd\";\n}\n.fa-cake {\n  --fa: \"\\f1fd\";\n}\n.fa-envelope {\n  --fa: \"\\f0e0\";\n}\n.fa-angles-up {\n  --fa: \"\\f102\";\n}\n.fa-angle-double-up {\n  --fa: \"\\f102\";\n}\n.fa-paperclip {\n  --fa: \"\\f0c6\";\n}\n.fa-arrow-right-to-city {\n  --fa: \"\\e4b3\";\n}\n.fa-ribbon {\n  --fa: \"\\f4d6\";\n}\n.fa-lungs {\n  --fa: \"\\f604\";\n}\n.fa-arrow-up-9-1 {\n  --fa: \"\\f887\";\n}\n.fa-sort-numeric-up-alt {\n  --fa: \"\\f887\";\n}\n.fa-litecoin-sign {\n  --fa: \"\\e1d3\";\n}\n.fa-border-none {\n  --fa: \"\\f850\";\n}\n.fa-circle-nodes {\n  --fa: \"\\e4e2\";\n}\n.fa-parachute-box {\n  --fa: \"\\f4cd\";\n}\n.fa-indent {\n  --fa: \"\\f03c\";\n}\n.fa-truck-field-un {\n  --fa: \"\\e58e\";\n}\n.fa-hourglass {\n  --fa: \"\\f254\";\n}\n.fa-hourglass-empty {\n  --fa: \"\\f254\";\n}\n.fa-mountain {\n  --fa: \"\\f6fc\";\n}\n.fa-user-doctor {\n  --fa: \"\\f0f0\";\n}\n.fa-user-md {\n  --fa: \"\\f0f0\";\n}\n.fa-circle-info {\n  --fa: \"\\f05a\";\n}\n.fa-info-circle {\n  --fa: \"\\f05a\";\n}\n.fa-cloud-meatball {\n  --fa: \"\\f73b\";\n}\n.fa-camera {\n  --fa: \"\\f030\";\n}\n.fa-camera-alt {\n  --fa: \"\\f030\";\n}\n.fa-square-virus {\n  --fa: \"\\e578\";\n}\n.fa-meteor {\n  --fa: \"\\f753\";\n}\n.fa-car-on {\n  --fa: \"\\e4dd\";\n}\n.fa-sleigh {\n  --fa: \"\\f7cc\";\n}\n.fa-arrow-down-1-9 {\n  --fa: \"\\f162\";\n}\n.fa-sort-numeric-asc {\n  --fa: \"\\f162\";\n}\n.fa-sort-numeric-down {\n  --fa: \"\\f162\";\n}\n.fa-hand-holding-droplet {\n  --fa: \"\\f4c1\";\n}\n.fa-hand-holding-water {\n  --fa: \"\\f4c1\";\n}\n.fa-water {\n  --fa: \"\\f773\";\n}\n.fa-calendar-check {\n  --fa: \"\\f274\";\n}\n.fa-braille {\n  --fa: \"\\f2a1\";\n}\n.fa-prescription-bottle-medical {\n  --fa: \"\\f486\";\n}\n.fa-prescription-bottle-alt {\n  --fa: \"\\f486\";\n}\n.fa-landmark {\n  --fa: \"\\f66f\";\n}\n.fa-truck {\n  --fa: \"\\f0d1\";\n}\n.fa-crosshairs {\n  --fa: \"\\f05b\";\n}\n.fa-person-cane {\n  --fa: \"\\e53c\";\n}\n.fa-tent {\n  --fa: \"\\e57d\";\n}\n.fa-vest-patches {\n  --fa: \"\\e086\";\n}\n.fa-check-double {\n  --fa: \"\\f560\";\n}\n.fa-arrow-down-a-z {\n  --fa: \"\\f15d\";\n}\n.fa-sort-alpha-asc {\n  --fa: \"\\f15d\";\n}\n.fa-sort-alpha-down {\n  --fa: \"\\f15d\";\n}\n.fa-money-bill-wheat {\n  --fa: \"\\e52a\";\n}\n.fa-cookie {\n  --fa: \"\\f563\";\n}\n.fa-arrow-rotate-left {\n  --fa: \"\\f0e2\";\n}\n.fa-arrow-left-rotate {\n  --fa: \"\\f0e2\";\n}\n.fa-arrow-rotate-back {\n  --fa: \"\\f0e2\";\n}\n.fa-arrow-rotate-backward {\n  --fa: \"\\f0e2\";\n}\n.fa-undo {\n  --fa: \"\\f0e2\";\n}\n.fa-hard-drive {\n  --fa: \"\\f0a0\";\n}\n.fa-hdd {\n  --fa: \"\\f0a0\";\n}\n.fa-face-grin-squint-tears {\n  --fa: \"\\f586\";\n}\n.fa-grin-squint-tears {\n  --fa: \"\\f586\";\n}\n.fa-dumbbell {\n  --fa: \"\\f44b\";\n}\n.fa-rectangle-list {\n  --fa: \"\\f022\";\n}\n.fa-list-alt {\n  --fa: \"\\f022\";\n}\n.fa-tarp-droplet {\n  --fa: \"\\e57c\";\n}\n.fa-house-medical-circle-check {\n  --fa: \"\\e511\";\n}\n.fa-person-skiing-nordic {\n  --fa: \"\\f7ca\";\n}\n.fa-skiing-nordic {\n  --fa: \"\\f7ca\";\n}\n.fa-calendar-plus {\n  --fa: \"\\f271\";\n}\n.fa-plane-arrival {\n  --fa: \"\\f5af\";\n}\n.fa-circle-left {\n  --fa: \"\\f359\";\n}\n.fa-arrow-alt-circle-left {\n  --fa: \"\\f359\";\n}\n.fa-train-subway {\n  --fa: \"\\f239\";\n}\n.fa-subway {\n  --fa: \"\\f239\";\n}\n.fa-chart-gantt {\n  --fa: \"\\e0e4\";\n}\n.fa-indian-rupee-sign {\n  --fa: \"\\e1bc\";\n}\n.fa-indian-rupee {\n  --fa: \"\\e1bc\";\n}\n.fa-inr {\n  --fa: \"\\e1bc\";\n}\n.fa-crop-simple {\n  --fa: \"\\f565\";\n}\n.fa-crop-alt {\n  --fa: \"\\f565\";\n}\n.fa-money-bill-1 {\n  --fa: \"\\f3d1\";\n}\n.fa-money-bill-alt {\n  --fa: \"\\f3d1\";\n}\n.fa-left-long {\n  --fa: \"\\f30a\";\n}\n.fa-long-arrow-alt-left {\n  --fa: \"\\f30a\";\n}\n.fa-dna {\n  --fa: \"\\f471\";\n}\n.fa-virus-slash {\n  --fa: \"\\e075\";\n}\n.fa-minus {\n  --fa: \"\\f068\";\n}\n.fa-subtract {\n  --fa: \"\\f068\";\n}\n.fa-chess {\n  --fa: \"\\f439\";\n}\n.fa-arrow-left-long {\n  --fa: \"\\f177\";\n}\n.fa-long-arrow-left {\n  --fa: \"\\f177\";\n}\n.fa-plug-circle-check {\n  --fa: \"\\e55c\";\n}\n.fa-street-view {\n  --fa: \"\\f21d\";\n}\n.fa-franc-sign {\n  --fa: \"\\e18f\";\n}\n.fa-volume-off {\n  --fa: \"\\f026\";\n}\n.fa-hands-asl-interpreting {\n  --fa: \"\\f2a3\";\n}\n.fa-american-sign-language-interpreting {\n  --fa: \"\\f2a3\";\n}\n.fa-asl-interpreting {\n  --fa: \"\\f2a3\";\n}\n.fa-hands-american-sign-language-interpreting {\n  --fa: \"\\f2a3\";\n}\n.fa-gear {\n  --fa: \"\\f013\";\n}\n.fa-cog {\n  --fa: \"\\f013\";\n}\n.fa-droplet-slash {\n  --fa: \"\\f5c7\";\n}\n.fa-tint-slash {\n  --fa: \"\\f5c7\";\n}\n.fa-mosque {\n  --fa: \"\\f678\";\n}\n.fa-mosquito {\n  --fa: \"\\e52b\";\n}\n.fa-star-of-david {\n  --fa: \"\\f69a\";\n}\n.fa-person-military-rifle {\n  --fa: \"\\e54b\";\n}\n.fa-cart-shopping {\n  --fa: \"\\f07a\";\n}\n.fa-shopping-cart {\n  --fa: \"\\f07a\";\n}\n.fa-vials {\n  --fa: \"\\f493\";\n}\n.fa-plug-circle-plus {\n  --fa: \"\\e55f\";\n}\n.fa-place-of-worship {\n  --fa: \"\\f67f\";\n}\n.fa-grip-vertical {\n  --fa: \"\\f58e\";\n}\n.fa-hexagon-nodes {\n  --fa: \"\\e699\";\n}\n.fa-arrow-turn-up {\n  --fa: \"\\f148\";\n}\n.fa-level-up {\n  --fa: \"\\f148\";\n}\n.fa-u {\n  --fa: \"\\55\";\n}\n.fa-square-root-variable {\n  --fa: \"\\f698\";\n}\n.fa-square-root-alt {\n  --fa: \"\\f698\";\n}\n.fa-clock {\n  --fa: \"\\f017\";\n}\n.fa-clock-four {\n  --fa: \"\\f017\";\n}\n.fa-backward-step {\n  --fa: \"\\f048\";\n}\n.fa-step-backward {\n  --fa: \"\\f048\";\n}\n.fa-pallet {\n  --fa: \"\\f482\";\n}\n.fa-faucet {\n  --fa: \"\\e005\";\n}\n.fa-baseball-bat-ball {\n  --fa: \"\\f432\";\n}\n.fa-s {\n  --fa: \"\\53\";\n}\n.fa-timeline {\n  --fa: \"\\e29c\";\n}\n.fa-keyboard {\n  --fa: \"\\f11c\";\n}\n.fa-caret-down {\n  --fa: \"\\f0d7\";\n}\n.fa-house-chimney-medical {\n  --fa: \"\\f7f2\";\n}\n.fa-clinic-medical {\n  --fa: \"\\f7f2\";\n}\n.fa-temperature-three-quarters {\n  --fa: \"\\f2c8\";\n}\n.fa-temperature-3 {\n  --fa: \"\\f2c8\";\n}\n.fa-thermometer-3 {\n  --fa: \"\\f2c8\";\n}\n.fa-thermometer-three-quarters {\n  --fa: \"\\f2c8\";\n}\n.fa-mobile-screen {\n  --fa: \"\\f3cf\";\n}\n.fa-mobile-android-alt {\n  --fa: \"\\f3cf\";\n}\n.fa-plane-up {\n  --fa: \"\\e22d\";\n}\n.fa-piggy-bank {\n  --fa: \"\\f4d3\";\n}\n.fa-battery-half {\n  --fa: \"\\f242\";\n}\n.fa-battery-3 {\n  --fa: \"\\f242\";\n}\n.fa-mountain-city {\n  --fa: \"\\e52e\";\n}\n.fa-coins {\n  --fa: \"\\f51e\";\n}\n.fa-khanda {\n  --fa: \"\\f66d\";\n}\n.fa-sliders {\n  --fa: \"\\f1de\";\n}\n.fa-sliders-h {\n  --fa: \"\\f1de\";\n}\n.fa-folder-tree {\n  --fa: \"\\f802\";\n}\n.fa-network-wired {\n  --fa: \"\\f6ff\";\n}\n.fa-map-pin {\n  --fa: \"\\f276\";\n}\n.fa-hamsa {\n  --fa: \"\\f665\";\n}\n.fa-cent-sign {\n  --fa: \"\\e3f5\";\n}\n.fa-flask {\n  --fa: \"\\f0c3\";\n}\n.fa-person-pregnant {\n  --fa: \"\\e31e\";\n}\n.fa-wand-sparkles {\n  --fa: \"\\f72b\";\n}\n.fa-ellipsis-vertical {\n  --fa: \"\\f142\";\n}\n.fa-ellipsis-v {\n  --fa: \"\\f142\";\n}\n.fa-ticket {\n  --fa: \"\\f145\";\n}\n.fa-power-off {\n  --fa: \"\\f011\";\n}\n.fa-right-long {\n  --fa: \"\\f30b\";\n}\n.fa-long-arrow-alt-right {\n  --fa: \"\\f30b\";\n}\n.fa-flag-usa {\n  --fa: \"\\f74d\";\n}\n.fa-laptop-file {\n  --fa: \"\\e51d\";\n}\n.fa-tty {\n  --fa: \"\\f1e4\";\n}\n.fa-teletype {\n  --fa: \"\\f1e4\";\n}\n.fa-diagram-next {\n  --fa: \"\\e476\";\n}\n.fa-person-rifle {\n  --fa: \"\\e54e\";\n}\n.fa-house-medical-circle-exclamation {\n  --fa: \"\\e512\";\n}\n.fa-closed-captioning {\n  --fa: \"\\f20a\";\n}\n.fa-person-hiking {\n  --fa: \"\\f6ec\";\n}\n.fa-hiking {\n  --fa: \"\\f6ec\";\n}\n.fa-venus-double {\n  --fa: \"\\f226\";\n}\n.fa-images {\n  --fa: \"\\f302\";\n}\n.fa-calculator {\n  --fa: \"\\f1ec\";\n}\n.fa-people-pulling {\n  --fa: \"\\e535\";\n}\n.fa-n {\n  --fa: \"\\4e\";\n}\n.fa-cable-car {\n  --fa: \"\\f7da\";\n}\n.fa-tram {\n  --fa: \"\\f7da\";\n}\n.fa-cloud-rain {\n  --fa: \"\\f73d\";\n}\n.fa-building-circle-xmark {\n  --fa: \"\\e4d4\";\n}\n.fa-ship {\n  --fa: \"\\f21a\";\n}\n.fa-arrows-down-to-line {\n  --fa: \"\\e4b8\";\n}\n.fa-download {\n  --fa: \"\\f019\";\n}\n.fa-face-grin {\n  --fa: \"\\f580\";\n}\n.fa-grin {\n  --fa: \"\\f580\";\n}\n.fa-delete-left {\n  --fa: \"\\f55a\";\n}\n.fa-backspace {\n  --fa: \"\\f55a\";\n}\n.fa-eye-dropper {\n  --fa: \"\\f1fb\";\n}\n.fa-eye-dropper-empty {\n  --fa: \"\\f1fb\";\n}\n.fa-eyedropper {\n  --fa: \"\\f1fb\";\n}\n.fa-file-circle-check {\n  --fa: \"\\e5a0\";\n}\n.fa-forward {\n  --fa: \"\\f04e\";\n}\n.fa-mobile {\n  --fa: \"\\f3ce\";\n}\n.fa-mobile-android {\n  --fa: \"\\f3ce\";\n}\n.fa-mobile-phone {\n  --fa: \"\\f3ce\";\n}\n.fa-face-meh {\n  --fa: \"\\f11a\";\n}\n.fa-meh {\n  --fa: \"\\f11a\";\n}\n.fa-align-center {\n  --fa: \"\\f037\";\n}\n.fa-book-skull {\n  --fa: \"\\f6b7\";\n}\n.fa-book-dead {\n  --fa: \"\\f6b7\";\n}\n.fa-id-card {\n  --fa: \"\\f2c2\";\n}\n.fa-drivers-license {\n  --fa: \"\\f2c2\";\n}\n.fa-outdent {\n  --fa: \"\\f03b\";\n}\n.fa-dedent {\n  --fa: \"\\f03b\";\n}\n.fa-heart-circle-exclamation {\n  --fa: \"\\e4fe\";\n}\n.fa-house {\n  --fa: \"\\f015\";\n}\n.fa-home {\n  --fa: \"\\f015\";\n}\n.fa-home-alt {\n  --fa: \"\\f015\";\n}\n.fa-home-lg-alt {\n  --fa: \"\\f015\";\n}\n.fa-calendar-week {\n  --fa: \"\\f784\";\n}\n.fa-laptop-medical {\n  --fa: \"\\f812\";\n}\n.fa-b {\n  --fa: \"\\42\";\n}\n.fa-file-medical {\n  --fa: \"\\f477\";\n}\n.fa-dice-one {\n  --fa: \"\\f525\";\n}\n.fa-kiwi-bird {\n  --fa: \"\\f535\";\n}\n.fa-arrow-right-arrow-left {\n  --fa: \"\\f0ec\";\n}\n.fa-exchange {\n  --fa: \"\\f0ec\";\n}\n.fa-rotate-right {\n  --fa: \"\\f2f9\";\n}\n.fa-redo-alt {\n  --fa: \"\\f2f9\";\n}\n.fa-rotate-forward {\n  --fa: \"\\f2f9\";\n}\n.fa-utensils {\n  --fa: \"\\f2e7\";\n}\n.fa-cutlery {\n  --fa: \"\\f2e7\";\n}\n.fa-arrow-up-wide-short {\n  --fa: \"\\f161\";\n}\n.fa-sort-amount-up {\n  --fa: \"\\f161\";\n}\n.fa-mill-sign {\n  --fa: \"\\e1ed\";\n}\n.fa-bowl-rice {\n  --fa: \"\\e2eb\";\n}\n.fa-skull {\n  --fa: \"\\f54c\";\n}\n.fa-tower-broadcast {\n  --fa: \"\\f519\";\n}\n.fa-broadcast-tower {\n  --fa: \"\\f519\";\n}\n.fa-truck-pickup {\n  --fa: \"\\f63c\";\n}\n.fa-up-long {\n  --fa: \"\\f30c\";\n}\n.fa-long-arrow-alt-up {\n  --fa: \"\\f30c\";\n}\n.fa-stop {\n  --fa: \"\\f04d\";\n}\n.fa-code-merge {\n  --fa: \"\\f387\";\n}\n.fa-upload {\n  --fa: \"\\f093\";\n}\n.fa-hurricane {\n  --fa: \"\\f751\";\n}\n.fa-mound {\n  --fa: \"\\e52d\";\n}\n.fa-toilet-portable {\n  --fa: \"\\e583\";\n}\n.fa-compact-disc {\n  --fa: \"\\f51f\";\n}\n.fa-file-arrow-down {\n  --fa: \"\\f56d\";\n}\n.fa-file-download {\n  --fa: \"\\f56d\";\n}\n.fa-caravan {\n  --fa: \"\\f8ff\";\n}\n.fa-shield-cat {\n  --fa: \"\\e572\";\n}\n.fa-bolt {\n  --fa: \"\\f0e7\";\n}\n.fa-zap {\n  --fa: \"\\f0e7\";\n}\n.fa-glass-water {\n  --fa: \"\\e4f4\";\n}\n.fa-oil-well {\n  --fa: \"\\e532\";\n}\n.fa-vault {\n  --fa: \"\\e2c5\";\n}\n.fa-mars {\n  --fa: \"\\f222\";\n}\n.fa-toilet {\n  --fa: \"\\f7d8\";\n}\n.fa-plane-circle-xmark {\n  --fa: \"\\e557\";\n}\n.fa-yen-sign {\n  --fa: \"\\f157\";\n}\n.fa-cny {\n  --fa: \"\\f157\";\n}\n.fa-jpy {\n  --fa: \"\\f157\";\n}\n.fa-rmb {\n  --fa: \"\\f157\";\n}\n.fa-yen {\n  --fa: \"\\f157\";\n}\n.fa-ruble-sign {\n  --fa: \"\\f158\";\n}\n.fa-rouble {\n  --fa: \"\\f158\";\n}\n.fa-rub {\n  --fa: \"\\f158\";\n}\n.fa-ruble {\n  --fa: \"\\f158\";\n}\n.fa-sun {\n  --fa: \"\\f185\";\n}\n.fa-guitar {\n  --fa: \"\\f7a6\";\n}\n.fa-face-laugh-wink {\n  --fa: \"\\f59c\";\n}\n.fa-laugh-wink {\n  --fa: \"\\f59c\";\n}\n.fa-horse-head {\n  --fa: \"\\f7ab\";\n}\n.fa-bore-hole {\n  --fa: \"\\e4c3\";\n}\n.fa-industry {\n  --fa: \"\\f275\";\n}\n.fa-circle-down {\n  --fa: \"\\f358\";\n}\n.fa-arrow-alt-circle-down {\n  --fa: \"\\f358\";\n}\n.fa-arrows-turn-to-dots {\n  --fa: \"\\e4c1\";\n}\n.fa-florin-sign {\n  --fa: \"\\e184\";\n}\n.fa-arrow-down-short-wide {\n  --fa: \"\\f884\";\n}\n.fa-sort-amount-desc {\n  --fa: \"\\f884\";\n}\n.fa-sort-amount-down-alt {\n  --fa: \"\\f884\";\n}\n.fa-less-than {\n  --fa: \"\\3c\";\n}\n.fa-angle-down {\n  --fa: \"\\f107\";\n}\n.fa-car-tunnel {\n  --fa: \"\\e4de\";\n}\n.fa-head-side-cough {\n  --fa: \"\\e061\";\n}\n.fa-grip-lines {\n  --fa: \"\\f7a4\";\n}\n.fa-thumbs-down {\n  --fa: \"\\f165\";\n}\n.fa-user-lock {\n  --fa: \"\\f502\";\n}\n.fa-arrow-right-long {\n  --fa: \"\\f178\";\n}\n.fa-long-arrow-right {\n  --fa: \"\\f178\";\n}\n.fa-anchor-circle-xmark {\n  --fa: \"\\e4ac\";\n}\n.fa-ellipsis {\n  --fa: \"\\f141\";\n}\n.fa-ellipsis-h {\n  --fa: \"\\f141\";\n}\n.fa-chess-pawn {\n  --fa: \"\\f443\";\n}\n.fa-kit-medical {\n  --fa: \"\\f479\";\n}\n.fa-first-aid {\n  --fa: \"\\f479\";\n}\n.fa-person-through-window {\n  --fa: \"\\e5a9\";\n}\n.fa-toolbox {\n  --fa: \"\\f552\";\n}\n.fa-hands-holding-circle {\n  --fa: \"\\e4fb\";\n}\n.fa-bug {\n  --fa: \"\\f188\";\n}\n.fa-credit-card {\n  --fa: \"\\f09d\";\n}\n.fa-credit-card-alt {\n  --fa: \"\\f09d\";\n}\n.fa-car {\n  --fa: \"\\f1b9\";\n}\n.fa-automobile {\n  --fa: \"\\f1b9\";\n}\n.fa-hand-holding-hand {\n  --fa: \"\\e4f7\";\n}\n.fa-book-open-reader {\n  --fa: \"\\f5da\";\n}\n.fa-book-reader {\n  --fa: \"\\f5da\";\n}\n.fa-mountain-sun {\n  --fa: \"\\e52f\";\n}\n.fa-arrows-left-right-to-line {\n  --fa: \"\\e4ba\";\n}\n.fa-dice-d20 {\n  --fa: \"\\f6cf\";\n}\n.fa-truck-droplet {\n  --fa: \"\\e58c\";\n}\n.fa-file-circle-xmark {\n  --fa: \"\\e5a1\";\n}\n.fa-temperature-arrow-up {\n  --fa: \"\\e040\";\n}\n.fa-temperature-up {\n  --fa: \"\\e040\";\n}\n.fa-medal {\n  --fa: \"\\f5a2\";\n}\n.fa-bed {\n  --fa: \"\\f236\";\n}\n.fa-square-h {\n  --fa: \"\\f0fd\";\n}\n.fa-h-square {\n  --fa: \"\\f0fd\";\n}\n.fa-podcast {\n  --fa: \"\\f2ce\";\n}\n.fa-temperature-full {\n  --fa: \"\\f2c7\";\n}\n.fa-temperature-4 {\n  --fa: \"\\f2c7\";\n}\n.fa-thermometer-4 {\n  --fa: \"\\f2c7\";\n}\n.fa-thermometer-full {\n  --fa: \"\\f2c7\";\n}\n.fa-bell {\n  --fa: \"\\f0f3\";\n}\n.fa-superscript {\n  --fa: \"\\f12b\";\n}\n.fa-plug-circle-xmark {\n  --fa: \"\\e560\";\n}\n.fa-star-of-life {\n  --fa: \"\\f621\";\n}\n.fa-phone-slash {\n  --fa: \"\\f3dd\";\n}\n.fa-paint-roller {\n  --fa: \"\\f5aa\";\n}\n.fa-handshake-angle {\n  --fa: \"\\f4c4\";\n}\n.fa-hands-helping {\n  --fa: \"\\f4c4\";\n}\n.fa-location-dot {\n  --fa: \"\\f3c5\";\n}\n.fa-map-marker-alt {\n  --fa: \"\\f3c5\";\n}\n.fa-file {\n  --fa: \"\\f15b\";\n}\n.fa-greater-than {\n  --fa: \"\\3e\";\n}\n.fa-person-swimming {\n  --fa: \"\\f5c4\";\n}\n.fa-swimmer {\n  --fa: \"\\f5c4\";\n}\n.fa-arrow-down {\n  --fa: \"\\f063\";\n}\n.fa-droplet {\n  --fa: \"\\f043\";\n}\n.fa-tint {\n  --fa: \"\\f043\";\n}\n.fa-eraser {\n  --fa: \"\\f12d\";\n}\n.fa-earth-americas {\n  --fa: \"\\f57d\";\n}\n.fa-earth {\n  --fa: \"\\f57d\";\n}\n.fa-earth-america {\n  --fa: \"\\f57d\";\n}\n.fa-globe-americas {\n  --fa: \"\\f57d\";\n}\n.fa-person-burst {\n  --fa: \"\\e53b\";\n}\n.fa-dove {\n  --fa: \"\\f4ba\";\n}\n.fa-battery-empty {\n  --fa: \"\\f244\";\n}\n.fa-battery-0 {\n  --fa: \"\\f244\";\n}\n.fa-socks {\n  --fa: \"\\f696\";\n}\n.fa-inbox {\n  --fa: \"\\f01c\";\n}\n.fa-section {\n  --fa: \"\\e447\";\n}\n.fa-gauge-high {\n  --fa: \"\\f625\";\n}\n.fa-tachometer-alt {\n  --fa: \"\\f625\";\n}\n.fa-tachometer-alt-fast {\n  --fa: \"\\f625\";\n}\n.fa-envelope-open-text {\n  --fa: \"\\f658\";\n}\n.fa-hospital {\n  --fa: \"\\f0f8\";\n}\n.fa-hospital-alt {\n  --fa: \"\\f0f8\";\n}\n.fa-hospital-wide {\n  --fa: \"\\f0f8\";\n}\n.fa-wine-bottle {\n  --fa: \"\\f72f\";\n}\n.fa-chess-rook {\n  --fa: \"\\f447\";\n}\n.fa-bars-staggered {\n  --fa: \"\\f550\";\n}\n.fa-reorder {\n  --fa: \"\\f550\";\n}\n.fa-stream {\n  --fa: \"\\f550\";\n}\n.fa-dharmachakra {\n  --fa: \"\\f655\";\n}\n.fa-hotdog {\n  --fa: \"\\f80f\";\n}\n.fa-person-walking-with-cane {\n  --fa: \"\\f29d\";\n}\n.fa-blind {\n  --fa: \"\\f29d\";\n}\n.fa-drum {\n  --fa: \"\\f569\";\n}\n.fa-ice-cream {\n  --fa: \"\\f810\";\n}\n.fa-heart-circle-bolt {\n  --fa: \"\\e4fc\";\n}\n.fa-fax {\n  --fa: \"\\f1ac\";\n}\n.fa-paragraph {\n  --fa: \"\\f1dd\";\n}\n.fa-check-to-slot {\n  --fa: \"\\f772\";\n}\n.fa-vote-yea {\n  --fa: \"\\f772\";\n}\n.fa-star-half {\n  --fa: \"\\f089\";\n}\n.fa-boxes-stacked {\n  --fa: \"\\f468\";\n}\n.fa-boxes {\n  --fa: \"\\f468\";\n}\n.fa-boxes-alt {\n  --fa: \"\\f468\";\n}\n.fa-link {\n  --fa: \"\\f0c1\";\n}\n.fa-chain {\n  --fa: \"\\f0c1\";\n}\n.fa-ear-listen {\n  --fa: \"\\f2a2\";\n}\n.fa-assistive-listening-systems {\n  --fa: \"\\f2a2\";\n}\n.fa-tree-city {\n  --fa: \"\\e587\";\n}\n.fa-play {\n  --fa: \"\\f04b\";\n}\n.fa-font {\n  --fa: \"\\f031\";\n}\n.fa-table-cells-row-lock {\n  --fa: \"\\e67a\";\n}\n.fa-rupiah-sign {\n  --fa: \"\\e23d\";\n}\n.fa-magnifying-glass {\n  --fa: \"\\f002\";\n}\n.fa-search {\n  --fa: \"\\f002\";\n}\n.fa-table-tennis-paddle-ball {\n  --fa: \"\\f45d\";\n}\n.fa-ping-pong-paddle-ball {\n  --fa: \"\\f45d\";\n}\n.fa-table-tennis {\n  --fa: \"\\f45d\";\n}\n.fa-person-dots-from-line {\n  --fa: \"\\f470\";\n}\n.fa-diagnoses {\n  --fa: \"\\f470\";\n}\n.fa-trash-can-arrow-up {\n  --fa: \"\\f82a\";\n}\n.fa-trash-restore-alt {\n  --fa: \"\\f82a\";\n}\n.fa-naira-sign {\n  --fa: \"\\e1f6\";\n}\n.fa-cart-arrow-down {\n  --fa: \"\\f218\";\n}\n.fa-walkie-talkie {\n  --fa: \"\\f8ef\";\n}\n.fa-file-pen {\n  --fa: \"\\f31c\";\n}\n.fa-file-edit {\n  --fa: \"\\f31c\";\n}\n.fa-receipt {\n  --fa: \"\\f543\";\n}\n.fa-square-pen {\n  --fa: \"\\f14b\";\n}\n.fa-pen-square {\n  --fa: \"\\f14b\";\n}\n.fa-pencil-square {\n  --fa: \"\\f14b\";\n}\n.fa-suitcase-rolling {\n  --fa: \"\\f5c1\";\n}\n.fa-person-circle-exclamation {\n  --fa: \"\\e53f\";\n}\n.fa-chevron-down {\n  --fa: \"\\f078\";\n}\n.fa-battery-full {\n  --fa: \"\\f240\";\n}\n.fa-battery {\n  --fa: \"\\f240\";\n}\n.fa-battery-5 {\n  --fa: \"\\f240\";\n}\n.fa-skull-crossbones {\n  --fa: \"\\f714\";\n}\n.fa-code-compare {\n  --fa: \"\\e13a\";\n}\n.fa-list-ul {\n  --fa: \"\\f0ca\";\n}\n.fa-list-dots {\n  --fa: \"\\f0ca\";\n}\n.fa-school-lock {\n  --fa: \"\\e56f\";\n}\n.fa-tower-cell {\n  --fa: \"\\e585\";\n}\n.fa-down-long {\n  --fa: \"\\f309\";\n}\n.fa-long-arrow-alt-down {\n  --fa: \"\\f309\";\n}\n.fa-ranking-star {\n  --fa: \"\\e561\";\n}\n.fa-chess-king {\n  --fa: \"\\f43f\";\n}\n.fa-person-harassing {\n  --fa: \"\\e549\";\n}\n.fa-brazilian-real-sign {\n  --fa: \"\\e46c\";\n}\n.fa-landmark-dome {\n  --fa: \"\\f752\";\n}\n.fa-landmark-alt {\n  --fa: \"\\f752\";\n}\n.fa-arrow-up {\n  --fa: \"\\f062\";\n}\n.fa-tv {\n  --fa: \"\\f26c\";\n}\n.fa-television {\n  --fa: \"\\f26c\";\n}\n.fa-tv-alt {\n  --fa: \"\\f26c\";\n}\n.fa-shrimp {\n  --fa: \"\\e448\";\n}\n.fa-list-check {\n  --fa: \"\\f0ae\";\n}\n.fa-tasks {\n  --fa: \"\\f0ae\";\n}\n.fa-jug-detergent {\n  --fa: \"\\e519\";\n}\n.fa-circle-user {\n  --fa: \"\\f2bd\";\n}\n.fa-user-circle {\n  --fa: \"\\f2bd\";\n}\n.fa-user-shield {\n  --fa: \"\\f505\";\n}\n.fa-wind {\n  --fa: \"\\f72e\";\n}\n.fa-car-burst {\n  --fa: \"\\f5e1\";\n}\n.fa-car-crash {\n  --fa: \"\\f5e1\";\n}\n.fa-y {\n  --fa: \"\\59\";\n}\n.fa-person-snowboarding {\n  --fa: \"\\f7ce\";\n}\n.fa-snowboarding {\n  --fa: \"\\f7ce\";\n}\n.fa-truck-fast {\n  --fa: \"\\f48b\";\n}\n.fa-shipping-fast {\n  --fa: \"\\f48b\";\n}\n.fa-fish {\n  --fa: \"\\f578\";\n}\n.fa-user-graduate {\n  --fa: \"\\f501\";\n}\n.fa-circle-half-stroke {\n  --fa: \"\\f042\";\n}\n.fa-adjust {\n  --fa: \"\\f042\";\n}\n.fa-clapperboard {\n  --fa: \"\\e131\";\n}\n.fa-circle-radiation {\n  --fa: \"\\f7ba\";\n}\n.fa-radiation-alt {\n  --fa: \"\\f7ba\";\n}\n.fa-baseball {\n  --fa: \"\\f433\";\n}\n.fa-baseball-ball {\n  --fa: \"\\f433\";\n}\n.fa-jet-fighter-up {\n  --fa: \"\\e518\";\n}\n.fa-diagram-project {\n  --fa: \"\\f542\";\n}\n.fa-project-diagram {\n  --fa: \"\\f542\";\n}\n.fa-copy {\n  --fa: \"\\f0c5\";\n}\n.fa-volume-xmark {\n  --fa: \"\\f6a9\";\n}\n.fa-volume-mute {\n  --fa: \"\\f6a9\";\n}\n.fa-volume-times {\n  --fa: \"\\f6a9\";\n}\n.fa-hand-sparkles {\n  --fa: \"\\e05d\";\n}\n.fa-grip {\n  --fa: \"\\f58d\";\n}\n.fa-grip-horizontal {\n  --fa: \"\\f58d\";\n}\n.fa-share-from-square {\n  --fa: \"\\f14d\";\n}\n.fa-share-square {\n  --fa: \"\\f14d\";\n}\n.fa-child-combatant {\n  --fa: \"\\e4e0\";\n}\n.fa-child-rifle {\n  --fa: \"\\e4e0\";\n}\n.fa-gun {\n  --fa: \"\\e19b\";\n}\n.fa-square-phone {\n  --fa: \"\\f098\";\n}\n.fa-phone-square {\n  --fa: \"\\f098\";\n}\n.fa-plus {\n  --fa: \"\\2b\";\n}\n.fa-add {\n  --fa: \"\\2b\";\n}\n.fa-expand {\n  --fa: \"\\f065\";\n}\n.fa-computer {\n  --fa: \"\\e4e5\";\n}\n.fa-xmark {\n  --fa: \"\\f00d\";\n}\n.fa-close {\n  --fa: \"\\f00d\";\n}\n.fa-multiply {\n  --fa: \"\\f00d\";\n}\n.fa-remove {\n  --fa: \"\\f00d\";\n}\n.fa-times {\n  --fa: \"\\f00d\";\n}\n.fa-arrows-up-down-left-right {\n  --fa: \"\\f047\";\n}\n.fa-arrows {\n  --fa: \"\\f047\";\n}\n.fa-chalkboard-user {\n  --fa: \"\\f51c\";\n}\n.fa-chalkboard-teacher {\n  --fa: \"\\f51c\";\n}\n.fa-peso-sign {\n  --fa: \"\\e222\";\n}\n.fa-building-shield {\n  --fa: \"\\e4d8\";\n}\n.fa-baby {\n  --fa: \"\\f77c\";\n}\n.fa-users-line {\n  --fa: \"\\e592\";\n}\n.fa-quote-left {\n  --fa: \"\\f10d\";\n}\n.fa-quote-left-alt {\n  --fa: \"\\f10d\";\n}\n.fa-tractor {\n  --fa: \"\\f722\";\n}\n.fa-trash-arrow-up {\n  --fa: \"\\f829\";\n}\n.fa-trash-restore {\n  --fa: \"\\f829\";\n}\n.fa-arrow-down-up-lock {\n  --fa: \"\\e4b0\";\n}\n.fa-lines-leaning {\n  --fa: \"\\e51e\";\n}\n.fa-ruler-combined {\n  --fa: \"\\f546\";\n}\n.fa-copyright {\n  --fa: \"\\f1f9\";\n}\n.fa-equals {\n  --fa: \"\\3d\";\n}\n.fa-blender {\n  --fa: \"\\f517\";\n}\n.fa-teeth {\n  --fa: \"\\f62e\";\n}\n.fa-shekel-sign {\n  --fa: \"\\f20b\";\n}\n.fa-ils {\n  --fa: \"\\f20b\";\n}\n.fa-shekel {\n  --fa: \"\\f20b\";\n}\n.fa-sheqel {\n  --fa: \"\\f20b\";\n}\n.fa-sheqel-sign {\n  --fa: \"\\f20b\";\n}\n.fa-map {\n  --fa: \"\\f279\";\n}\n.fa-rocket {\n  --fa: \"\\f135\";\n}\n.fa-photo-film {\n  --fa: \"\\f87c\";\n}\n.fa-photo-video {\n  --fa: \"\\f87c\";\n}\n.fa-folder-minus {\n  --fa: \"\\f65d\";\n}\n.fa-hexagon-nodes-bolt {\n  --fa: \"\\e69a\";\n}\n.fa-store {\n  --fa: \"\\f54e\";\n}\n.fa-arrow-trend-up {\n  --fa: \"\\e098\";\n}\n.fa-plug-circle-minus {\n  --fa: \"\\e55e\";\n}\n.fa-sign-hanging {\n  --fa: \"\\f4d9\";\n}\n.fa-sign {\n  --fa: \"\\f4d9\";\n}\n.fa-bezier-curve {\n  --fa: \"\\f55b\";\n}\n.fa-bell-slash {\n  --fa: \"\\f1f6\";\n}\n.fa-tablet {\n  --fa: \"\\f3fb\";\n}\n.fa-tablet-android {\n  --fa: \"\\f3fb\";\n}\n.fa-school-flag {\n  --fa: \"\\e56e\";\n}\n.fa-fill {\n  --fa: \"\\f575\";\n}\n.fa-angle-up {\n  --fa: \"\\f106\";\n}\n.fa-drumstick-bite {\n  --fa: \"\\f6d7\";\n}\n.fa-holly-berry {\n  --fa: \"\\f7aa\";\n}\n.fa-chevron-left {\n  --fa: \"\\f053\";\n}\n.fa-bacteria {\n  --fa: \"\\e059\";\n}\n.fa-hand-lizard {\n  --fa: \"\\f258\";\n}\n.fa-notdef {\n  --fa: \"\\e1fe\";\n}\n.fa-disease {\n  --fa: \"\\f7fa\";\n}\n.fa-briefcase-medical {\n  --fa: \"\\f469\";\n}\n.fa-genderless {\n  --fa: \"\\f22d\";\n}\n.fa-chevron-right {\n  --fa: \"\\f054\";\n}\n.fa-retweet {\n  --fa: \"\\f079\";\n}\n.fa-car-rear {\n  --fa: \"\\f5de\";\n}\n.fa-car-alt {\n  --fa: \"\\f5de\";\n}\n.fa-pump-soap {\n  --fa: \"\\e06b\";\n}\n.fa-video-slash {\n  --fa: \"\\f4e2\";\n}\n.fa-battery-quarter {\n  --fa: \"\\f243\";\n}\n.fa-battery-2 {\n  --fa: \"\\f243\";\n}\n.fa-radio {\n  --fa: \"\\f8d7\";\n}\n.fa-baby-carriage {\n  --fa: \"\\f77d\";\n}\n.fa-carriage-baby {\n  --fa: \"\\f77d\";\n}\n.fa-traffic-light {\n  --fa: \"\\f637\";\n}\n.fa-thermometer {\n  --fa: \"\\f491\";\n}\n.fa-vr-cardboard {\n  --fa: \"\\f729\";\n}\n.fa-hand-middle-finger {\n  --fa: \"\\f806\";\n}\n.fa-percent {\n  --fa: \"\\25\";\n}\n.fa-percentage {\n  --fa: \"\\25\";\n}\n.fa-truck-moving {\n  --fa: \"\\f4df\";\n}\n.fa-glass-water-droplet {\n  --fa: \"\\e4f5\";\n}\n.fa-display {\n  --fa: \"\\e163\";\n}\n.fa-face-smile {\n  --fa: \"\\f118\";\n}\n.fa-smile {\n  --fa: \"\\f118\";\n}\n.fa-thumbtack {\n  --fa: \"\\f08d\";\n}\n.fa-thumb-tack {\n  --fa: \"\\f08d\";\n}\n.fa-trophy {\n  --fa: \"\\f091\";\n}\n.fa-person-praying {\n  --fa: \"\\f683\";\n}\n.fa-pray {\n  --fa: \"\\f683\";\n}\n.fa-hammer {\n  --fa: \"\\f6e3\";\n}\n.fa-hand-peace {\n  --fa: \"\\f25b\";\n}\n.fa-rotate {\n  --fa: \"\\f2f1\";\n}\n.fa-sync-alt {\n  --fa: \"\\f2f1\";\n}\n.fa-spinner {\n  --fa: \"\\f110\";\n}\n.fa-robot {\n  --fa: \"\\f544\";\n}\n.fa-peace {\n  --fa: \"\\f67c\";\n}\n.fa-gears {\n  --fa: \"\\f085\";\n}\n.fa-cogs {\n  --fa: \"\\f085\";\n}\n.fa-warehouse {\n  --fa: \"\\f494\";\n}\n.fa-arrow-up-right-dots {\n  --fa: \"\\e4b7\";\n}\n.fa-splotch {\n  --fa: \"\\f5bc\";\n}\n.fa-face-grin-hearts {\n  --fa: \"\\f584\";\n}\n.fa-grin-hearts {\n  --fa: \"\\f584\";\n}\n.fa-dice-four {\n  --fa: \"\\f524\";\n}\n.fa-sim-card {\n  --fa: \"\\f7c4\";\n}\n.fa-transgender {\n  --fa: \"\\f225\";\n}\n.fa-transgender-alt {\n  --fa: \"\\f225\";\n}\n.fa-mercury {\n  --fa: \"\\f223\";\n}\n.fa-arrow-turn-down {\n  --fa: \"\\f149\";\n}\n.fa-level-down {\n  --fa: \"\\f149\";\n}\n.fa-person-falling-burst {\n  --fa: \"\\e547\";\n}\n.fa-award {\n  --fa: \"\\f559\";\n}\n.fa-ticket-simple {\n  --fa: \"\\f3ff\";\n}\n.fa-ticket-alt {\n  --fa: \"\\f3ff\";\n}\n.fa-building {\n  --fa: \"\\f1ad\";\n}\n.fa-angles-left {\n  --fa: \"\\f100\";\n}\n.fa-angle-double-left {\n  --fa: \"\\f100\";\n}\n.fa-qrcode {\n  --fa: \"\\f029\";\n}\n.fa-clock-rotate-left {\n  --fa: \"\\f1da\";\n}\n.fa-history {\n  --fa: \"\\f1da\";\n}\n.fa-face-grin-beam-sweat {\n  --fa: \"\\f583\";\n}\n.fa-grin-beam-sweat {\n  --fa: \"\\f583\";\n}\n.fa-file-export {\n  --fa: \"\\f56e\";\n}\n.fa-arrow-right-from-file {\n  --fa: \"\\f56e\";\n}\n.fa-shield {\n  --fa: \"\\f132\";\n}\n.fa-shield-blank {\n  --fa: \"\\f132\";\n}\n.fa-arrow-up-short-wide {\n  --fa: \"\\f885\";\n}\n.fa-sort-amount-up-alt {\n  --fa: \"\\f885\";\n}\n.fa-comment-nodes {\n  --fa: \"\\e696\";\n}\n.fa-house-medical {\n  --fa: \"\\e3b2\";\n}\n.fa-golf-ball-tee {\n  --fa: \"\\f450\";\n}\n.fa-golf-ball {\n  --fa: \"\\f450\";\n}\n.fa-circle-chevron-left {\n  --fa: \"\\f137\";\n}\n.fa-chevron-circle-left {\n  --fa: \"\\f137\";\n}\n.fa-house-chimney-window {\n  --fa: \"\\e00d\";\n}\n.fa-pen-nib {\n  --fa: \"\\f5ad\";\n}\n.fa-tent-arrow-turn-left {\n  --fa: \"\\e580\";\n}\n.fa-tents {\n  --fa: \"\\e582\";\n}\n.fa-wand-magic {\n  --fa: \"\\f0d0\";\n}\n.fa-magic {\n  --fa: \"\\f0d0\";\n}\n.fa-dog {\n  --fa: \"\\f6d3\";\n}\n.fa-carrot {\n  --fa: \"\\f787\";\n}\n.fa-moon {\n  --fa: \"\\f186\";\n}\n.fa-wine-glass-empty {\n  --fa: \"\\f5ce\";\n}\n.fa-wine-glass-alt {\n  --fa: \"\\f5ce\";\n}\n.fa-cheese {\n  --fa: \"\\f7ef\";\n}\n.fa-yin-yang {\n  --fa: \"\\f6ad\";\n}\n.fa-music {\n  --fa: \"\\f001\";\n}\n.fa-code-commit {\n  --fa: \"\\f386\";\n}\n.fa-temperature-low {\n  --fa: \"\\f76b\";\n}\n.fa-person-biking {\n  --fa: \"\\f84a\";\n}\n.fa-biking {\n  --fa: \"\\f84a\";\n}\n.fa-broom {\n  --fa: \"\\f51a\";\n}\n.fa-shield-heart {\n  --fa: \"\\e574\";\n}\n.fa-gopuram {\n  --fa: \"\\f664\";\n}\n.fa-earth-oceania {\n  --fa: \"\\e47b\";\n}\n.fa-globe-oceania {\n  --fa: \"\\e47b\";\n}\n.fa-square-xmark {\n  --fa: \"\\f2d3\";\n}\n.fa-times-square {\n  --fa: \"\\f2d3\";\n}\n.fa-xmark-square {\n  --fa: \"\\f2d3\";\n}\n.fa-hashtag {\n  --fa: \"\\23\";\n}\n.fa-up-right-and-down-left-from-center {\n  --fa: \"\\f424\";\n}\n.fa-expand-alt {\n  --fa: \"\\f424\";\n}\n.fa-oil-can {\n  --fa: \"\\f613\";\n}\n.fa-t {\n  --fa: \"\\54\";\n}\n.fa-hippo {\n  --fa: \"\\f6ed\";\n}\n.fa-chart-column {\n  --fa: \"\\e0e3\";\n}\n.fa-infinity {\n  --fa: \"\\f534\";\n}\n.fa-vial-circle-check {\n  --fa: \"\\e596\";\n}\n.fa-person-arrow-down-to-line {\n  --fa: \"\\e538\";\n}\n.fa-voicemail {\n  --fa: \"\\f897\";\n}\n.fa-fan {\n  --fa: \"\\f863\";\n}\n.fa-person-walking-luggage {\n  --fa: \"\\e554\";\n}\n.fa-up-down {\n  --fa: \"\\f338\";\n}\n.fa-arrows-alt-v {\n  --fa: \"\\f338\";\n}\n.fa-cloud-moon-rain {\n  --fa: \"\\f73c\";\n}\n.fa-calendar {\n  --fa: \"\\f133\";\n}\n.fa-trailer {\n  --fa: \"\\e041\";\n}\n.fa-bahai {\n  --fa: \"\\f666\";\n}\n.fa-haykal {\n  --fa: \"\\f666\";\n}\n.fa-sd-card {\n  --fa: \"\\f7c2\";\n}\n.fa-dragon {\n  --fa: \"\\f6d5\";\n}\n.fa-shoe-prints {\n  --fa: \"\\f54b\";\n}\n.fa-circle-plus {\n  --fa: \"\\f055\";\n}\n.fa-plus-circle {\n  --fa: \"\\f055\";\n}\n.fa-face-grin-tongue-wink {\n  --fa: \"\\f58b\";\n}\n.fa-grin-tongue-wink {\n  --fa: \"\\f58b\";\n}\n.fa-hand-holding {\n  --fa: \"\\f4bd\";\n}\n.fa-plug-circle-exclamation {\n  --fa: \"\\e55d\";\n}\n.fa-link-slash {\n  --fa: \"\\f127\";\n}\n.fa-chain-broken {\n  --fa: \"\\f127\";\n}\n.fa-chain-slash {\n  --fa: \"\\f127\";\n}\n.fa-unlink {\n  --fa: \"\\f127\";\n}\n.fa-clone {\n  --fa: \"\\f24d\";\n}\n.fa-person-walking-arrow-loop-left {\n  --fa: \"\\e551\";\n}\n.fa-arrow-up-z-a {\n  --fa: \"\\f882\";\n}\n.fa-sort-alpha-up-alt {\n  --fa: \"\\f882\";\n}\n.fa-fire-flame-curved {\n  --fa: \"\\f7e4\";\n}\n.fa-fire-alt {\n  --fa: \"\\f7e4\";\n}\n.fa-tornado {\n  --fa: \"\\f76f\";\n}\n.fa-file-circle-plus {\n  --fa: \"\\e494\";\n}\n.fa-book-quran {\n  --fa: \"\\f687\";\n}\n.fa-quran {\n  --fa: \"\\f687\";\n}\n.fa-anchor {\n  --fa: \"\\f13d\";\n}\n.fa-border-all {\n  --fa: \"\\f84c\";\n}\n.fa-face-angry {\n  --fa: \"\\f556\";\n}\n.fa-angry {\n  --fa: \"\\f556\";\n}\n.fa-cookie-bite {\n  --fa: \"\\f564\";\n}\n.fa-arrow-trend-down {\n  --fa: \"\\e097\";\n}\n.fa-rss {\n  --fa: \"\\f09e\";\n}\n.fa-feed {\n  --fa: \"\\f09e\";\n}\n.fa-draw-polygon {\n  --fa: \"\\f5ee\";\n}\n.fa-scale-balanced {\n  --fa: \"\\f24e\";\n}\n.fa-balance-scale {\n  --fa: \"\\f24e\";\n}\n.fa-gauge-simple-high {\n  --fa: \"\\f62a\";\n}\n.fa-tachometer {\n  --fa: \"\\f62a\";\n}\n.fa-tachometer-fast {\n  --fa: \"\\f62a\";\n}\n.fa-shower {\n  --fa: \"\\f2cc\";\n}\n.fa-desktop {\n  --fa: \"\\f390\";\n}\n.fa-desktop-alt {\n  --fa: \"\\f390\";\n}\n.fa-m {\n  --fa: \"\\4d\";\n}\n.fa-table-list {\n  --fa: \"\\f00b\";\n}\n.fa-th-list {\n  --fa: \"\\f00b\";\n}\n.fa-comment-sms {\n  --fa: \"\\f7cd\";\n}\n.fa-sms {\n  --fa: \"\\f7cd\";\n}\n.fa-book {\n  --fa: \"\\f02d\";\n}\n.fa-user-plus {\n  --fa: \"\\f234\";\n}\n.fa-check {\n  --fa: \"\\f00c\";\n}\n.fa-battery-three-quarters {\n  --fa: \"\\f241\";\n}\n.fa-battery-4 {\n  --fa: \"\\f241\";\n}\n.fa-house-circle-check {\n  --fa: \"\\e509\";\n}\n.fa-angle-left {\n  --fa: \"\\f104\";\n}\n.fa-diagram-successor {\n  --fa: \"\\e47a\";\n}\n.fa-truck-arrow-right {\n  --fa: \"\\e58b\";\n}\n.fa-arrows-split-up-and-left {\n  --fa: \"\\e4bc\";\n}\n.fa-hand-fist {\n  --fa: \"\\f6de\";\n}\n.fa-fist-raised {\n  --fa: \"\\f6de\";\n}\n.fa-cloud-moon {\n  --fa: \"\\f6c3\";\n}\n.fa-briefcase {\n  --fa: \"\\f0b1\";\n}\n.fa-person-falling {\n  --fa: \"\\e546\";\n}\n.fa-image-portrait {\n  --fa: \"\\f3e0\";\n}\n.fa-portrait {\n  --fa: \"\\f3e0\";\n}\n.fa-user-tag {\n  --fa: \"\\f507\";\n}\n.fa-rug {\n  --fa: \"\\e569\";\n}\n.fa-earth-europe {\n  --fa: \"\\f7a2\";\n}\n.fa-globe-europe {\n  --fa: \"\\f7a2\";\n}\n.fa-cart-flatbed-suitcase {\n  --fa: \"\\f59d\";\n}\n.fa-luggage-cart {\n  --fa: \"\\f59d\";\n}\n.fa-rectangle-xmark {\n  --fa: \"\\f410\";\n}\n.fa-rectangle-times {\n  --fa: \"\\f410\";\n}\n.fa-times-rectangle {\n  --fa: \"\\f410\";\n}\n.fa-window-close {\n  --fa: \"\\f410\";\n}\n.fa-baht-sign {\n  --fa: \"\\e0ac\";\n}\n.fa-book-open {\n  --fa: \"\\f518\";\n}\n.fa-book-journal-whills {\n  --fa: \"\\f66a\";\n}\n.fa-journal-whills {\n  --fa: \"\\f66a\";\n}\n.fa-handcuffs {\n  --fa: \"\\e4f8\";\n}\n.fa-triangle-exclamation {\n  --fa: \"\\f071\";\n}\n.fa-exclamation-triangle {\n  --fa: \"\\f071\";\n}\n.fa-warning {\n  --fa: \"\\f071\";\n}\n.fa-database {\n  --fa: \"\\f1c0\";\n}\n.fa-share {\n  --fa: \"\\f064\";\n}\n.fa-mail-forward {\n  --fa: \"\\f064\";\n}\n.fa-bottle-droplet {\n  --fa: \"\\e4c4\";\n}\n.fa-mask-face {\n  --fa: \"\\e1d7\";\n}\n.fa-hill-rockslide {\n  --fa: \"\\e508\";\n}\n.fa-right-left {\n  --fa: \"\\f362\";\n}\n.fa-exchange-alt {\n  --fa: \"\\f362\";\n}\n.fa-paper-plane {\n  --fa: \"\\f1d8\";\n}\n.fa-road-circle-exclamation {\n  --fa: \"\\e565\";\n}\n.fa-dungeon {\n  --fa: \"\\f6d9\";\n}\n.fa-align-right {\n  --fa: \"\\f038\";\n}\n.fa-money-bill-1-wave {\n  --fa: \"\\f53b\";\n}\n.fa-money-bill-wave-alt {\n  --fa: \"\\f53b\";\n}\n.fa-life-ring {\n  --fa: \"\\f1cd\";\n}\n.fa-hands {\n  --fa: \"\\f2a7\";\n}\n.fa-sign-language {\n  --fa: \"\\f2a7\";\n}\n.fa-signing {\n  --fa: \"\\f2a7\";\n}\n.fa-calendar-day {\n  --fa: \"\\f783\";\n}\n.fa-water-ladder {\n  --fa: \"\\f5c5\";\n}\n.fa-ladder-water {\n  --fa: \"\\f5c5\";\n}\n.fa-swimming-pool {\n  --fa: \"\\f5c5\";\n}\n.fa-arrows-up-down {\n  --fa: \"\\f07d\";\n}\n.fa-arrows-v {\n  --fa: \"\\f07d\";\n}\n.fa-face-grimace {\n  --fa: \"\\f57f\";\n}\n.fa-grimace {\n  --fa: \"\\f57f\";\n}\n.fa-wheelchair-move {\n  --fa: \"\\e2ce\";\n}\n.fa-wheelchair-alt {\n  --fa: \"\\e2ce\";\n}\n.fa-turn-down {\n  --fa: \"\\f3be\";\n}\n.fa-level-down-alt {\n  --fa: \"\\f3be\";\n}\n.fa-person-walking-arrow-right {\n  --fa: \"\\e552\";\n}\n.fa-square-envelope {\n  --fa: \"\\f199\";\n}\n.fa-envelope-square {\n  --fa: \"\\f199\";\n}\n.fa-dice {\n  --fa: \"\\f522\";\n}\n.fa-bowling-ball {\n  --fa: \"\\f436\";\n}\n.fa-brain {\n  --fa: \"\\f5dc\";\n}\n.fa-bandage {\n  --fa: \"\\f462\";\n}\n.fa-band-aid {\n  --fa: \"\\f462\";\n}\n.fa-calendar-minus {\n  --fa: \"\\f272\";\n}\n.fa-circle-xmark {\n  --fa: \"\\f057\";\n}\n.fa-times-circle {\n  --fa: \"\\f057\";\n}\n.fa-xmark-circle {\n  --fa: \"\\f057\";\n}\n.fa-gifts {\n  --fa: \"\\f79c\";\n}\n.fa-hotel {\n  --fa: \"\\f594\";\n}\n.fa-earth-asia {\n  --fa: \"\\f57e\";\n}\n.fa-globe-asia {\n  --fa: \"\\f57e\";\n}\n.fa-id-card-clip {\n  --fa: \"\\f47f\";\n}\n.fa-id-card-alt {\n  --fa: \"\\f47f\";\n}\n.fa-magnifying-glass-plus {\n  --fa: \"\\f00e\";\n}\n.fa-search-plus {\n  --fa: \"\\f00e\";\n}\n.fa-thumbs-up {\n  --fa: \"\\f164\";\n}\n.fa-user-clock {\n  --fa: \"\\f4fd\";\n}\n.fa-hand-dots {\n  --fa: \"\\f461\";\n}\n.fa-allergies {\n  --fa: \"\\f461\";\n}\n.fa-file-invoice {\n  --fa: \"\\f570\";\n}\n.fa-window-minimize {\n  --fa: \"\\f2d1\";\n}\n.fa-mug-saucer {\n  --fa: \"\\f0f4\";\n}\n.fa-coffee {\n  --fa: \"\\f0f4\";\n}\n.fa-brush {\n  --fa: \"\\f55d\";\n}\n.fa-file-half-dashed {\n  --fa: \"\\e698\";\n}\n.fa-mask {\n  --fa: \"\\f6fa\";\n}\n.fa-magnifying-glass-minus {\n  --fa: \"\\f010\";\n}\n.fa-search-minus {\n  --fa: \"\\f010\";\n}\n.fa-ruler-vertical {\n  --fa: \"\\f548\";\n}\n.fa-user-large {\n  --fa: \"\\f406\";\n}\n.fa-user-alt {\n  --fa: \"\\f406\";\n}\n.fa-train-tram {\n  --fa: \"\\e5b4\";\n}\n.fa-user-nurse {\n  --fa: \"\\f82f\";\n}\n.fa-syringe {\n  --fa: \"\\f48e\";\n}\n.fa-cloud-sun {\n  --fa: \"\\f6c4\";\n}\n.fa-stopwatch-20 {\n  --fa: \"\\e06f\";\n}\n.fa-square-full {\n  --fa: \"\\f45c\";\n}\n.fa-magnet {\n  --fa: \"\\f076\";\n}\n.fa-jar {\n  --fa: \"\\e516\";\n}\n.fa-note-sticky {\n  --fa: \"\\f249\";\n}\n.fa-sticky-note {\n  --fa: \"\\f249\";\n}\n.fa-bug-slash {\n  --fa: \"\\e490\";\n}\n.fa-arrow-up-from-water-pump {\n  --fa: \"\\e4b6\";\n}\n.fa-bone {\n  --fa: \"\\f5d7\";\n}\n.fa-table-cells-row-unlock {\n  --fa: \"\\e691\";\n}\n.fa-user-injured {\n  --fa: \"\\f728\";\n}\n.fa-face-sad-tear {\n  --fa: \"\\f5b4\";\n}\n.fa-sad-tear {\n  --fa: \"\\f5b4\";\n}\n.fa-plane {\n  --fa: \"\\f072\";\n}\n.fa-tent-arrows-down {\n  --fa: \"\\e581\";\n}\n.fa-exclamation {\n  --fa: \"\\21\";\n}\n.fa-arrows-spin {\n  --fa: \"\\e4bb\";\n}\n.fa-print {\n  --fa: \"\\f02f\";\n}\n.fa-turkish-lira-sign {\n  --fa: \"\\e2bb\";\n}\n.fa-try {\n  --fa: \"\\e2bb\";\n}\n.fa-turkish-lira {\n  --fa: \"\\e2bb\";\n}\n.fa-dollar-sign {\n  --fa: \"\\24\";\n}\n.fa-dollar {\n  --fa: \"\\24\";\n}\n.fa-usd {\n  --fa: \"\\24\";\n}\n.fa-x {\n  --fa: \"\\58\";\n}\n.fa-magnifying-glass-dollar {\n  --fa: \"\\f688\";\n}\n.fa-search-dollar {\n  --fa: \"\\f688\";\n}\n.fa-users-gear {\n  --fa: \"\\f509\";\n}\n.fa-users-cog {\n  --fa: \"\\f509\";\n}\n.fa-person-military-pointing {\n  --fa: \"\\e54a\";\n}\n.fa-building-columns {\n  --fa: \"\\f19c\";\n}\n.fa-bank {\n  --fa: \"\\f19c\";\n}\n.fa-institution {\n  --fa: \"\\f19c\";\n}\n.fa-museum {\n  --fa: \"\\f19c\";\n}\n.fa-university {\n  --fa: \"\\f19c\";\n}\n.fa-umbrella {\n  --fa: \"\\f0e9\";\n}\n.fa-trowel {\n  --fa: \"\\e589\";\n}\n.fa-d {\n  --fa: \"\\44\";\n}\n.fa-stapler {\n  --fa: \"\\e5af\";\n}\n.fa-masks-theater {\n  --fa: \"\\f630\";\n}\n.fa-theater-masks {\n  --fa: \"\\f630\";\n}\n.fa-kip-sign {\n  --fa: \"\\e1c4\";\n}\n.fa-hand-point-left {\n  --fa: \"\\f0a5\";\n}\n.fa-handshake-simple {\n  --fa: \"\\f4c6\";\n}\n.fa-handshake-alt {\n  --fa: \"\\f4c6\";\n}\n.fa-jet-fighter {\n  --fa: \"\\f0fb\";\n}\n.fa-fighter-jet {\n  --fa: \"\\f0fb\";\n}\n.fa-square-share-nodes {\n  --fa: \"\\f1e1\";\n}\n.fa-share-alt-square {\n  --fa: \"\\f1e1\";\n}\n.fa-barcode {\n  --fa: \"\\f02a\";\n}\n.fa-plus-minus {\n  --fa: \"\\e43c\";\n}\n.fa-video {\n  --fa: \"\\f03d\";\n}\n.fa-video-camera {\n  --fa: \"\\f03d\";\n}\n.fa-graduation-cap {\n  --fa: \"\\f19d\";\n}\n.fa-mortar-board {\n  --fa: \"\\f19d\";\n}\n.fa-hand-holding-medical {\n  --fa: \"\\e05c\";\n}\n.fa-person-circle-check {\n  --fa: \"\\e53e\";\n}\n.fa-turn-up {\n  --fa: \"\\f3bf\";\n}\n.fa-level-up-alt {\n  --fa: \"\\f3bf\";\n}\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n:root,\n:host {\n  --fa-style-family-brands: 'Font Awesome 6 Brands';\n  --fa-font-brands: normal 400 1em/1 'Font Awesome 6 Brands';\n}\n@font-face {\n  font-family: 'Font Awesome 6 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf\") format(\"truetype\");\n}\n.fab,\n.fa-brands {\n  font-weight: 400;\n}\n.fa-monero {\n  --fa: \"\\f3d0\";\n}\n.fa-hooli {\n  --fa: \"\\f427\";\n}\n.fa-yelp {\n  --fa: \"\\f1e9\";\n}\n.fa-cc-visa {\n  --fa: \"\\f1f0\";\n}\n.fa-lastfm {\n  --fa: \"\\f202\";\n}\n.fa-shopware {\n  --fa: \"\\f5b5\";\n}\n.fa-creative-commons-nc {\n  --fa: \"\\f4e8\";\n}\n.fa-aws {\n  --fa: \"\\f375\";\n}\n.fa-redhat {\n  --fa: \"\\f7bc\";\n}\n.fa-yoast {\n  --fa: \"\\f2b1\";\n}\n.fa-cloudflare {\n  --fa: \"\\e07d\";\n}\n.fa-ups {\n  --fa: \"\\f7e0\";\n}\n.fa-pixiv {\n  --fa: \"\\e640\";\n}\n.fa-wpexplorer {\n  --fa: \"\\f2de\";\n}\n.fa-dyalog {\n  --fa: \"\\f399\";\n}\n.fa-bity {\n  --fa: \"\\f37a\";\n}\n.fa-stackpath {\n  --fa: \"\\f842\";\n}\n.fa-buysellads {\n  --fa: \"\\f20d\";\n}\n.fa-first-order {\n  --fa: \"\\f2b0\";\n}\n.fa-modx {\n  --fa: \"\\f285\";\n}\n.fa-guilded {\n  --fa: \"\\e07e\";\n}\n.fa-vnv {\n  --fa: \"\\f40b\";\n}\n.fa-square-js {\n  --fa: \"\\f3b9\";\n}\n.fa-js-square {\n  --fa: \"\\f3b9\";\n}\n.fa-microsoft {\n  --fa: \"\\f3ca\";\n}\n.fa-qq {\n  --fa: \"\\f1d6\";\n}\n.fa-orcid {\n  --fa: \"\\f8d2\";\n}\n.fa-java {\n  --fa: \"\\f4e4\";\n}\n.fa-invision {\n  --fa: \"\\f7b0\";\n}\n.fa-creative-commons-pd-alt {\n  --fa: \"\\f4ed\";\n}\n.fa-centercode {\n  --fa: \"\\f380\";\n}\n.fa-glide-g {\n  --fa: \"\\f2a6\";\n}\n.fa-drupal {\n  --fa: \"\\f1a9\";\n}\n.fa-jxl {\n  --fa: \"\\e67b\";\n}\n.fa-dart-lang {\n  --fa: \"\\e693\";\n}\n.fa-hire-a-helper {\n  --fa: \"\\f3b0\";\n}\n.fa-creative-commons-by {\n  --fa: \"\\f4e7\";\n}\n.fa-unity {\n  --fa: \"\\e049\";\n}\n.fa-whmcs {\n  --fa: \"\\f40d\";\n}\n.fa-rocketchat {\n  --fa: \"\\f3e8\";\n}\n.fa-vk {\n  --fa: \"\\f189\";\n}\n.fa-untappd {\n  --fa: \"\\f405\";\n}\n.fa-mailchimp {\n  --fa: \"\\f59e\";\n}\n.fa-css3-alt {\n  --fa: \"\\f38b\";\n}\n.fa-square-reddit {\n  --fa: \"\\f1a2\";\n}\n.fa-reddit-square {\n  --fa: \"\\f1a2\";\n}\n.fa-vimeo-v {\n  --fa: \"\\f27d\";\n}\n.fa-contao {\n  --fa: \"\\f26d\";\n}\n.fa-square-font-awesome {\n  --fa: \"\\e5ad\";\n}\n.fa-deskpro {\n  --fa: \"\\f38f\";\n}\n.fa-brave {\n  --fa: \"\\e63c\";\n}\n.fa-sistrix {\n  --fa: \"\\f3ee\";\n}\n.fa-square-instagram {\n  --fa: \"\\e055\";\n}\n.fa-instagram-square {\n  --fa: \"\\e055\";\n}\n.fa-battle-net {\n  --fa: \"\\f835\";\n}\n.fa-the-red-yeti {\n  --fa: \"\\f69d\";\n}\n.fa-square-hacker-news {\n  --fa: \"\\f3af\";\n}\n.fa-hacker-news-square {\n  --fa: \"\\f3af\";\n}\n.fa-edge {\n  --fa: \"\\f282\";\n}\n.fa-threads {\n  --fa: \"\\e618\";\n}\n.fa-napster {\n  --fa: \"\\f3d2\";\n}\n.fa-square-snapchat {\n  --fa: \"\\f2ad\";\n}\n.fa-snapchat-square {\n  --fa: \"\\f2ad\";\n}\n.fa-google-plus-g {\n  --fa: \"\\f0d5\";\n}\n.fa-artstation {\n  --fa: \"\\f77a\";\n}\n.fa-markdown {\n  --fa: \"\\f60f\";\n}\n.fa-sourcetree {\n  --fa: \"\\f7d3\";\n}\n.fa-google-plus {\n  --fa: \"\\f2b3\";\n}\n.fa-diaspora {\n  --fa: \"\\f791\";\n}\n.fa-foursquare {\n  --fa: \"\\f180\";\n}\n.fa-stack-overflow {\n  --fa: \"\\f16c\";\n}\n.fa-github-alt {\n  --fa: \"\\f113\";\n}\n.fa-phoenix-squadron {\n  --fa: \"\\f511\";\n}\n.fa-pagelines {\n  --fa: \"\\f18c\";\n}\n.fa-algolia {\n  --fa: \"\\f36c\";\n}\n.fa-red-river {\n  --fa: \"\\f3e3\";\n}\n.fa-creative-commons-sa {\n  --fa: \"\\f4ef\";\n}\n.fa-safari {\n  --fa: \"\\f267\";\n}\n.fa-google {\n  --fa: \"\\f1a0\";\n}\n.fa-square-font-awesome-stroke {\n  --fa: \"\\f35c\";\n}\n.fa-font-awesome-alt {\n  --fa: \"\\f35c\";\n}\n.fa-atlassian {\n  --fa: \"\\f77b\";\n}\n.fa-linkedin-in {\n  --fa: \"\\f0e1\";\n}\n.fa-digital-ocean {\n  --fa: \"\\f391\";\n}\n.fa-nimblr {\n  --fa: \"\\f5a8\";\n}\n.fa-chromecast {\n  --fa: \"\\f838\";\n}\n.fa-evernote {\n  --fa: \"\\f839\";\n}\n.fa-hacker-news {\n  --fa: \"\\f1d4\";\n}\n.fa-creative-commons-sampling {\n  --fa: \"\\f4f0\";\n}\n.fa-adversal {\n  --fa: \"\\f36a\";\n}\n.fa-creative-commons {\n  --fa: \"\\f25e\";\n}\n.fa-watchman-monitoring {\n  --fa: \"\\e087\";\n}\n.fa-fonticons {\n  --fa: \"\\f280\";\n}\n.fa-weixin {\n  --fa: \"\\f1d7\";\n}\n.fa-shirtsinbulk {\n  --fa: \"\\f214\";\n}\n.fa-codepen {\n  --fa: \"\\f1cb\";\n}\n.fa-git-alt {\n  --fa: \"\\f841\";\n}\n.fa-lyft {\n  --fa: \"\\f3c3\";\n}\n.fa-rev {\n  --fa: \"\\f5b2\";\n}\n.fa-windows {\n  --fa: \"\\f17a\";\n}\n.fa-wizards-of-the-coast {\n  --fa: \"\\f730\";\n}\n.fa-square-viadeo {\n  --fa: \"\\f2aa\";\n}\n.fa-viadeo-square {\n  --fa: \"\\f2aa\";\n}\n.fa-meetup {\n  --fa: \"\\f2e0\";\n}\n.fa-centos {\n  --fa: \"\\f789\";\n}\n.fa-adn {\n  --fa: \"\\f170\";\n}\n.fa-cloudsmith {\n  --fa: \"\\f384\";\n}\n.fa-opensuse {\n  --fa: \"\\e62b\";\n}\n.fa-pied-piper-alt {\n  --fa: \"\\f1a8\";\n}\n.fa-square-dribbble {\n  --fa: \"\\f397\";\n}\n.fa-dribbble-square {\n  --fa: \"\\f397\";\n}\n.fa-codiepie {\n  --fa: \"\\f284\";\n}\n.fa-node {\n  --fa: \"\\f419\";\n}\n.fa-mix {\n  --fa: \"\\f3cb\";\n}\n.fa-steam {\n  --fa: \"\\f1b6\";\n}\n.fa-cc-apple-pay {\n  --fa: \"\\f416\";\n}\n.fa-scribd {\n  --fa: \"\\f28a\";\n}\n.fa-debian {\n  --fa: \"\\e60b\";\n}\n.fa-openid {\n  --fa: \"\\f19b\";\n}\n.fa-instalod {\n  --fa: \"\\e081\";\n}\n.fa-files-pinwheel {\n  --fa: \"\\e69f\";\n}\n.fa-expeditedssl {\n  --fa: \"\\f23e\";\n}\n.fa-sellcast {\n  --fa: \"\\f2da\";\n}\n.fa-square-twitter {\n  --fa: \"\\f081\";\n}\n.fa-twitter-square {\n  --fa: \"\\f081\";\n}\n.fa-r-project {\n  --fa: \"\\f4f7\";\n}\n.fa-delicious {\n  --fa: \"\\f1a5\";\n}\n.fa-freebsd {\n  --fa: \"\\f3a4\";\n}\n.fa-vuejs {\n  --fa: \"\\f41f\";\n}\n.fa-accusoft {\n  --fa: \"\\f369\";\n}\n.fa-ioxhost {\n  --fa: \"\\f208\";\n}\n.fa-fonticons-fi {\n  --fa: \"\\f3a2\";\n}\n.fa-app-store {\n  --fa: \"\\f36f\";\n}\n.fa-cc-mastercard {\n  --fa: \"\\f1f1\";\n}\n.fa-itunes-note {\n  --fa: \"\\f3b5\";\n}\n.fa-golang {\n  --fa: \"\\e40f\";\n}\n.fa-kickstarter {\n  --fa: \"\\f3bb\";\n}\n.fa-square-kickstarter {\n  --fa: \"\\f3bb\";\n}\n.fa-grav {\n  --fa: \"\\f2d6\";\n}\n.fa-weibo {\n  --fa: \"\\f18a\";\n}\n.fa-uncharted {\n  --fa: \"\\e084\";\n}\n.fa-firstdraft {\n  --fa: \"\\f3a1\";\n}\n.fa-square-youtube {\n  --fa: \"\\f431\";\n}\n.fa-youtube-square {\n  --fa: \"\\f431\";\n}\n.fa-wikipedia-w {\n  --fa: \"\\f266\";\n}\n.fa-wpressr {\n  --fa: \"\\f3e4\";\n}\n.fa-rendact {\n  --fa: \"\\f3e4\";\n}\n.fa-angellist {\n  --fa: \"\\f209\";\n}\n.fa-galactic-republic {\n  --fa: \"\\f50c\";\n}\n.fa-nfc-directional {\n  --fa: \"\\e530\";\n}\n.fa-skype {\n  --fa: \"\\f17e\";\n}\n.fa-joget {\n  --fa: \"\\f3b7\";\n}\n.fa-fedora {\n  --fa: \"\\f798\";\n}\n.fa-stripe-s {\n  --fa: \"\\f42a\";\n}\n.fa-meta {\n  --fa: \"\\e49b\";\n}\n.fa-laravel {\n  --fa: \"\\f3bd\";\n}\n.fa-hotjar {\n  --fa: \"\\f3b1\";\n}\n.fa-bluetooth-b {\n  --fa: \"\\f294\";\n}\n.fa-square-letterboxd {\n  --fa: \"\\e62e\";\n}\n.fa-sticker-mule {\n  --fa: \"\\f3f7\";\n}\n.fa-creative-commons-zero {\n  --fa: \"\\f4f3\";\n}\n.fa-hips {\n  --fa: \"\\f452\";\n}\n.fa-css {\n  --fa: \"\\e6a2\";\n}\n.fa-behance {\n  --fa: \"\\f1b4\";\n}\n.fa-reddit {\n  --fa: \"\\f1a1\";\n}\n.fa-discord {\n  --fa: \"\\f392\";\n}\n.fa-chrome {\n  --fa: \"\\f268\";\n}\n.fa-app-store-ios {\n  --fa: \"\\f370\";\n}\n.fa-cc-discover {\n  --fa: \"\\f1f2\";\n}\n.fa-wpbeginner {\n  --fa: \"\\f297\";\n}\n.fa-confluence {\n  --fa: \"\\f78d\";\n}\n.fa-shoelace {\n  --fa: \"\\e60c\";\n}\n.fa-mdb {\n  --fa: \"\\f8ca\";\n}\n.fa-dochub {\n  --fa: \"\\f394\";\n}\n.fa-accessible-icon {\n  --fa: \"\\f368\";\n}\n.fa-ebay {\n  --fa: \"\\f4f4\";\n}\n.fa-amazon {\n  --fa: \"\\f270\";\n}\n.fa-unsplash {\n  --fa: \"\\e07c\";\n}\n.fa-yarn {\n  --fa: \"\\f7e3\";\n}\n.fa-square-steam {\n  --fa: \"\\f1b7\";\n}\n.fa-steam-square {\n  --fa: \"\\f1b7\";\n}\n.fa-500px {\n  --fa: \"\\f26e\";\n}\n.fa-square-vimeo {\n  --fa: \"\\f194\";\n}\n.fa-vimeo-square {\n  --fa: \"\\f194\";\n}\n.fa-asymmetrik {\n  --fa: \"\\f372\";\n}\n.fa-font-awesome {\n  --fa: \"\\f2b4\";\n}\n.fa-font-awesome-flag {\n  --fa: \"\\f2b4\";\n}\n.fa-font-awesome-logo-full {\n  --fa: \"\\f2b4\";\n}\n.fa-gratipay {\n  --fa: \"\\f184\";\n}\n.fa-apple {\n  --fa: \"\\f179\";\n}\n.fa-hive {\n  --fa: \"\\e07f\";\n}\n.fa-gitkraken {\n  --fa: \"\\f3a6\";\n}\n.fa-keybase {\n  --fa: \"\\f4f5\";\n}\n.fa-apple-pay {\n  --fa: \"\\f415\";\n}\n.fa-padlet {\n  --fa: \"\\e4a0\";\n}\n.fa-amazon-pay {\n  --fa: \"\\f42c\";\n}\n.fa-square-github {\n  --fa: \"\\f092\";\n}\n.fa-github-square {\n  --fa: \"\\f092\";\n}\n.fa-stumbleupon {\n  --fa: \"\\f1a4\";\n}\n.fa-fedex {\n  --fa: \"\\f797\";\n}\n.fa-phoenix-framework {\n  --fa: \"\\f3dc\";\n}\n.fa-shopify {\n  --fa: \"\\e057\";\n}\n.fa-neos {\n  --fa: \"\\f612\";\n}\n.fa-square-threads {\n  --fa: \"\\e619\";\n}\n.fa-hackerrank {\n  --fa: \"\\f5f7\";\n}\n.fa-researchgate {\n  --fa: \"\\f4f8\";\n}\n.fa-swift {\n  --fa: \"\\f8e1\";\n}\n.fa-angular {\n  --fa: \"\\f420\";\n}\n.fa-speakap {\n  --fa: \"\\f3f3\";\n}\n.fa-angrycreative {\n  --fa: \"\\f36e\";\n}\n.fa-y-combinator {\n  --fa: \"\\f23b\";\n}\n.fa-empire {\n  --fa: \"\\f1d1\";\n}\n.fa-envira {\n  --fa: \"\\f299\";\n}\n.fa-google-scholar {\n  --fa: \"\\e63b\";\n}\n.fa-square-gitlab {\n  --fa: \"\\e5ae\";\n}\n.fa-gitlab-square {\n  --fa: \"\\e5ae\";\n}\n.fa-studiovinari {\n  --fa: \"\\f3f8\";\n}\n.fa-pied-piper {\n  --fa: \"\\f2ae\";\n}\n.fa-wordpress {\n  --fa: \"\\f19a\";\n}\n.fa-product-hunt {\n  --fa: \"\\f288\";\n}\n.fa-firefox {\n  --fa: \"\\f269\";\n}\n.fa-linode {\n  --fa: \"\\f2b8\";\n}\n.fa-goodreads {\n  --fa: \"\\f3a8\";\n}\n.fa-square-odnoklassniki {\n  --fa: \"\\f264\";\n}\n.fa-odnoklassniki-square {\n  --fa: \"\\f264\";\n}\n.fa-jsfiddle {\n  --fa: \"\\f1cc\";\n}\n.fa-sith {\n  --fa: \"\\f512\";\n}\n.fa-themeisle {\n  --fa: \"\\f2b2\";\n}\n.fa-page4 {\n  --fa: \"\\f3d7\";\n}\n.fa-hashnode {\n  --fa: \"\\e499\";\n}\n.fa-react {\n  --fa: \"\\f41b\";\n}\n.fa-cc-paypal {\n  --fa: \"\\f1f4\";\n}\n.fa-squarespace {\n  --fa: \"\\f5be\";\n}\n.fa-cc-stripe {\n  --fa: \"\\f1f5\";\n}\n.fa-creative-commons-share {\n  --fa: \"\\f4f2\";\n}\n.fa-bitcoin {\n  --fa: \"\\f379\";\n}\n.fa-keycdn {\n  --fa: \"\\f3ba\";\n}\n.fa-opera {\n  --fa: \"\\f26a\";\n}\n.fa-itch-io {\n  --fa: \"\\f83a\";\n}\n.fa-umbraco {\n  --fa: \"\\f8e8\";\n}\n.fa-galactic-senate {\n  --fa: \"\\f50d\";\n}\n.fa-ubuntu {\n  --fa: \"\\f7df\";\n}\n.fa-draft2digital {\n  --fa: \"\\f396\";\n}\n.fa-stripe {\n  --fa: \"\\f429\";\n}\n.fa-houzz {\n  --fa: \"\\f27c\";\n}\n.fa-gg {\n  --fa: \"\\f260\";\n}\n.fa-dhl {\n  --fa: \"\\f790\";\n}\n.fa-square-pinterest {\n  --fa: \"\\f0d3\";\n}\n.fa-pinterest-square {\n  --fa: \"\\f0d3\";\n}\n.fa-xing {\n  --fa: \"\\f168\";\n}\n.fa-blackberry {\n  --fa: \"\\f37b\";\n}\n.fa-creative-commons-pd {\n  --fa: \"\\f4ec\";\n}\n.fa-playstation {\n  --fa: \"\\f3df\";\n}\n.fa-quinscape {\n  --fa: \"\\f459\";\n}\n.fa-less {\n  --fa: \"\\f41d\";\n}\n.fa-blogger-b {\n  --fa: \"\\f37d\";\n}\n.fa-opencart {\n  --fa: \"\\f23d\";\n}\n.fa-vine {\n  --fa: \"\\f1ca\";\n}\n.fa-signal-messenger {\n  --fa: \"\\e663\";\n}\n.fa-paypal {\n  --fa: \"\\f1ed\";\n}\n.fa-gitlab {\n  --fa: \"\\f296\";\n}\n.fa-typo3 {\n  --fa: \"\\f42b\";\n}\n.fa-reddit-alien {\n  --fa: \"\\f281\";\n}\n.fa-yahoo {\n  --fa: \"\\f19e\";\n}\n.fa-dailymotion {\n  --fa: \"\\e052\";\n}\n.fa-affiliatetheme {\n  --fa: \"\\f36b\";\n}\n.fa-pied-piper-pp {\n  --fa: \"\\f1a7\";\n}\n.fa-bootstrap {\n  --fa: \"\\f836\";\n}\n.fa-odnoklassniki {\n  --fa: \"\\f263\";\n}\n.fa-nfc-symbol {\n  --fa: \"\\e531\";\n}\n.fa-mintbit {\n  --fa: \"\\e62f\";\n}\n.fa-ethereum {\n  --fa: \"\\f42e\";\n}\n.fa-speaker-deck {\n  --fa: \"\\f83c\";\n}\n.fa-creative-commons-nc-eu {\n  --fa: \"\\f4e9\";\n}\n.fa-patreon {\n  --fa: \"\\f3d9\";\n}\n.fa-avianex {\n  --fa: \"\\f374\";\n}\n.fa-ello {\n  --fa: \"\\f5f1\";\n}\n.fa-gofore {\n  --fa: \"\\f3a7\";\n}\n.fa-bimobject {\n  --fa: \"\\f378\";\n}\n.fa-brave-reverse {\n  --fa: \"\\e63d\";\n}\n.fa-facebook-f {\n  --fa: \"\\f39e\";\n}\n.fa-square-google-plus {\n  --fa: \"\\f0d4\";\n}\n.fa-google-plus-square {\n  --fa: \"\\f0d4\";\n}\n.fa-web-awesome {\n  --fa: \"\\e682\";\n}\n.fa-mandalorian {\n  --fa: \"\\f50f\";\n}\n.fa-first-order-alt {\n  --fa: \"\\f50a\";\n}\n.fa-osi {\n  --fa: \"\\f41a\";\n}\n.fa-google-wallet {\n  --fa: \"\\f1ee\";\n}\n.fa-d-and-d-beyond {\n  --fa: \"\\f6ca\";\n}\n.fa-periscope {\n  --fa: \"\\f3da\";\n}\n.fa-fulcrum {\n  --fa: \"\\f50b\";\n}\n.fa-cloudscale {\n  --fa: \"\\f383\";\n}\n.fa-forumbee {\n  --fa: \"\\f211\";\n}\n.fa-mizuni {\n  --fa: \"\\f3cc\";\n}\n.fa-schlix {\n  --fa: \"\\f3ea\";\n}\n.fa-square-xing {\n  --fa: \"\\f169\";\n}\n.fa-xing-square {\n  --fa: \"\\f169\";\n}\n.fa-bandcamp {\n  --fa: \"\\f2d5\";\n}\n.fa-wpforms {\n  --fa: \"\\f298\";\n}\n.fa-cloudversify {\n  --fa: \"\\f385\";\n}\n.fa-usps {\n  --fa: \"\\f7e1\";\n}\n.fa-megaport {\n  --fa: \"\\f5a3\";\n}\n.fa-magento {\n  --fa: \"\\f3c4\";\n}\n.fa-spotify {\n  --fa: \"\\f1bc\";\n}\n.fa-optin-monster {\n  --fa: \"\\f23c\";\n}\n.fa-fly {\n  --fa: \"\\f417\";\n}\n.fa-square-bluesky {\n  --fa: \"\\e6a3\";\n}\n.fa-aviato {\n  --fa: \"\\f421\";\n}\n.fa-itunes {\n  --fa: \"\\f3b4\";\n}\n.fa-cuttlefish {\n  --fa: \"\\f38c\";\n}\n.fa-blogger {\n  --fa: \"\\f37c\";\n}\n.fa-flickr {\n  --fa: \"\\f16e\";\n}\n.fa-viber {\n  --fa: \"\\f409\";\n}\n.fa-soundcloud {\n  --fa: \"\\f1be\";\n}\n.fa-digg {\n  --fa: \"\\f1a6\";\n}\n.fa-tencent-weibo {\n  --fa: \"\\f1d5\";\n}\n.fa-letterboxd {\n  --fa: \"\\e62d\";\n}\n.fa-symfony {\n  --fa: \"\\f83d\";\n}\n.fa-maxcdn {\n  --fa: \"\\f136\";\n}\n.fa-etsy {\n  --fa: \"\\f2d7\";\n}\n.fa-facebook-messenger {\n  --fa: \"\\f39f\";\n}\n.fa-audible {\n  --fa: \"\\f373\";\n}\n.fa-think-peaks {\n  --fa: \"\\f731\";\n}\n.fa-bilibili {\n  --fa: \"\\e3d9\";\n}\n.fa-erlang {\n  --fa: \"\\f39d\";\n}\n.fa-x-twitter {\n  --fa: \"\\e61b\";\n}\n.fa-cotton-bureau {\n  --fa: \"\\f89e\";\n}\n.fa-dashcube {\n  --fa: \"\\f210\";\n}\n.fa-42-group {\n  --fa: \"\\e080\";\n}\n.fa-innosoft {\n  --fa: \"\\e080\";\n}\n.fa-stack-exchange {\n  --fa: \"\\f18d\";\n}\n.fa-elementor {\n  --fa: \"\\f430\";\n}\n.fa-square-pied-piper {\n  --fa: \"\\e01e\";\n}\n.fa-pied-piper-square {\n  --fa: \"\\e01e\";\n}\n.fa-creative-commons-nd {\n  --fa: \"\\f4eb\";\n}\n.fa-palfed {\n  --fa: \"\\f3d8\";\n}\n.fa-superpowers {\n  --fa: \"\\f2dd\";\n}\n.fa-resolving {\n  --fa: \"\\f3e7\";\n}\n.fa-xbox {\n  --fa: \"\\f412\";\n}\n.fa-square-web-awesome-stroke {\n  --fa: \"\\e684\";\n}\n.fa-searchengin {\n  --fa: \"\\f3eb\";\n}\n.fa-tiktok {\n  --fa: \"\\e07b\";\n}\n.fa-square-facebook {\n  --fa: \"\\f082\";\n}\n.fa-facebook-square {\n  --fa: \"\\f082\";\n}\n.fa-renren {\n  --fa: \"\\f18b\";\n}\n.fa-linux {\n  --fa: \"\\f17c\";\n}\n.fa-glide {\n  --fa: \"\\f2a5\";\n}\n.fa-linkedin {\n  --fa: \"\\f08c\";\n}\n.fa-hubspot {\n  --fa: \"\\f3b2\";\n}\n.fa-deploydog {\n  --fa: \"\\f38e\";\n}\n.fa-twitch {\n  --fa: \"\\f1e8\";\n}\n.fa-flutter {\n  --fa: \"\\e694\";\n}\n.fa-ravelry {\n  --fa: \"\\f2d9\";\n}\n.fa-mixer {\n  --fa: \"\\e056\";\n}\n.fa-square-lastfm {\n  --fa: \"\\f203\";\n}\n.fa-lastfm-square {\n  --fa: \"\\f203\";\n}\n.fa-vimeo {\n  --fa: \"\\f40a\";\n}\n.fa-mendeley {\n  --fa: \"\\f7b3\";\n}\n.fa-uniregistry {\n  --fa: \"\\f404\";\n}\n.fa-figma {\n  --fa: \"\\f799\";\n}\n.fa-creative-commons-remix {\n  --fa: \"\\f4ee\";\n}\n.fa-cc-amazon-pay {\n  --fa: \"\\f42d\";\n}\n.fa-dropbox {\n  --fa: \"\\f16b\";\n}\n.fa-instagram {\n  --fa: \"\\f16d\";\n}\n.fa-cmplid {\n  --fa: \"\\e360\";\n}\n.fa-upwork {\n  --fa: \"\\e641\";\n}\n.fa-facebook {\n  --fa: \"\\f09a\";\n}\n.fa-gripfire {\n  --fa: \"\\f3ac\";\n}\n.fa-jedi-order {\n  --fa: \"\\f50e\";\n}\n.fa-uikit {\n  --fa: \"\\f403\";\n}\n.fa-fort-awesome-alt {\n  --fa: \"\\f3a3\";\n}\n.fa-phabricator {\n  --fa: \"\\f3db\";\n}\n.fa-ussunnah {\n  --fa: \"\\f407\";\n}\n.fa-earlybirds {\n  --fa: \"\\f39a\";\n}\n.fa-trade-federation {\n  --fa: \"\\f513\";\n}\n.fa-autoprefixer {\n  --fa: \"\\f41c\";\n}\n.fa-whatsapp {\n  --fa: \"\\f232\";\n}\n.fa-square-upwork {\n  --fa: \"\\e67c\";\n}\n.fa-slideshare {\n  --fa: \"\\f1e7\";\n}\n.fa-google-play {\n  --fa: \"\\f3ab\";\n}\n.fa-viadeo {\n  --fa: \"\\f2a9\";\n}\n.fa-line {\n  --fa: \"\\f3c0\";\n}\n.fa-google-drive {\n  --fa: \"\\f3aa\";\n}\n.fa-servicestack {\n  --fa: \"\\f3ec\";\n}\n.fa-simplybuilt {\n  --fa: \"\\f215\";\n}\n.fa-bitbucket {\n  --fa: \"\\f171\";\n}\n.fa-imdb {\n  --fa: \"\\f2d8\";\n}\n.fa-deezer {\n  --fa: \"\\e077\";\n}\n.fa-raspberry-pi {\n  --fa: \"\\f7bb\";\n}\n.fa-jira {\n  --fa: \"\\f7b1\";\n}\n.fa-docker {\n  --fa: \"\\f395\";\n}\n.fa-screenpal {\n  --fa: \"\\e570\";\n}\n.fa-bluetooth {\n  --fa: \"\\f293\";\n}\n.fa-gitter {\n  --fa: \"\\f426\";\n}\n.fa-d-and-d {\n  --fa: \"\\f38d\";\n}\n.fa-microblog {\n  --fa: \"\\e01a\";\n}\n.fa-cc-diners-club {\n  --fa: \"\\f24c\";\n}\n.fa-gg-circle {\n  --fa: \"\\f261\";\n}\n.fa-pied-piper-hat {\n  --fa: \"\\f4e5\";\n}\n.fa-kickstarter-k {\n  --fa: \"\\f3bc\";\n}\n.fa-yandex {\n  --fa: \"\\f413\";\n}\n.fa-readme {\n  --fa: \"\\f4d5\";\n}\n.fa-html5 {\n  --fa: \"\\f13b\";\n}\n.fa-sellsy {\n  --fa: \"\\f213\";\n}\n.fa-square-web-awesome {\n  --fa: \"\\e683\";\n}\n.fa-sass {\n  --fa: \"\\f41e\";\n}\n.fa-wirsindhandwerk {\n  --fa: \"\\e2d0\";\n}\n.fa-wsh {\n  --fa: \"\\e2d0\";\n}\n.fa-buromobelexperte {\n  --fa: \"\\f37f\";\n}\n.fa-salesforce {\n  --fa: \"\\f83b\";\n}\n.fa-octopus-deploy {\n  --fa: \"\\e082\";\n}\n.fa-medapps {\n  --fa: \"\\f3c6\";\n}\n.fa-ns8 {\n  --fa: \"\\f3d5\";\n}\n.fa-pinterest-p {\n  --fa: \"\\f231\";\n}\n.fa-apper {\n  --fa: \"\\f371\";\n}\n.fa-fort-awesome {\n  --fa: \"\\f286\";\n}\n.fa-waze {\n  --fa: \"\\f83f\";\n}\n.fa-bluesky {\n  --fa: \"\\e671\";\n}\n.fa-cc-jcb {\n  --fa: \"\\f24b\";\n}\n.fa-snapchat {\n  --fa: \"\\f2ab\";\n}\n.fa-snapchat-ghost {\n  --fa: \"\\f2ab\";\n}\n.fa-fantasy-flight-games {\n  --fa: \"\\f6dc\";\n}\n.fa-rust {\n  --fa: \"\\e07a\";\n}\n.fa-wix {\n  --fa: \"\\f5cf\";\n}\n.fa-square-behance {\n  --fa: \"\\f1b5\";\n}\n.fa-behance-square {\n  --fa: \"\\f1b5\";\n}\n.fa-supple {\n  --fa: \"\\f3f9\";\n}\n.fa-webflow {\n  --fa: \"\\e65c\";\n}\n.fa-rebel {\n  --fa: \"\\f1d0\";\n}\n.fa-css3 {\n  --fa: \"\\f13c\";\n}\n.fa-staylinked {\n  --fa: \"\\f3f5\";\n}\n.fa-kaggle {\n  --fa: \"\\f5fa\";\n}\n.fa-space-awesome {\n  --fa: \"\\e5ac\";\n}\n.fa-deviantart {\n  --fa: \"\\f1bd\";\n}\n.fa-cpanel {\n  --fa: \"\\f388\";\n}\n.fa-goodreads-g {\n  --fa: \"\\f3a9\";\n}\n.fa-square-git {\n  --fa: \"\\f1d2\";\n}\n.fa-git-square {\n  --fa: \"\\f1d2\";\n}\n.fa-square-tumblr {\n  --fa: \"\\f174\";\n}\n.fa-tumblr-square {\n  --fa: \"\\f174\";\n}\n.fa-trello {\n  --fa: \"\\f181\";\n}\n.fa-creative-commons-nc-jp {\n  --fa: \"\\f4ea\";\n}\n.fa-get-pocket {\n  --fa: \"\\f265\";\n}\n.fa-perbyte {\n  --fa: \"\\e083\";\n}\n.fa-grunt {\n  --fa: \"\\f3ad\";\n}\n.fa-weebly {\n  --fa: \"\\f5cc\";\n}\n.fa-connectdevelop {\n  --fa: \"\\f20e\";\n}\n.fa-leanpub {\n  --fa: \"\\f212\";\n}\n.fa-black-tie {\n  --fa: \"\\f27e\";\n}\n.fa-themeco {\n  --fa: \"\\f5c6\";\n}\n.fa-python {\n  --fa: \"\\f3e2\";\n}\n.fa-android {\n  --fa: \"\\f17b\";\n}\n.fa-bots {\n  --fa: \"\\e340\";\n}\n.fa-free-code-camp {\n  --fa: \"\\f2c5\";\n}\n.fa-hornbill {\n  --fa: \"\\f592\";\n}\n.fa-js {\n  --fa: \"\\f3b8\";\n}\n.fa-ideal {\n  --fa: \"\\e013\";\n}\n.fa-git {\n  --fa: \"\\f1d3\";\n}\n.fa-dev {\n  --fa: \"\\f6cc\";\n}\n.fa-sketch {\n  --fa: \"\\f7c6\";\n}\n.fa-yandex-international {\n  --fa: \"\\f414\";\n}\n.fa-cc-amex {\n  --fa: \"\\f1f3\";\n}\n.fa-uber {\n  --fa: \"\\f402\";\n}\n.fa-github {\n  --fa: \"\\f09b\";\n}\n.fa-php {\n  --fa: \"\\f457\";\n}\n.fa-alipay {\n  --fa: \"\\f642\";\n}\n.fa-youtube {\n  --fa: \"\\f167\";\n}\n.fa-skyatlas {\n  --fa: \"\\f216\";\n}\n.fa-firefox-browser {\n  --fa: \"\\e007\";\n}\n.fa-replyd {\n  --fa: \"\\f3e6\";\n}\n.fa-suse {\n  --fa: \"\\f7d6\";\n}\n.fa-jenkins {\n  --fa: \"\\f3b6\";\n}\n.fa-twitter {\n  --fa: \"\\f099\";\n}\n.fa-rockrms {\n  --fa: \"\\f3e9\";\n}\n.fa-pinterest {\n  --fa: \"\\f0d2\";\n}\n.fa-buffer {\n  --fa: \"\\f837\";\n}\n.fa-npm {\n  --fa: \"\\f3d4\";\n}\n.fa-yammer {\n  --fa: \"\\f840\";\n}\n.fa-btc {\n  --fa: \"\\f15a\";\n}\n.fa-dribbble {\n  --fa: \"\\f17d\";\n}\n.fa-stumbleupon-circle {\n  --fa: \"\\f1a3\";\n}\n.fa-internet-explorer {\n  --fa: \"\\f26b\";\n}\n.fa-stubber {\n  --fa: \"\\e5c7\";\n}\n.fa-telegram {\n  --fa: \"\\f2c6\";\n}\n.fa-telegram-plane {\n  --fa: \"\\f2c6\";\n}\n.fa-old-republic {\n  --fa: \"\\f510\";\n}\n.fa-odysee {\n  --fa: \"\\e5c6\";\n}\n.fa-square-whatsapp {\n  --fa: \"\\f40c\";\n}\n.fa-whatsapp-square {\n  --fa: \"\\f40c\";\n}\n.fa-node-js {\n  --fa: \"\\f3d3\";\n}\n.fa-edge-legacy {\n  --fa: \"\\e078\";\n}\n.fa-slack {\n  --fa: \"\\f198\";\n}\n.fa-slack-hash {\n  --fa: \"\\f198\";\n}\n.fa-medrt {\n  --fa: \"\\f3c8\";\n}\n.fa-usb {\n  --fa: \"\\f287\";\n}\n.fa-tumblr {\n  --fa: \"\\f173\";\n}\n.fa-vaadin {\n  --fa: \"\\f408\";\n}\n.fa-quora {\n  --fa: \"\\f2c4\";\n}\n.fa-square-x-twitter {\n  --fa: \"\\e61a\";\n}\n.fa-reacteurope {\n  --fa: \"\\f75d\";\n}\n.fa-medium {\n  --fa: \"\\f23a\";\n}\n.fa-medium-m {\n  --fa: \"\\f23a\";\n}\n.fa-amilia {\n  --fa: \"\\f36d\";\n}\n.fa-mixcloud {\n  --fa: \"\\f289\";\n}\n.fa-flipboard {\n  --fa: \"\\f44d\";\n}\n.fa-viacoin {\n  --fa: \"\\f237\";\n}\n.fa-critical-role {\n  --fa: \"\\f6c9\";\n}\n.fa-sitrox {\n  --fa: \"\\e44a\";\n}\n.fa-discourse {\n  --fa: \"\\f393\";\n}\n.fa-joomla {\n  --fa: \"\\f1aa\";\n}\n.fa-mastodon {\n  --fa: \"\\f4f6\";\n}\n.fa-airbnb {\n  --fa: \"\\f834\";\n}\n.fa-wolf-pack-battalion {\n  --fa: \"\\f514\";\n}\n.fa-buy-n-large {\n  --fa: \"\\f8a6\";\n}\n.fa-gulp {\n  --fa: \"\\f3ae\";\n}\n.fa-creative-commons-sampling-plus {\n  --fa: \"\\f4f1\";\n}\n.fa-strava {\n  --fa: \"\\f428\";\n}\n.fa-ember {\n  --fa: \"\\f423\";\n}\n.fa-canadian-maple-leaf {\n  --fa: \"\\f785\";\n}\n.fa-teamspeak {\n  --fa: \"\\f4f9\";\n}\n.fa-pushed {\n  --fa: \"\\f3e1\";\n}\n.fa-wordpress-simple {\n  --fa: \"\\f411\";\n}\n.fa-nutritionix {\n  --fa: \"\\f3d6\";\n}\n.fa-wodu {\n  --fa: \"\\e088\";\n}\n.fa-google-pay {\n  --fa: \"\\e079\";\n}\n.fa-intercom {\n  --fa: \"\\f7af\";\n}\n.fa-zhihu {\n  --fa: \"\\f63f\";\n}\n.fa-korvue {\n  --fa: \"\\f42f\";\n}\n.fa-pix {\n  --fa: \"\\e43a\";\n}\n.fa-steam-symbol {\n  --fa: \"\\f3f6\";\n}\n:root,\n:host {\n  --fa-style-family-classic: 'Font Awesome 6 Free';\n  --fa-font-regular: normal 400 1em/1 'Font Awesome 6 Free';\n}\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf\") format(\"truetype\");\n}\n.far,\n.fa-regular {\n  font-weight: 400;\n}\n:root,\n:host {\n  --fa-style-family-classic: 'Font Awesome 6 Free';\n  --fa-font-solid: normal 900 1em/1 'Font Awesome 6 Free';\n}\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: block;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf\") format(\"truetype\");\n}\n.fas,\n.fa-solid {\n  font-weight: 900;\n}\n@font-face {\n  font-family: 'Font Awesome 5 Brands';\n  font-display: block;\n  font-weight: 400;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-display: block;\n  font-weight: 900;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-display: block;\n  font-weight: 400;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: 'FontAwesome';\n  font-display: block;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: 'FontAwesome';\n  font-display: block;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-brands-400.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: 'FontAwesome';\n  font-display: block;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-regular-400.ttf\") format(\"truetype\");\n  unicode-range: U+F003, U+F006, U+F014, U+F016-F017, U+F01A-F01B, U+F01D, U+F022, U+F03E, U+F044, U+F046, U+F05C-F05D, U+F06E, U+F070, U+F087-F088, U+F08A, U+F094, U+F096-F097, U+F09D, U+F0A0, U+F0A2, U+F0A4-F0A7, U+F0C5, U+F0C7, U+F0E5-F0E6, U+F0EB, U+F0F6-F0F8, U+F10C, U+F114-F115, U+F118-F11A, U+F11C-F11D, U+F133, U+F147, U+F14E, U+F150-F152, U+F185-F186, U+F18E, U+F190-F192, U+F196, U+F1C1-F1C9, U+F1D9, U+F1DB, U+F1E3, U+F1EA, U+F1F7, U+F1F9, U+F20A, U+F247-F248, U+F24A, U+F24D, U+F255-F25B, U+F25D, U+F271-F274, U+F278, U+F27B, U+F28C, U+F28E, U+F29C, U+F2B5, U+F2B7, U+F2BA, U+F2BC, U+F2BE, U+F2C0-F2C1, U+F2C3, U+F2D0, U+F2D2, U+F2D4, U+F2DC;\n}\n@font-face {\n  font-family: 'FontAwesome';\n  font-display: block;\n  src: url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-v4compatibility.woff2\") format(\"woff2\"), url(\"../../../node_modules/@fortawesome/fontawesome-free/webfonts/fa-v4compatibility.ttf\") format(\"truetype\");\n  unicode-range: U+F041, U+F047, U+F065-F066, U+F07D-F07E, U+F080, U+F08B, U+F08E, U+F090, U+F09A, U+F0AC, U+F0AE, U+F0B2, U+F0D0, U+F0D6, U+F0E4, U+F0EC, U+F10A-F10B, U+F123, U+F13E, U+F148-F149, U+F14C, U+F156, U+F15E, U+F160-F161, U+F163, U+F175-F178, U+F195, U+F1F8, U+F219, U+F27A;\n}\nhtml {\n  font-size: 14px;\n}\n.text-larger {\n  font-size: larger;\n}\n@media (min-width: 640px) {\n  .text-larger\\@s {\n    font-size: larger;\n  }\n}\n@media (min-width: 960px) {\n  html {\n    font-size: 0.75rem;\n  }\n  .text-larger\\@m {\n    font-size: larger;\n  }\n}\n@media (min-width: 1200px) {\n  .text-larger\\@l {\n    font-size: larger;\n  }\n}\n@media (min-width: 1600px) {\n  html {\n    font-size: 1rem;\n  }\n  .text-larger\\@xl {\n    font-size: larger;\n  }\n}\n.site-header {\n  height: 70px;\n}\n.site-header .site-header-logo img {\n  max-height: 60px;\n  padding: 0;\n  margin-left: 15px;\n}\n.site-header .site-header-logo h1 {\n  display: inline-block;\n  margin: 0;\n  margin-left: 10px;\n  color: #003768;\n  font-size: 1.8em;\n}\n.site-header .uk-navbar-container:not(.uk-navbar-transparent) {\n  background-color: #ffffff;\n}\n.site-header .uk-navbar-nav > li > a {\n  min-height: 70px;\n}\n.site-header .icone-offcanvas {\n  margin-left: 15px;\n  margin-right: -5px;\n}\n.site-header .uk-offcanvas-bar .uk-navbar-dropdown-nav > li > a,\n.site-header .uk-offcanvas-bar .uk-nav.uk-nav-parent-icon a {\n  color: black;\n}\n.site-header .uk-offcanvas-bar .uk-navbar-nav > li > a {\n  color: black;\n}\n.site-header .uk-offcanvas-bar .uk-nav-default .uk-nav-sub li.uk-active > a {\n  color: black;\n  background: #e1e1e1;\n}\n.site-header .site-header-usuario {\n  margin-top: 20px;\n}\n.site-header .site-header-usuario .uk-subnav > * > :first-child {\n  text-transform: none;\n}\n.site-header .site-header-usuario .uk-dropdown {\n  padding: 10px 20px;\n  min-width: 150px;\n}\n.site-header .site-header-usuario .uk-dropdown a {\n  justify-content: flex-end;\n  text-transform: none;\n}\n@media (max-width: 1199px) {\n  .site-header {\n    height: auto;\n  }\n  .site-header > nav > [uk-navbar] {\n    gap: 8px;\n  }\n  .site-header .uk-navbar-left {\n    flex-shrink: 0;\n  }\n  .site-header .site-header-usuario {\n    flex: 1 1 0;\n    min-width: 0;\n    margin-top: 0;\n    margin-right: 12px !important;\n  }\n  .site-header .site-header-usuario nav {\n    width: 100%;\n    min-width: 0;\n  }\n  .site-header .site-header-usuario .uk-subnav {\n    margin: 0;\n    gap: 8px;\n    flex-wrap: nowrap;\n    justify-content: flex-end;\n  }\n  .site-header .site-header-usuario .uk-subnav > li {\n    min-width: 0;\n    padding-left: 0;\n  }\n  .site-header .site-header-usuario .uk-subnav > li:last-child {\n    flex: 0 1 auto;\n  }\n  .site-header .site-header-usuario .uk-subnav > li > a {\n    display: block;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    text-align: right;\n  }\n  .site-header .site-header-usuario .uk-subnav > li > a .uk-icon {\n    flex-shrink: 0;\n  }\n}\n.side-menu {\n  position: fixed;\n  top: 70px;\n  z-index: 999;\n  background-color: #fff;\n  overflow-x: hidden;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  padding: 15px;\n  transition: all 0.1s linear;\n}\n.side-menu .uk-nav-default,\n.side-menu .uk-nav-default .uk-nav-sub {\n  font-size: 14px;\n}\n.side-menu .uk-nav.uk-nav-divider > :not(.uk-nav-header,.uk-nav-divider) + :not(.uk-nav-header,.uk-nav-divider) {\n  margin-top: 0;\n  padding-top: 0;\n  border-top: 1px solid #e5e5e5;\n}\n.side-menu .uk-nav .uk-nav-divider {\n  margin-top: 0;\n  padding-top: 0;\n}\n.side-menu .uk-nav-default > li > a,\n.side-menu .uk-nav-default .uk-nav-sub a {\n  color: black;\n  line-height: 30px;\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n.side-menu .uk-nav-default .uk-nav-sub a {\n  padding-left: 10px;\n}\n.side-menu .uk-nav-default > li > a:hover,\n.side-menu .uk-nav-default .uk-nav-sub a:hover {\n  background-color: #e1e1e1;\n}\n.side-menu .uk-nav-default > li.uk-active > a,\n.side-menu .uk-nav-default .uk-nav-sub li.uk-active > a {\n  background-color: #003768;\n  color: white;\n}\n.side-menu .uk-nav-default.uk-nav-divider.uk-nav {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.side-menu .uk-nav .uk-nav-divider {\n  margin-bottom: 0;\n}\n.side-menu .uk-nav-sub.uk-nav {\n  padding-left: 55px;\n}\n.side-menu .side-menu-icone {\n  line-height: 20px;\n}\n.side-menu .side-menu-descricao {\n  display: block;\n  margin-left: 5px;\n  text-overflow: ellipsis;\n  line-height: 20px;\n}\n.side-menu .side-menu-icone-parent {\n  display: block;\n  line-height: 20px;\n}\n.side-menu .uk-nav-sub {\n  display: block;\n  padding-right: 0 !important;\n  padding-bottom: 0 !important;\n}\n.side-menu li > a {\n  justify-content: left;\n}\n.side-menu .side-menu-logo {\n  border-top: 1px solid #e5e5e5;\n  display: none;\n  margin-left: -15px;\n  margin-top: 5px;\n  padding: 20px;\n  text-align: center;\n}\n.side-menu .side-menu-logo img {\n  display: block;\n  height: auto;\n  margin: 0 auto;\n  max-height: 180px;\n  max-width: 100%;\n  object-fit: contain;\n}\n.side-menu-fixed .side-menu .side-menu-logo {\n  display: block;\n}\n@media (min-width: 1200px) {\n  .side-menu-fixed .side-menu {\n    width: 250px;\n  }\n  .side-menu-fixed .side-menu .side-menu-descricao {\n    max-width: 150px;\n  }\n  .side-menu-fixed .side-menu-margin {\n    margin-left: 250px;\n  }\n}\n@media (min-width: 1600px) {\n  .side-menu-fixed .side-menu {\n    width: 250px;\n  }\n  .side-menu-fixed .side-menu .side-menu-descricao {\n    max-width: 190px;\n  }\n  .side-menu-fixed .side-menu-margin {\n    margin-left: 250px;\n  }\n}\n.side-menu-auto .side-menu {\n  width: 50px;\n  transition: all 0.1s linear;\n  text-align: center;\n}\n.side-menu-auto .side-menu .side-menu-descricao {\n  display: none;\n}\n.side-menu-auto .side-menu .side-menu-icone-parent {\n  display: none;\n}\n.side-menu-auto .side-menu .uk-nav-sub {\n  display: none;\n}\n.side-menu-auto .side-menu li > a {\n  justify-content: center;\n}\n.side-menu-auto .side-menu-margin {\n  margin-left: 50px;\n}\n.side-menu-auto .side-menu:hover {\n  text-align: left;\n}\n.side-menu-auto .side-menu:hover .side-menu-descricao {\n  display: block;\n}\n.side-menu-auto .side-menu:hover .side-menu-icone-parent {\n  display: block;\n}\n.side-menu-auto .side-menu:hover .uk-nav-sub {\n  display: block;\n}\n.side-menu-auto .side-menu:hover li > a {\n  justify-content: left;\n}\n.side-menu-auto .side-menu:hover .side-menu-logo {\n  display: block;\n}\n.side-menu-auto .side-menu:hover .uk-nav-sub {\n  display: block;\n}\n@media (min-width: 1200px) {\n  .side-menu-auto .side-menu:hover {\n    width: 250px;\n  }\n  .side-menu-auto .side-menu:hover .side-menu-descricao {\n    max-width: 150px;\n  }\n}\n@media (min-width: 1600px) {\n  .side-menu-auto .side-menu:hover {\n    width: 250px;\n  }\n  .side-menu-auto .side-menu:hover .side-menu-descricao {\n    max-width: 190px;\n  }\n}\n@media (max-width: 1199px) {\n  .side-menu-margin {\n    margin-left: 0 !important;\n  }\n}\n@media (max-width: 960px) {\n  .height-auto {\n    height: auto;\n  }\n}\n@media (min-width: 640px) {\n  .margin-small-left\\@s {\n    margin-left: 10px !important;\n  }\n  .margin-remove-top\\@s {\n    margin-top: 0 !important;\n  }\n  .margin-remove\\@s {\n    margin: 0 !important;\n  }\n}\n@media (min-width: 960px) {\n  .margin-remove-top\\@m {\n    margin-top: 0 !important;\n  }\n  .margin-remove\\@m {\n    margin: 0 !important;\n  }\n}\n@media (min-width: 1200px) {\n  .margin-remove-top\\@l {\n    margin-top: 0 !important;\n  }\n  .margin-remove\\@l {\n    margin: 0 !important;\n  }\n}\n@media (min-width: 1600px) {\n  .margin-remove-top\\@xl {\n    margin-top: 0 !important;\n  }\n  .margin-remove\\@xl {\n    margin: 0 !important;\n  }\n}\n.padding-remove {\n  padding: 0 0 0 0;\n}\n.padding-remove-top {\n  padding-top: 0;\n}\n.padding-nano {\n  padding: 5px 5px 5px 5px;\n}\n.padding-nano-top {\n  padding: 5px 0 0 0;\n}\n.padding-nano-right {\n  padding: 0 5px 0 0;\n}\n.padding-nano-bottom {\n  padding: 0 0 5px 0;\n}\n.padding-nano-left {\n  padding: 0 0 0 5px;\n}\n.padding-nano-vertical {\n  padding: 5px 0;\n}\n.padding-nano-horizontal {\n  padding: 0 5px;\n}\n.padding-micro {\n  padding: 10px 10px 10px 10px;\n}\n.padding-micro-top {\n  padding: 10px 0 0 0;\n}\n.padding-micro-right {\n  padding: 0 10px 0 0;\n}\n.padding-micro-bottom {\n  padding: 0 0 10px 0;\n}\n.padding-micro-left {\n  padding: 0 0 0 10px;\n}\n.padding-micro-vertical {\n  padding: 10px 0;\n}\n.padding-micro-horizontal {\n  padding: 0 10px;\n}\n.padding-small {\n  padding: 15px 15px 15px 15px;\n}\n.padding-small-top {\n  padding: 15px 0 0 0;\n}\n.padding-small-right {\n  padding: 0 15px 0 0;\n}\n.padding-small-bottom {\n  padding: 0 0 15px 0;\n}\n.padding-small-left {\n  padding: 0 0 0 15px;\n}\n.padding-small-vertical {\n  padding: 15px 0;\n}\n.padding-small-horizontal {\n  padding: 0 15px;\n}\n.padding-medium {\n  padding: 30px 30px 30px 30px;\n}\n.padding-medium-top {\n  padding: 30px 0 0 0;\n}\n.padding-medium-right {\n  padding: 0 30px 0 0;\n}\n.padding-medium-bottom {\n  padding: 0 0 30px 0;\n}\n.padding-medium-left {\n  padding: 0 0 0 30px;\n}\n.padding-medium-vertical {\n  padding: 30px 0;\n}\n.padding-medium-horizontal {\n  padding: 0 30px;\n}\n.padding-large {\n  padding: 50px 50px 50px 50px;\n}\n.padding-large-top {\n  padding: 50px 0 0 0;\n}\n.padding-large-right {\n  padding: 0 50px 0 0;\n}\n.padding-large-bottom {\n  padding: 0 0 50px 0;\n}\n.padding-large-left {\n  padding: 0 0 0 50px;\n}\n.padding-large-vertical {\n  padding: 50px 0;\n}\n.padding-large-horizontal {\n  padding: 0 50px;\n}\n.padding-letter-top {\n  padding-top: 21px;\n}\n@media (min-width: 435px) {\n  .padding-remove\\@xs {\n    padding: 0 0 0 0;\n  }\n  .padding-nano\\@xs {\n    padding: 5px 5px 5px 5px;\n  }\n  .padding-nano-top\\@xs {\n    padding: 5px 0 0 0;\n  }\n  .padding-nano-right\\@xs {\n    padding: 0 5px 0 0;\n  }\n  .padding-nano-bottom\\@xs {\n    padding: 0 0 5px 0;\n  }\n  .padding-nano-left\\@xs {\n    padding: 0 0 0 5px;\n  }\n  .padding-nano-vertical\\@xs {\n    padding: 5px 0;\n  }\n  .padding-nano-horizontal\\@xs {\n    padding: 0 5px;\n  }\n  .padding-micro\\@xs {\n    padding: 10px 10px 10px 10px;\n  }\n  .padding-micro-top\\@xs {\n    padding: 10px 0 0 0;\n  }\n  .padding-micro-right\\@xs {\n    padding: 0 10px 0 0;\n  }\n  .padding-micro-bottom\\@xs {\n    padding: 0 0 10px 0;\n  }\n  .padding-micro-left\\@xs {\n    padding: 0 0 0 10px;\n  }\n  .padding-micro-vertical\\@xs {\n    padding: 10px 0;\n  }\n  .padding-micro-horizontal\\@xs {\n    padding: 0 10px;\n  }\n  .padding-small\\@xs {\n    padding: 15px 15px 15px 15px;\n  }\n  .padding-small-top\\@xs {\n    padding: 15px 0 0 0;\n  }\n  .padding-small-right\\@xs {\n    padding: 0 15px 0 0;\n  }\n  .padding-small-bottom\\@xs {\n    padding: 0 0 15px 0;\n  }\n  .padding-small-left\\@xs {\n    padding: 0 0 0 15px;\n  }\n  .padding-small-vertical\\@xs {\n    padding: 15px 0;\n  }\n  .padding-small-horizontal\\@xs {\n    padding: 0 15px;\n  }\n  .padding-medium\\@xs {\n    padding: 30px 30px 30px 30px;\n  }\n  .padding-medium-top\\@xs {\n    padding: 30px 0 0 0;\n  }\n  .padding-medium-right\\@xs {\n    padding: 0 30px 0 0;\n  }\n  .padding-medium-bottom\\@xs {\n    padding: 0 0 30px 0;\n  }\n  .padding-medium-left\\@xs {\n    padding: 0 0 0 30px;\n  }\n  .padding-medium-vertical\\@xs {\n    padding: 30px 0;\n  }\n  .padding-medium-horizontal\\@xs {\n    padding: 0 30px;\n  }\n  .padding-large\\@xs {\n    padding: 50px 50px 50px 50px;\n  }\n  .padding-large-top\\@xs {\n    padding: 50px 0 0 0;\n  }\n  .padding-large-right\\@xs {\n    padding: 0 50px 0 0;\n  }\n  .padding-large-bottom\\@xs {\n    padding: 0 0 50px 0;\n  }\n  .padding-large-left\\@xs {\n    padding: 0 0 0 50px;\n  }\n  .padding-large-vertical\\@xs {\n    padding: 50px 0;\n  }\n  .padding-large-horizontal\\@xs {\n    padding: 0 50px;\n  }\n}\n@media (min-width: 640px) {\n  .padding-remove\\@s {\n    padding: 0 0 0 0;\n  }\n  .padding-nano\\@s {\n    padding: 5px 5px 5px 5px;\n  }\n  .padding-nano-top\\@s {\n    padding: 5px 0 0 0;\n  }\n  .padding-nano-right\\@s {\n    padding: 0 5px 0 0;\n  }\n  .padding-nano-bottom\\@s {\n    padding: 0 0 5px 0;\n  }\n  .padding-nano-left\\@s {\n    padding: 0 0 0 5px;\n  }\n  .padding-nano-vertical\\@s {\n    padding: 5px 0;\n  }\n  .padding-nano-horizontal\\@s {\n    padding: 0 5px;\n  }\n  .padding-micro\\@s {\n    padding: 10px 10px 10px 10px;\n  }\n  .padding-micro-top\\@s {\n    padding: 10px 0 0 0;\n  }\n  .padding-micro-right\\@s {\n    padding: 0 10px 0 0;\n  }\n  .padding-micro-bottom\\@s {\n    padding: 0 0 10px 0;\n  }\n  .padding-micro-left\\@s {\n    padding: 0 0 0 10px;\n  }\n  .padding-micro-vertical\\@s {\n    padding: 10px 0;\n  }\n  .padding-micro-horizontal\\@s {\n    padding: 0 10px;\n  }\n  .padding-small\\@s {\n    padding: 15px 15px 15px 15px;\n  }\n  .padding-small-top\\@s {\n    padding: 15px 0 0 0;\n  }\n  .padding-small-right\\@s {\n    padding: 0 15px 0 0;\n  }\n  .padding-small-bottom\\@s {\n    padding: 0 0 15px 0;\n  }\n  .padding-small-left\\@s {\n    padding: 0 0 0 15px;\n  }\n  .padding-small-vertical\\@s {\n    padding: 15px 0;\n  }\n  .padding-small-horizontal\\@s {\n    padding: 0 15px;\n  }\n  .padding-medium\\@s {\n    padding: 30px 30px 30px 30px;\n  }\n  .padding-medium-top\\@s {\n    padding: 30px 0 0 0;\n  }\n  .padding-medium-right\\@s {\n    padding: 0 30px 0 0;\n  }\n  .padding-medium-bottom\\@s {\n    padding: 0 0 30px 0;\n  }\n  .padding-medium-left\\@s {\n    padding: 0 0 0 30px;\n  }\n  .padding-medium-vertical\\@s {\n    padding: 30px 0;\n  }\n  .padding-medium-horizontal\\@s {\n    padding: 0 30px;\n  }\n  .padding-large\\@s {\n    padding: 50px 50px 50px 50px;\n  }\n  .padding-large-top\\@s {\n    padding: 50px 0 0 0;\n  }\n  .padding-large-right\\@s {\n    padding: 0 50px 0 0;\n  }\n  .padding-large-bottom\\@s {\n    padding: 0 0 50px 0;\n  }\n  .padding-large-left\\@s {\n    padding: 0 0 0 50px;\n  }\n  .padding-large-vertical\\@s {\n    padding: 50px 0;\n  }\n  .padding-large-horizontal\\@s {\n    padding: 0 50px;\n  }\n}\n@media (min-width: 960px) {\n  .padding-remove\\@m {\n    padding: 0 0 0 0;\n  }\n  .padding-nano\\@m {\n    padding: 5px 5px 5px 5px;\n  }\n  .padding-nano-top\\@m {\n    padding: 5px 0 0 0;\n  }\n  .padding-nano-right\\@m {\n    padding: 0 5px 0 0;\n  }\n  .padding-nano-bottom\\@m {\n    padding: 0 0 5px 0;\n  }\n  .padding-nano-left\\@m {\n    padding: 0 0 0 5px;\n  }\n  .padding-nano-vertical\\@m {\n    padding: 5px 0;\n  }\n  .padding-nano-horizontal\\@m {\n    padding: 0 5px;\n  }\n  .padding-micro\\@m {\n    padding: 10px 10px 10px 10px;\n  }\n  .padding-micro-top\\@m {\n    padding: 10px 0 0 0;\n  }\n  .padding-micro-right\\@m {\n    padding: 0 10px 0 0;\n  }\n  .padding-micro-bottom\\@m {\n    padding: 0 0 10px 0;\n  }\n  .padding-micro-left\\@m {\n    padding: 0 0 0 10px;\n  }\n  .padding-micro-vertical\\@m {\n    padding: 10px 0;\n  }\n  .padding-micro-horizontal\\@m {\n    padding: 0 10px;\n  }\n  .padding-small\\@m {\n    padding: 15px 15px 15px 15px;\n  }\n  .padding-small-top\\@m {\n    padding: 15px 0 0 0;\n  }\n  .padding-small-right\\@m {\n    padding: 0 15px 0 0;\n  }\n  .padding-small-bottom\\@m {\n    padding: 0 0 15px 0;\n  }\n  .padding-small-left\\@m {\n    padding: 0 0 0 15px;\n  }\n  .padding-small-vertical\\@m {\n    padding: 15px 0;\n  }\n  .padding-small-horizontal\\@m {\n    padding: 0 15px;\n  }\n  .padding-medium\\@m {\n    padding: 30px 30px 30px 30px;\n  }\n  .padding-medium-top\\@m {\n    padding: 30px 0 0 0;\n  }\n  .padding-medium-right\\@m {\n    padding: 0 30px 0 0;\n  }\n  .padding-medium-bottom\\@m {\n    padding: 0 0 30px 0;\n  }\n  .padding-medium-left\\@m {\n    padding: 0 0 0 30px;\n  }\n  .padding-medium-vertical\\@m {\n    padding: 30px 0;\n  }\n  .padding-medium-horizontal\\@m {\n    padding: 0 30px;\n  }\n  .padding-large\\@m {\n    padding: 50px 50px 50px 50px;\n  }\n  .padding-large-top\\@m {\n    padding: 50px 0 0 0;\n  }\n  .padding-large-right\\@m {\n    padding: 0 50px 0 0;\n  }\n  .padding-large-bottom\\@m {\n    padding: 0 0 50px 0;\n  }\n  .padding-large-left\\@m {\n    padding: 0 0 0 50px;\n  }\n  .padding-large-vertical\\@m {\n    padding: 50px 0;\n  }\n  .padding-large-horizontal\\@m {\n    padding: 0 50px;\n  }\n  .padding-letter-top {\n    padding-top: 18px;\n  }\n}\n@media (min-width: 1200px) {\n  .padding-remove\\@l {\n    padding: 0 0 0 0;\n  }\n  .padding-nano\\@l {\n    padding: 5px 5px 5px 5px;\n  }\n  .padding-nano-top\\@l {\n    padding: 5px 0 0 0;\n  }\n  .padding-nano-right\\@l {\n    padding: 0 5px 0 0;\n  }\n  .padding-nano-bottom\\@l {\n    padding: 0 0 5px 0;\n  }\n  .padding-nano-left\\@l {\n    padding: 0 0 0 5px;\n  }\n  .padding-nano-vertical\\@l {\n    padding: 5px 0;\n  }\n  .padding-nano-horizontal\\@l {\n    padding: 0 5px;\n  }\n  .padding-micro\\@l {\n    padding: 10px 10px 10px 10px;\n  }\n  .padding-micro-top\\@l {\n    padding: 10px 0 0 0;\n  }\n  .padding-micro-right\\@l {\n    padding: 0 10px 0 0;\n  }\n  .padding-micro-bottom\\@l {\n    padding: 0 0 10px 0;\n  }\n  .padding-micro-left\\@l {\n    padding: 0 0 0 10px;\n  }\n  .padding-micro-vertical\\@l {\n    padding: 10px 0;\n  }\n  .padding-micro-horizontal\\@l {\n    padding: 0 10px;\n  }\n  .padding-small\\@l {\n    padding: 15px 15px 15px 15px;\n  }\n  .padding-small-top\\@l {\n    padding: 15px 0 0 0;\n  }\n  .padding-small-right\\@l {\n    padding: 0 15px 0 0;\n  }\n  .padding-small-bottom\\@l {\n    padding: 0 0 15px 0;\n  }\n  .padding-small-left\\@l {\n    padding: 0 0 0 15px;\n  }\n  .padding-small-vertical\\@l {\n    padding: 15px 0;\n  }\n  .padding-small-horizontal\\@l {\n    padding: 0 15px;\n  }\n  .padding-medium\\@l {\n    padding: 30px 30px 30px 30px;\n  }\n  .padding-medium-top\\@l {\n    padding: 30px 0 0 0;\n  }\n  .padding-medium-right\\@l {\n    padding: 0 30px 0 0;\n  }\n  .padding-medium-bottom\\@l {\n    padding: 0 0 30px 0;\n  }\n  .padding-medium-left\\@l {\n    padding: 0 0 0 30px;\n  }\n  .padding-medium-vertical\\@l {\n    padding: 30px 0;\n  }\n  .padding-medium-horizontal\\@l {\n    padding: 0 30px;\n  }\n  .padding-large\\@l {\n    padding: 50px 50px 50px 50px;\n  }\n  .padding-large-top\\@l {\n    padding: 50px 0 0 0;\n  }\n  .padding-large-right\\@l {\n    padding: 0 50px 0 0;\n  }\n  .padding-large-bottom\\@l {\n    padding: 0 0 50px 0;\n  }\n  .padding-large-left\\@l {\n    padding: 0 0 0 50px;\n  }\n  .padding-large-vertical\\@l {\n    padding: 50px 0;\n  }\n  .padding-large-horizontal\\@l {\n    padding: 0 50px;\n  }\n}\n@media (min-width: 1600px) {\n  .padding-remove\\@xl {\n    padding: 0 0 0 0;\n  }\n  .padding-nano\\@xl {\n    padding: 5px 5px 5px 5px;\n  }\n  .padding-nano-top\\@xl {\n    padding: 5px 0 0 0;\n  }\n  .padding-nano-right\\@xl {\n    padding: 0 5px 0 0;\n  }\n  .padding-nano-bottom\\@xl {\n    padding: 0 0 5px 0;\n  }\n  .padding-nano-left\\@xl {\n    padding: 0 0 0 5px;\n  }\n  .padding-nano-vertical\\@xl {\n    padding: 5px 0;\n  }\n  .padding-nano-horizontal\\@xl {\n    padding: 0 5px;\n  }\n  .padding-micro\\@xl {\n    padding: 10px 10px 10px 10px;\n  }\n  .padding-micro-top\\@xl {\n    padding: 10px 0 0 0;\n  }\n  .padding-micro-right\\@xl {\n    padding: 0 10px 0 0;\n  }\n  .padding-micro-bottom\\@xl {\n    padding: 0 0 10px 0;\n  }\n  .padding-micro-left\\@xl {\n    padding: 0 0 0 10px;\n  }\n  .padding-micro-vertical\\@xl {\n    padding: 10px 0;\n  }\n  .padding-micro-horizontal\\@xl {\n    padding: 0 10px;\n  }\n  .padding-small\\@xl {\n    padding: 15px 15px 15px 15px;\n  }\n  .padding-small-top\\@xl {\n    padding: 15px 0 0 0;\n  }\n  .padding-small-right\\@xl {\n    padding: 0 15px 0 0;\n  }\n  .padding-small-bottom\\@xl {\n    padding: 0 0 15px 0;\n  }\n  .padding-small-left\\@xl {\n    padding: 0 0 0 15px;\n  }\n  .padding-small-vertical\\@xl {\n    padding: 15px 0;\n  }\n  .padding-small-horizontal\\@xl {\n    padding: 0 15px;\n  }\n  .padding-medium\\@xl {\n    padding: 30px 30px 30px 30px;\n  }\n  .padding-medium-top\\@xl {\n    padding: 30px 0 0 0;\n  }\n  .padding-medium-right\\@xl {\n    padding: 0 30px 0 0;\n  }\n  .padding-medium-bottom\\@xl {\n    padding: 0 0 30px 0;\n  }\n  .padding-medium-left\\@xl {\n    padding: 0 0 0 30px;\n  }\n  .padding-medium-vertical\\@xl {\n    padding: 30px 0;\n  }\n  .padding-medium-horizontal\\@xl {\n    padding: 0 30px;\n  }\n  .padding-large\\@xl {\n    padding: 50px 50px 50px 50px;\n  }\n  .padding-large-top\\@xl {\n    padding: 50px 0 0 0;\n  }\n  .padding-large-right\\@xl {\n    padding: 0 50px 0 0;\n  }\n  .padding-large-bottom\\@xl {\n    padding: 0 0 50px 0;\n  }\n  .padding-large-left\\@xl {\n    padding: 0 0 0 50px;\n  }\n  .padding-large-vertical\\@xl {\n    padding: 50px 0;\n  }\n  .padding-large-horizontal\\@xl {\n    padding: 0 50px;\n  }\n  .padding-letter-top {\n    padding-top: 24px;\n  }\n}\n.switch-micro {\n  width: 30px;\n  height: 15px;\n  position: relative;\n  display: inline-block;\n  border-radius: calc(15px / 2);\n}\n.switch-micro input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.switch-micro .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: calc(15px / 2);\n}\n.switch-micro .slider:before {\n  position: absolute;\n  content: \"\";\n  height: calc(15px - 8px);\n  width: calc(15px - 8px);\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n.switch-micro input:checked + .slider {\n  background-color: #10be2d;\n}\n.switch-micro input:focus + .slider {\n  box-shadow: 0 0 1px #10be2d;\n}\n.switch-micro input:checked + .slider:before {\n  transform: translateX(15px);\n}\n.switch-small {\n  width: 40px;\n  height: 20px;\n  position: relative;\n  display: inline-block;\n  border-radius: calc(20px / 2);\n}\n.switch-small input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.switch-small .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: calc(20px / 2);\n}\n.switch-small .slider:before {\n  position: absolute;\n  content: \"\";\n  height: calc(20px - 8px);\n  width: calc(20px - 8px);\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n.switch-small input:checked + .slider {\n  background-color: #10be2d;\n}\n.switch-small input:focus + .slider {\n  box-shadow: 0 0 1px #10be2d;\n}\n.switch-small input:checked + .slider:before {\n  transform: translateX(20px);\n}\n.switch-medium {\n  width: 60px;\n  height: 34px;\n  position: relative;\n  display: inline-block;\n  border-radius: calc(34px / 2);\n}\n.switch-medium input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.switch-medium .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: calc(34px / 2);\n}\n.switch-medium .slider:before {\n  position: absolute;\n  content: \"\";\n  height: calc(34px - 8px);\n  width: calc(34px - 8px);\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n.switch-medium input:checked + .slider {\n  background-color: #10be2d;\n}\n.switch-medium input:focus + .slider {\n  box-shadow: 0 0 1px #10be2d;\n}\n.switch-medium input:checked + .slider:before {\n  transform: translateX(26px);\n}\n.switch-large {\n  width: 80px;\n  height: 44px;\n  position: relative;\n  display: inline-block;\n  border-radius: calc(44px / 2);\n}\n.switch-large input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n.switch-large .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: calc(44px / 2);\n}\n.switch-large .slider:before {\n  position: absolute;\n  content: \"\";\n  height: calc(44px - 8px);\n  width: calc(44px - 8px);\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n.switch-large input:checked + .slider {\n  background-color: #10be2d;\n}\n.switch-large input:focus + .slider {\n  box-shadow: 0 0 1px #10be2d;\n}\n.switch-large input:checked + .slider:before {\n  transform: translateX(36px);\n}\n.width-small-medium {\n  width: 200;\n}\n.width-micro {\n  width: 100px;\n}\n.width-nano {\n  width: 50px;\n}\n@media (min-width: 960px) {\n  .width-large\\@m {\n    width: 338px;\n  }\n  .width-medium\\@m {\n    width: 225px;\n  }\n  .width-small-medium\\@m {\n    width: 150px;\n  }\n  .width-small\\@m {\n    width: 112px;\n  }\n  .width-micro\\@m {\n    width: 75px;\n  }\n  .width-nano\\@m {\n    width: 38px;\n  }\n}\n@media (min-width: 1600px) {\n  .width-large\\@m {\n    width: 450px;\n  }\n  .width-medium\\@m {\n    width: 300px;\n  }\n  .width-small-medium\\@m {\n    width: 200px;\n  }\n  .width-small\\@m {\n    width: 150px;\n  }\n  .width-micro\\@m {\n    width: 100px;\n  }\n  .width-nano\\@m {\n    width: 50px;\n  }\n}\n.width-25 {\n  width: 25px;\n}\n.width-50 {\n  width: 50px;\n}\n.width-75 {\n  width: 75px;\n}\n.width-100 {\n  width: 100px;\n}\n.width-125 {\n  width: 125px;\n}\n.width-150 {\n  width: 150px;\n}\n.width-175 {\n  width: 175px;\n}\n.width-185 {\n  width: 185px;\n}\n.width-200 {\n  width: 200px;\n}\n.width-250 {\n  width: 250px;\n}\n.width-275 {\n  width: 275px;\n}\n.width-300 {\n  width: 300px;\n}\n.width-350 {\n  width: 350px;\n}\n.width-400 {\n  width: 400px;\n}\n@media (min-width: 640px) {\n  .width-25\\@s {\n    width: 25px;\n  }\n  .width-50\\@s {\n    width: 50px;\n  }\n  .width-75\\@s {\n    width: 75px;\n  }\n  .width-100\\@s {\n    width: 100px;\n  }\n  .width-125\\@s {\n    width: 125px;\n  }\n  .width-150\\@s {\n    width: 150px;\n  }\n  .width-175\\@s {\n    width: 175px;\n  }\n  .width-200\\@s {\n    width: 200px;\n  }\n  .width-250\\@s {\n    width: 250px;\n  }\n  .width-275\\@s {\n    width: 275px;\n  }\n  .width-300\\@s {\n    width: 300px;\n  }\n  .width-350\\@s {\n    width: 350px;\n  }\n  .width-400\\@s {\n    width: 400px;\n  }\n}\n@media (min-width: 640px) {\n  .width-25\\@s {\n    width: 25px;\n  }\n  .width-50\\@s {\n    width: 50px;\n  }\n  .width-75\\@s {\n    width: 75px;\n  }\n  .width-100\\@s {\n    width: 100px;\n  }\n  .width-125\\@s {\n    width: 125px;\n  }\n  .width-150\\@s {\n    width: 150px;\n  }\n  .width-175\\@s {\n    width: 175px;\n  }\n  .width-185\\@s {\n    width: 185px;\n  }\n  .width-200\\@s {\n    width: 200px;\n  }\n  .width-250\\@s {\n    width: 250px;\n  }\n  .width-300\\@s {\n    width: 300px;\n  }\n}\n@media (min-width: 960px) {\n  .width-25\\@m {\n    width: 25px;\n  }\n  .width-50\\@m {\n    width: 50px;\n  }\n  .width-75\\@m {\n    width: 75px;\n  }\n  .width-100\\@m {\n    width: 100px;\n  }\n  .width-125\\@m {\n    width: 125px;\n  }\n  .width-150\\@m {\n    width: 150px;\n  }\n  .width-175\\@m {\n    width: 175px;\n  }\n  .width-185\\@m {\n    width: 185px;\n  }\n  .width-200\\@m {\n    width: 200px;\n  }\n  .width-250\\@m {\n    width: 250px;\n  }\n  .width-275\\@m {\n    width: 275px;\n  }\n  .width-300\\@m {\n    width: 300px;\n  }\n  .width-350\\@m {\n    width: 350px;\n  }\n  .width-400\\@m {\n    width: 400px;\n  }\n}\n@media (min-width: 1200px) {\n  .width-25\\@l {\n    width: 25px;\n  }\n  .width-50\\@l {\n    width: 50px;\n  }\n  .width-75\\@l {\n    width: 75px;\n  }\n  .width-100\\@l {\n    width: 100px;\n  }\n  .width-110\\@l {\n    width: 110px;\n  }\n  .width-125\\@l {\n    width: 125px;\n  }\n  .width-150\\@l {\n    width: 150px;\n  }\n  .width-175\\@l {\n    width: 175px;\n  }\n  .width-185\\@l {\n    width: 185px;\n  }\n  .width-200\\@l {\n    width: 200px;\n  }\n  .width-250\\@l {\n    width: 250px;\n  }\n  .width-275\\@l {\n    width: 275px;\n  }\n  .width-300\\@l {\n    width: 300px;\n  }\n  .width-350\\@l {\n    width: 350px;\n  }\n  .width-400\\@l {\n    width: 400px;\n  }\n}\n@media (min-width: 1600px) {\n  .width-25\\@xl {\n    width: 25px;\n  }\n  .width-50\\@xl {\n    width: 50px;\n  }\n  .width-75\\@xl {\n    width: 75px;\n  }\n  .width-100\\@xl {\n    width: 100px;\n  }\n  .width-125\\@xl {\n    width: 125px;\n  }\n  .width-150\\@xl {\n    width: 150px;\n  }\n  .width-175\\@xl {\n    width: 175px;\n  }\n  .width-185\\@xl {\n    width: 185px;\n  }\n  .width-200\\@xl {\n    width: 200px;\n  }\n  .width-250\\@xl {\n    width: 250px;\n  }\n  .width-275\\@xl {\n    width: 275px;\n  }\n  .width-300\\@xl {\n    width: 300px;\n  }\n  .width-350\\@xl {\n    width: 350px;\n  }\n  .width-400\\@xl {\n    width: 400px;\n  }\n}\n.width-12-12 {\n  width: 100%;\n}\n.width-11-12 {\n  width: 91.66666667%;\n}\n.width-10-12 {\n  width: 83.33333333%;\n}\n.width-9-12 {\n  width: 75%;\n}\n.width-8-12 {\n  width: 66.66666667%;\n}\n.width-7-12 {\n  width: 58.33333333%;\n}\n.width-6-12 {\n  width: 50%;\n}\n.width-5-12 {\n  width: 41.66666667%;\n}\n.width-4-12 {\n  width: 33.33333333%;\n}\n.width-3-12 {\n  width: 25%;\n}\n.width-2-12 {\n  width: 16.66666667%;\n}\n.width-1-12 {\n  width: 8.33333333%;\n}\n@media (min-width: 640px) {\n  .width-12-12\\@s {\n    width: 100%;\n  }\n  .width-11-12\\@s {\n    width: 91.66666667%;\n  }\n  .width-10-12\\@s {\n    width: 83.33333333%;\n  }\n  .width-9-12\\@s {\n    width: 75%;\n  }\n  .width-8-12\\@s {\n    width: 66.66666667%;\n  }\n  .width-7-12\\@s {\n    width: 58.33333333%;\n  }\n  .width-6-12\\@s {\n    width: 50%;\n  }\n  .width-5-12\\@s {\n    width: 41.66666667%;\n  }\n  .width-4-12\\@s {\n    width: 33.33333333%;\n  }\n  .width-3-12\\@s {\n    width: 25%;\n  }\n  .width-2-12\\@s {\n    width: 16.66666667%;\n  }\n  .width-1-12\\@s {\n    width: 8.33333333%;\n  }\n}\n@media (min-width: 960px) {\n  .width-12-12\\@m {\n    width: 100%;\n  }\n  .width-11-12\\@m {\n    width: 91.66666667%;\n  }\n  .width-10-12\\@m {\n    width: 83.33333333%;\n  }\n  .width-9-12\\@m {\n    width: 75%;\n  }\n  .width-8-12\\@m {\n    width: 66.66666667%;\n  }\n  .width-7-12\\@m {\n    width: 58.33333333%;\n  }\n  .width-6-12\\@m {\n    width: 50%;\n  }\n  .width-5-12\\@m {\n    width: 41.66666667%;\n  }\n  .width-4-12\\@m {\n    width: 33.33333333%;\n  }\n  .width-3-12\\@m {\n    width: 25%;\n  }\n  .width-2-12\\@m {\n    width: 16.66666667%;\n  }\n  .width-1-12\\@m {\n    width: 8.33333333%;\n  }\n}\n@media (min-width: 1200px) {\n  .width-12-12\\@l {\n    width: 100%;\n  }\n  .width-11-12\\@l {\n    width: 91.66666667%;\n  }\n  .width-10-12\\@l {\n    width: 83.33333333%;\n  }\n  .width-9-12\\@l {\n    width: 75%;\n  }\n  .width-8-12\\@l {\n    width: 66.66666667%;\n  }\n  .width-7-12\\@l {\n    width: 58.33333333%;\n  }\n  .width-6-12\\@l {\n    width: 50%;\n  }\n  .width-5-12\\@l {\n    width: 41.66666667%;\n  }\n  .width-4-12\\@l {\n    width: 33.33333333%;\n  }\n  .width-3-12\\@l {\n    width: 25%;\n  }\n  .width-2-12\\@l {\n    width: 16.66666667%;\n  }\n  .width-1-12\\@l {\n    width: 8.33333333%;\n  }\n}\n@media (min-width: 1600px) {\n  .width-12-12\\@xl {\n    width: 100%;\n  }\n  .width-11-12\\@xl {\n    width: 91.66666667%;\n  }\n  .width-10-12\\@xl {\n    width: 83.33333333%;\n  }\n  .width-9-12\\@xl {\n    width: 75%;\n  }\n  .width-8-12\\@xl {\n    width: 66.66666667%;\n  }\n  .width-7-12\\@xl {\n    width: 58.33333333%;\n  }\n  .width-6-12\\@xl {\n    width: 50%;\n  }\n  .width-5-12\\@xl {\n    width: 41.66666667%;\n  }\n  .width-4-12\\@xl {\n    width: 33.33333333%;\n  }\n  .width-3-12\\@xl {\n    width: 25%;\n  }\n  .width-2-12\\@xl {\n    width: 16.66666667%;\n  }\n  .width-1-12\\@xl {\n    width: 8.33333333%;\n  }\n}\n.width-20-20 {\n  width: 100%;\n}\n.width-19-20 {\n  width: 95%;\n}\n.width-18-20 {\n  width: 90%;\n}\n.width-17-20 {\n  width: 85%;\n}\n.width-16-20 {\n  width: 80%;\n}\n.width-15-20 {\n  width: 75%;\n}\n.width-14-20 {\n  width: 70%;\n}\n.width-13-20 {\n  width: 65%;\n}\n.width-12-20 {\n  width: 60%;\n}\n.width-11-20 {\n  width: 55%;\n}\n.width-10-20 {\n  width: 50%;\n}\n.width-9-20 {\n  width: 45%;\n}\n.width-8-20 {\n  width: 40%;\n}\n.width-7-20 {\n  width: 35%;\n}\n.width-6-20 {\n  width: 30%;\n}\n.width-5-20 {\n  width: 25%;\n}\n.width-4-20 {\n  width: 20%;\n}\n.width-3-20 {\n  width: 15%;\n}\n.width-2-20 {\n  width: 10%;\n}\n.width-1-20 {\n  width: 5%;\n}\n@media (min-width: 640px) {\n  .width-20-20\\@s {\n    width: 100%;\n  }\n  .width-19-20\\@s {\n    width: 95%;\n  }\n  .width-18-20\\@s {\n    width: 90%;\n  }\n  .width-17-20\\@s {\n    width: 85%;\n  }\n  .width-16-20\\@s {\n    width: 80%;\n  }\n  .width-15-20\\@s {\n    width: 75%;\n  }\n  .width-14-20\\@s {\n    width: 70%;\n  }\n  .width-13-20\\@s {\n    width: 65%;\n  }\n  .width-12-20\\@s {\n    width: 60%;\n  }\n  .width-11-20\\@s {\n    width: 55%;\n  }\n  .width-10-20\\@s {\n    width: 50%;\n  }\n  .width-9-20\\@s {\n    width: 45%;\n  }\n  .width-8-20\\@s {\n    width: 40%;\n  }\n  .width-7-20\\@s {\n    width: 35%;\n  }\n  .width-6-20\\@s {\n    width: 30%;\n  }\n  .width-5-20\\@s {\n    width: 25%;\n  }\n  .width-4-20\\@s {\n    width: 20%;\n  }\n  .width-3-20\\@s {\n    width: 15%;\n  }\n  .width-2-20\\@s {\n    width: 10%;\n  }\n  .width-1-20\\@s {\n    width: 5%;\n  }\n}\n@media (min-width: 960px) {\n  .width-20-20\\@m {\n    width: 100%;\n  }\n  .width-19-20\\@m {\n    width: 95%;\n  }\n  .width-18-20\\@m {\n    width: 90%;\n  }\n  .width-17-20\\@m {\n    width: 85%;\n  }\n  .width-16-20\\@m {\n    width: 80%;\n  }\n  .width-15-20\\@m {\n    width: 75%;\n  }\n  .width-14-20\\@m {\n    width: 70%;\n  }\n  .width-13-20\\@m {\n    width: 65%;\n  }\n  .width-12-20\\@m {\n    width: 60%;\n  }\n  .width-11-20\\@m {\n    width: 55%;\n  }\n  .width-10-20\\@m {\n    width: 50%;\n  }\n  .width-9-20\\@m {\n    width: 45%;\n  }\n  .width-8-20\\@m {\n    width: 40%;\n  }\n  .width-7-20\\@m {\n    width: 35%;\n  }\n  .width-6-20\\@m {\n    width: 30%;\n  }\n  .width-5-20\\@m {\n    width: 25%;\n  }\n  .width-4-20\\@m {\n    width: 20%;\n  }\n  .width-3-20\\@m {\n    width: 15%;\n  }\n  .width-2-20\\@m {\n    width: 10%;\n  }\n  .width-1-20\\@m {\n    width: 5%;\n  }\n}\n@media (min-width: 1200px) {\n  .width-20-20\\@l {\n    width: 100%;\n  }\n  .width-19-20\\@l {\n    width: 95%;\n  }\n  .width-18-20\\@l {\n    width: 90%;\n  }\n  .width-17-20\\@l {\n    width: 85%;\n  }\n  .width-16-20\\@l {\n    width: 80%;\n  }\n  .width-15-20\\@l {\n    width: 75%;\n  }\n  .width-14-20\\@l {\n    width: 70%;\n  }\n  .width-13-20\\@l {\n    width: 65%;\n  }\n  .width-12-20\\@l {\n    width: 60%;\n  }\n  .width-11-20\\@l {\n    width: 55%;\n  }\n  .width-10-20\\@l {\n    width: 50%;\n  }\n  .width-9-20\\@l {\n    width: 45%;\n  }\n  .width-8-20\\@l {\n    width: 40%;\n  }\n  .width-7-20\\@l {\n    width: 35%;\n  }\n  .width-6-20\\@l {\n    width: 30%;\n  }\n  .width-5-20\\@l {\n    width: 25%;\n  }\n  .width-4-20\\@l {\n    width: 20%;\n  }\n  .width-3-20\\@l {\n    width: 15%;\n  }\n  .width-2-20\\@l {\n    width: 10%;\n  }\n  .width-1-20\\@l {\n    width: 5%;\n  }\n}\n@media (min-width: 1600px) {\n  .width-20-20\\@xl {\n    width: 100%;\n  }\n  .width-19-20\\@xl {\n    width: 95%;\n  }\n  .width-18-20\\@xl {\n    width: 90%;\n  }\n  .width-17-20\\@xl {\n    width: 85%;\n  }\n  .width-16-20\\@xl {\n    width: 80%;\n  }\n  .width-15-20\\@xl {\n    width: 75%;\n  }\n  .width-14-20\\@xl {\n    width: 70%;\n  }\n  .width-13-20\\@xl {\n    width: 65%;\n  }\n  .width-12-20\\@xl {\n    width: 60%;\n  }\n  .width-11-20\\@xl {\n    width: 55%;\n  }\n  .width-10-20\\@xl {\n    width: 50%;\n  }\n  .width-9-20\\@xl {\n    width: 45%;\n  }\n  .width-8-20\\@xl {\n    width: 40%;\n  }\n  .width-7-20\\@xl {\n    width: 35%;\n  }\n  .width-6-20\\@xl {\n    width: 30%;\n  }\n  .width-5-20\\@xl {\n    width: 25%;\n  }\n  .width-4-20\\@xl {\n    width: 20%;\n  }\n  .width-3-20\\@xl {\n    width: 15%;\n  }\n  .width-2-20\\@xl {\n    width: 10%;\n  }\n  .width-1-20\\@xl {\n    width: 5%;\n  }\n}\n.botao-excel {\n  background-color: #007F00 !important;\n  white-space: nowrap;\n  color: white !important;\n}\n.botao-excel:hover {\n  background-color: #33a033 !important;\n}\n.botao-excel .icone-excel {\n  display: inline-block;\n  width: 17px !important;\n  height: 17px !important;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(../../styles/images/excel-branco.svg) !important;\n  margin-right: 5px;\n  float: left;\n}\n.botao-pdf {\n  background-color: #B30B00 !important;\n  white-space: nowrap;\n  color: white !important;\n}\n.botao-pdf:hover {\n  background-color: #c7160a !important;\n}\n.botao-pdf .icone-pdf {\n  font-size: 0.9em;\n  margin-right: 2px;\n}\n.ghost {\n  opacity: 0.4;\n  background-color: #f0f0f0;\n  border: 1px dashed #ccc;\n}\n.dragging {\n  opacity: 0;\n}\n.button-ia {\n  padding: 4px 6px !important;\n  margin: 0 5px 2px 5px;\n  font-size: 0.75rem !important;\n  line-height: 1 !important;\n  min-height: auto !important;\n  border-radius: 3px !important;\n  background-color: #222 !important;\n  color: white;\n  border: 1px solid transparent;\n  opacity: 0.5;\n}\n.button-ia:hover {\n  opacity: 1;\n}\n.button-ia {\n  padding: 4px 6px !important;\n  margin: 0 5px 2px 5px;\n  font-size: 0.75rem !important;\n  line-height: 1 !important;\n  min-height: auto !important;\n  border-radius: 3px !important;\n  background-color: #222 !important;\n  color: white;\n  border: 1px solid transparent;\n  opacity: 0.5;\n}\n.options-menu {\n  max-width: 125px !important;\n  min-width: 125px !important;\n  width: 125px !important;\n}\nhtml {\n  color: black;\n}\nbody {\n  background-color: #F2F2F2;\n}\n.uk-form-controls.error > .uk-icon {\n  padding-bottom: 18px;\n}\n.banner-ambiente {\n  position: fixed;\n  top: 0;\n  background-color: #003768;\n  color: white;\n  padding: 5px 10px;\n  font-weight: bold;\n  font-size: 12px;\n  width: 25%;\n  border-radius: 0 0 25px 25px;\n}\n.banner-ambiente .uk-icon {\n  color: white;\n}\n@media (max-width: 1199px) {\n  .banner-ambiente {\n    position: static;\n    box-sizing: border-box;\n    border-radius: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  }\n}\n.info-container.uk-navbar-right {\n  gap: 0;\n}\n.info-container .info-data-text {\n  font-weight: bold;\n}\n.uk-button-primary {\n  background-color: #003768;\n}\n.uk-button-primary:hover,\n.uk-button-primary:active {\n  background-color: #003768;\n}\n.uk-button-secundary {\n  color: white;\n  background-color: #b4b4b4;\n}\n.uk-button-secundary:hover,\n.uk-button-secundary:active {\n  background-color: #969696;\n}\n.chart-button {\n  background-color: #ff9d53;\n}\n.chart-button:hover,\n.chart-button:active {\n  background-color: #d88647;\n}\n.uk-offcanvas-bar .uk-nav {\n  z-index: 2;\n}\n.uk-heading-divider {\n  border-bottom: 1.5px solid #003768;\n}\n.border-vertical {\n  border-bottom: 1px solid #e5e5e5;\n  border-top: 1px solid #e5e5e5;\n}\n.esfera-alerta {\n  width: 10px;\n  height: 10px;\n  background-color: #ff0066;\n  border-radius: 50%;\n  display: inline-block;\n}\n.border-bottom {\n  border-bottom: 1px solid #e5e5e5;\n}\n.label-muted {\n  background-color: #f8f8f8;\n  color: #666;\n}\n.scroll-up {\n  position: fixed;\n  bottom: 5%;\n  right: 5%;\n  z-index: 9999;\n}\n.uk-tab > li > a {\n  padding-bottom: 13px;\n}\n.uk-subnav-pill > .uk-active > a {\n  background-color: #003768;\n  color: #fff;\n  font-weight: bolder;\n}\n.uk-subnav-pill > * > :first-child {\n  padding: 5px 10px;\n  background: 0 0;\n  color: #666;\n  border-color: #b2b2b2;\n}\n.uk-button-height {\n  line-height: 25px;\n  border-color: #b2b2b2;\n  color: #666;\n}\n.uk-button-height:hover {\n  background-color: #f8f8f8;\n  color: #666;\n}\n.label-neutral {\n  background-color: #b2b2b2;\n  color: #fff;\n}\n.ui-datepicker {\n  z-index: 1000 !important;\n}\n.uk-tab > .uk-active > a {\n  border-color: #003768;\n}\n.botao-danger {\n  background-color: transparent !important;\n  color: #f0506e !important;\n  border: 1px solid #f0506e !important;\n}\n@media (max-width: 400px) {\n  .response-button-inputs > div {\n    width: 100%;\n    padding-bottom: 3px;\n  }\n  .response-button-inputs > div > * {\n    width: 100%;\n  }\n  .text-nowrap\\@s {\n    white-space: normal !important;\n  }\n}\n@media (min-width: 640px) {\n  .padding-small-right\\@s {\n    padding-right: 15px;\n  }\n}\n@media (max-width: 680px) {\n  .uk-container {\n    padding: 0 !important;\n  }\n  .response-button-inputs > div {\n    padding-bottom: 3px;\n  }\n}\n@media (min-width: 960px) {\n  .padding-small-left\\@m {\n    padding-left: 30px;\n  }\n}\n@media (min-width: 1200px) {\n  .uk-text-normal\\@l {\n    font-weight: 400;\n  }\n  .padding-large-left\\@l {\n    padding-left: 50px;\n  }\n  .padding-large-right\\@l {\n    padding-right: 50px;\n  }\n}\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.spin {\n  animation: spin 1s linear infinite;\n}\na[disabled] {\n  pointer-events: none;\n  cursor: default;\n  color: #999;\n}\n.uk-modal-title {\n  font-size: 22px;\n}\nselect[readonly] {\n  background: #f8f8f8;\n  pointer-events: none;\n  touch-action: none;\n}\ninput[readonly] {\n  background: #f8f8f8;\n}\n.uk-form-label,\n.uk-description-list > dt {\n  font-weight: 700;\n  color: #003768;\n}\n.uk-table th {\n  font-weight: 700;\n  color: #003768;\n  text-transform: none;\n}\n.uk-card-title,\n.uk-card-default,\n.uk-tab > .uk-active > a,\n.uk-subnav > * > :first-child,\n.uk-input,\n.uk-select,\n.uk-textarea,\n.uk-select:not([multiple]):not([size]) option,\n.uk-input:disabled,\n.uk-select:disabled,\n.uk-textarea:disabled,\n.uk-input:focus,\n.uk-select:focus,\n.uk-textarea:focus {\n  color: black;\n}\n.uk-tab > * > a {\n  color: #303030;\n}\n.uk-description-list > dt {\n  color: #003768;\n  font-size: 1rem;\n  font-weight: 500;\n  text-transform: none;\n  margin-bottom: 4px;\n}\n.uk-description-list > dd {\n  color: black;\n  background-color: #fbfbfb;\n  border: 1px solid #e5e5e5;\n  padding: 10px;\n}\n.uk-dropdown-nav > li > a {\n  color: black;\n}\n.uk-dropdown-nav > li:hover > a {\n  color: #003768;\n}\n.uk-notification {\n  z-index: 99999;\n}\n.uk-form-label,\n.uk-description-list > dt {\n  font-weight: 700;\n  color: #003768;\n}\n.uk-table th {\n  font-weight: 700;\n  color: #003768;\n  text-transform: none;\n}\n.uk-card-title,\n.uk-card-default,\n.uk-tab > .uk-active > a,\n.uk-subnav > * > :first-child,\n.uk-input,\n.uk-select,\n.uk-textarea,\n.uk-select:not([multiple]):not([size]) option,\n.uk-input:disabled,\n.uk-select:disabled,\n.uk-textarea:disabled,\n.uk-input:focus,\n.uk-select:focus,\n.uk-textarea:focus {\n  color: black;\n}\n.uk-tab > * > a {\n  color: #303030;\n}\n.uk-description-list > dt {\n  color: #003768;\n  font-size: 1rem;\n  font-weight: 500;\n  text-transform: none;\n  margin-bottom: 4px;\n}\n.uk-description-list > dd {\n  color: black;\n  background-color: #fbfbfb;\n  border: 1px solid #e5e5e5;\n  padding: 10px;\n}\n.uk-dropdown-nav > li > a {\n  color: black;\n}\n.uk-dropdown-nav > li:hover > a {\n  color: #003768;\n}\n/*\n.logo-tf {\n    height: 140px;\n    width: 173px;\n    background-image: url(./images/logo.gif);\n    background-size: 100%;\n    background-repeat: no-repeat;\n    background-position: 50%;\n}\n*/\n","/*!\n * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com\n * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)\n * Copyright 2024 Fonticons, Inc.\n */\n.fa {\n  font-family: var(--fa-style-family, \"Font Awesome 6 Free\");\n  font-weight: var(--fa-style, 900); }\n\n.fas,\n.far,\n.fab,\n.fa-solid,\n.fa-regular,\n.fa-brands,\n.fa {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: var(--fa-display, inline-block);\n  font-style: normal;\n  font-variant: normal;\n  line-height: 1;\n  text-rendering: auto; }\n\n.fas::before,\n.far::before,\n.fab::before,\n.fa-solid::before,\n.fa-regular::before,\n.fa-brands::before,\n.fa::before {\n  content: var(--fa); }\n\n.fa-classic,\n.fas,\n.fa-solid,\n.far,\n.fa-regular {\n  font-family: 'Font Awesome 6 Free'; }\n\n.fa-brands,\n.fab {\n  font-family: 'Font Awesome 6 Brands'; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em; }\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.08333em;\n  vertical-align: 0.125em; }\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.07143em;\n  vertical-align: 0.05357em; }\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em; }\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.04167em;\n  vertical-align: -0.125em; }\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit; }\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em); }\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em); }\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em); }\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out); }\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1)); }\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1)); }\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1)); }\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out); }\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear); }\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear); }\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse; }\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8)); }\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n  .fa-bounce,\n  .fa-fade,\n  .fa-beat-fade,\n  .fa-flip,\n  .fa-pulse,\n  .fa-shake,\n  .fa-spin,\n  .fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s; } }\n\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1); }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25)); } }\n\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0); }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0); }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em)); }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0); }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em)); }\n  64% {\n    transform: scale(1, 1) translateY(0); }\n  100% {\n    transform: scale(1, 1) translateY(0); } }\n\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4); } }\n\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1); }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125)); } }\n\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg)); } }\n\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg); }\n  4% {\n    transform: rotate(15deg); }\n  8%, 24% {\n    transform: rotate(-18deg); }\n  12%, 28% {\n    transform: rotate(18deg); }\n  16% {\n    transform: rotate(-22deg); }\n  20% {\n    transform: rotate(22deg); }\n  32% {\n    transform: rotate(-12deg); }\n  36% {\n    transform: rotate(12deg); }\n  40%, 100% {\n    transform: rotate(0deg); } }\n\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  transform: scale(1, -1); }\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1); }\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0)); }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%;\n  z-index: var(--fa-stack-z-index, auto); }\n\n.fa-stack-1x {\n  line-height: inherit; }\n\n.fa-stack-2x {\n  font-size: 2em; }\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff); }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n\n.fa-0 {\n  --fa: \"\\30\"; }\n\n.fa-1 {\n  --fa: \"\\31\"; }\n\n.fa-2 {\n  --fa: \"\\32\"; }\n\n.fa-3 {\n  --fa: \"\\33\"; }\n\n.fa-4 {\n  --fa: \"\\34\"; }\n\n.fa-5 {\n  --fa: \"\\35\"; }\n\n.fa-6 {\n  --fa: \"\\36\"; }\n\n.fa-7 {\n  --fa: \"\\37\"; }\n\n.fa-8 {\n  --fa: \"\\38\"; }\n\n.fa-9 {\n  --fa: \"\\39\"; }\n\n.fa-fill-drip {\n  --fa: \"\\f576\"; }\n\n.fa-arrows-to-circle {\n  --fa: \"\\e4bd\"; }\n\n.fa-circle-chevron-right {\n  --fa: \"\\f138\"; }\n\n.fa-chevron-circle-right {\n  --fa: \"\\f138\"; }\n\n.fa-at {\n  --fa: \"\\40\"; }\n\n.fa-trash-can {\n  --fa: \"\\f2ed\"; }\n\n.fa-trash-alt {\n  --fa: \"\\f2ed\"; }\n\n.fa-text-height {\n  --fa: \"\\f034\"; }\n\n.fa-user-xmark {\n  --fa: \"\\f235\"; }\n\n.fa-user-times {\n  --fa: \"\\f235\"; }\n\n.fa-stethoscope {\n  --fa: \"\\f0f1\"; }\n\n.fa-message {\n  --fa: \"\\f27a\"; }\n\n.fa-comment-alt {\n  --fa: \"\\f27a\"; }\n\n.fa-info {\n  --fa: \"\\f129\"; }\n\n.fa-down-left-and-up-right-to-center {\n  --fa: \"\\f422\"; }\n\n.fa-compress-alt {\n  --fa: \"\\f422\"; }\n\n.fa-explosion {\n  --fa: \"\\e4e9\"; }\n\n.fa-file-lines {\n  --fa: \"\\f15c\"; }\n\n.fa-file-alt {\n  --fa: \"\\f15c\"; }\n\n.fa-file-text {\n  --fa: \"\\f15c\"; }\n\n.fa-wave-square {\n  --fa: \"\\f83e\"; }\n\n.fa-ring {\n  --fa: \"\\f70b\"; }\n\n.fa-building-un {\n  --fa: \"\\e4d9\"; }\n\n.fa-dice-three {\n  --fa: \"\\f527\"; }\n\n.fa-calendar-days {\n  --fa: \"\\f073\"; }\n\n.fa-calendar-alt {\n  --fa: \"\\f073\"; }\n\n.fa-anchor-circle-check {\n  --fa: \"\\e4aa\"; }\n\n.fa-building-circle-arrow-right {\n  --fa: \"\\e4d1\"; }\n\n.fa-volleyball {\n  --fa: \"\\f45f\"; }\n\n.fa-volleyball-ball {\n  --fa: \"\\f45f\"; }\n\n.fa-arrows-up-to-line {\n  --fa: \"\\e4c2\"; }\n\n.fa-sort-down {\n  --fa: \"\\f0dd\"; }\n\n.fa-sort-desc {\n  --fa: \"\\f0dd\"; }\n\n.fa-circle-minus {\n  --fa: \"\\f056\"; }\n\n.fa-minus-circle {\n  --fa: \"\\f056\"; }\n\n.fa-door-open {\n  --fa: \"\\f52b\"; }\n\n.fa-right-from-bracket {\n  --fa: \"\\f2f5\"; }\n\n.fa-sign-out-alt {\n  --fa: \"\\f2f5\"; }\n\n.fa-atom {\n  --fa: \"\\f5d2\"; }\n\n.fa-soap {\n  --fa: \"\\e06e\"; }\n\n.fa-icons {\n  --fa: \"\\f86d\"; }\n\n.fa-heart-music-camera-bolt {\n  --fa: \"\\f86d\"; }\n\n.fa-microphone-lines-slash {\n  --fa: \"\\f539\"; }\n\n.fa-microphone-alt-slash {\n  --fa: \"\\f539\"; }\n\n.fa-bridge-circle-check {\n  --fa: \"\\e4c9\"; }\n\n.fa-pump-medical {\n  --fa: \"\\e06a\"; }\n\n.fa-fingerprint {\n  --fa: \"\\f577\"; }\n\n.fa-hand-point-right {\n  --fa: \"\\f0a4\"; }\n\n.fa-magnifying-glass-location {\n  --fa: \"\\f689\"; }\n\n.fa-search-location {\n  --fa: \"\\f689\"; }\n\n.fa-forward-step {\n  --fa: \"\\f051\"; }\n\n.fa-step-forward {\n  --fa: \"\\f051\"; }\n\n.fa-face-smile-beam {\n  --fa: \"\\f5b8\"; }\n\n.fa-smile-beam {\n  --fa: \"\\f5b8\"; }\n\n.fa-flag-checkered {\n  --fa: \"\\f11e\"; }\n\n.fa-football {\n  --fa: \"\\f44e\"; }\n\n.fa-football-ball {\n  --fa: \"\\f44e\"; }\n\n.fa-school-circle-exclamation {\n  --fa: \"\\e56c\"; }\n\n.fa-crop {\n  --fa: \"\\f125\"; }\n\n.fa-angles-down {\n  --fa: \"\\f103\"; }\n\n.fa-angle-double-down {\n  --fa: \"\\f103\"; }\n\n.fa-users-rectangle {\n  --fa: \"\\e594\"; }\n\n.fa-people-roof {\n  --fa: \"\\e537\"; }\n\n.fa-people-line {\n  --fa: \"\\e534\"; }\n\n.fa-beer-mug-empty {\n  --fa: \"\\f0fc\"; }\n\n.fa-beer {\n  --fa: \"\\f0fc\"; }\n\n.fa-diagram-predecessor {\n  --fa: \"\\e477\"; }\n\n.fa-arrow-up-long {\n  --fa: \"\\f176\"; }\n\n.fa-long-arrow-up {\n  --fa: \"\\f176\"; }\n\n.fa-fire-flame-simple {\n  --fa: \"\\f46a\"; }\n\n.fa-burn {\n  --fa: \"\\f46a\"; }\n\n.fa-person {\n  --fa: \"\\f183\"; }\n\n.fa-male {\n  --fa: \"\\f183\"; }\n\n.fa-laptop {\n  --fa: \"\\f109\"; }\n\n.fa-file-csv {\n  --fa: \"\\f6dd\"; }\n\n.fa-menorah {\n  --fa: \"\\f676\"; }\n\n.fa-truck-plane {\n  --fa: \"\\e58f\"; }\n\n.fa-record-vinyl {\n  --fa: \"\\f8d9\"; }\n\n.fa-face-grin-stars {\n  --fa: \"\\f587\"; }\n\n.fa-grin-stars {\n  --fa: \"\\f587\"; }\n\n.fa-bong {\n  --fa: \"\\f55c\"; }\n\n.fa-spaghetti-monster-flying {\n  --fa: \"\\f67b\"; }\n\n.fa-pastafarianism {\n  --fa: \"\\f67b\"; }\n\n.fa-arrow-down-up-across-line {\n  --fa: \"\\e4af\"; }\n\n.fa-spoon {\n  --fa: \"\\f2e5\"; }\n\n.fa-utensil-spoon {\n  --fa: \"\\f2e5\"; }\n\n.fa-jar-wheat {\n  --fa: \"\\e517\"; }\n\n.fa-envelopes-bulk {\n  --fa: \"\\f674\"; }\n\n.fa-mail-bulk {\n  --fa: \"\\f674\"; }\n\n.fa-file-circle-exclamation {\n  --fa: \"\\e4eb\"; }\n\n.fa-circle-h {\n  --fa: \"\\f47e\"; }\n\n.fa-hospital-symbol {\n  --fa: \"\\f47e\"; }\n\n.fa-pager {\n  --fa: \"\\f815\"; }\n\n.fa-address-book {\n  --fa: \"\\f2b9\"; }\n\n.fa-contact-book {\n  --fa: \"\\f2b9\"; }\n\n.fa-strikethrough {\n  --fa: \"\\f0cc\"; }\n\n.fa-k {\n  --fa: \"\\4b\"; }\n\n.fa-landmark-flag {\n  --fa: \"\\e51c\"; }\n\n.fa-pencil {\n  --fa: \"\\f303\"; }\n\n.fa-pencil-alt {\n  --fa: \"\\f303\"; }\n\n.fa-backward {\n  --fa: \"\\f04a\"; }\n\n.fa-caret-right {\n  --fa: \"\\f0da\"; }\n\n.fa-comments {\n  --fa: \"\\f086\"; }\n\n.fa-paste {\n  --fa: \"\\f0ea\"; }\n\n.fa-file-clipboard {\n  --fa: \"\\f0ea\"; }\n\n.fa-code-pull-request {\n  --fa: \"\\e13c\"; }\n\n.fa-clipboard-list {\n  --fa: \"\\f46d\"; }\n\n.fa-truck-ramp-box {\n  --fa: \"\\f4de\"; }\n\n.fa-truck-loading {\n  --fa: \"\\f4de\"; }\n\n.fa-user-check {\n  --fa: \"\\f4fc\"; }\n\n.fa-vial-virus {\n  --fa: \"\\e597\"; }\n\n.fa-sheet-plastic {\n  --fa: \"\\e571\"; }\n\n.fa-blog {\n  --fa: \"\\f781\"; }\n\n.fa-user-ninja {\n  --fa: \"\\f504\"; }\n\n.fa-person-arrow-up-from-line {\n  --fa: \"\\e539\"; }\n\n.fa-scroll-torah {\n  --fa: \"\\f6a0\"; }\n\n.fa-torah {\n  --fa: \"\\f6a0\"; }\n\n.fa-broom-ball {\n  --fa: \"\\f458\"; }\n\n.fa-quidditch {\n  --fa: \"\\f458\"; }\n\n.fa-quidditch-broom-ball {\n  --fa: \"\\f458\"; }\n\n.fa-toggle-off {\n  --fa: \"\\f204\"; }\n\n.fa-box-archive {\n  --fa: \"\\f187\"; }\n\n.fa-archive {\n  --fa: \"\\f187\"; }\n\n.fa-person-drowning {\n  --fa: \"\\e545\"; }\n\n.fa-arrow-down-9-1 {\n  --fa: \"\\f886\"; }\n\n.fa-sort-numeric-desc {\n  --fa: \"\\f886\"; }\n\n.fa-sort-numeric-down-alt {\n  --fa: \"\\f886\"; }\n\n.fa-face-grin-tongue-squint {\n  --fa: \"\\f58a\"; }\n\n.fa-grin-tongue-squint {\n  --fa: \"\\f58a\"; }\n\n.fa-spray-can {\n  --fa: \"\\f5bd\"; }\n\n.fa-truck-monster {\n  --fa: \"\\f63b\"; }\n\n.fa-w {\n  --fa: \"\\57\"; }\n\n.fa-earth-africa {\n  --fa: \"\\f57c\"; }\n\n.fa-globe-africa {\n  --fa: \"\\f57c\"; }\n\n.fa-rainbow {\n  --fa: \"\\f75b\"; }\n\n.fa-circle-notch {\n  --fa: \"\\f1ce\"; }\n\n.fa-tablet-screen-button {\n  --fa: \"\\f3fa\"; }\n\n.fa-tablet-alt {\n  --fa: \"\\f3fa\"; }\n\n.fa-paw {\n  --fa: \"\\f1b0\"; }\n\n.fa-cloud {\n  --fa: \"\\f0c2\"; }\n\n.fa-trowel-bricks {\n  --fa: \"\\e58a\"; }\n\n.fa-face-flushed {\n  --fa: \"\\f579\"; }\n\n.fa-flushed {\n  --fa: \"\\f579\"; }\n\n.fa-hospital-user {\n  --fa: \"\\f80d\"; }\n\n.fa-tent-arrow-left-right {\n  --fa: \"\\e57f\"; }\n\n.fa-gavel {\n  --fa: \"\\f0e3\"; }\n\n.fa-legal {\n  --fa: \"\\f0e3\"; }\n\n.fa-binoculars {\n  --fa: \"\\f1e5\"; }\n\n.fa-microphone-slash {\n  --fa: \"\\f131\"; }\n\n.fa-box-tissue {\n  --fa: \"\\e05b\"; }\n\n.fa-motorcycle {\n  --fa: \"\\f21c\"; }\n\n.fa-bell-concierge {\n  --fa: \"\\f562\"; }\n\n.fa-concierge-bell {\n  --fa: \"\\f562\"; }\n\n.fa-pen-ruler {\n  --fa: \"\\f5ae\"; }\n\n.fa-pencil-ruler {\n  --fa: \"\\f5ae\"; }\n\n.fa-people-arrows {\n  --fa: \"\\e068\"; }\n\n.fa-people-arrows-left-right {\n  --fa: \"\\e068\"; }\n\n.fa-mars-and-venus-burst {\n  --fa: \"\\e523\"; }\n\n.fa-square-caret-right {\n  --fa: \"\\f152\"; }\n\n.fa-caret-square-right {\n  --fa: \"\\f152\"; }\n\n.fa-scissors {\n  --fa: \"\\f0c4\"; }\n\n.fa-cut {\n  --fa: \"\\f0c4\"; }\n\n.fa-sun-plant-wilt {\n  --fa: \"\\e57a\"; }\n\n.fa-toilets-portable {\n  --fa: \"\\e584\"; }\n\n.fa-hockey-puck {\n  --fa: \"\\f453\"; }\n\n.fa-table {\n  --fa: \"\\f0ce\"; }\n\n.fa-magnifying-glass-arrow-right {\n  --fa: \"\\e521\"; }\n\n.fa-tachograph-digital {\n  --fa: \"\\f566\"; }\n\n.fa-digital-tachograph {\n  --fa: \"\\f566\"; }\n\n.fa-users-slash {\n  --fa: \"\\e073\"; }\n\n.fa-clover {\n  --fa: \"\\e139\"; }\n\n.fa-reply {\n  --fa: \"\\f3e5\"; }\n\n.fa-mail-reply {\n  --fa: \"\\f3e5\"; }\n\n.fa-star-and-crescent {\n  --fa: \"\\f699\"; }\n\n.fa-house-fire {\n  --fa: \"\\e50c\"; }\n\n.fa-square-minus {\n  --fa: \"\\f146\"; }\n\n.fa-minus-square {\n  --fa: \"\\f146\"; }\n\n.fa-helicopter {\n  --fa: \"\\f533\"; }\n\n.fa-compass {\n  --fa: \"\\f14e\"; }\n\n.fa-square-caret-down {\n  --fa: \"\\f150\"; }\n\n.fa-caret-square-down {\n  --fa: \"\\f150\"; }\n\n.fa-file-circle-question {\n  --fa: \"\\e4ef\"; }\n\n.fa-laptop-code {\n  --fa: \"\\f5fc\"; }\n\n.fa-swatchbook {\n  --fa: \"\\f5c3\"; }\n\n.fa-prescription-bottle {\n  --fa: \"\\f485\"; }\n\n.fa-bars {\n  --fa: \"\\f0c9\"; }\n\n.fa-navicon {\n  --fa: \"\\f0c9\"; }\n\n.fa-people-group {\n  --fa: \"\\e533\"; }\n\n.fa-hourglass-end {\n  --fa: \"\\f253\"; }\n\n.fa-hourglass-3 {\n  --fa: \"\\f253\"; }\n\n.fa-heart-crack {\n  --fa: \"\\f7a9\"; }\n\n.fa-heart-broken {\n  --fa: \"\\f7a9\"; }\n\n.fa-square-up-right {\n  --fa: \"\\f360\"; }\n\n.fa-external-link-square-alt {\n  --fa: \"\\f360\"; }\n\n.fa-face-kiss-beam {\n  --fa: \"\\f597\"; }\n\n.fa-kiss-beam {\n  --fa: \"\\f597\"; }\n\n.fa-film {\n  --fa: \"\\f008\"; }\n\n.fa-ruler-horizontal {\n  --fa: \"\\f547\"; }\n\n.fa-people-robbery {\n  --fa: \"\\e536\"; }\n\n.fa-lightbulb {\n  --fa: \"\\f0eb\"; }\n\n.fa-caret-left {\n  --fa: \"\\f0d9\"; }\n\n.fa-circle-exclamation {\n  --fa: \"\\f06a\"; }\n\n.fa-exclamation-circle {\n  --fa: \"\\f06a\"; }\n\n.fa-school-circle-xmark {\n  --fa: \"\\e56d\"; }\n\n.fa-arrow-right-from-bracket {\n  --fa: \"\\f08b\"; }\n\n.fa-sign-out {\n  --fa: \"\\f08b\"; }\n\n.fa-circle-chevron-down {\n  --fa: \"\\f13a\"; }\n\n.fa-chevron-circle-down {\n  --fa: \"\\f13a\"; }\n\n.fa-unlock-keyhole {\n  --fa: \"\\f13e\"; }\n\n.fa-unlock-alt {\n  --fa: \"\\f13e\"; }\n\n.fa-cloud-showers-heavy {\n  --fa: \"\\f740\"; }\n\n.fa-headphones-simple {\n  --fa: \"\\f58f\"; }\n\n.fa-headphones-alt {\n  --fa: \"\\f58f\"; }\n\n.fa-sitemap {\n  --fa: \"\\f0e8\"; }\n\n.fa-circle-dollar-to-slot {\n  --fa: \"\\f4b9\"; }\n\n.fa-donate {\n  --fa: \"\\f4b9\"; }\n\n.fa-memory {\n  --fa: \"\\f538\"; }\n\n.fa-road-spikes {\n  --fa: \"\\e568\"; }\n\n.fa-fire-burner {\n  --fa: \"\\e4f1\"; }\n\n.fa-flag {\n  --fa: \"\\f024\"; }\n\n.fa-hanukiah {\n  --fa: \"\\f6e6\"; }\n\n.fa-feather {\n  --fa: \"\\f52d\"; }\n\n.fa-volume-low {\n  --fa: \"\\f027\"; }\n\n.fa-volume-down {\n  --fa: \"\\f027\"; }\n\n.fa-comment-slash {\n  --fa: \"\\f4b3\"; }\n\n.fa-cloud-sun-rain {\n  --fa: \"\\f743\"; }\n\n.fa-compress {\n  --fa: \"\\f066\"; }\n\n.fa-wheat-awn {\n  --fa: \"\\e2cd\"; }\n\n.fa-wheat-alt {\n  --fa: \"\\e2cd\"; }\n\n.fa-ankh {\n  --fa: \"\\f644\"; }\n\n.fa-hands-holding-child {\n  --fa: \"\\e4fa\"; }\n\n.fa-asterisk {\n  --fa: \"\\2a\"; }\n\n.fa-square-check {\n  --fa: \"\\f14a\"; }\n\n.fa-check-square {\n  --fa: \"\\f14a\"; }\n\n.fa-peseta-sign {\n  --fa: \"\\e221\"; }\n\n.fa-heading {\n  --fa: \"\\f1dc\"; }\n\n.fa-header {\n  --fa: \"\\f1dc\"; }\n\n.fa-ghost {\n  --fa: \"\\f6e2\"; }\n\n.fa-list {\n  --fa: \"\\f03a\"; }\n\n.fa-list-squares {\n  --fa: \"\\f03a\"; }\n\n.fa-square-phone-flip {\n  --fa: \"\\f87b\"; }\n\n.fa-phone-square-alt {\n  --fa: \"\\f87b\"; }\n\n.fa-cart-plus {\n  --fa: \"\\f217\"; }\n\n.fa-gamepad {\n  --fa: \"\\f11b\"; }\n\n.fa-circle-dot {\n  --fa: \"\\f192\"; }\n\n.fa-dot-circle {\n  --fa: \"\\f192\"; }\n\n.fa-face-dizzy {\n  --fa: \"\\f567\"; }\n\n.fa-dizzy {\n  --fa: \"\\f567\"; }\n\n.fa-egg {\n  --fa: \"\\f7fb\"; }\n\n.fa-house-medical-circle-xmark {\n  --fa: \"\\e513\"; }\n\n.fa-campground {\n  --fa: \"\\f6bb\"; }\n\n.fa-folder-plus {\n  --fa: \"\\f65e\"; }\n\n.fa-futbol {\n  --fa: \"\\f1e3\"; }\n\n.fa-futbol-ball {\n  --fa: \"\\f1e3\"; }\n\n.fa-soccer-ball {\n  --fa: \"\\f1e3\"; }\n\n.fa-paintbrush {\n  --fa: \"\\f1fc\"; }\n\n.fa-paint-brush {\n  --fa: \"\\f1fc\"; }\n\n.fa-lock {\n  --fa: \"\\f023\"; }\n\n.fa-gas-pump {\n  --fa: \"\\f52f\"; }\n\n.fa-hot-tub-person {\n  --fa: \"\\f593\"; }\n\n.fa-hot-tub {\n  --fa: \"\\f593\"; }\n\n.fa-map-location {\n  --fa: \"\\f59f\"; }\n\n.fa-map-marked {\n  --fa: \"\\f59f\"; }\n\n.fa-house-flood-water {\n  --fa: \"\\e50e\"; }\n\n.fa-tree {\n  --fa: \"\\f1bb\"; }\n\n.fa-bridge-lock {\n  --fa: \"\\e4cc\"; }\n\n.fa-sack-dollar {\n  --fa: \"\\f81d\"; }\n\n.fa-pen-to-square {\n  --fa: \"\\f044\"; }\n\n.fa-edit {\n  --fa: \"\\f044\"; }\n\n.fa-car-side {\n  --fa: \"\\f5e4\"; }\n\n.fa-share-nodes {\n  --fa: \"\\f1e0\"; }\n\n.fa-share-alt {\n  --fa: \"\\f1e0\"; }\n\n.fa-heart-circle-minus {\n  --fa: \"\\e4ff\"; }\n\n.fa-hourglass-half {\n  --fa: \"\\f252\"; }\n\n.fa-hourglass-2 {\n  --fa: \"\\f252\"; }\n\n.fa-microscope {\n  --fa: \"\\f610\"; }\n\n.fa-sink {\n  --fa: \"\\e06d\"; }\n\n.fa-bag-shopping {\n  --fa: \"\\f290\"; }\n\n.fa-shopping-bag {\n  --fa: \"\\f290\"; }\n\n.fa-arrow-down-z-a {\n  --fa: \"\\f881\"; }\n\n.fa-sort-alpha-desc {\n  --fa: \"\\f881\"; }\n\n.fa-sort-alpha-down-alt {\n  --fa: \"\\f881\"; }\n\n.fa-mitten {\n  --fa: \"\\f7b5\"; }\n\n.fa-person-rays {\n  --fa: \"\\e54d\"; }\n\n.fa-users {\n  --fa: \"\\f0c0\"; }\n\n.fa-eye-slash {\n  --fa: \"\\f070\"; }\n\n.fa-flask-vial {\n  --fa: \"\\e4f3\"; }\n\n.fa-hand {\n  --fa: \"\\f256\"; }\n\n.fa-hand-paper {\n  --fa: \"\\f256\"; }\n\n.fa-om {\n  --fa: \"\\f679\"; }\n\n.fa-worm {\n  --fa: \"\\e599\"; }\n\n.fa-house-circle-xmark {\n  --fa: \"\\e50b\"; }\n\n.fa-plug {\n  --fa: \"\\f1e6\"; }\n\n.fa-chevron-up {\n  --fa: \"\\f077\"; }\n\n.fa-hand-spock {\n  --fa: \"\\f259\"; }\n\n.fa-stopwatch {\n  --fa: \"\\f2f2\"; }\n\n.fa-face-kiss {\n  --fa: \"\\f596\"; }\n\n.fa-kiss {\n  --fa: \"\\f596\"; }\n\n.fa-bridge-circle-xmark {\n  --fa: \"\\e4cb\"; }\n\n.fa-face-grin-tongue {\n  --fa: \"\\f589\"; }\n\n.fa-grin-tongue {\n  --fa: \"\\f589\"; }\n\n.fa-chess-bishop {\n  --fa: \"\\f43a\"; }\n\n.fa-face-grin-wink {\n  --fa: \"\\f58c\"; }\n\n.fa-grin-wink {\n  --fa: \"\\f58c\"; }\n\n.fa-ear-deaf {\n  --fa: \"\\f2a4\"; }\n\n.fa-deaf {\n  --fa: \"\\f2a4\"; }\n\n.fa-deafness {\n  --fa: \"\\f2a4\"; }\n\n.fa-hard-of-hearing {\n  --fa: \"\\f2a4\"; }\n\n.fa-road-circle-check {\n  --fa: \"\\e564\"; }\n\n.fa-dice-five {\n  --fa: \"\\f523\"; }\n\n.fa-square-rss {\n  --fa: \"\\f143\"; }\n\n.fa-rss-square {\n  --fa: \"\\f143\"; }\n\n.fa-land-mine-on {\n  --fa: \"\\e51b\"; }\n\n.fa-i-cursor {\n  --fa: \"\\f246\"; }\n\n.fa-stamp {\n  --fa: \"\\f5bf\"; }\n\n.fa-stairs {\n  --fa: \"\\e289\"; }\n\n.fa-i {\n  --fa: \"\\49\"; }\n\n.fa-hryvnia-sign {\n  --fa: \"\\f6f2\"; }\n\n.fa-hryvnia {\n  --fa: \"\\f6f2\"; }\n\n.fa-pills {\n  --fa: \"\\f484\"; }\n\n.fa-face-grin-wide {\n  --fa: \"\\f581\"; }\n\n.fa-grin-alt {\n  --fa: \"\\f581\"; }\n\n.fa-tooth {\n  --fa: \"\\f5c9\"; }\n\n.fa-v {\n  --fa: \"\\56\"; }\n\n.fa-bangladeshi-taka-sign {\n  --fa: \"\\e2e6\"; }\n\n.fa-bicycle {\n  --fa: \"\\f206\"; }\n\n.fa-staff-snake {\n  --fa: \"\\e579\"; }\n\n.fa-rod-asclepius {\n  --fa: \"\\e579\"; }\n\n.fa-rod-snake {\n  --fa: \"\\e579\"; }\n\n.fa-staff-aesculapius {\n  --fa: \"\\e579\"; }\n\n.fa-head-side-cough-slash {\n  --fa: \"\\e062\"; }\n\n.fa-truck-medical {\n  --fa: \"\\f0f9\"; }\n\n.fa-ambulance {\n  --fa: \"\\f0f9\"; }\n\n.fa-wheat-awn-circle-exclamation {\n  --fa: \"\\e598\"; }\n\n.fa-snowman {\n  --fa: \"\\f7d0\"; }\n\n.fa-mortar-pestle {\n  --fa: \"\\f5a7\"; }\n\n.fa-road-barrier {\n  --fa: \"\\e562\"; }\n\n.fa-school {\n  --fa: \"\\f549\"; }\n\n.fa-igloo {\n  --fa: \"\\f7ae\"; }\n\n.fa-joint {\n  --fa: \"\\f595\"; }\n\n.fa-angle-right {\n  --fa: \"\\f105\"; }\n\n.fa-horse {\n  --fa: \"\\f6f0\"; }\n\n.fa-q {\n  --fa: \"\\51\"; }\n\n.fa-g {\n  --fa: \"\\47\"; }\n\n.fa-notes-medical {\n  --fa: \"\\f481\"; }\n\n.fa-temperature-half {\n  --fa: \"\\f2c9\"; }\n\n.fa-temperature-2 {\n  --fa: \"\\f2c9\"; }\n\n.fa-thermometer-2 {\n  --fa: \"\\f2c9\"; }\n\n.fa-thermometer-half {\n  --fa: \"\\f2c9\"; }\n\n.fa-dong-sign {\n  --fa: \"\\e169\"; }\n\n.fa-capsules {\n  --fa: \"\\f46b\"; }\n\n.fa-poo-storm {\n  --fa: \"\\f75a\"; }\n\n.fa-poo-bolt {\n  --fa: \"\\f75a\"; }\n\n.fa-face-frown-open {\n  --fa: \"\\f57a\"; }\n\n.fa-frown-open {\n  --fa: \"\\f57a\"; }\n\n.fa-hand-point-up {\n  --fa: \"\\f0a6\"; }\n\n.fa-money-bill {\n  --fa: \"\\f0d6\"; }\n\n.fa-bookmark {\n  --fa: \"\\f02e\"; }\n\n.fa-align-justify {\n  --fa: \"\\f039\"; }\n\n.fa-umbrella-beach {\n  --fa: \"\\f5ca\"; }\n\n.fa-helmet-un {\n  --fa: \"\\e503\"; }\n\n.fa-bullseye {\n  --fa: \"\\f140\"; }\n\n.fa-bacon {\n  --fa: \"\\f7e5\"; }\n\n.fa-hand-point-down {\n  --fa: \"\\f0a7\"; }\n\n.fa-arrow-up-from-bracket {\n  --fa: \"\\e09a\"; }\n\n.fa-folder {\n  --fa: \"\\f07b\"; }\n\n.fa-folder-blank {\n  --fa: \"\\f07b\"; }\n\n.fa-file-waveform {\n  --fa: \"\\f478\"; }\n\n.fa-file-medical-alt {\n  --fa: \"\\f478\"; }\n\n.fa-radiation {\n  --fa: \"\\f7b9\"; }\n\n.fa-chart-simple {\n  --fa: \"\\e473\"; }\n\n.fa-mars-stroke {\n  --fa: \"\\f229\"; }\n\n.fa-vial {\n  --fa: \"\\f492\"; }\n\n.fa-gauge {\n  --fa: \"\\f624\"; }\n\n.fa-dashboard {\n  --fa: \"\\f624\"; }\n\n.fa-gauge-med {\n  --fa: \"\\f624\"; }\n\n.fa-tachometer-alt-average {\n  --fa: \"\\f624\"; }\n\n.fa-wand-magic-sparkles {\n  --fa: \"\\e2ca\"; }\n\n.fa-magic-wand-sparkles {\n  --fa: \"\\e2ca\"; }\n\n.fa-e {\n  --fa: \"\\45\"; }\n\n.fa-pen-clip {\n  --fa: \"\\f305\"; }\n\n.fa-pen-alt {\n  --fa: \"\\f305\"; }\n\n.fa-bridge-circle-exclamation {\n  --fa: \"\\e4ca\"; }\n\n.fa-user {\n  --fa: \"\\f007\"; }\n\n.fa-school-circle-check {\n  --fa: \"\\e56b\"; }\n\n.fa-dumpster {\n  --fa: \"\\f793\"; }\n\n.fa-van-shuttle {\n  --fa: \"\\f5b6\"; }\n\n.fa-shuttle-van {\n  --fa: \"\\f5b6\"; }\n\n.fa-building-user {\n  --fa: \"\\e4da\"; }\n\n.fa-square-caret-left {\n  --fa: \"\\f191\"; }\n\n.fa-caret-square-left {\n  --fa: \"\\f191\"; }\n\n.fa-highlighter {\n  --fa: \"\\f591\"; }\n\n.fa-key {\n  --fa: \"\\f084\"; }\n\n.fa-bullhorn {\n  --fa: \"\\f0a1\"; }\n\n.fa-globe {\n  --fa: \"\\f0ac\"; }\n\n.fa-synagogue {\n  --fa: \"\\f69b\"; }\n\n.fa-person-half-dress {\n  --fa: \"\\e548\"; }\n\n.fa-road-bridge {\n  --fa: \"\\e563\"; }\n\n.fa-location-arrow {\n  --fa: \"\\f124\"; }\n\n.fa-c {\n  --fa: \"\\43\"; }\n\n.fa-tablet-button {\n  --fa: \"\\f10a\"; }\n\n.fa-building-lock {\n  --fa: \"\\e4d6\"; }\n\n.fa-pizza-slice {\n  --fa: \"\\f818\"; }\n\n.fa-money-bill-wave {\n  --fa: \"\\f53a\"; }\n\n.fa-chart-area {\n  --fa: \"\\f1fe\"; }\n\n.fa-area-chart {\n  --fa: \"\\f1fe\"; }\n\n.fa-house-flag {\n  --fa: \"\\e50d\"; }\n\n.fa-person-circle-minus {\n  --fa: \"\\e540\"; }\n\n.fa-ban {\n  --fa: \"\\f05e\"; }\n\n.fa-cancel {\n  --fa: \"\\f05e\"; }\n\n.fa-camera-rotate {\n  --fa: \"\\e0d8\"; }\n\n.fa-spray-can-sparkles {\n  --fa: \"\\f5d0\"; }\n\n.fa-air-freshener {\n  --fa: \"\\f5d0\"; }\n\n.fa-star {\n  --fa: \"\\f005\"; }\n\n.fa-repeat {\n  --fa: \"\\f363\"; }\n\n.fa-cross {\n  --fa: \"\\f654\"; }\n\n.fa-box {\n  --fa: \"\\f466\"; }\n\n.fa-venus-mars {\n  --fa: \"\\f228\"; }\n\n.fa-arrow-pointer {\n  --fa: \"\\f245\"; }\n\n.fa-mouse-pointer {\n  --fa: \"\\f245\"; }\n\n.fa-maximize {\n  --fa: \"\\f31e\"; }\n\n.fa-expand-arrows-alt {\n  --fa: \"\\f31e\"; }\n\n.fa-charging-station {\n  --fa: \"\\f5e7\"; }\n\n.fa-shapes {\n  --fa: \"\\f61f\"; }\n\n.fa-triangle-circle-square {\n  --fa: \"\\f61f\"; }\n\n.fa-shuffle {\n  --fa: \"\\f074\"; }\n\n.fa-random {\n  --fa: \"\\f074\"; }\n\n.fa-person-running {\n  --fa: \"\\f70c\"; }\n\n.fa-running {\n  --fa: \"\\f70c\"; }\n\n.fa-mobile-retro {\n  --fa: \"\\e527\"; }\n\n.fa-grip-lines-vertical {\n  --fa: \"\\f7a5\"; }\n\n.fa-spider {\n  --fa: \"\\f717\"; }\n\n.fa-hands-bound {\n  --fa: \"\\e4f9\"; }\n\n.fa-file-invoice-dollar {\n  --fa: \"\\f571\"; }\n\n.fa-plane-circle-exclamation {\n  --fa: \"\\e556\"; }\n\n.fa-x-ray {\n  --fa: \"\\f497\"; }\n\n.fa-spell-check {\n  --fa: \"\\f891\"; }\n\n.fa-slash {\n  --fa: \"\\f715\"; }\n\n.fa-computer-mouse {\n  --fa: \"\\f8cc\"; }\n\n.fa-mouse {\n  --fa: \"\\f8cc\"; }\n\n.fa-arrow-right-to-bracket {\n  --fa: \"\\f090\"; }\n\n.fa-sign-in {\n  --fa: \"\\f090\"; }\n\n.fa-shop-slash {\n  --fa: \"\\e070\"; }\n\n.fa-store-alt-slash {\n  --fa: \"\\e070\"; }\n\n.fa-server {\n  --fa: \"\\f233\"; }\n\n.fa-virus-covid-slash {\n  --fa: \"\\e4a9\"; }\n\n.fa-shop-lock {\n  --fa: \"\\e4a5\"; }\n\n.fa-hourglass-start {\n  --fa: \"\\f251\"; }\n\n.fa-hourglass-1 {\n  --fa: \"\\f251\"; }\n\n.fa-blender-phone {\n  --fa: \"\\f6b6\"; }\n\n.fa-building-wheat {\n  --fa: \"\\e4db\"; }\n\n.fa-person-breastfeeding {\n  --fa: \"\\e53a\"; }\n\n.fa-right-to-bracket {\n  --fa: \"\\f2f6\"; }\n\n.fa-sign-in-alt {\n  --fa: \"\\f2f6\"; }\n\n.fa-venus {\n  --fa: \"\\f221\"; }\n\n.fa-passport {\n  --fa: \"\\f5ab\"; }\n\n.fa-thumbtack-slash {\n  --fa: \"\\e68f\"; }\n\n.fa-thumb-tack-slash {\n  --fa: \"\\e68f\"; }\n\n.fa-heart-pulse {\n  --fa: \"\\f21e\"; }\n\n.fa-heartbeat {\n  --fa: \"\\f21e\"; }\n\n.fa-people-carry-box {\n  --fa: \"\\f4ce\"; }\n\n.fa-people-carry {\n  --fa: \"\\f4ce\"; }\n\n.fa-temperature-high {\n  --fa: \"\\f769\"; }\n\n.fa-microchip {\n  --fa: \"\\f2db\"; }\n\n.fa-crown {\n  --fa: \"\\f521\"; }\n\n.fa-weight-hanging {\n  --fa: \"\\f5cd\"; }\n\n.fa-xmarks-lines {\n  --fa: \"\\e59a\"; }\n\n.fa-file-prescription {\n  --fa: \"\\f572\"; }\n\n.fa-weight-scale {\n  --fa: \"\\f496\"; }\n\n.fa-weight {\n  --fa: \"\\f496\"; }\n\n.fa-user-group {\n  --fa: \"\\f500\"; }\n\n.fa-user-friends {\n  --fa: \"\\f500\"; }\n\n.fa-arrow-up-a-z {\n  --fa: \"\\f15e\"; }\n\n.fa-sort-alpha-up {\n  --fa: \"\\f15e\"; }\n\n.fa-chess-knight {\n  --fa: \"\\f441\"; }\n\n.fa-face-laugh-squint {\n  --fa: \"\\f59b\"; }\n\n.fa-laugh-squint {\n  --fa: \"\\f59b\"; }\n\n.fa-wheelchair {\n  --fa: \"\\f193\"; }\n\n.fa-circle-arrow-up {\n  --fa: \"\\f0aa\"; }\n\n.fa-arrow-circle-up {\n  --fa: \"\\f0aa\"; }\n\n.fa-toggle-on {\n  --fa: \"\\f205\"; }\n\n.fa-person-walking {\n  --fa: \"\\f554\"; }\n\n.fa-walking {\n  --fa: \"\\f554\"; }\n\n.fa-l {\n  --fa: \"\\4c\"; }\n\n.fa-fire {\n  --fa: \"\\f06d\"; }\n\n.fa-bed-pulse {\n  --fa: \"\\f487\"; }\n\n.fa-procedures {\n  --fa: \"\\f487\"; }\n\n.fa-shuttle-space {\n  --fa: \"\\f197\"; }\n\n.fa-space-shuttle {\n  --fa: \"\\f197\"; }\n\n.fa-face-laugh {\n  --fa: \"\\f599\"; }\n\n.fa-laugh {\n  --fa: \"\\f599\"; }\n\n.fa-folder-open {\n  --fa: \"\\f07c\"; }\n\n.fa-heart-circle-plus {\n  --fa: \"\\e500\"; }\n\n.fa-code-fork {\n  --fa: \"\\e13b\"; }\n\n.fa-city {\n  --fa: \"\\f64f\"; }\n\n.fa-microphone-lines {\n  --fa: \"\\f3c9\"; }\n\n.fa-microphone-alt {\n  --fa: \"\\f3c9\"; }\n\n.fa-pepper-hot {\n  --fa: \"\\f816\"; }\n\n.fa-unlock {\n  --fa: \"\\f09c\"; }\n\n.fa-colon-sign {\n  --fa: \"\\e140\"; }\n\n.fa-headset {\n  --fa: \"\\f590\"; }\n\n.fa-store-slash {\n  --fa: \"\\e071\"; }\n\n.fa-road-circle-xmark {\n  --fa: \"\\e566\"; }\n\n.fa-user-minus {\n  --fa: \"\\f503\"; }\n\n.fa-mars-stroke-up {\n  --fa: \"\\f22a\"; }\n\n.fa-mars-stroke-v {\n  --fa: \"\\f22a\"; }\n\n.fa-champagne-glasses {\n  --fa: \"\\f79f\"; }\n\n.fa-glass-cheers {\n  --fa: \"\\f79f\"; }\n\n.fa-clipboard {\n  --fa: \"\\f328\"; }\n\n.fa-house-circle-exclamation {\n  --fa: \"\\e50a\"; }\n\n.fa-file-arrow-up {\n  --fa: \"\\f574\"; }\n\n.fa-file-upload {\n  --fa: \"\\f574\"; }\n\n.fa-wifi {\n  --fa: \"\\f1eb\"; }\n\n.fa-wifi-3 {\n  --fa: \"\\f1eb\"; }\n\n.fa-wifi-strong {\n  --fa: \"\\f1eb\"; }\n\n.fa-bath {\n  --fa: \"\\f2cd\"; }\n\n.fa-bathtub {\n  --fa: \"\\f2cd\"; }\n\n.fa-underline {\n  --fa: \"\\f0cd\"; }\n\n.fa-user-pen {\n  --fa: \"\\f4ff\"; }\n\n.fa-user-edit {\n  --fa: \"\\f4ff\"; }\n\n.fa-signature {\n  --fa: \"\\f5b7\"; }\n\n.fa-stroopwafel {\n  --fa: \"\\f551\"; }\n\n.fa-bold {\n  --fa: \"\\f032\"; }\n\n.fa-anchor-lock {\n  --fa: \"\\e4ad\"; }\n\n.fa-building-ngo {\n  --fa: \"\\e4d7\"; }\n\n.fa-manat-sign {\n  --fa: \"\\e1d5\"; }\n\n.fa-not-equal {\n  --fa: \"\\f53e\"; }\n\n.fa-border-top-left {\n  --fa: \"\\f853\"; }\n\n.fa-border-style {\n  --fa: \"\\f853\"; }\n\n.fa-map-location-dot {\n  --fa: \"\\f5a0\"; }\n\n.fa-map-marked-alt {\n  --fa: \"\\f5a0\"; }\n\n.fa-jedi {\n  --fa: \"\\f669\"; }\n\n.fa-square-poll-vertical {\n  --fa: \"\\f681\"; }\n\n.fa-poll {\n  --fa: \"\\f681\"; }\n\n.fa-mug-hot {\n  --fa: \"\\f7b6\"; }\n\n.fa-car-battery {\n  --fa: \"\\f5df\"; }\n\n.fa-battery-car {\n  --fa: \"\\f5df\"; }\n\n.fa-gift {\n  --fa: \"\\f06b\"; }\n\n.fa-dice-two {\n  --fa: \"\\f528\"; }\n\n.fa-chess-queen {\n  --fa: \"\\f445\"; }\n\n.fa-glasses {\n  --fa: \"\\f530\"; }\n\n.fa-chess-board {\n  --fa: \"\\f43c\"; }\n\n.fa-building-circle-check {\n  --fa: \"\\e4d2\"; }\n\n.fa-person-chalkboard {\n  --fa: \"\\e53d\"; }\n\n.fa-mars-stroke-right {\n  --fa: \"\\f22b\"; }\n\n.fa-mars-stroke-h {\n  --fa: \"\\f22b\"; }\n\n.fa-hand-back-fist {\n  --fa: \"\\f255\"; }\n\n.fa-hand-rock {\n  --fa: \"\\f255\"; }\n\n.fa-square-caret-up {\n  --fa: \"\\f151\"; }\n\n.fa-caret-square-up {\n  --fa: \"\\f151\"; }\n\n.fa-cloud-showers-water {\n  --fa: \"\\e4e4\"; }\n\n.fa-chart-bar {\n  --fa: \"\\f080\"; }\n\n.fa-bar-chart {\n  --fa: \"\\f080\"; }\n\n.fa-hands-bubbles {\n  --fa: \"\\e05e\"; }\n\n.fa-hands-wash {\n  --fa: \"\\e05e\"; }\n\n.fa-less-than-equal {\n  --fa: \"\\f537\"; }\n\n.fa-train {\n  --fa: \"\\f238\"; }\n\n.fa-eye-low-vision {\n  --fa: \"\\f2a8\"; }\n\n.fa-low-vision {\n  --fa: \"\\f2a8\"; }\n\n.fa-crow {\n  --fa: \"\\f520\"; }\n\n.fa-sailboat {\n  --fa: \"\\e445\"; }\n\n.fa-window-restore {\n  --fa: \"\\f2d2\"; }\n\n.fa-square-plus {\n  --fa: \"\\f0fe\"; }\n\n.fa-plus-square {\n  --fa: \"\\f0fe\"; }\n\n.fa-torii-gate {\n  --fa: \"\\f6a1\"; }\n\n.fa-frog {\n  --fa: \"\\f52e\"; }\n\n.fa-bucket {\n  --fa: \"\\e4cf\"; }\n\n.fa-image {\n  --fa: \"\\f03e\"; }\n\n.fa-microphone {\n  --fa: \"\\f130\"; }\n\n.fa-cow {\n  --fa: \"\\f6c8\"; }\n\n.fa-caret-up {\n  --fa: \"\\f0d8\"; }\n\n.fa-screwdriver {\n  --fa: \"\\f54a\"; }\n\n.fa-folder-closed {\n  --fa: \"\\e185\"; }\n\n.fa-house-tsunami {\n  --fa: \"\\e515\"; }\n\n.fa-square-nfi {\n  --fa: \"\\e576\"; }\n\n.fa-arrow-up-from-ground-water {\n  --fa: \"\\e4b5\"; }\n\n.fa-martini-glass {\n  --fa: \"\\f57b\"; }\n\n.fa-glass-martini-alt {\n  --fa: \"\\f57b\"; }\n\n.fa-square-binary {\n  --fa: \"\\e69b\"; }\n\n.fa-rotate-left {\n  --fa: \"\\f2ea\"; }\n\n.fa-rotate-back {\n  --fa: \"\\f2ea\"; }\n\n.fa-rotate-backward {\n  --fa: \"\\f2ea\"; }\n\n.fa-undo-alt {\n  --fa: \"\\f2ea\"; }\n\n.fa-table-columns {\n  --fa: \"\\f0db\"; }\n\n.fa-columns {\n  --fa: \"\\f0db\"; }\n\n.fa-lemon {\n  --fa: \"\\f094\"; }\n\n.fa-head-side-mask {\n  --fa: \"\\e063\"; }\n\n.fa-handshake {\n  --fa: \"\\f2b5\"; }\n\n.fa-gem {\n  --fa: \"\\f3a5\"; }\n\n.fa-dolly {\n  --fa: \"\\f472\"; }\n\n.fa-dolly-box {\n  --fa: \"\\f472\"; }\n\n.fa-smoking {\n  --fa: \"\\f48d\"; }\n\n.fa-minimize {\n  --fa: \"\\f78c\"; }\n\n.fa-compress-arrows-alt {\n  --fa: \"\\f78c\"; }\n\n.fa-monument {\n  --fa: \"\\f5a6\"; }\n\n.fa-snowplow {\n  --fa: \"\\f7d2\"; }\n\n.fa-angles-right {\n  --fa: \"\\f101\"; }\n\n.fa-angle-double-right {\n  --fa: \"\\f101\"; }\n\n.fa-cannabis {\n  --fa: \"\\f55f\"; }\n\n.fa-circle-play {\n  --fa: \"\\f144\"; }\n\n.fa-play-circle {\n  --fa: \"\\f144\"; }\n\n.fa-tablets {\n  --fa: \"\\f490\"; }\n\n.fa-ethernet {\n  --fa: \"\\f796\"; }\n\n.fa-euro-sign {\n  --fa: \"\\f153\"; }\n\n.fa-eur {\n  --fa: \"\\f153\"; }\n\n.fa-euro {\n  --fa: \"\\f153\"; }\n\n.fa-chair {\n  --fa: \"\\f6c0\"; }\n\n.fa-circle-check {\n  --fa: \"\\f058\"; }\n\n.fa-check-circle {\n  --fa: \"\\f058\"; }\n\n.fa-circle-stop {\n  --fa: \"\\f28d\"; }\n\n.fa-stop-circle {\n  --fa: \"\\f28d\"; }\n\n.fa-compass-drafting {\n  --fa: \"\\f568\"; }\n\n.fa-drafting-compass {\n  --fa: \"\\f568\"; }\n\n.fa-plate-wheat {\n  --fa: \"\\e55a\"; }\n\n.fa-icicles {\n  --fa: \"\\f7ad\"; }\n\n.fa-person-shelter {\n  --fa: \"\\e54f\"; }\n\n.fa-neuter {\n  --fa: \"\\f22c\"; }\n\n.fa-id-badge {\n  --fa: \"\\f2c1\"; }\n\n.fa-marker {\n  --fa: \"\\f5a1\"; }\n\n.fa-face-laugh-beam {\n  --fa: \"\\f59a\"; }\n\n.fa-laugh-beam {\n  --fa: \"\\f59a\"; }\n\n.fa-helicopter-symbol {\n  --fa: \"\\e502\"; }\n\n.fa-universal-access {\n  --fa: \"\\f29a\"; }\n\n.fa-circle-chevron-up {\n  --fa: \"\\f139\"; }\n\n.fa-chevron-circle-up {\n  --fa: \"\\f139\"; }\n\n.fa-lari-sign {\n  --fa: \"\\e1c8\"; }\n\n.fa-volcano {\n  --fa: \"\\f770\"; }\n\n.fa-person-walking-dashed-line-arrow-right {\n  --fa: \"\\e553\"; }\n\n.fa-sterling-sign {\n  --fa: \"\\f154\"; }\n\n.fa-gbp {\n  --fa: \"\\f154\"; }\n\n.fa-pound-sign {\n  --fa: \"\\f154\"; }\n\n.fa-viruses {\n  --fa: \"\\e076\"; }\n\n.fa-square-person-confined {\n  --fa: \"\\e577\"; }\n\n.fa-user-tie {\n  --fa: \"\\f508\"; }\n\n.fa-arrow-down-long {\n  --fa: \"\\f175\"; }\n\n.fa-long-arrow-down {\n  --fa: \"\\f175\"; }\n\n.fa-tent-arrow-down-to-line {\n  --fa: \"\\e57e\"; }\n\n.fa-certificate {\n  --fa: \"\\f0a3\"; }\n\n.fa-reply-all {\n  --fa: \"\\f122\"; }\n\n.fa-mail-reply-all {\n  --fa: \"\\f122\"; }\n\n.fa-suitcase {\n  --fa: \"\\f0f2\"; }\n\n.fa-person-skating {\n  --fa: \"\\f7c5\"; }\n\n.fa-skating {\n  --fa: \"\\f7c5\"; }\n\n.fa-filter-circle-dollar {\n  --fa: \"\\f662\"; }\n\n.fa-funnel-dollar {\n  --fa: \"\\f662\"; }\n\n.fa-camera-retro {\n  --fa: \"\\f083\"; }\n\n.fa-circle-arrow-down {\n  --fa: \"\\f0ab\"; }\n\n.fa-arrow-circle-down {\n  --fa: \"\\f0ab\"; }\n\n.fa-file-import {\n  --fa: \"\\f56f\"; }\n\n.fa-arrow-right-to-file {\n  --fa: \"\\f56f\"; }\n\n.fa-square-arrow-up-right {\n  --fa: \"\\f14c\"; }\n\n.fa-external-link-square {\n  --fa: \"\\f14c\"; }\n\n.fa-box-open {\n  --fa: \"\\f49e\"; }\n\n.fa-scroll {\n  --fa: \"\\f70e\"; }\n\n.fa-spa {\n  --fa: \"\\f5bb\"; }\n\n.fa-location-pin-lock {\n  --fa: \"\\e51f\"; }\n\n.fa-pause {\n  --fa: \"\\f04c\"; }\n\n.fa-hill-avalanche {\n  --fa: \"\\e507\"; }\n\n.fa-temperature-empty {\n  --fa: \"\\f2cb\"; }\n\n.fa-temperature-0 {\n  --fa: \"\\f2cb\"; }\n\n.fa-thermometer-0 {\n  --fa: \"\\f2cb\"; }\n\n.fa-thermometer-empty {\n  --fa: \"\\f2cb\"; }\n\n.fa-bomb {\n  --fa: \"\\f1e2\"; }\n\n.fa-registered {\n  --fa: \"\\f25d\"; }\n\n.fa-address-card {\n  --fa: \"\\f2bb\"; }\n\n.fa-contact-card {\n  --fa: \"\\f2bb\"; }\n\n.fa-vcard {\n  --fa: \"\\f2bb\"; }\n\n.fa-scale-unbalanced-flip {\n  --fa: \"\\f516\"; }\n\n.fa-balance-scale-right {\n  --fa: \"\\f516\"; }\n\n.fa-subscript {\n  --fa: \"\\f12c\"; }\n\n.fa-diamond-turn-right {\n  --fa: \"\\f5eb\"; }\n\n.fa-directions {\n  --fa: \"\\f5eb\"; }\n\n.fa-burst {\n  --fa: \"\\e4dc\"; }\n\n.fa-house-laptop {\n  --fa: \"\\e066\"; }\n\n.fa-laptop-house {\n  --fa: \"\\e066\"; }\n\n.fa-face-tired {\n  --fa: \"\\f5c8\"; }\n\n.fa-tired {\n  --fa: \"\\f5c8\"; }\n\n.fa-money-bills {\n  --fa: \"\\e1f3\"; }\n\n.fa-smog {\n  --fa: \"\\f75f\"; }\n\n.fa-crutch {\n  --fa: \"\\f7f7\"; }\n\n.fa-cloud-arrow-up {\n  --fa: \"\\f0ee\"; }\n\n.fa-cloud-upload {\n  --fa: \"\\f0ee\"; }\n\n.fa-cloud-upload-alt {\n  --fa: \"\\f0ee\"; }\n\n.fa-palette {\n  --fa: \"\\f53f\"; }\n\n.fa-arrows-turn-right {\n  --fa: \"\\e4c0\"; }\n\n.fa-vest {\n  --fa: \"\\e085\"; }\n\n.fa-ferry {\n  --fa: \"\\e4ea\"; }\n\n.fa-arrows-down-to-people {\n  --fa: \"\\e4b9\"; }\n\n.fa-seedling {\n  --fa: \"\\f4d8\"; }\n\n.fa-sprout {\n  --fa: \"\\f4d8\"; }\n\n.fa-left-right {\n  --fa: \"\\f337\"; }\n\n.fa-arrows-alt-h {\n  --fa: \"\\f337\"; }\n\n.fa-boxes-packing {\n  --fa: \"\\e4c7\"; }\n\n.fa-circle-arrow-left {\n  --fa: \"\\f0a8\"; }\n\n.fa-arrow-circle-left {\n  --fa: \"\\f0a8\"; }\n\n.fa-group-arrows-rotate {\n  --fa: \"\\e4f6\"; }\n\n.fa-bowl-food {\n  --fa: \"\\e4c6\"; }\n\n.fa-candy-cane {\n  --fa: \"\\f786\"; }\n\n.fa-arrow-down-wide-short {\n  --fa: \"\\f160\"; }\n\n.fa-sort-amount-asc {\n  --fa: \"\\f160\"; }\n\n.fa-sort-amount-down {\n  --fa: \"\\f160\"; }\n\n.fa-cloud-bolt {\n  --fa: \"\\f76c\"; }\n\n.fa-thunderstorm {\n  --fa: \"\\f76c\"; }\n\n.fa-text-slash {\n  --fa: \"\\f87d\"; }\n\n.fa-remove-format {\n  --fa: \"\\f87d\"; }\n\n.fa-face-smile-wink {\n  --fa: \"\\f4da\"; }\n\n.fa-smile-wink {\n  --fa: \"\\f4da\"; }\n\n.fa-file-word {\n  --fa: \"\\f1c2\"; }\n\n.fa-file-powerpoint {\n  --fa: \"\\f1c4\"; }\n\n.fa-arrows-left-right {\n  --fa: \"\\f07e\"; }\n\n.fa-arrows-h {\n  --fa: \"\\f07e\"; }\n\n.fa-house-lock {\n  --fa: \"\\e510\"; }\n\n.fa-cloud-arrow-down {\n  --fa: \"\\f0ed\"; }\n\n.fa-cloud-download {\n  --fa: \"\\f0ed\"; }\n\n.fa-cloud-download-alt {\n  --fa: \"\\f0ed\"; }\n\n.fa-children {\n  --fa: \"\\e4e1\"; }\n\n.fa-chalkboard {\n  --fa: \"\\f51b\"; }\n\n.fa-blackboard {\n  --fa: \"\\f51b\"; }\n\n.fa-user-large-slash {\n  --fa: \"\\f4fa\"; }\n\n.fa-user-alt-slash {\n  --fa: \"\\f4fa\"; }\n\n.fa-envelope-open {\n  --fa: \"\\f2b6\"; }\n\n.fa-handshake-simple-slash {\n  --fa: \"\\e05f\"; }\n\n.fa-handshake-alt-slash {\n  --fa: \"\\e05f\"; }\n\n.fa-mattress-pillow {\n  --fa: \"\\e525\"; }\n\n.fa-guarani-sign {\n  --fa: \"\\e19a\"; }\n\n.fa-arrows-rotate {\n  --fa: \"\\f021\"; }\n\n.fa-refresh {\n  --fa: \"\\f021\"; }\n\n.fa-sync {\n  --fa: \"\\f021\"; }\n\n.fa-fire-extinguisher {\n  --fa: \"\\f134\"; }\n\n.fa-cruzeiro-sign {\n  --fa: \"\\e152\"; }\n\n.fa-greater-than-equal {\n  --fa: \"\\f532\"; }\n\n.fa-shield-halved {\n  --fa: \"\\f3ed\"; }\n\n.fa-shield-alt {\n  --fa: \"\\f3ed\"; }\n\n.fa-book-atlas {\n  --fa: \"\\f558\"; }\n\n.fa-atlas {\n  --fa: \"\\f558\"; }\n\n.fa-virus {\n  --fa: \"\\e074\"; }\n\n.fa-envelope-circle-check {\n  --fa: \"\\e4e8\"; }\n\n.fa-layer-group {\n  --fa: \"\\f5fd\"; }\n\n.fa-arrows-to-dot {\n  --fa: \"\\e4be\"; }\n\n.fa-archway {\n  --fa: \"\\f557\"; }\n\n.fa-heart-circle-check {\n  --fa: \"\\e4fd\"; }\n\n.fa-house-chimney-crack {\n  --fa: \"\\f6f1\"; }\n\n.fa-house-damage {\n  --fa: \"\\f6f1\"; }\n\n.fa-file-zipper {\n  --fa: \"\\f1c6\"; }\n\n.fa-file-archive {\n  --fa: \"\\f1c6\"; }\n\n.fa-square {\n  --fa: \"\\f0c8\"; }\n\n.fa-martini-glass-empty {\n  --fa: \"\\f000\"; }\n\n.fa-glass-martini {\n  --fa: \"\\f000\"; }\n\n.fa-couch {\n  --fa: \"\\f4b8\"; }\n\n.fa-cedi-sign {\n  --fa: \"\\e0df\"; }\n\n.fa-italic {\n  --fa: \"\\f033\"; }\n\n.fa-table-cells-column-lock {\n  --fa: \"\\e678\"; }\n\n.fa-church {\n  --fa: \"\\f51d\"; }\n\n.fa-comments-dollar {\n  --fa: \"\\f653\"; }\n\n.fa-democrat {\n  --fa: \"\\f747\"; }\n\n.fa-z {\n  --fa: \"\\5a\"; }\n\n.fa-person-skiing {\n  --fa: \"\\f7c9\"; }\n\n.fa-skiing {\n  --fa: \"\\f7c9\"; }\n\n.fa-road-lock {\n  --fa: \"\\e567\"; }\n\n.fa-a {\n  --fa: \"\\41\"; }\n\n.fa-temperature-arrow-down {\n  --fa: \"\\e03f\"; }\n\n.fa-temperature-down {\n  --fa: \"\\e03f\"; }\n\n.fa-feather-pointed {\n  --fa: \"\\f56b\"; }\n\n.fa-feather-alt {\n  --fa: \"\\f56b\"; }\n\n.fa-p {\n  --fa: \"\\50\"; }\n\n.fa-snowflake {\n  --fa: \"\\f2dc\"; }\n\n.fa-newspaper {\n  --fa: \"\\f1ea\"; }\n\n.fa-rectangle-ad {\n  --fa: \"\\f641\"; }\n\n.fa-ad {\n  --fa: \"\\f641\"; }\n\n.fa-circle-arrow-right {\n  --fa: \"\\f0a9\"; }\n\n.fa-arrow-circle-right {\n  --fa: \"\\f0a9\"; }\n\n.fa-filter-circle-xmark {\n  --fa: \"\\e17b\"; }\n\n.fa-locust {\n  --fa: \"\\e520\"; }\n\n.fa-sort {\n  --fa: \"\\f0dc\"; }\n\n.fa-unsorted {\n  --fa: \"\\f0dc\"; }\n\n.fa-list-ol {\n  --fa: \"\\f0cb\"; }\n\n.fa-list-1-2 {\n  --fa: \"\\f0cb\"; }\n\n.fa-list-numeric {\n  --fa: \"\\f0cb\"; }\n\n.fa-person-dress-burst {\n  --fa: \"\\e544\"; }\n\n.fa-money-check-dollar {\n  --fa: \"\\f53d\"; }\n\n.fa-money-check-alt {\n  --fa: \"\\f53d\"; }\n\n.fa-vector-square {\n  --fa: \"\\f5cb\"; }\n\n.fa-bread-slice {\n  --fa: \"\\f7ec\"; }\n\n.fa-language {\n  --fa: \"\\f1ab\"; }\n\n.fa-face-kiss-wink-heart {\n  --fa: \"\\f598\"; }\n\n.fa-kiss-wink-heart {\n  --fa: \"\\f598\"; }\n\n.fa-filter {\n  --fa: \"\\f0b0\"; }\n\n.fa-question {\n  --fa: \"\\3f\"; }\n\n.fa-file-signature {\n  --fa: \"\\f573\"; }\n\n.fa-up-down-left-right {\n  --fa: \"\\f0b2\"; }\n\n.fa-arrows-alt {\n  --fa: \"\\f0b2\"; }\n\n.fa-house-chimney-user {\n  --fa: \"\\e065\"; }\n\n.fa-hand-holding-heart {\n  --fa: \"\\f4be\"; }\n\n.fa-puzzle-piece {\n  --fa: \"\\f12e\"; }\n\n.fa-money-check {\n  --fa: \"\\f53c\"; }\n\n.fa-star-half-stroke {\n  --fa: \"\\f5c0\"; }\n\n.fa-star-half-alt {\n  --fa: \"\\f5c0\"; }\n\n.fa-code {\n  --fa: \"\\f121\"; }\n\n.fa-whiskey-glass {\n  --fa: \"\\f7a0\"; }\n\n.fa-glass-whiskey {\n  --fa: \"\\f7a0\"; }\n\n.fa-building-circle-exclamation {\n  --fa: \"\\e4d3\"; }\n\n.fa-magnifying-glass-chart {\n  --fa: \"\\e522\"; }\n\n.fa-arrow-up-right-from-square {\n  --fa: \"\\f08e\"; }\n\n.fa-external-link {\n  --fa: \"\\f08e\"; }\n\n.fa-cubes-stacked {\n  --fa: \"\\e4e6\"; }\n\n.fa-won-sign {\n  --fa: \"\\f159\"; }\n\n.fa-krw {\n  --fa: \"\\f159\"; }\n\n.fa-won {\n  --fa: \"\\f159\"; }\n\n.fa-virus-covid {\n  --fa: \"\\e4a8\"; }\n\n.fa-austral-sign {\n  --fa: \"\\e0a9\"; }\n\n.fa-f {\n  --fa: \"\\46\"; }\n\n.fa-leaf {\n  --fa: \"\\f06c\"; }\n\n.fa-road {\n  --fa: \"\\f018\"; }\n\n.fa-taxi {\n  --fa: \"\\f1ba\"; }\n\n.fa-cab {\n  --fa: \"\\f1ba\"; }\n\n.fa-person-circle-plus {\n  --fa: \"\\e541\"; }\n\n.fa-chart-pie {\n  --fa: \"\\f200\"; }\n\n.fa-pie-chart {\n  --fa: \"\\f200\"; }\n\n.fa-bolt-lightning {\n  --fa: \"\\e0b7\"; }\n\n.fa-sack-xmark {\n  --fa: \"\\e56a\"; }\n\n.fa-file-excel {\n  --fa: \"\\f1c3\"; }\n\n.fa-file-contract {\n  --fa: \"\\f56c\"; }\n\n.fa-fish-fins {\n  --fa: \"\\e4f2\"; }\n\n.fa-building-flag {\n  --fa: \"\\e4d5\"; }\n\n.fa-face-grin-beam {\n  --fa: \"\\f582\"; }\n\n.fa-grin-beam {\n  --fa: \"\\f582\"; }\n\n.fa-object-ungroup {\n  --fa: \"\\f248\"; }\n\n.fa-poop {\n  --fa: \"\\f619\"; }\n\n.fa-location-pin {\n  --fa: \"\\f041\"; }\n\n.fa-map-marker {\n  --fa: \"\\f041\"; }\n\n.fa-kaaba {\n  --fa: \"\\f66b\"; }\n\n.fa-toilet-paper {\n  --fa: \"\\f71e\"; }\n\n.fa-helmet-safety {\n  --fa: \"\\f807\"; }\n\n.fa-hard-hat {\n  --fa: \"\\f807\"; }\n\n.fa-hat-hard {\n  --fa: \"\\f807\"; }\n\n.fa-eject {\n  --fa: \"\\f052\"; }\n\n.fa-circle-right {\n  --fa: \"\\f35a\"; }\n\n.fa-arrow-alt-circle-right {\n  --fa: \"\\f35a\"; }\n\n.fa-plane-circle-check {\n  --fa: \"\\e555\"; }\n\n.fa-face-rolling-eyes {\n  --fa: \"\\f5a5\"; }\n\n.fa-meh-rolling-eyes {\n  --fa: \"\\f5a5\"; }\n\n.fa-object-group {\n  --fa: \"\\f247\"; }\n\n.fa-chart-line {\n  --fa: \"\\f201\"; }\n\n.fa-line-chart {\n  --fa: \"\\f201\"; }\n\n.fa-mask-ventilator {\n  --fa: \"\\e524\"; }\n\n.fa-arrow-right {\n  --fa: \"\\f061\"; }\n\n.fa-signs-post {\n  --fa: \"\\f277\"; }\n\n.fa-map-signs {\n  --fa: \"\\f277\"; }\n\n.fa-cash-register {\n  --fa: \"\\f788\"; }\n\n.fa-person-circle-question {\n  --fa: \"\\e542\"; }\n\n.fa-h {\n  --fa: \"\\48\"; }\n\n.fa-tarp {\n  --fa: \"\\e57b\"; }\n\n.fa-screwdriver-wrench {\n  --fa: \"\\f7d9\"; }\n\n.fa-tools {\n  --fa: \"\\f7d9\"; }\n\n.fa-arrows-to-eye {\n  --fa: \"\\e4bf\"; }\n\n.fa-plug-circle-bolt {\n  --fa: \"\\e55b\"; }\n\n.fa-heart {\n  --fa: \"\\f004\"; }\n\n.fa-mars-and-venus {\n  --fa: \"\\f224\"; }\n\n.fa-house-user {\n  --fa: \"\\e1b0\"; }\n\n.fa-home-user {\n  --fa: \"\\e1b0\"; }\n\n.fa-dumpster-fire {\n  --fa: \"\\f794\"; }\n\n.fa-house-crack {\n  --fa: \"\\e3b1\"; }\n\n.fa-martini-glass-citrus {\n  --fa: \"\\f561\"; }\n\n.fa-cocktail {\n  --fa: \"\\f561\"; }\n\n.fa-face-surprise {\n  --fa: \"\\f5c2\"; }\n\n.fa-surprise {\n  --fa: \"\\f5c2\"; }\n\n.fa-bottle-water {\n  --fa: \"\\e4c5\"; }\n\n.fa-circle-pause {\n  --fa: \"\\f28b\"; }\n\n.fa-pause-circle {\n  --fa: \"\\f28b\"; }\n\n.fa-toilet-paper-slash {\n  --fa: \"\\e072\"; }\n\n.fa-apple-whole {\n  --fa: \"\\f5d1\"; }\n\n.fa-apple-alt {\n  --fa: \"\\f5d1\"; }\n\n.fa-kitchen-set {\n  --fa: \"\\e51a\"; }\n\n.fa-r {\n  --fa: \"\\52\"; }\n\n.fa-temperature-quarter {\n  --fa: \"\\f2ca\"; }\n\n.fa-temperature-1 {\n  --fa: \"\\f2ca\"; }\n\n.fa-thermometer-1 {\n  --fa: \"\\f2ca\"; }\n\n.fa-thermometer-quarter {\n  --fa: \"\\f2ca\"; }\n\n.fa-cube {\n  --fa: \"\\f1b2\"; }\n\n.fa-bitcoin-sign {\n  --fa: \"\\e0b4\"; }\n\n.fa-shield-dog {\n  --fa: \"\\e573\"; }\n\n.fa-solar-panel {\n  --fa: \"\\f5ba\"; }\n\n.fa-lock-open {\n  --fa: \"\\f3c1\"; }\n\n.fa-elevator {\n  --fa: \"\\e16d\"; }\n\n.fa-money-bill-transfer {\n  --fa: \"\\e528\"; }\n\n.fa-money-bill-trend-up {\n  --fa: \"\\e529\"; }\n\n.fa-house-flood-water-circle-arrow-right {\n  --fa: \"\\e50f\"; }\n\n.fa-square-poll-horizontal {\n  --fa: \"\\f682\"; }\n\n.fa-poll-h {\n  --fa: \"\\f682\"; }\n\n.fa-circle {\n  --fa: \"\\f111\"; }\n\n.fa-backward-fast {\n  --fa: \"\\f049\"; }\n\n.fa-fast-backward {\n  --fa: \"\\f049\"; }\n\n.fa-recycle {\n  --fa: \"\\f1b8\"; }\n\n.fa-user-astronaut {\n  --fa: \"\\f4fb\"; }\n\n.fa-plane-slash {\n  --fa: \"\\e069\"; }\n\n.fa-trademark {\n  --fa: \"\\f25c\"; }\n\n.fa-basketball {\n  --fa: \"\\f434\"; }\n\n.fa-basketball-ball {\n  --fa: \"\\f434\"; }\n\n.fa-satellite-dish {\n  --fa: \"\\f7c0\"; }\n\n.fa-circle-up {\n  --fa: \"\\f35b\"; }\n\n.fa-arrow-alt-circle-up {\n  --fa: \"\\f35b\"; }\n\n.fa-mobile-screen-button {\n  --fa: \"\\f3cd\"; }\n\n.fa-mobile-alt {\n  --fa: \"\\f3cd\"; }\n\n.fa-volume-high {\n  --fa: \"\\f028\"; }\n\n.fa-volume-up {\n  --fa: \"\\f028\"; }\n\n.fa-users-rays {\n  --fa: \"\\e593\"; }\n\n.fa-wallet {\n  --fa: \"\\f555\"; }\n\n.fa-clipboard-check {\n  --fa: \"\\f46c\"; }\n\n.fa-file-audio {\n  --fa: \"\\f1c7\"; }\n\n.fa-burger {\n  --fa: \"\\f805\"; }\n\n.fa-hamburger {\n  --fa: \"\\f805\"; }\n\n.fa-wrench {\n  --fa: \"\\f0ad\"; }\n\n.fa-bugs {\n  --fa: \"\\e4d0\"; }\n\n.fa-rupee-sign {\n  --fa: \"\\f156\"; }\n\n.fa-rupee {\n  --fa: \"\\f156\"; }\n\n.fa-file-image {\n  --fa: \"\\f1c5\"; }\n\n.fa-circle-question {\n  --fa: \"\\f059\"; }\n\n.fa-question-circle {\n  --fa: \"\\f059\"; }\n\n.fa-plane-departure {\n  --fa: \"\\f5b0\"; }\n\n.fa-handshake-slash {\n  --fa: \"\\e060\"; }\n\n.fa-book-bookmark {\n  --fa: \"\\e0bb\"; }\n\n.fa-code-branch {\n  --fa: \"\\f126\"; }\n\n.fa-hat-cowboy {\n  --fa: \"\\f8c0\"; }\n\n.fa-bridge {\n  --fa: \"\\e4c8\"; }\n\n.fa-phone-flip {\n  --fa: \"\\f879\"; }\n\n.fa-phone-alt {\n  --fa: \"\\f879\"; }\n\n.fa-truck-front {\n  --fa: \"\\e2b7\"; }\n\n.fa-cat {\n  --fa: \"\\f6be\"; }\n\n.fa-anchor-circle-exclamation {\n  --fa: \"\\e4ab\"; }\n\n.fa-truck-field {\n  --fa: \"\\e58d\"; }\n\n.fa-route {\n  --fa: \"\\f4d7\"; }\n\n.fa-clipboard-question {\n  --fa: \"\\e4e3\"; }\n\n.fa-panorama {\n  --fa: \"\\e209\"; }\n\n.fa-comment-medical {\n  --fa: \"\\f7f5\"; }\n\n.fa-teeth-open {\n  --fa: \"\\f62f\"; }\n\n.fa-file-circle-minus {\n  --fa: \"\\e4ed\"; }\n\n.fa-tags {\n  --fa: \"\\f02c\"; }\n\n.fa-wine-glass {\n  --fa: \"\\f4e3\"; }\n\n.fa-forward-fast {\n  --fa: \"\\f050\"; }\n\n.fa-fast-forward {\n  --fa: \"\\f050\"; }\n\n.fa-face-meh-blank {\n  --fa: \"\\f5a4\"; }\n\n.fa-meh-blank {\n  --fa: \"\\f5a4\"; }\n\n.fa-square-parking {\n  --fa: \"\\f540\"; }\n\n.fa-parking {\n  --fa: \"\\f540\"; }\n\n.fa-house-signal {\n  --fa: \"\\e012\"; }\n\n.fa-bars-progress {\n  --fa: \"\\f828\"; }\n\n.fa-tasks-alt {\n  --fa: \"\\f828\"; }\n\n.fa-faucet-drip {\n  --fa: \"\\e006\"; }\n\n.fa-cart-flatbed {\n  --fa: \"\\f474\"; }\n\n.fa-dolly-flatbed {\n  --fa: \"\\f474\"; }\n\n.fa-ban-smoking {\n  --fa: \"\\f54d\"; }\n\n.fa-smoking-ban {\n  --fa: \"\\f54d\"; }\n\n.fa-terminal {\n  --fa: \"\\f120\"; }\n\n.fa-mobile-button {\n  --fa: \"\\f10b\"; }\n\n.fa-house-medical-flag {\n  --fa: \"\\e514\"; }\n\n.fa-basket-shopping {\n  --fa: \"\\f291\"; }\n\n.fa-shopping-basket {\n  --fa: \"\\f291\"; }\n\n.fa-tape {\n  --fa: \"\\f4db\"; }\n\n.fa-bus-simple {\n  --fa: \"\\f55e\"; }\n\n.fa-bus-alt {\n  --fa: \"\\f55e\"; }\n\n.fa-eye {\n  --fa: \"\\f06e\"; }\n\n.fa-face-sad-cry {\n  --fa: \"\\f5b3\"; }\n\n.fa-sad-cry {\n  --fa: \"\\f5b3\"; }\n\n.fa-audio-description {\n  --fa: \"\\f29e\"; }\n\n.fa-person-military-to-person {\n  --fa: \"\\e54c\"; }\n\n.fa-file-shield {\n  --fa: \"\\e4f0\"; }\n\n.fa-user-slash {\n  --fa: \"\\f506\"; }\n\n.fa-pen {\n  --fa: \"\\f304\"; }\n\n.fa-tower-observation {\n  --fa: \"\\e586\"; }\n\n.fa-file-code {\n  --fa: \"\\f1c9\"; }\n\n.fa-signal {\n  --fa: \"\\f012\"; }\n\n.fa-signal-5 {\n  --fa: \"\\f012\"; }\n\n.fa-signal-perfect {\n  --fa: \"\\f012\"; }\n\n.fa-bus {\n  --fa: \"\\f207\"; }\n\n.fa-heart-circle-xmark {\n  --fa: \"\\e501\"; }\n\n.fa-house-chimney {\n  --fa: \"\\e3af\"; }\n\n.fa-home-lg {\n  --fa: \"\\e3af\"; }\n\n.fa-window-maximize {\n  --fa: \"\\f2d0\"; }\n\n.fa-face-frown {\n  --fa: \"\\f119\"; }\n\n.fa-frown {\n  --fa: \"\\f119\"; }\n\n.fa-prescription {\n  --fa: \"\\f5b1\"; }\n\n.fa-shop {\n  --fa: \"\\f54f\"; }\n\n.fa-store-alt {\n  --fa: \"\\f54f\"; }\n\n.fa-floppy-disk {\n  --fa: \"\\f0c7\"; }\n\n.fa-save {\n  --fa: \"\\f0c7\"; }\n\n.fa-vihara {\n  --fa: \"\\f6a7\"; }\n\n.fa-scale-unbalanced {\n  --fa: \"\\f515\"; }\n\n.fa-balance-scale-left {\n  --fa: \"\\f515\"; }\n\n.fa-sort-up {\n  --fa: \"\\f0de\"; }\n\n.fa-sort-asc {\n  --fa: \"\\f0de\"; }\n\n.fa-comment-dots {\n  --fa: \"\\f4ad\"; }\n\n.fa-commenting {\n  --fa: \"\\f4ad\"; }\n\n.fa-plant-wilt {\n  --fa: \"\\e5aa\"; }\n\n.fa-diamond {\n  --fa: \"\\f219\"; }\n\n.fa-face-grin-squint {\n  --fa: \"\\f585\"; }\n\n.fa-grin-squint {\n  --fa: \"\\f585\"; }\n\n.fa-hand-holding-dollar {\n  --fa: \"\\f4c0\"; }\n\n.fa-hand-holding-usd {\n  --fa: \"\\f4c0\"; }\n\n.fa-chart-diagram {\n  --fa: \"\\e695\"; }\n\n.fa-bacterium {\n  --fa: \"\\e05a\"; }\n\n.fa-hand-pointer {\n  --fa: \"\\f25a\"; }\n\n.fa-drum-steelpan {\n  --fa: \"\\f56a\"; }\n\n.fa-hand-scissors {\n  --fa: \"\\f257\"; }\n\n.fa-hands-praying {\n  --fa: \"\\f684\"; }\n\n.fa-praying-hands {\n  --fa: \"\\f684\"; }\n\n.fa-arrow-rotate-right {\n  --fa: \"\\f01e\"; }\n\n.fa-arrow-right-rotate {\n  --fa: \"\\f01e\"; }\n\n.fa-arrow-rotate-forward {\n  --fa: \"\\f01e\"; }\n\n.fa-redo {\n  --fa: \"\\f01e\"; }\n\n.fa-biohazard {\n  --fa: \"\\f780\"; }\n\n.fa-location-crosshairs {\n  --fa: \"\\f601\"; }\n\n.fa-location {\n  --fa: \"\\f601\"; }\n\n.fa-mars-double {\n  --fa: \"\\f227\"; }\n\n.fa-child-dress {\n  --fa: \"\\e59c\"; }\n\n.fa-users-between-lines {\n  --fa: \"\\e591\"; }\n\n.fa-lungs-virus {\n  --fa: \"\\e067\"; }\n\n.fa-face-grin-tears {\n  --fa: \"\\f588\"; }\n\n.fa-grin-tears {\n  --fa: \"\\f588\"; }\n\n.fa-phone {\n  --fa: \"\\f095\"; }\n\n.fa-calendar-xmark {\n  --fa: \"\\f273\"; }\n\n.fa-calendar-times {\n  --fa: \"\\f273\"; }\n\n.fa-child-reaching {\n  --fa: \"\\e59d\"; }\n\n.fa-head-side-virus {\n  --fa: \"\\e064\"; }\n\n.fa-user-gear {\n  --fa: \"\\f4fe\"; }\n\n.fa-user-cog {\n  --fa: \"\\f4fe\"; }\n\n.fa-arrow-up-1-9 {\n  --fa: \"\\f163\"; }\n\n.fa-sort-numeric-up {\n  --fa: \"\\f163\"; }\n\n.fa-door-closed {\n  --fa: \"\\f52a\"; }\n\n.fa-shield-virus {\n  --fa: \"\\e06c\"; }\n\n.fa-dice-six {\n  --fa: \"\\f526\"; }\n\n.fa-mosquito-net {\n  --fa: \"\\e52c\"; }\n\n.fa-file-fragment {\n  --fa: \"\\e697\"; }\n\n.fa-bridge-water {\n  --fa: \"\\e4ce\"; }\n\n.fa-person-booth {\n  --fa: \"\\f756\"; }\n\n.fa-text-width {\n  --fa: \"\\f035\"; }\n\n.fa-hat-wizard {\n  --fa: \"\\f6e8\"; }\n\n.fa-pen-fancy {\n  --fa: \"\\f5ac\"; }\n\n.fa-person-digging {\n  --fa: \"\\f85e\"; }\n\n.fa-digging {\n  --fa: \"\\f85e\"; }\n\n.fa-trash {\n  --fa: \"\\f1f8\"; }\n\n.fa-gauge-simple {\n  --fa: \"\\f629\"; }\n\n.fa-gauge-simple-med {\n  --fa: \"\\f629\"; }\n\n.fa-tachometer-average {\n  --fa: \"\\f629\"; }\n\n.fa-book-medical {\n  --fa: \"\\f7e6\"; }\n\n.fa-poo {\n  --fa: \"\\f2fe\"; }\n\n.fa-quote-right {\n  --fa: \"\\f10e\"; }\n\n.fa-quote-right-alt {\n  --fa: \"\\f10e\"; }\n\n.fa-shirt {\n  --fa: \"\\f553\"; }\n\n.fa-t-shirt {\n  --fa: \"\\f553\"; }\n\n.fa-tshirt {\n  --fa: \"\\f553\"; }\n\n.fa-cubes {\n  --fa: \"\\f1b3\"; }\n\n.fa-divide {\n  --fa: \"\\f529\"; }\n\n.fa-tenge-sign {\n  --fa: \"\\f7d7\"; }\n\n.fa-tenge {\n  --fa: \"\\f7d7\"; }\n\n.fa-headphones {\n  --fa: \"\\f025\"; }\n\n.fa-hands-holding {\n  --fa: \"\\f4c2\"; }\n\n.fa-hands-clapping {\n  --fa: \"\\e1a8\"; }\n\n.fa-republican {\n  --fa: \"\\f75e\"; }\n\n.fa-arrow-left {\n  --fa: \"\\f060\"; }\n\n.fa-person-circle-xmark {\n  --fa: \"\\e543\"; }\n\n.fa-ruler {\n  --fa: \"\\f545\"; }\n\n.fa-align-left {\n  --fa: \"\\f036\"; }\n\n.fa-dice-d6 {\n  --fa: \"\\f6d1\"; }\n\n.fa-restroom {\n  --fa: \"\\f7bd\"; }\n\n.fa-j {\n  --fa: \"\\4a\"; }\n\n.fa-users-viewfinder {\n  --fa: \"\\e595\"; }\n\n.fa-file-video {\n  --fa: \"\\f1c8\"; }\n\n.fa-up-right-from-square {\n  --fa: \"\\f35d\"; }\n\n.fa-external-link-alt {\n  --fa: \"\\f35d\"; }\n\n.fa-table-cells {\n  --fa: \"\\f00a\"; }\n\n.fa-th {\n  --fa: \"\\f00a\"; }\n\n.fa-file-pdf {\n  --fa: \"\\f1c1\"; }\n\n.fa-book-bible {\n  --fa: \"\\f647\"; }\n\n.fa-bible {\n  --fa: \"\\f647\"; }\n\n.fa-o {\n  --fa: \"\\4f\"; }\n\n.fa-suitcase-medical {\n  --fa: \"\\f0fa\"; }\n\n.fa-medkit {\n  --fa: \"\\f0fa\"; }\n\n.fa-user-secret {\n  --fa: \"\\f21b\"; }\n\n.fa-otter {\n  --fa: \"\\f700\"; }\n\n.fa-person-dress {\n  --fa: \"\\f182\"; }\n\n.fa-female {\n  --fa: \"\\f182\"; }\n\n.fa-comment-dollar {\n  --fa: \"\\f651\"; }\n\n.fa-business-time {\n  --fa: \"\\f64a\"; }\n\n.fa-briefcase-clock {\n  --fa: \"\\f64a\"; }\n\n.fa-table-cells-large {\n  --fa: \"\\f009\"; }\n\n.fa-th-large {\n  --fa: \"\\f009\"; }\n\n.fa-book-tanakh {\n  --fa: \"\\f827\"; }\n\n.fa-tanakh {\n  --fa: \"\\f827\"; }\n\n.fa-phone-volume {\n  --fa: \"\\f2a0\"; }\n\n.fa-volume-control-phone {\n  --fa: \"\\f2a0\"; }\n\n.fa-hat-cowboy-side {\n  --fa: \"\\f8c1\"; }\n\n.fa-clipboard-user {\n  --fa: \"\\f7f3\"; }\n\n.fa-child {\n  --fa: \"\\f1ae\"; }\n\n.fa-lira-sign {\n  --fa: \"\\f195\"; }\n\n.fa-satellite {\n  --fa: \"\\f7bf\"; }\n\n.fa-plane-lock {\n  --fa: \"\\e558\"; }\n\n.fa-tag {\n  --fa: \"\\f02b\"; }\n\n.fa-comment {\n  --fa: \"\\f075\"; }\n\n.fa-cake-candles {\n  --fa: \"\\f1fd\"; }\n\n.fa-birthday-cake {\n  --fa: \"\\f1fd\"; }\n\n.fa-cake {\n  --fa: \"\\f1fd\"; }\n\n.fa-envelope {\n  --fa: \"\\f0e0\"; }\n\n.fa-angles-up {\n  --fa: \"\\f102\"; }\n\n.fa-angle-double-up {\n  --fa: \"\\f102\"; }\n\n.fa-paperclip {\n  --fa: \"\\f0c6\"; }\n\n.fa-arrow-right-to-city {\n  --fa: \"\\e4b3\"; }\n\n.fa-ribbon {\n  --fa: \"\\f4d6\"; }\n\n.fa-lungs {\n  --fa: \"\\f604\"; }\n\n.fa-arrow-up-9-1 {\n  --fa: \"\\f887\"; }\n\n.fa-sort-numeric-up-alt {\n  --fa: \"\\f887\"; }\n\n.fa-litecoin-sign {\n  --fa: \"\\e1d3\"; }\n\n.fa-border-none {\n  --fa: \"\\f850\"; }\n\n.fa-circle-nodes {\n  --fa: \"\\e4e2\"; }\n\n.fa-parachute-box {\n  --fa: \"\\f4cd\"; }\n\n.fa-indent {\n  --fa: \"\\f03c\"; }\n\n.fa-truck-field-un {\n  --fa: \"\\e58e\"; }\n\n.fa-hourglass {\n  --fa: \"\\f254\"; }\n\n.fa-hourglass-empty {\n  --fa: \"\\f254\"; }\n\n.fa-mountain {\n  --fa: \"\\f6fc\"; }\n\n.fa-user-doctor {\n  --fa: \"\\f0f0\"; }\n\n.fa-user-md {\n  --fa: \"\\f0f0\"; }\n\n.fa-circle-info {\n  --fa: \"\\f05a\"; }\n\n.fa-info-circle {\n  --fa: \"\\f05a\"; }\n\n.fa-cloud-meatball {\n  --fa: \"\\f73b\"; }\n\n.fa-camera {\n  --fa: \"\\f030\"; }\n\n.fa-camera-alt {\n  --fa: \"\\f030\"; }\n\n.fa-square-virus {\n  --fa: \"\\e578\"; }\n\n.fa-meteor {\n  --fa: \"\\f753\"; }\n\n.fa-car-on {\n  --fa: \"\\e4dd\"; }\n\n.fa-sleigh {\n  --fa: \"\\f7cc\"; }\n\n.fa-arrow-down-1-9 {\n  --fa: \"\\f162\"; }\n\n.fa-sort-numeric-asc {\n  --fa: \"\\f162\"; }\n\n.fa-sort-numeric-down {\n  --fa: \"\\f162\"; }\n\n.fa-hand-holding-droplet {\n  --fa: \"\\f4c1\"; }\n\n.fa-hand-holding-water {\n  --fa: \"\\f4c1\"; }\n\n.fa-water {\n  --fa: \"\\f773\"; }\n\n.fa-calendar-check {\n  --fa: \"\\f274\"; }\n\n.fa-braille {\n  --fa: \"\\f2a1\"; }\n\n.fa-prescription-bottle-medical {\n  --fa: \"\\f486\"; }\n\n.fa-prescription-bottle-alt {\n  --fa: \"\\f486\"; }\n\n.fa-landmark {\n  --fa: \"\\f66f\"; }\n\n.fa-truck {\n  --fa: \"\\f0d1\"; }\n\n.fa-crosshairs {\n  --fa: \"\\f05b\"; }\n\n.fa-person-cane {\n  --fa: \"\\e53c\"; }\n\n.fa-tent {\n  --fa: \"\\e57d\"; }\n\n.fa-vest-patches {\n  --fa: \"\\e086\"; }\n\n.fa-check-double {\n  --fa: \"\\f560\"; }\n\n.fa-arrow-down-a-z {\n  --fa: \"\\f15d\"; }\n\n.fa-sort-alpha-asc {\n  --fa: \"\\f15d\"; }\n\n.fa-sort-alpha-down {\n  --fa: \"\\f15d\"; }\n\n.fa-money-bill-wheat {\n  --fa: \"\\e52a\"; }\n\n.fa-cookie {\n  --fa: \"\\f563\"; }\n\n.fa-arrow-rotate-left {\n  --fa: \"\\f0e2\"; }\n\n.fa-arrow-left-rotate {\n  --fa: \"\\f0e2\"; }\n\n.fa-arrow-rotate-back {\n  --fa: \"\\f0e2\"; }\n\n.fa-arrow-rotate-backward {\n  --fa: \"\\f0e2\"; }\n\n.fa-undo {\n  --fa: \"\\f0e2\"; }\n\n.fa-hard-drive {\n  --fa: \"\\f0a0\"; }\n\n.fa-hdd {\n  --fa: \"\\f0a0\"; }\n\n.fa-face-grin-squint-tears {\n  --fa: \"\\f586\"; }\n\n.fa-grin-squint-tears {\n  --fa: \"\\f586\"; }\n\n.fa-dumbbell {\n  --fa: \"\\f44b\"; }\n\n.fa-rectangle-list {\n  --fa: \"\\f022\"; }\n\n.fa-list-alt {\n  --fa: \"\\f022\"; }\n\n.fa-tarp-droplet {\n  --fa: \"\\e57c\"; }\n\n.fa-house-medical-circle-check {\n  --fa: \"\\e511\"; }\n\n.fa-person-skiing-nordic {\n  --fa: \"\\f7ca\"; }\n\n.fa-skiing-nordic {\n  --fa: \"\\f7ca\"; }\n\n.fa-calendar-plus {\n  --fa: \"\\f271\"; }\n\n.fa-plane-arrival {\n  --fa: \"\\f5af\"; }\n\n.fa-circle-left {\n  --fa: \"\\f359\"; }\n\n.fa-arrow-alt-circle-left {\n  --fa: \"\\f359\"; }\n\n.fa-train-subway {\n  --fa: \"\\f239\"; }\n\n.fa-subway {\n  --fa: \"\\f239\"; }\n\n.fa-chart-gantt {\n  --fa: \"\\e0e4\"; }\n\n.fa-indian-rupee-sign {\n  --fa: \"\\e1bc\"; }\n\n.fa-indian-rupee {\n  --fa: \"\\e1bc\"; }\n\n.fa-inr {\n  --fa: \"\\e1bc\"; }\n\n.fa-crop-simple {\n  --fa: \"\\f565\"; }\n\n.fa-crop-alt {\n  --fa: \"\\f565\"; }\n\n.fa-money-bill-1 {\n  --fa: \"\\f3d1\"; }\n\n.fa-money-bill-alt {\n  --fa: \"\\f3d1\"; }\n\n.fa-left-long {\n  --fa: \"\\f30a\"; }\n\n.fa-long-arrow-alt-left {\n  --fa: \"\\f30a\"; }\n\n.fa-dna {\n  --fa: \"\\f471\"; }\n\n.fa-virus-slash {\n  --fa: \"\\e075\"; }\n\n.fa-minus {\n  --fa: \"\\f068\"; }\n\n.fa-subtract {\n  --fa: \"\\f068\"; }\n\n.fa-chess {\n  --fa: \"\\f439\"; }\n\n.fa-arrow-left-long {\n  --fa: \"\\f177\"; }\n\n.fa-long-arrow-left {\n  --fa: \"\\f177\"; }\n\n.fa-plug-circle-check {\n  --fa: \"\\e55c\"; }\n\n.fa-street-view {\n  --fa: \"\\f21d\"; }\n\n.fa-franc-sign {\n  --fa: \"\\e18f\"; }\n\n.fa-volume-off {\n  --fa: \"\\f026\"; }\n\n.fa-hands-asl-interpreting {\n  --fa: \"\\f2a3\"; }\n\n.fa-american-sign-language-interpreting {\n  --fa: \"\\f2a3\"; }\n\n.fa-asl-interpreting {\n  --fa: \"\\f2a3\"; }\n\n.fa-hands-american-sign-language-interpreting {\n  --fa: \"\\f2a3\"; }\n\n.fa-gear {\n  --fa: \"\\f013\"; }\n\n.fa-cog {\n  --fa: \"\\f013\"; }\n\n.fa-droplet-slash {\n  --fa: \"\\f5c7\"; }\n\n.fa-tint-slash {\n  --fa: \"\\f5c7\"; }\n\n.fa-mosque {\n  --fa: \"\\f678\"; }\n\n.fa-mosquito {\n  --fa: \"\\e52b\"; }\n\n.fa-star-of-david {\n  --fa: \"\\f69a\"; }\n\n.fa-person-military-rifle {\n  --fa: \"\\e54b\"; }\n\n.fa-cart-shopping {\n  --fa: \"\\f07a\"; }\n\n.fa-shopping-cart {\n  --fa: \"\\f07a\"; }\n\n.fa-vials {\n  --fa: \"\\f493\"; }\n\n.fa-plug-circle-plus {\n  --fa: \"\\e55f\"; }\n\n.fa-place-of-worship {\n  --fa: \"\\f67f\"; }\n\n.fa-grip-vertical {\n  --fa: \"\\f58e\"; }\n\n.fa-hexagon-nodes {\n  --fa: \"\\e699\"; }\n\n.fa-arrow-turn-up {\n  --fa: \"\\f148\"; }\n\n.fa-level-up {\n  --fa: \"\\f148\"; }\n\n.fa-u {\n  --fa: \"\\55\"; }\n\n.fa-square-root-variable {\n  --fa: \"\\f698\"; }\n\n.fa-square-root-alt {\n  --fa: \"\\f698\"; }\n\n.fa-clock {\n  --fa: \"\\f017\"; }\n\n.fa-clock-four {\n  --fa: \"\\f017\"; }\n\n.fa-backward-step {\n  --fa: \"\\f048\"; }\n\n.fa-step-backward {\n  --fa: \"\\f048\"; }\n\n.fa-pallet {\n  --fa: \"\\f482\"; }\n\n.fa-faucet {\n  --fa: \"\\e005\"; }\n\n.fa-baseball-bat-ball {\n  --fa: \"\\f432\"; }\n\n.fa-s {\n  --fa: \"\\53\"; }\n\n.fa-timeline {\n  --fa: \"\\e29c\"; }\n\n.fa-keyboard {\n  --fa: \"\\f11c\"; }\n\n.fa-caret-down {\n  --fa: \"\\f0d7\"; }\n\n.fa-house-chimney-medical {\n  --fa: \"\\f7f2\"; }\n\n.fa-clinic-medical {\n  --fa: \"\\f7f2\"; }\n\n.fa-temperature-three-quarters {\n  --fa: \"\\f2c8\"; }\n\n.fa-temperature-3 {\n  --fa: \"\\f2c8\"; }\n\n.fa-thermometer-3 {\n  --fa: \"\\f2c8\"; }\n\n.fa-thermometer-three-quarters {\n  --fa: \"\\f2c8\"; }\n\n.fa-mobile-screen {\n  --fa: \"\\f3cf\"; }\n\n.fa-mobile-android-alt {\n  --fa: \"\\f3cf\"; }\n\n.fa-plane-up {\n  --fa: \"\\e22d\"; }\n\n.fa-piggy-bank {\n  --fa: \"\\f4d3\"; }\n\n.fa-battery-half {\n  --fa: \"\\f242\"; }\n\n.fa-battery-3 {\n  --fa: \"\\f242\"; }\n\n.fa-mountain-city {\n  --fa: \"\\e52e\"; }\n\n.fa-coins {\n  --fa: \"\\f51e\"; }\n\n.fa-khanda {\n  --fa: \"\\f66d\"; }\n\n.fa-sliders {\n  --fa: \"\\f1de\"; }\n\n.fa-sliders-h {\n  --fa: \"\\f1de\"; }\n\n.fa-folder-tree {\n  --fa: \"\\f802\"; }\n\n.fa-network-wired {\n  --fa: \"\\f6ff\"; }\n\n.fa-map-pin {\n  --fa: \"\\f276\"; }\n\n.fa-hamsa {\n  --fa: \"\\f665\"; }\n\n.fa-cent-sign {\n  --fa: \"\\e3f5\"; }\n\n.fa-flask {\n  --fa: \"\\f0c3\"; }\n\n.fa-person-pregnant {\n  --fa: \"\\e31e\"; }\n\n.fa-wand-sparkles {\n  --fa: \"\\f72b\"; }\n\n.fa-ellipsis-vertical {\n  --fa: \"\\f142\"; }\n\n.fa-ellipsis-v {\n  --fa: \"\\f142\"; }\n\n.fa-ticket {\n  --fa: \"\\f145\"; }\n\n.fa-power-off {\n  --fa: \"\\f011\"; }\n\n.fa-right-long {\n  --fa: \"\\f30b\"; }\n\n.fa-long-arrow-alt-right {\n  --fa: \"\\f30b\"; }\n\n.fa-flag-usa {\n  --fa: \"\\f74d\"; }\n\n.fa-laptop-file {\n  --fa: \"\\e51d\"; }\n\n.fa-tty {\n  --fa: \"\\f1e4\"; }\n\n.fa-teletype {\n  --fa: \"\\f1e4\"; }\n\n.fa-diagram-next {\n  --fa: \"\\e476\"; }\n\n.fa-person-rifle {\n  --fa: \"\\e54e\"; }\n\n.fa-house-medical-circle-exclamation {\n  --fa: \"\\e512\"; }\n\n.fa-closed-captioning {\n  --fa: \"\\f20a\"; }\n\n.fa-person-hiking {\n  --fa: \"\\f6ec\"; }\n\n.fa-hiking {\n  --fa: \"\\f6ec\"; }\n\n.fa-venus-double {\n  --fa: \"\\f226\"; }\n\n.fa-images {\n  --fa: \"\\f302\"; }\n\n.fa-calculator {\n  --fa: \"\\f1ec\"; }\n\n.fa-people-pulling {\n  --fa: \"\\e535\"; }\n\n.fa-n {\n  --fa: \"\\4e\"; }\n\n.fa-cable-car {\n  --fa: \"\\f7da\"; }\n\n.fa-tram {\n  --fa: \"\\f7da\"; }\n\n.fa-cloud-rain {\n  --fa: \"\\f73d\"; }\n\n.fa-building-circle-xmark {\n  --fa: \"\\e4d4\"; }\n\n.fa-ship {\n  --fa: \"\\f21a\"; }\n\n.fa-arrows-down-to-line {\n  --fa: \"\\e4b8\"; }\n\n.fa-download {\n  --fa: \"\\f019\"; }\n\n.fa-face-grin {\n  --fa: \"\\f580\"; }\n\n.fa-grin {\n  --fa: \"\\f580\"; }\n\n.fa-delete-left {\n  --fa: \"\\f55a\"; }\n\n.fa-backspace {\n  --fa: \"\\f55a\"; }\n\n.fa-eye-dropper {\n  --fa: \"\\f1fb\"; }\n\n.fa-eye-dropper-empty {\n  --fa: \"\\f1fb\"; }\n\n.fa-eyedropper {\n  --fa: \"\\f1fb\"; }\n\n.fa-file-circle-check {\n  --fa: \"\\e5a0\"; }\n\n.fa-forward {\n  --fa: \"\\f04e\"; }\n\n.fa-mobile {\n  --fa: \"\\f3ce\"; }\n\n.fa-mobile-android {\n  --fa: \"\\f3ce\"; }\n\n.fa-mobile-phone {\n  --fa: \"\\f3ce\"; }\n\n.fa-face-meh {\n  --fa: \"\\f11a\"; }\n\n.fa-meh {\n  --fa: \"\\f11a\"; }\n\n.fa-align-center {\n  --fa: \"\\f037\"; }\n\n.fa-book-skull {\n  --fa: \"\\f6b7\"; }\n\n.fa-book-dead {\n  --fa: \"\\f6b7\"; }\n\n.fa-id-card {\n  --fa: \"\\f2c2\"; }\n\n.fa-drivers-license {\n  --fa: \"\\f2c2\"; }\n\n.fa-outdent {\n  --fa: \"\\f03b\"; }\n\n.fa-dedent {\n  --fa: \"\\f03b\"; }\n\n.fa-heart-circle-exclamation {\n  --fa: \"\\e4fe\"; }\n\n.fa-house {\n  --fa: \"\\f015\"; }\n\n.fa-home {\n  --fa: \"\\f015\"; }\n\n.fa-home-alt {\n  --fa: \"\\f015\"; }\n\n.fa-home-lg-alt {\n  --fa: \"\\f015\"; }\n\n.fa-calendar-week {\n  --fa: \"\\f784\"; }\n\n.fa-laptop-medical {\n  --fa: \"\\f812\"; }\n\n.fa-b {\n  --fa: \"\\42\"; }\n\n.fa-file-medical {\n  --fa: \"\\f477\"; }\n\n.fa-dice-one {\n  --fa: \"\\f525\"; }\n\n.fa-kiwi-bird {\n  --fa: \"\\f535\"; }\n\n.fa-arrow-right-arrow-left {\n  --fa: \"\\f0ec\"; }\n\n.fa-exchange {\n  --fa: \"\\f0ec\"; }\n\n.fa-rotate-right {\n  --fa: \"\\f2f9\"; }\n\n.fa-redo-alt {\n  --fa: \"\\f2f9\"; }\n\n.fa-rotate-forward {\n  --fa: \"\\f2f9\"; }\n\n.fa-utensils {\n  --fa: \"\\f2e7\"; }\n\n.fa-cutlery {\n  --fa: \"\\f2e7\"; }\n\n.fa-arrow-up-wide-short {\n  --fa: \"\\f161\"; }\n\n.fa-sort-amount-up {\n  --fa: \"\\f161\"; }\n\n.fa-mill-sign {\n  --fa: \"\\e1ed\"; }\n\n.fa-bowl-rice {\n  --fa: \"\\e2eb\"; }\n\n.fa-skull {\n  --fa: \"\\f54c\"; }\n\n.fa-tower-broadcast {\n  --fa: \"\\f519\"; }\n\n.fa-broadcast-tower {\n  --fa: \"\\f519\"; }\n\n.fa-truck-pickup {\n  --fa: \"\\f63c\"; }\n\n.fa-up-long {\n  --fa: \"\\f30c\"; }\n\n.fa-long-arrow-alt-up {\n  --fa: \"\\f30c\"; }\n\n.fa-stop {\n  --fa: \"\\f04d\"; }\n\n.fa-code-merge {\n  --fa: \"\\f387\"; }\n\n.fa-upload {\n  --fa: \"\\f093\"; }\n\n.fa-hurricane {\n  --fa: \"\\f751\"; }\n\n.fa-mound {\n  --fa: \"\\e52d\"; }\n\n.fa-toilet-portable {\n  --fa: \"\\e583\"; }\n\n.fa-compact-disc {\n  --fa: \"\\f51f\"; }\n\n.fa-file-arrow-down {\n  --fa: \"\\f56d\"; }\n\n.fa-file-download {\n  --fa: \"\\f56d\"; }\n\n.fa-caravan {\n  --fa: \"\\f8ff\"; }\n\n.fa-shield-cat {\n  --fa: \"\\e572\"; }\n\n.fa-bolt {\n  --fa: \"\\f0e7\"; }\n\n.fa-zap {\n  --fa: \"\\f0e7\"; }\n\n.fa-glass-water {\n  --fa: \"\\e4f4\"; }\n\n.fa-oil-well {\n  --fa: \"\\e532\"; }\n\n.fa-vault {\n  --fa: \"\\e2c5\"; }\n\n.fa-mars {\n  --fa: \"\\f222\"; }\n\n.fa-toilet {\n  --fa: \"\\f7d8\"; }\n\n.fa-plane-circle-xmark {\n  --fa: \"\\e557\"; }\n\n.fa-yen-sign {\n  --fa: \"\\f157\"; }\n\n.fa-cny {\n  --fa: \"\\f157\"; }\n\n.fa-jpy {\n  --fa: \"\\f157\"; }\n\n.fa-rmb {\n  --fa: \"\\f157\"; }\n\n.fa-yen {\n  --fa: \"\\f157\"; }\n\n.fa-ruble-sign {\n  --fa: \"\\f158\"; }\n\n.fa-rouble {\n  --fa: \"\\f158\"; }\n\n.fa-rub {\n  --fa: \"\\f158\"; }\n\n.fa-ruble {\n  --fa: \"\\f158\"; }\n\n.fa-sun {\n  --fa: \"\\f185\"; }\n\n.fa-guitar {\n  --fa: \"\\f7a6\"; }\n\n.fa-face-laugh-wink {\n  --fa: \"\\f59c\"; }\n\n.fa-laugh-wink {\n  --fa: \"\\f59c\"; }\n\n.fa-horse-head {\n  --fa: \"\\f7ab\"; }\n\n.fa-bore-hole {\n  --fa: \"\\e4c3\"; }\n\n.fa-industry {\n  --fa: \"\\f275\"; }\n\n.fa-circle-down {\n  --fa: \"\\f358\"; }\n\n.fa-arrow-alt-circle-down {\n  --fa: \"\\f358\"; }\n\n.fa-arrows-turn-to-dots {\n  --fa: \"\\e4c1\"; }\n\n.fa-florin-sign {\n  --fa: \"\\e184\"; }\n\n.fa-arrow-down-short-wide {\n  --fa: \"\\f884\"; }\n\n.fa-sort-amount-desc {\n  --fa: \"\\f884\"; }\n\n.fa-sort-amount-down-alt {\n  --fa: \"\\f884\"; }\n\n.fa-less-than {\n  --fa: \"\\3c\"; }\n\n.fa-angle-down {\n  --fa: \"\\f107\"; }\n\n.fa-car-tunnel {\n  --fa: \"\\e4de\"; }\n\n.fa-head-side-cough {\n  --fa: \"\\e061\"; }\n\n.fa-grip-lines {\n  --fa: \"\\f7a4\"; }\n\n.fa-thumbs-down {\n  --fa: \"\\f165\"; }\n\n.fa-user-lock {\n  --fa: \"\\f502\"; }\n\n.fa-arrow-right-long {\n  --fa: \"\\f178\"; }\n\n.fa-long-arrow-right {\n  --fa: \"\\f178\"; }\n\n.fa-anchor-circle-xmark {\n  --fa: \"\\e4ac\"; }\n\n.fa-ellipsis {\n  --fa: \"\\f141\"; }\n\n.fa-ellipsis-h {\n  --fa: \"\\f141\"; }\n\n.fa-chess-pawn {\n  --fa: \"\\f443\"; }\n\n.fa-kit-medical {\n  --fa: \"\\f479\"; }\n\n.fa-first-aid {\n  --fa: \"\\f479\"; }\n\n.fa-person-through-window {\n  --fa: \"\\e5a9\"; }\n\n.fa-toolbox {\n  --fa: \"\\f552\"; }\n\n.fa-hands-holding-circle {\n  --fa: \"\\e4fb\"; }\n\n.fa-bug {\n  --fa: \"\\f188\"; }\n\n.fa-credit-card {\n  --fa: \"\\f09d\"; }\n\n.fa-credit-card-alt {\n  --fa: \"\\f09d\"; }\n\n.fa-car {\n  --fa: \"\\f1b9\"; }\n\n.fa-automobile {\n  --fa: \"\\f1b9\"; }\n\n.fa-hand-holding-hand {\n  --fa: \"\\e4f7\"; }\n\n.fa-book-open-reader {\n  --fa: \"\\f5da\"; }\n\n.fa-book-reader {\n  --fa: \"\\f5da\"; }\n\n.fa-mountain-sun {\n  --fa: \"\\e52f\"; }\n\n.fa-arrows-left-right-to-line {\n  --fa: \"\\e4ba\"; }\n\n.fa-dice-d20 {\n  --fa: \"\\f6cf\"; }\n\n.fa-truck-droplet {\n  --fa: \"\\e58c\"; }\n\n.fa-file-circle-xmark {\n  --fa: \"\\e5a1\"; }\n\n.fa-temperature-arrow-up {\n  --fa: \"\\e040\"; }\n\n.fa-temperature-up {\n  --fa: \"\\e040\"; }\n\n.fa-medal {\n  --fa: \"\\f5a2\"; }\n\n.fa-bed {\n  --fa: \"\\f236\"; }\n\n.fa-square-h {\n  --fa: \"\\f0fd\"; }\n\n.fa-h-square {\n  --fa: \"\\f0fd\"; }\n\n.fa-podcast {\n  --fa: \"\\f2ce\"; }\n\n.fa-temperature-full {\n  --fa: \"\\f2c7\"; }\n\n.fa-temperature-4 {\n  --fa: \"\\f2c7\"; }\n\n.fa-thermometer-4 {\n  --fa: \"\\f2c7\"; }\n\n.fa-thermometer-full {\n  --fa: \"\\f2c7\"; }\n\n.fa-bell {\n  --fa: \"\\f0f3\"; }\n\n.fa-superscript {\n  --fa: \"\\f12b\"; }\n\n.fa-plug-circle-xmark {\n  --fa: \"\\e560\"; }\n\n.fa-star-of-life {\n  --fa: \"\\f621\"; }\n\n.fa-phone-slash {\n  --fa: \"\\f3dd\"; }\n\n.fa-paint-roller {\n  --fa: \"\\f5aa\"; }\n\n.fa-handshake-angle {\n  --fa: \"\\f4c4\"; }\n\n.fa-hands-helping {\n  --fa: \"\\f4c4\"; }\n\n.fa-location-dot {\n  --fa: \"\\f3c5\"; }\n\n.fa-map-marker-alt {\n  --fa: \"\\f3c5\"; }\n\n.fa-file {\n  --fa: \"\\f15b\"; }\n\n.fa-greater-than {\n  --fa: \"\\3e\"; }\n\n.fa-person-swimming {\n  --fa: \"\\f5c4\"; }\n\n.fa-swimmer {\n  --fa: \"\\f5c4\"; }\n\n.fa-arrow-down {\n  --fa: \"\\f063\"; }\n\n.fa-droplet {\n  --fa: \"\\f043\"; }\n\n.fa-tint {\n  --fa: \"\\f043\"; }\n\n.fa-eraser {\n  --fa: \"\\f12d\"; }\n\n.fa-earth-americas {\n  --fa: \"\\f57d\"; }\n\n.fa-earth {\n  --fa: \"\\f57d\"; }\n\n.fa-earth-america {\n  --fa: \"\\f57d\"; }\n\n.fa-globe-americas {\n  --fa: \"\\f57d\"; }\n\n.fa-person-burst {\n  --fa: \"\\e53b\"; }\n\n.fa-dove {\n  --fa: \"\\f4ba\"; }\n\n.fa-battery-empty {\n  --fa: \"\\f244\"; }\n\n.fa-battery-0 {\n  --fa: \"\\f244\"; }\n\n.fa-socks {\n  --fa: \"\\f696\"; }\n\n.fa-inbox {\n  --fa: \"\\f01c\"; }\n\n.fa-section {\n  --fa: \"\\e447\"; }\n\n.fa-gauge-high {\n  --fa: \"\\f625\"; }\n\n.fa-tachometer-alt {\n  --fa: \"\\f625\"; }\n\n.fa-tachometer-alt-fast {\n  --fa: \"\\f625\"; }\n\n.fa-envelope-open-text {\n  --fa: \"\\f658\"; }\n\n.fa-hospital {\n  --fa: \"\\f0f8\"; }\n\n.fa-hospital-alt {\n  --fa: \"\\f0f8\"; }\n\n.fa-hospital-wide {\n  --fa: \"\\f0f8\"; }\n\n.fa-wine-bottle {\n  --fa: \"\\f72f\"; }\n\n.fa-chess-rook {\n  --fa: \"\\f447\"; }\n\n.fa-bars-staggered {\n  --fa: \"\\f550\"; }\n\n.fa-reorder {\n  --fa: \"\\f550\"; }\n\n.fa-stream {\n  --fa: \"\\f550\"; }\n\n.fa-dharmachakra {\n  --fa: \"\\f655\"; }\n\n.fa-hotdog {\n  --fa: \"\\f80f\"; }\n\n.fa-person-walking-with-cane {\n  --fa: \"\\f29d\"; }\n\n.fa-blind {\n  --fa: \"\\f29d\"; }\n\n.fa-drum {\n  --fa: \"\\f569\"; }\n\n.fa-ice-cream {\n  --fa: \"\\f810\"; }\n\n.fa-heart-circle-bolt {\n  --fa: \"\\e4fc\"; }\n\n.fa-fax {\n  --fa: \"\\f1ac\"; }\n\n.fa-paragraph {\n  --fa: \"\\f1dd\"; }\n\n.fa-check-to-slot {\n  --fa: \"\\f772\"; }\n\n.fa-vote-yea {\n  --fa: \"\\f772\"; }\n\n.fa-star-half {\n  --fa: \"\\f089\"; }\n\n.fa-boxes-stacked {\n  --fa: \"\\f468\"; }\n\n.fa-boxes {\n  --fa: \"\\f468\"; }\n\n.fa-boxes-alt {\n  --fa: \"\\f468\"; }\n\n.fa-link {\n  --fa: \"\\f0c1\"; }\n\n.fa-chain {\n  --fa: \"\\f0c1\"; }\n\n.fa-ear-listen {\n  --fa: \"\\f2a2\"; }\n\n.fa-assistive-listening-systems {\n  --fa: \"\\f2a2\"; }\n\n.fa-tree-city {\n  --fa: \"\\e587\"; }\n\n.fa-play {\n  --fa: \"\\f04b\"; }\n\n.fa-font {\n  --fa: \"\\f031\"; }\n\n.fa-table-cells-row-lock {\n  --fa: \"\\e67a\"; }\n\n.fa-rupiah-sign {\n  --fa: \"\\e23d\"; }\n\n.fa-magnifying-glass {\n  --fa: \"\\f002\"; }\n\n.fa-search {\n  --fa: \"\\f002\"; }\n\n.fa-table-tennis-paddle-ball {\n  --fa: \"\\f45d\"; }\n\n.fa-ping-pong-paddle-ball {\n  --fa: \"\\f45d\"; }\n\n.fa-table-tennis {\n  --fa: \"\\f45d\"; }\n\n.fa-person-dots-from-line {\n  --fa: \"\\f470\"; }\n\n.fa-diagnoses {\n  --fa: \"\\f470\"; }\n\n.fa-trash-can-arrow-up {\n  --fa: \"\\f82a\"; }\n\n.fa-trash-restore-alt {\n  --fa: \"\\f82a\"; }\n\n.fa-naira-sign {\n  --fa: \"\\e1f6\"; }\n\n.fa-cart-arrow-down {\n  --fa: \"\\f218\"; }\n\n.fa-walkie-talkie {\n  --fa: \"\\f8ef\"; }\n\n.fa-file-pen {\n  --fa: \"\\f31c\"; }\n\n.fa-file-edit {\n  --fa: \"\\f31c\"; }\n\n.fa-receipt {\n  --fa: \"\\f543\"; }\n\n.fa-square-pen {\n  --fa: \"\\f14b\"; }\n\n.fa-pen-square {\n  --fa: \"\\f14b\"; }\n\n.fa-pencil-square {\n  --fa: \"\\f14b\"; }\n\n.fa-suitcase-rolling {\n  --fa: \"\\f5c1\"; }\n\n.fa-person-circle-exclamation {\n  --fa: \"\\e53f\"; }\n\n.fa-chevron-down {\n  --fa: \"\\f078\"; }\n\n.fa-battery-full {\n  --fa: \"\\f240\"; }\n\n.fa-battery {\n  --fa: \"\\f240\"; }\n\n.fa-battery-5 {\n  --fa: \"\\f240\"; }\n\n.fa-skull-crossbones {\n  --fa: \"\\f714\"; }\n\n.fa-code-compare {\n  --fa: \"\\e13a\"; }\n\n.fa-list-ul {\n  --fa: \"\\f0ca\"; }\n\n.fa-list-dots {\n  --fa: \"\\f0ca\"; }\n\n.fa-school-lock {\n  --fa: \"\\e56f\"; }\n\n.fa-tower-cell {\n  --fa: \"\\e585\"; }\n\n.fa-down-long {\n  --fa: \"\\f309\"; }\n\n.fa-long-arrow-alt-down {\n  --fa: \"\\f309\"; }\n\n.fa-ranking-star {\n  --fa: \"\\e561\"; }\n\n.fa-chess-king {\n  --fa: \"\\f43f\"; }\n\n.fa-person-harassing {\n  --fa: \"\\e549\"; }\n\n.fa-brazilian-real-sign {\n  --fa: \"\\e46c\"; }\n\n.fa-landmark-dome {\n  --fa: \"\\f752\"; }\n\n.fa-landmark-alt {\n  --fa: \"\\f752\"; }\n\n.fa-arrow-up {\n  --fa: \"\\f062\"; }\n\n.fa-tv {\n  --fa: \"\\f26c\"; }\n\n.fa-television {\n  --fa: \"\\f26c\"; }\n\n.fa-tv-alt {\n  --fa: \"\\f26c\"; }\n\n.fa-shrimp {\n  --fa: \"\\e448\"; }\n\n.fa-list-check {\n  --fa: \"\\f0ae\"; }\n\n.fa-tasks {\n  --fa: \"\\f0ae\"; }\n\n.fa-jug-detergent {\n  --fa: \"\\e519\"; }\n\n.fa-circle-user {\n  --fa: \"\\f2bd\"; }\n\n.fa-user-circle {\n  --fa: \"\\f2bd\"; }\n\n.fa-user-shield {\n  --fa: \"\\f505\"; }\n\n.fa-wind {\n  --fa: \"\\f72e\"; }\n\n.fa-car-burst {\n  --fa: \"\\f5e1\"; }\n\n.fa-car-crash {\n  --fa: \"\\f5e1\"; }\n\n.fa-y {\n  --fa: \"\\59\"; }\n\n.fa-person-snowboarding {\n  --fa: \"\\f7ce\"; }\n\n.fa-snowboarding {\n  --fa: \"\\f7ce\"; }\n\n.fa-truck-fast {\n  --fa: \"\\f48b\"; }\n\n.fa-shipping-fast {\n  --fa: \"\\f48b\"; }\n\n.fa-fish {\n  --fa: \"\\f578\"; }\n\n.fa-user-graduate {\n  --fa: \"\\f501\"; }\n\n.fa-circle-half-stroke {\n  --fa: \"\\f042\"; }\n\n.fa-adjust {\n  --fa: \"\\f042\"; }\n\n.fa-clapperboard {\n  --fa: \"\\e131\"; }\n\n.fa-circle-radiation {\n  --fa: \"\\f7ba\"; }\n\n.fa-radiation-alt {\n  --fa: \"\\f7ba\"; }\n\n.fa-baseball {\n  --fa: \"\\f433\"; }\n\n.fa-baseball-ball {\n  --fa: \"\\f433\"; }\n\n.fa-jet-fighter-up {\n  --fa: \"\\e518\"; }\n\n.fa-diagram-project {\n  --fa: \"\\f542\"; }\n\n.fa-project-diagram {\n  --fa: \"\\f542\"; }\n\n.fa-copy {\n  --fa: \"\\f0c5\"; }\n\n.fa-volume-xmark {\n  --fa: \"\\f6a9\"; }\n\n.fa-volume-mute {\n  --fa: \"\\f6a9\"; }\n\n.fa-volume-times {\n  --fa: \"\\f6a9\"; }\n\n.fa-hand-sparkles {\n  --fa: \"\\e05d\"; }\n\n.fa-grip {\n  --fa: \"\\f58d\"; }\n\n.fa-grip-horizontal {\n  --fa: \"\\f58d\"; }\n\n.fa-share-from-square {\n  --fa: \"\\f14d\"; }\n\n.fa-share-square {\n  --fa: \"\\f14d\"; }\n\n.fa-child-combatant {\n  --fa: \"\\e4e0\"; }\n\n.fa-child-rifle {\n  --fa: \"\\e4e0\"; }\n\n.fa-gun {\n  --fa: \"\\e19b\"; }\n\n.fa-square-phone {\n  --fa: \"\\f098\"; }\n\n.fa-phone-square {\n  --fa: \"\\f098\"; }\n\n.fa-plus {\n  --fa: \"\\2b\"; }\n\n.fa-add {\n  --fa: \"\\2b\"; }\n\n.fa-expand {\n  --fa: \"\\f065\"; }\n\n.fa-computer {\n  --fa: \"\\e4e5\"; }\n\n.fa-xmark {\n  --fa: \"\\f00d\"; }\n\n.fa-close {\n  --fa: \"\\f00d\"; }\n\n.fa-multiply {\n  --fa: \"\\f00d\"; }\n\n.fa-remove {\n  --fa: \"\\f00d\"; }\n\n.fa-times {\n  --fa: \"\\f00d\"; }\n\n.fa-arrows-up-down-left-right {\n  --fa: \"\\f047\"; }\n\n.fa-arrows {\n  --fa: \"\\f047\"; }\n\n.fa-chalkboard-user {\n  --fa: \"\\f51c\"; }\n\n.fa-chalkboard-teacher {\n  --fa: \"\\f51c\"; }\n\n.fa-peso-sign {\n  --fa: \"\\e222\"; }\n\n.fa-building-shield {\n  --fa: \"\\e4d8\"; }\n\n.fa-baby {\n  --fa: \"\\f77c\"; }\n\n.fa-users-line {\n  --fa: \"\\e592\"; }\n\n.fa-quote-left {\n  --fa: \"\\f10d\"; }\n\n.fa-quote-left-alt {\n  --fa: \"\\f10d\"; }\n\n.fa-tractor {\n  --fa: \"\\f722\"; }\n\n.fa-trash-arrow-up {\n  --fa: \"\\f829\"; }\n\n.fa-trash-restore {\n  --fa: \"\\f829\"; }\n\n.fa-arrow-down-up-lock {\n  --fa: \"\\e4b0\"; }\n\n.fa-lines-leaning {\n  --fa: \"\\e51e\"; }\n\n.fa-ruler-combined {\n  --fa: \"\\f546\"; }\n\n.fa-copyright {\n  --fa: \"\\f1f9\"; }\n\n.fa-equals {\n  --fa: \"\\3d\"; }\n\n.fa-blender {\n  --fa: \"\\f517\"; }\n\n.fa-teeth {\n  --fa: \"\\f62e\"; }\n\n.fa-shekel-sign {\n  --fa: \"\\f20b\"; }\n\n.fa-ils {\n  --fa: \"\\f20b\"; }\n\n.fa-shekel {\n  --fa: \"\\f20b\"; }\n\n.fa-sheqel {\n  --fa: \"\\f20b\"; }\n\n.fa-sheqel-sign {\n  --fa: \"\\f20b\"; }\n\n.fa-map {\n  --fa: \"\\f279\"; }\n\n.fa-rocket {\n  --fa: \"\\f135\"; }\n\n.fa-photo-film {\n  --fa: \"\\f87c\"; }\n\n.fa-photo-video {\n  --fa: \"\\f87c\"; }\n\n.fa-folder-minus {\n  --fa: \"\\f65d\"; }\n\n.fa-hexagon-nodes-bolt {\n  --fa: \"\\e69a\"; }\n\n.fa-store {\n  --fa: \"\\f54e\"; }\n\n.fa-arrow-trend-up {\n  --fa: \"\\e098\"; }\n\n.fa-plug-circle-minus {\n  --fa: \"\\e55e\"; }\n\n.fa-sign-hanging {\n  --fa: \"\\f4d9\"; }\n\n.fa-sign {\n  --fa: \"\\f4d9\"; }\n\n.fa-bezier-curve {\n  --fa: \"\\f55b\"; }\n\n.fa-bell-slash {\n  --fa: \"\\f1f6\"; }\n\n.fa-tablet {\n  --fa: \"\\f3fb\"; }\n\n.fa-tablet-android {\n  --fa: \"\\f3fb\"; }\n\n.fa-school-flag {\n  --fa: \"\\e56e\"; }\n\n.fa-fill {\n  --fa: \"\\f575\"; }\n\n.fa-angle-up {\n  --fa: \"\\f106\"; }\n\n.fa-drumstick-bite {\n  --fa: \"\\f6d7\"; }\n\n.fa-holly-berry {\n  --fa: \"\\f7aa\"; }\n\n.fa-chevron-left {\n  --fa: \"\\f053\"; }\n\n.fa-bacteria {\n  --fa: \"\\e059\"; }\n\n.fa-hand-lizard {\n  --fa: \"\\f258\"; }\n\n.fa-notdef {\n  --fa: \"\\e1fe\"; }\n\n.fa-disease {\n  --fa: \"\\f7fa\"; }\n\n.fa-briefcase-medical {\n  --fa: \"\\f469\"; }\n\n.fa-genderless {\n  --fa: \"\\f22d\"; }\n\n.fa-chevron-right {\n  --fa: \"\\f054\"; }\n\n.fa-retweet {\n  --fa: \"\\f079\"; }\n\n.fa-car-rear {\n  --fa: \"\\f5de\"; }\n\n.fa-car-alt {\n  --fa: \"\\f5de\"; }\n\n.fa-pump-soap {\n  --fa: \"\\e06b\"; }\n\n.fa-video-slash {\n  --fa: \"\\f4e2\"; }\n\n.fa-battery-quarter {\n  --fa: \"\\f243\"; }\n\n.fa-battery-2 {\n  --fa: \"\\f243\"; }\n\n.fa-radio {\n  --fa: \"\\f8d7\"; }\n\n.fa-baby-carriage {\n  --fa: \"\\f77d\"; }\n\n.fa-carriage-baby {\n  --fa: \"\\f77d\"; }\n\n.fa-traffic-light {\n  --fa: \"\\f637\"; }\n\n.fa-thermometer {\n  --fa: \"\\f491\"; }\n\n.fa-vr-cardboard {\n  --fa: \"\\f729\"; }\n\n.fa-hand-middle-finger {\n  --fa: \"\\f806\"; }\n\n.fa-percent {\n  --fa: \"\\25\"; }\n\n.fa-percentage {\n  --fa: \"\\25\"; }\n\n.fa-truck-moving {\n  --fa: \"\\f4df\"; }\n\n.fa-glass-water-droplet {\n  --fa: \"\\e4f5\"; }\n\n.fa-display {\n  --fa: \"\\e163\"; }\n\n.fa-face-smile {\n  --fa: \"\\f118\"; }\n\n.fa-smile {\n  --fa: \"\\f118\"; }\n\n.fa-thumbtack {\n  --fa: \"\\f08d\"; }\n\n.fa-thumb-tack {\n  --fa: \"\\f08d\"; }\n\n.fa-trophy {\n  --fa: \"\\f091\"; }\n\n.fa-person-praying {\n  --fa: \"\\f683\"; }\n\n.fa-pray {\n  --fa: \"\\f683\"; }\n\n.fa-hammer {\n  --fa: \"\\f6e3\"; }\n\n.fa-hand-peace {\n  --fa: \"\\f25b\"; }\n\n.fa-rotate {\n  --fa: \"\\f2f1\"; }\n\n.fa-sync-alt {\n  --fa: \"\\f2f1\"; }\n\n.fa-spinner {\n  --fa: \"\\f110\"; }\n\n.fa-robot {\n  --fa: \"\\f544\"; }\n\n.fa-peace {\n  --fa: \"\\f67c\"; }\n\n.fa-gears {\n  --fa: \"\\f085\"; }\n\n.fa-cogs {\n  --fa: \"\\f085\"; }\n\n.fa-warehouse {\n  --fa: \"\\f494\"; }\n\n.fa-arrow-up-right-dots {\n  --fa: \"\\e4b7\"; }\n\n.fa-splotch {\n  --fa: \"\\f5bc\"; }\n\n.fa-face-grin-hearts {\n  --fa: \"\\f584\"; }\n\n.fa-grin-hearts {\n  --fa: \"\\f584\"; }\n\n.fa-dice-four {\n  --fa: \"\\f524\"; }\n\n.fa-sim-card {\n  --fa: \"\\f7c4\"; }\n\n.fa-transgender {\n  --fa: \"\\f225\"; }\n\n.fa-transgender-alt {\n  --fa: \"\\f225\"; }\n\n.fa-mercury {\n  --fa: \"\\f223\"; }\n\n.fa-arrow-turn-down {\n  --fa: \"\\f149\"; }\n\n.fa-level-down {\n  --fa: \"\\f149\"; }\n\n.fa-person-falling-burst {\n  --fa: \"\\e547\"; }\n\n.fa-award {\n  --fa: \"\\f559\"; }\n\n.fa-ticket-simple {\n  --fa: \"\\f3ff\"; }\n\n.fa-ticket-alt {\n  --fa: \"\\f3ff\"; }\n\n.fa-building {\n  --fa: \"\\f1ad\"; }\n\n.fa-angles-left {\n  --fa: \"\\f100\"; }\n\n.fa-angle-double-left {\n  --fa: \"\\f100\"; }\n\n.fa-qrcode {\n  --fa: \"\\f029\"; }\n\n.fa-clock-rotate-left {\n  --fa: \"\\f1da\"; }\n\n.fa-history {\n  --fa: \"\\f1da\"; }\n\n.fa-face-grin-beam-sweat {\n  --fa: \"\\f583\"; }\n\n.fa-grin-beam-sweat {\n  --fa: \"\\f583\"; }\n\n.fa-file-export {\n  --fa: \"\\f56e\"; }\n\n.fa-arrow-right-from-file {\n  --fa: \"\\f56e\"; }\n\n.fa-shield {\n  --fa: \"\\f132\"; }\n\n.fa-shield-blank {\n  --fa: \"\\f132\"; }\n\n.fa-arrow-up-short-wide {\n  --fa: \"\\f885\"; }\n\n.fa-sort-amount-up-alt {\n  --fa: \"\\f885\"; }\n\n.fa-comment-nodes {\n  --fa: \"\\e696\"; }\n\n.fa-house-medical {\n  --fa: \"\\e3b2\"; }\n\n.fa-golf-ball-tee {\n  --fa: \"\\f450\"; }\n\n.fa-golf-ball {\n  --fa: \"\\f450\"; }\n\n.fa-circle-chevron-left {\n  --fa: \"\\f137\"; }\n\n.fa-chevron-circle-left {\n  --fa: \"\\f137\"; }\n\n.fa-house-chimney-window {\n  --fa: \"\\e00d\"; }\n\n.fa-pen-nib {\n  --fa: \"\\f5ad\"; }\n\n.fa-tent-arrow-turn-left {\n  --fa: \"\\e580\"; }\n\n.fa-tents {\n  --fa: \"\\e582\"; }\n\n.fa-wand-magic {\n  --fa: \"\\f0d0\"; }\n\n.fa-magic {\n  --fa: \"\\f0d0\"; }\n\n.fa-dog {\n  --fa: \"\\f6d3\"; }\n\n.fa-carrot {\n  --fa: \"\\f787\"; }\n\n.fa-moon {\n  --fa: \"\\f186\"; }\n\n.fa-wine-glass-empty {\n  --fa: \"\\f5ce\"; }\n\n.fa-wine-glass-alt {\n  --fa: \"\\f5ce\"; }\n\n.fa-cheese {\n  --fa: \"\\f7ef\"; }\n\n.fa-yin-yang {\n  --fa: \"\\f6ad\"; }\n\n.fa-music {\n  --fa: \"\\f001\"; }\n\n.fa-code-commit {\n  --fa: \"\\f386\"; }\n\n.fa-temperature-low {\n  --fa: \"\\f76b\"; }\n\n.fa-person-biking {\n  --fa: \"\\f84a\"; }\n\n.fa-biking {\n  --fa: \"\\f84a\"; }\n\n.fa-broom {\n  --fa: \"\\f51a\"; }\n\n.fa-shield-heart {\n  --fa: \"\\e574\"; }\n\n.fa-gopuram {\n  --fa: \"\\f664\"; }\n\n.fa-earth-oceania {\n  --fa: \"\\e47b\"; }\n\n.fa-globe-oceania {\n  --fa: \"\\e47b\"; }\n\n.fa-square-xmark {\n  --fa: \"\\f2d3\"; }\n\n.fa-times-square {\n  --fa: \"\\f2d3\"; }\n\n.fa-xmark-square {\n  --fa: \"\\f2d3\"; }\n\n.fa-hashtag {\n  --fa: \"\\23\"; }\n\n.fa-up-right-and-down-left-from-center {\n  --fa: \"\\f424\"; }\n\n.fa-expand-alt {\n  --fa: \"\\f424\"; }\n\n.fa-oil-can {\n  --fa: \"\\f613\"; }\n\n.fa-t {\n  --fa: \"\\54\"; }\n\n.fa-hippo {\n  --fa: \"\\f6ed\"; }\n\n.fa-chart-column {\n  --fa: \"\\e0e3\"; }\n\n.fa-infinity {\n  --fa: \"\\f534\"; }\n\n.fa-vial-circle-check {\n  --fa: \"\\e596\"; }\n\n.fa-person-arrow-down-to-line {\n  --fa: \"\\e538\"; }\n\n.fa-voicemail {\n  --fa: \"\\f897\"; }\n\n.fa-fan {\n  --fa: \"\\f863\"; }\n\n.fa-person-walking-luggage {\n  --fa: \"\\e554\"; }\n\n.fa-up-down {\n  --fa: \"\\f338\"; }\n\n.fa-arrows-alt-v {\n  --fa: \"\\f338\"; }\n\n.fa-cloud-moon-rain {\n  --fa: \"\\f73c\"; }\n\n.fa-calendar {\n  --fa: \"\\f133\"; }\n\n.fa-trailer {\n  --fa: \"\\e041\"; }\n\n.fa-bahai {\n  --fa: \"\\f666\"; }\n\n.fa-haykal {\n  --fa: \"\\f666\"; }\n\n.fa-sd-card {\n  --fa: \"\\f7c2\"; }\n\n.fa-dragon {\n  --fa: \"\\f6d5\"; }\n\n.fa-shoe-prints {\n  --fa: \"\\f54b\"; }\n\n.fa-circle-plus {\n  --fa: \"\\f055\"; }\n\n.fa-plus-circle {\n  --fa: \"\\f055\"; }\n\n.fa-face-grin-tongue-wink {\n  --fa: \"\\f58b\"; }\n\n.fa-grin-tongue-wink {\n  --fa: \"\\f58b\"; }\n\n.fa-hand-holding {\n  --fa: \"\\f4bd\"; }\n\n.fa-plug-circle-exclamation {\n  --fa: \"\\e55d\"; }\n\n.fa-link-slash {\n  --fa: \"\\f127\"; }\n\n.fa-chain-broken {\n  --fa: \"\\f127\"; }\n\n.fa-chain-slash {\n  --fa: \"\\f127\"; }\n\n.fa-unlink {\n  --fa: \"\\f127\"; }\n\n.fa-clone {\n  --fa: \"\\f24d\"; }\n\n.fa-person-walking-arrow-loop-left {\n  --fa: \"\\e551\"; }\n\n.fa-arrow-up-z-a {\n  --fa: \"\\f882\"; }\n\n.fa-sort-alpha-up-alt {\n  --fa: \"\\f882\"; }\n\n.fa-fire-flame-curved {\n  --fa: \"\\f7e4\"; }\n\n.fa-fire-alt {\n  --fa: \"\\f7e4\"; }\n\n.fa-tornado {\n  --fa: \"\\f76f\"; }\n\n.fa-file-circle-plus {\n  --fa: \"\\e494\"; }\n\n.fa-book-quran {\n  --fa: \"\\f687\"; }\n\n.fa-quran {\n  --fa: \"\\f687\"; }\n\n.fa-anchor {\n  --fa: \"\\f13d\"; }\n\n.fa-border-all {\n  --fa: \"\\f84c\"; }\n\n.fa-face-angry {\n  --fa: \"\\f556\"; }\n\n.fa-angry {\n  --fa: \"\\f556\"; }\n\n.fa-cookie-bite {\n  --fa: \"\\f564\"; }\n\n.fa-arrow-trend-down {\n  --fa: \"\\e097\"; }\n\n.fa-rss {\n  --fa: \"\\f09e\"; }\n\n.fa-feed {\n  --fa: \"\\f09e\"; }\n\n.fa-draw-polygon {\n  --fa: \"\\f5ee\"; }\n\n.fa-scale-balanced {\n  --fa: \"\\f24e\"; }\n\n.fa-balance-scale {\n  --fa: \"\\f24e\"; }\n\n.fa-gauge-simple-high {\n  --fa: \"\\f62a\"; }\n\n.fa-tachometer {\n  --fa: \"\\f62a\"; }\n\n.fa-tachometer-fast {\n  --fa: \"\\f62a\"; }\n\n.fa-shower {\n  --fa: \"\\f2cc\"; }\n\n.fa-desktop {\n  --fa: \"\\f390\"; }\n\n.fa-desktop-alt {\n  --fa: \"\\f390\"; }\n\n.fa-m {\n  --fa: \"\\4d\"; }\n\n.fa-table-list {\n  --fa: \"\\f00b\"; }\n\n.fa-th-list {\n  --fa: \"\\f00b\"; }\n\n.fa-comment-sms {\n  --fa: \"\\f7cd\"; }\n\n.fa-sms {\n  --fa: \"\\f7cd\"; }\n\n.fa-book {\n  --fa: \"\\f02d\"; }\n\n.fa-user-plus {\n  --fa: \"\\f234\"; }\n\n.fa-check {\n  --fa: \"\\f00c\"; }\n\n.fa-battery-three-quarters {\n  --fa: \"\\f241\"; }\n\n.fa-battery-4 {\n  --fa: \"\\f241\"; }\n\n.fa-house-circle-check {\n  --fa: \"\\e509\"; }\n\n.fa-angle-left {\n  --fa: \"\\f104\"; }\n\n.fa-diagram-successor {\n  --fa: \"\\e47a\"; }\n\n.fa-truck-arrow-right {\n  --fa: \"\\e58b\"; }\n\n.fa-arrows-split-up-and-left {\n  --fa: \"\\e4bc\"; }\n\n.fa-hand-fist {\n  --fa: \"\\f6de\"; }\n\n.fa-fist-raised {\n  --fa: \"\\f6de\"; }\n\n.fa-cloud-moon {\n  --fa: \"\\f6c3\"; }\n\n.fa-briefcase {\n  --fa: \"\\f0b1\"; }\n\n.fa-person-falling {\n  --fa: \"\\e546\"; }\n\n.fa-image-portrait {\n  --fa: \"\\f3e0\"; }\n\n.fa-portrait {\n  --fa: \"\\f3e0\"; }\n\n.fa-user-tag {\n  --fa: \"\\f507\"; }\n\n.fa-rug {\n  --fa: \"\\e569\"; }\n\n.fa-earth-europe {\n  --fa: \"\\f7a2\"; }\n\n.fa-globe-europe {\n  --fa: \"\\f7a2\"; }\n\n.fa-cart-flatbed-suitcase {\n  --fa: \"\\f59d\"; }\n\n.fa-luggage-cart {\n  --fa: \"\\f59d\"; }\n\n.fa-rectangle-xmark {\n  --fa: \"\\f410\"; }\n\n.fa-rectangle-times {\n  --fa: \"\\f410\"; }\n\n.fa-times-rectangle {\n  --fa: \"\\f410\"; }\n\n.fa-window-close {\n  --fa: \"\\f410\"; }\n\n.fa-baht-sign {\n  --fa: \"\\e0ac\"; }\n\n.fa-book-open {\n  --fa: \"\\f518\"; }\n\n.fa-book-journal-whills {\n  --fa: \"\\f66a\"; }\n\n.fa-journal-whills {\n  --fa: \"\\f66a\"; }\n\n.fa-handcuffs {\n  --fa: \"\\e4f8\"; }\n\n.fa-triangle-exclamation {\n  --fa: \"\\f071\"; }\n\n.fa-exclamation-triangle {\n  --fa: \"\\f071\"; }\n\n.fa-warning {\n  --fa: \"\\f071\"; }\n\n.fa-database {\n  --fa: \"\\f1c0\"; }\n\n.fa-share {\n  --fa: \"\\f064\"; }\n\n.fa-mail-forward {\n  --fa: \"\\f064\"; }\n\n.fa-bottle-droplet {\n  --fa: \"\\e4c4\"; }\n\n.fa-mask-face {\n  --fa: \"\\e1d7\"; }\n\n.fa-hill-rockslide {\n  --fa: \"\\e508\"; }\n\n.fa-right-left {\n  --fa: \"\\f362\"; }\n\n.fa-exchange-alt {\n  --fa: \"\\f362\"; }\n\n.fa-paper-plane {\n  --fa: \"\\f1d8\"; }\n\n.fa-road-circle-exclamation {\n  --fa: \"\\e565\"; }\n\n.fa-dungeon {\n  --fa: \"\\f6d9\"; }\n\n.fa-align-right {\n  --fa: \"\\f038\"; }\n\n.fa-money-bill-1-wave {\n  --fa: \"\\f53b\"; }\n\n.fa-money-bill-wave-alt {\n  --fa: \"\\f53b\"; }\n\n.fa-life-ring {\n  --fa: \"\\f1cd\"; }\n\n.fa-hands {\n  --fa: \"\\f2a7\"; }\n\n.fa-sign-language {\n  --fa: \"\\f2a7\"; }\n\n.fa-signing {\n  --fa: \"\\f2a7\"; }\n\n.fa-calendar-day {\n  --fa: \"\\f783\"; }\n\n.fa-water-ladder {\n  --fa: \"\\f5c5\"; }\n\n.fa-ladder-water {\n  --fa: \"\\f5c5\"; }\n\n.fa-swimming-pool {\n  --fa: \"\\f5c5\"; }\n\n.fa-arrows-up-down {\n  --fa: \"\\f07d\"; }\n\n.fa-arrows-v {\n  --fa: \"\\f07d\"; }\n\n.fa-face-grimace {\n  --fa: \"\\f57f\"; }\n\n.fa-grimace {\n  --fa: \"\\f57f\"; }\n\n.fa-wheelchair-move {\n  --fa: \"\\e2ce\"; }\n\n.fa-wheelchair-alt {\n  --fa: \"\\e2ce\"; }\n\n.fa-turn-down {\n  --fa: \"\\f3be\"; }\n\n.fa-level-down-alt {\n  --fa: \"\\f3be\"; }\n\n.fa-person-walking-arrow-right {\n  --fa: \"\\e552\"; }\n\n.fa-square-envelope {\n  --fa: \"\\f199\"; }\n\n.fa-envelope-square {\n  --fa: \"\\f199\"; }\n\n.fa-dice {\n  --fa: \"\\f522\"; }\n\n.fa-bowling-ball {\n  --fa: \"\\f436\"; }\n\n.fa-brain {\n  --fa: \"\\f5dc\"; }\n\n.fa-bandage {\n  --fa: \"\\f462\"; }\n\n.fa-band-aid {\n  --fa: \"\\f462\"; }\n\n.fa-calendar-minus {\n  --fa: \"\\f272\"; }\n\n.fa-circle-xmark {\n  --fa: \"\\f057\"; }\n\n.fa-times-circle {\n  --fa: \"\\f057\"; }\n\n.fa-xmark-circle {\n  --fa: \"\\f057\"; }\n\n.fa-gifts {\n  --fa: \"\\f79c\"; }\n\n.fa-hotel {\n  --fa: \"\\f594\"; }\n\n.fa-earth-asia {\n  --fa: \"\\f57e\"; }\n\n.fa-globe-asia {\n  --fa: \"\\f57e\"; }\n\n.fa-id-card-clip {\n  --fa: \"\\f47f\"; }\n\n.fa-id-card-alt {\n  --fa: \"\\f47f\"; }\n\n.fa-magnifying-glass-plus {\n  --fa: \"\\f00e\"; }\n\n.fa-search-plus {\n  --fa: \"\\f00e\"; }\n\n.fa-thumbs-up {\n  --fa: \"\\f164\"; }\n\n.fa-user-clock {\n  --fa: \"\\f4fd\"; }\n\n.fa-hand-dots {\n  --fa: \"\\f461\"; }\n\n.fa-allergies {\n  --fa: \"\\f461\"; }\n\n.fa-file-invoice {\n  --fa: \"\\f570\"; }\n\n.fa-window-minimize {\n  --fa: \"\\f2d1\"; }\n\n.fa-mug-saucer {\n  --fa: \"\\f0f4\"; }\n\n.fa-coffee {\n  --fa: \"\\f0f4\"; }\n\n.fa-brush {\n  --fa: \"\\f55d\"; }\n\n.fa-file-half-dashed {\n  --fa: \"\\e698\"; }\n\n.fa-mask {\n  --fa: \"\\f6fa\"; }\n\n.fa-magnifying-glass-minus {\n  --fa: \"\\f010\"; }\n\n.fa-search-minus {\n  --fa: \"\\f010\"; }\n\n.fa-ruler-vertical {\n  --fa: \"\\f548\"; }\n\n.fa-user-large {\n  --fa: \"\\f406\"; }\n\n.fa-user-alt {\n  --fa: \"\\f406\"; }\n\n.fa-train-tram {\n  --fa: \"\\e5b4\"; }\n\n.fa-user-nurse {\n  --fa: \"\\f82f\"; }\n\n.fa-syringe {\n  --fa: \"\\f48e\"; }\n\n.fa-cloud-sun {\n  --fa: \"\\f6c4\"; }\n\n.fa-stopwatch-20 {\n  --fa: \"\\e06f\"; }\n\n.fa-square-full {\n  --fa: \"\\f45c\"; }\n\n.fa-magnet {\n  --fa: \"\\f076\"; }\n\n.fa-jar {\n  --fa: \"\\e516\"; }\n\n.fa-note-sticky {\n  --fa: \"\\f249\"; }\n\n.fa-sticky-note {\n  --fa: \"\\f249\"; }\n\n.fa-bug-slash {\n  --fa: \"\\e490\"; }\n\n.fa-arrow-up-from-water-pump {\n  --fa: \"\\e4b6\"; }\n\n.fa-bone {\n  --fa: \"\\f5d7\"; }\n\n.fa-table-cells-row-unlock {\n  --fa: \"\\e691\"; }\n\n.fa-user-injured {\n  --fa: \"\\f728\"; }\n\n.fa-face-sad-tear {\n  --fa: \"\\f5b4\"; }\n\n.fa-sad-tear {\n  --fa: \"\\f5b4\"; }\n\n.fa-plane {\n  --fa: \"\\f072\"; }\n\n.fa-tent-arrows-down {\n  --fa: \"\\e581\"; }\n\n.fa-exclamation {\n  --fa: \"\\21\"; }\n\n.fa-arrows-spin {\n  --fa: \"\\e4bb\"; }\n\n.fa-print {\n  --fa: \"\\f02f\"; }\n\n.fa-turkish-lira-sign {\n  --fa: \"\\e2bb\"; }\n\n.fa-try {\n  --fa: \"\\e2bb\"; }\n\n.fa-turkish-lira {\n  --fa: \"\\e2bb\"; }\n\n.fa-dollar-sign {\n  --fa: \"\\24\"; }\n\n.fa-dollar {\n  --fa: \"\\24\"; }\n\n.fa-usd {\n  --fa: \"\\24\"; }\n\n.fa-x {\n  --fa: \"\\58\"; }\n\n.fa-magnifying-glass-dollar {\n  --fa: \"\\f688\"; }\n\n.fa-search-dollar {\n  --fa: \"\\f688\"; }\n\n.fa-users-gear {\n  --fa: \"\\f509\"; }\n\n.fa-users-cog {\n  --fa: \"\\f509\"; }\n\n.fa-person-military-pointing {\n  --fa: \"\\e54a\"; }\n\n.fa-building-columns {\n  --fa: \"\\f19c\"; }\n\n.fa-bank {\n  --fa: \"\\f19c\"; }\n\n.fa-institution {\n  --fa: \"\\f19c\"; }\n\n.fa-museum {\n  --fa: \"\\f19c\"; }\n\n.fa-university {\n  --fa: \"\\f19c\"; }\n\n.fa-umbrella {\n  --fa: \"\\f0e9\"; }\n\n.fa-trowel {\n  --fa: \"\\e589\"; }\n\n.fa-d {\n  --fa: \"\\44\"; }\n\n.fa-stapler {\n  --fa: \"\\e5af\"; }\n\n.fa-masks-theater {\n  --fa: \"\\f630\"; }\n\n.fa-theater-masks {\n  --fa: \"\\f630\"; }\n\n.fa-kip-sign {\n  --fa: \"\\e1c4\"; }\n\n.fa-hand-point-left {\n  --fa: \"\\f0a5\"; }\n\n.fa-handshake-simple {\n  --fa: \"\\f4c6\"; }\n\n.fa-handshake-alt {\n  --fa: \"\\f4c6\"; }\n\n.fa-jet-fighter {\n  --fa: \"\\f0fb\"; }\n\n.fa-fighter-jet {\n  --fa: \"\\f0fb\"; }\n\n.fa-square-share-nodes {\n  --fa: \"\\f1e1\"; }\n\n.fa-share-alt-square {\n  --fa: \"\\f1e1\"; }\n\n.fa-barcode {\n  --fa: \"\\f02a\"; }\n\n.fa-plus-minus {\n  --fa: \"\\e43c\"; }\n\n.fa-video {\n  --fa: \"\\f03d\"; }\n\n.fa-video-camera {\n  --fa: \"\\f03d\"; }\n\n.fa-graduation-cap {\n  --fa: \"\\f19d\"; }\n\n.fa-mortar-board {\n  --fa: \"\\f19d\"; }\n\n.fa-hand-holding-medical {\n  --fa: \"\\e05c\"; }\n\n.fa-person-circle-check {\n  --fa: \"\\e53e\"; }\n\n.fa-turn-up {\n  --fa: \"\\f3bf\"; }\n\n.fa-level-up-alt {\n  --fa: \"\\f3bf\"; }\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0; }\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0; }\n:root, :host {\n  --fa-style-family-brands: 'Font Awesome 6 Brands';\n  --fa-font-brands: normal 400 1em/1 'Font Awesome 6 Brands'; }\n\n@font-face {\n  font-family: 'Font Awesome 6 Brands';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-brands-400.ttf\") format(\"truetype\"); }\n\n.fab,\n.fa-brands {\n  font-weight: 400; }\n\n.fa-monero {\n  --fa: \"\\f3d0\"; }\n\n.fa-hooli {\n  --fa: \"\\f427\"; }\n\n.fa-yelp {\n  --fa: \"\\f1e9\"; }\n\n.fa-cc-visa {\n  --fa: \"\\f1f0\"; }\n\n.fa-lastfm {\n  --fa: \"\\f202\"; }\n\n.fa-shopware {\n  --fa: \"\\f5b5\"; }\n\n.fa-creative-commons-nc {\n  --fa: \"\\f4e8\"; }\n\n.fa-aws {\n  --fa: \"\\f375\"; }\n\n.fa-redhat {\n  --fa: \"\\f7bc\"; }\n\n.fa-yoast {\n  --fa: \"\\f2b1\"; }\n\n.fa-cloudflare {\n  --fa: \"\\e07d\"; }\n\n.fa-ups {\n  --fa: \"\\f7e0\"; }\n\n.fa-pixiv {\n  --fa: \"\\e640\"; }\n\n.fa-wpexplorer {\n  --fa: \"\\f2de\"; }\n\n.fa-dyalog {\n  --fa: \"\\f399\"; }\n\n.fa-bity {\n  --fa: \"\\f37a\"; }\n\n.fa-stackpath {\n  --fa: \"\\f842\"; }\n\n.fa-buysellads {\n  --fa: \"\\f20d\"; }\n\n.fa-first-order {\n  --fa: \"\\f2b0\"; }\n\n.fa-modx {\n  --fa: \"\\f285\"; }\n\n.fa-guilded {\n  --fa: \"\\e07e\"; }\n\n.fa-vnv {\n  --fa: \"\\f40b\"; }\n\n.fa-square-js {\n  --fa: \"\\f3b9\"; }\n\n.fa-js-square {\n  --fa: \"\\f3b9\"; }\n\n.fa-microsoft {\n  --fa: \"\\f3ca\"; }\n\n.fa-qq {\n  --fa: \"\\f1d6\"; }\n\n.fa-orcid {\n  --fa: \"\\f8d2\"; }\n\n.fa-java {\n  --fa: \"\\f4e4\"; }\n\n.fa-invision {\n  --fa: \"\\f7b0\"; }\n\n.fa-creative-commons-pd-alt {\n  --fa: \"\\f4ed\"; }\n\n.fa-centercode {\n  --fa: \"\\f380\"; }\n\n.fa-glide-g {\n  --fa: \"\\f2a6\"; }\n\n.fa-drupal {\n  --fa: \"\\f1a9\"; }\n\n.fa-jxl {\n  --fa: \"\\e67b\"; }\n\n.fa-dart-lang {\n  --fa: \"\\e693\"; }\n\n.fa-hire-a-helper {\n  --fa: \"\\f3b0\"; }\n\n.fa-creative-commons-by {\n  --fa: \"\\f4e7\"; }\n\n.fa-unity {\n  --fa: \"\\e049\"; }\n\n.fa-whmcs {\n  --fa: \"\\f40d\"; }\n\n.fa-rocketchat {\n  --fa: \"\\f3e8\"; }\n\n.fa-vk {\n  --fa: \"\\f189\"; }\n\n.fa-untappd {\n  --fa: \"\\f405\"; }\n\n.fa-mailchimp {\n  --fa: \"\\f59e\"; }\n\n.fa-css3-alt {\n  --fa: \"\\f38b\"; }\n\n.fa-square-reddit {\n  --fa: \"\\f1a2\"; }\n\n.fa-reddit-square {\n  --fa: \"\\f1a2\"; }\n\n.fa-vimeo-v {\n  --fa: \"\\f27d\"; }\n\n.fa-contao {\n  --fa: \"\\f26d\"; }\n\n.fa-square-font-awesome {\n  --fa: \"\\e5ad\"; }\n\n.fa-deskpro {\n  --fa: \"\\f38f\"; }\n\n.fa-brave {\n  --fa: \"\\e63c\"; }\n\n.fa-sistrix {\n  --fa: \"\\f3ee\"; }\n\n.fa-square-instagram {\n  --fa: \"\\e055\"; }\n\n.fa-instagram-square {\n  --fa: \"\\e055\"; }\n\n.fa-battle-net {\n  --fa: \"\\f835\"; }\n\n.fa-the-red-yeti {\n  --fa: \"\\f69d\"; }\n\n.fa-square-hacker-news {\n  --fa: \"\\f3af\"; }\n\n.fa-hacker-news-square {\n  --fa: \"\\f3af\"; }\n\n.fa-edge {\n  --fa: \"\\f282\"; }\n\n.fa-threads {\n  --fa: \"\\e618\"; }\n\n.fa-napster {\n  --fa: \"\\f3d2\"; }\n\n.fa-square-snapchat {\n  --fa: \"\\f2ad\"; }\n\n.fa-snapchat-square {\n  --fa: \"\\f2ad\"; }\n\n.fa-google-plus-g {\n  --fa: \"\\f0d5\"; }\n\n.fa-artstation {\n  --fa: \"\\f77a\"; }\n\n.fa-markdown {\n  --fa: \"\\f60f\"; }\n\n.fa-sourcetree {\n  --fa: \"\\f7d3\"; }\n\n.fa-google-plus {\n  --fa: \"\\f2b3\"; }\n\n.fa-diaspora {\n  --fa: \"\\f791\"; }\n\n.fa-foursquare {\n  --fa: \"\\f180\"; }\n\n.fa-stack-overflow {\n  --fa: \"\\f16c\"; }\n\n.fa-github-alt {\n  --fa: \"\\f113\"; }\n\n.fa-phoenix-squadron {\n  --fa: \"\\f511\"; }\n\n.fa-pagelines {\n  --fa: \"\\f18c\"; }\n\n.fa-algolia {\n  --fa: \"\\f36c\"; }\n\n.fa-red-river {\n  --fa: \"\\f3e3\"; }\n\n.fa-creative-commons-sa {\n  --fa: \"\\f4ef\"; }\n\n.fa-safari {\n  --fa: \"\\f267\"; }\n\n.fa-google {\n  --fa: \"\\f1a0\"; }\n\n.fa-square-font-awesome-stroke {\n  --fa: \"\\f35c\"; }\n\n.fa-font-awesome-alt {\n  --fa: \"\\f35c\"; }\n\n.fa-atlassian {\n  --fa: \"\\f77b\"; }\n\n.fa-linkedin-in {\n  --fa: \"\\f0e1\"; }\n\n.fa-digital-ocean {\n  --fa: \"\\f391\"; }\n\n.fa-nimblr {\n  --fa: \"\\f5a8\"; }\n\n.fa-chromecast {\n  --fa: \"\\f838\"; }\n\n.fa-evernote {\n  --fa: \"\\f839\"; }\n\n.fa-hacker-news {\n  --fa: \"\\f1d4\"; }\n\n.fa-creative-commons-sampling {\n  --fa: \"\\f4f0\"; }\n\n.fa-adversal {\n  --fa: \"\\f36a\"; }\n\n.fa-creative-commons {\n  --fa: \"\\f25e\"; }\n\n.fa-watchman-monitoring {\n  --fa: \"\\e087\"; }\n\n.fa-fonticons {\n  --fa: \"\\f280\"; }\n\n.fa-weixin {\n  --fa: \"\\f1d7\"; }\n\n.fa-shirtsinbulk {\n  --fa: \"\\f214\"; }\n\n.fa-codepen {\n  --fa: \"\\f1cb\"; }\n\n.fa-git-alt {\n  --fa: \"\\f841\"; }\n\n.fa-lyft {\n  --fa: \"\\f3c3\"; }\n\n.fa-rev {\n  --fa: \"\\f5b2\"; }\n\n.fa-windows {\n  --fa: \"\\f17a\"; }\n\n.fa-wizards-of-the-coast {\n  --fa: \"\\f730\"; }\n\n.fa-square-viadeo {\n  --fa: \"\\f2aa\"; }\n\n.fa-viadeo-square {\n  --fa: \"\\f2aa\"; }\n\n.fa-meetup {\n  --fa: \"\\f2e0\"; }\n\n.fa-centos {\n  --fa: \"\\f789\"; }\n\n.fa-adn {\n  --fa: \"\\f170\"; }\n\n.fa-cloudsmith {\n  --fa: \"\\f384\"; }\n\n.fa-opensuse {\n  --fa: \"\\e62b\"; }\n\n.fa-pied-piper-alt {\n  --fa: \"\\f1a8\"; }\n\n.fa-square-dribbble {\n  --fa: \"\\f397\"; }\n\n.fa-dribbble-square {\n  --fa: \"\\f397\"; }\n\n.fa-codiepie {\n  --fa: \"\\f284\"; }\n\n.fa-node {\n  --fa: \"\\f419\"; }\n\n.fa-mix {\n  --fa: \"\\f3cb\"; }\n\n.fa-steam {\n  --fa: \"\\f1b6\"; }\n\n.fa-cc-apple-pay {\n  --fa: \"\\f416\"; }\n\n.fa-scribd {\n  --fa: \"\\f28a\"; }\n\n.fa-debian {\n  --fa: \"\\e60b\"; }\n\n.fa-openid {\n  --fa: \"\\f19b\"; }\n\n.fa-instalod {\n  --fa: \"\\e081\"; }\n\n.fa-files-pinwheel {\n  --fa: \"\\e69f\"; }\n\n.fa-expeditedssl {\n  --fa: \"\\f23e\"; }\n\n.fa-sellcast {\n  --fa: \"\\f2da\"; }\n\n.fa-square-twitter {\n  --fa: \"\\f081\"; }\n\n.fa-twitter-square {\n  --fa: \"\\f081\"; }\n\n.fa-r-project {\n  --fa: \"\\f4f7\"; }\n\n.fa-delicious {\n  --fa: \"\\f1a5\"; }\n\n.fa-freebsd {\n  --fa: \"\\f3a4\"; }\n\n.fa-vuejs {\n  --fa: \"\\f41f\"; }\n\n.fa-accusoft {\n  --fa: \"\\f369\"; }\n\n.fa-ioxhost {\n  --fa: \"\\f208\"; }\n\n.fa-fonticons-fi {\n  --fa: \"\\f3a2\"; }\n\n.fa-app-store {\n  --fa: \"\\f36f\"; }\n\n.fa-cc-mastercard {\n  --fa: \"\\f1f1\"; }\n\n.fa-itunes-note {\n  --fa: \"\\f3b5\"; }\n\n.fa-golang {\n  --fa: \"\\e40f\"; }\n\n.fa-kickstarter {\n  --fa: \"\\f3bb\"; }\n\n.fa-square-kickstarter {\n  --fa: \"\\f3bb\"; }\n\n.fa-grav {\n  --fa: \"\\f2d6\"; }\n\n.fa-weibo {\n  --fa: \"\\f18a\"; }\n\n.fa-uncharted {\n  --fa: \"\\e084\"; }\n\n.fa-firstdraft {\n  --fa: \"\\f3a1\"; }\n\n.fa-square-youtube {\n  --fa: \"\\f431\"; }\n\n.fa-youtube-square {\n  --fa: \"\\f431\"; }\n\n.fa-wikipedia-w {\n  --fa: \"\\f266\"; }\n\n.fa-wpressr {\n  --fa: \"\\f3e4\"; }\n\n.fa-rendact {\n  --fa: \"\\f3e4\"; }\n\n.fa-angellist {\n  --fa: \"\\f209\"; }\n\n.fa-galactic-republic {\n  --fa: \"\\f50c\"; }\n\n.fa-nfc-directional {\n  --fa: \"\\e530\"; }\n\n.fa-skype {\n  --fa: \"\\f17e\"; }\n\n.fa-joget {\n  --fa: \"\\f3b7\"; }\n\n.fa-fedora {\n  --fa: \"\\f798\"; }\n\n.fa-stripe-s {\n  --fa: \"\\f42a\"; }\n\n.fa-meta {\n  --fa: \"\\e49b\"; }\n\n.fa-laravel {\n  --fa: \"\\f3bd\"; }\n\n.fa-hotjar {\n  --fa: \"\\f3b1\"; }\n\n.fa-bluetooth-b {\n  --fa: \"\\f294\"; }\n\n.fa-square-letterboxd {\n  --fa: \"\\e62e\"; }\n\n.fa-sticker-mule {\n  --fa: \"\\f3f7\"; }\n\n.fa-creative-commons-zero {\n  --fa: \"\\f4f3\"; }\n\n.fa-hips {\n  --fa: \"\\f452\"; }\n\n.fa-css {\n  --fa: \"\\e6a2\"; }\n\n.fa-behance {\n  --fa: \"\\f1b4\"; }\n\n.fa-reddit {\n  --fa: \"\\f1a1\"; }\n\n.fa-discord {\n  --fa: \"\\f392\"; }\n\n.fa-chrome {\n  --fa: \"\\f268\"; }\n\n.fa-app-store-ios {\n  --fa: \"\\f370\"; }\n\n.fa-cc-discover {\n  --fa: \"\\f1f2\"; }\n\n.fa-wpbeginner {\n  --fa: \"\\f297\"; }\n\n.fa-confluence {\n  --fa: \"\\f78d\"; }\n\n.fa-shoelace {\n  --fa: \"\\e60c\"; }\n\n.fa-mdb {\n  --fa: \"\\f8ca\"; }\n\n.fa-dochub {\n  --fa: \"\\f394\"; }\n\n.fa-accessible-icon {\n  --fa: \"\\f368\"; }\n\n.fa-ebay {\n  --fa: \"\\f4f4\"; }\n\n.fa-amazon {\n  --fa: \"\\f270\"; }\n\n.fa-unsplash {\n  --fa: \"\\e07c\"; }\n\n.fa-yarn {\n  --fa: \"\\f7e3\"; }\n\n.fa-square-steam {\n  --fa: \"\\f1b7\"; }\n\n.fa-steam-square {\n  --fa: \"\\f1b7\"; }\n\n.fa-500px {\n  --fa: \"\\f26e\"; }\n\n.fa-square-vimeo {\n  --fa: \"\\f194\"; }\n\n.fa-vimeo-square {\n  --fa: \"\\f194\"; }\n\n.fa-asymmetrik {\n  --fa: \"\\f372\"; }\n\n.fa-font-awesome {\n  --fa: \"\\f2b4\"; }\n\n.fa-font-awesome-flag {\n  --fa: \"\\f2b4\"; }\n\n.fa-font-awesome-logo-full {\n  --fa: \"\\f2b4\"; }\n\n.fa-gratipay {\n  --fa: \"\\f184\"; }\n\n.fa-apple {\n  --fa: \"\\f179\"; }\n\n.fa-hive {\n  --fa: \"\\e07f\"; }\n\n.fa-gitkraken {\n  --fa: \"\\f3a6\"; }\n\n.fa-keybase {\n  --fa: \"\\f4f5\"; }\n\n.fa-apple-pay {\n  --fa: \"\\f415\"; }\n\n.fa-padlet {\n  --fa: \"\\e4a0\"; }\n\n.fa-amazon-pay {\n  --fa: \"\\f42c\"; }\n\n.fa-square-github {\n  --fa: \"\\f092\"; }\n\n.fa-github-square {\n  --fa: \"\\f092\"; }\n\n.fa-stumbleupon {\n  --fa: \"\\f1a4\"; }\n\n.fa-fedex {\n  --fa: \"\\f797\"; }\n\n.fa-phoenix-framework {\n  --fa: \"\\f3dc\"; }\n\n.fa-shopify {\n  --fa: \"\\e057\"; }\n\n.fa-neos {\n  --fa: \"\\f612\"; }\n\n.fa-square-threads {\n  --fa: \"\\e619\"; }\n\n.fa-hackerrank {\n  --fa: \"\\f5f7\"; }\n\n.fa-researchgate {\n  --fa: \"\\f4f8\"; }\n\n.fa-swift {\n  --fa: \"\\f8e1\"; }\n\n.fa-angular {\n  --fa: \"\\f420\"; }\n\n.fa-speakap {\n  --fa: \"\\f3f3\"; }\n\n.fa-angrycreative {\n  --fa: \"\\f36e\"; }\n\n.fa-y-combinator {\n  --fa: \"\\f23b\"; }\n\n.fa-empire {\n  --fa: \"\\f1d1\"; }\n\n.fa-envira {\n  --fa: \"\\f299\"; }\n\n.fa-google-scholar {\n  --fa: \"\\e63b\"; }\n\n.fa-square-gitlab {\n  --fa: \"\\e5ae\"; }\n\n.fa-gitlab-square {\n  --fa: \"\\e5ae\"; }\n\n.fa-studiovinari {\n  --fa: \"\\f3f8\"; }\n\n.fa-pied-piper {\n  --fa: \"\\f2ae\"; }\n\n.fa-wordpress {\n  --fa: \"\\f19a\"; }\n\n.fa-product-hunt {\n  --fa: \"\\f288\"; }\n\n.fa-firefox {\n  --fa: \"\\f269\"; }\n\n.fa-linode {\n  --fa: \"\\f2b8\"; }\n\n.fa-goodreads {\n  --fa: \"\\f3a8\"; }\n\n.fa-square-odnoklassniki {\n  --fa: \"\\f264\"; }\n\n.fa-odnoklassniki-square {\n  --fa: \"\\f264\"; }\n\n.fa-jsfiddle {\n  --fa: \"\\f1cc\"; }\n\n.fa-sith {\n  --fa: \"\\f512\"; }\n\n.fa-themeisle {\n  --fa: \"\\f2b2\"; }\n\n.fa-page4 {\n  --fa: \"\\f3d7\"; }\n\n.fa-hashnode {\n  --fa: \"\\e499\"; }\n\n.fa-react {\n  --fa: \"\\f41b\"; }\n\n.fa-cc-paypal {\n  --fa: \"\\f1f4\"; }\n\n.fa-squarespace {\n  --fa: \"\\f5be\"; }\n\n.fa-cc-stripe {\n  --fa: \"\\f1f5\"; }\n\n.fa-creative-commons-share {\n  --fa: \"\\f4f2\"; }\n\n.fa-bitcoin {\n  --fa: \"\\f379\"; }\n\n.fa-keycdn {\n  --fa: \"\\f3ba\"; }\n\n.fa-opera {\n  --fa: \"\\f26a\"; }\n\n.fa-itch-io {\n  --fa: \"\\f83a\"; }\n\n.fa-umbraco {\n  --fa: \"\\f8e8\"; }\n\n.fa-galactic-senate {\n  --fa: \"\\f50d\"; }\n\n.fa-ubuntu {\n  --fa: \"\\f7df\"; }\n\n.fa-draft2digital {\n  --fa: \"\\f396\"; }\n\n.fa-stripe {\n  --fa: \"\\f429\"; }\n\n.fa-houzz {\n  --fa: \"\\f27c\"; }\n\n.fa-gg {\n  --fa: \"\\f260\"; }\n\n.fa-dhl {\n  --fa: \"\\f790\"; }\n\n.fa-square-pinterest {\n  --fa: \"\\f0d3\"; }\n\n.fa-pinterest-square {\n  --fa: \"\\f0d3\"; }\n\n.fa-xing {\n  --fa: \"\\f168\"; }\n\n.fa-blackberry {\n  --fa: \"\\f37b\"; }\n\n.fa-creative-commons-pd {\n  --fa: \"\\f4ec\"; }\n\n.fa-playstation {\n  --fa: \"\\f3df\"; }\n\n.fa-quinscape {\n  --fa: \"\\f459\"; }\n\n.fa-less {\n  --fa: \"\\f41d\"; }\n\n.fa-blogger-b {\n  --fa: \"\\f37d\"; }\n\n.fa-opencart {\n  --fa: \"\\f23d\"; }\n\n.fa-vine {\n  --fa: \"\\f1ca\"; }\n\n.fa-signal-messenger {\n  --fa: \"\\e663\"; }\n\n.fa-paypal {\n  --fa: \"\\f1ed\"; }\n\n.fa-gitlab {\n  --fa: \"\\f296\"; }\n\n.fa-typo3 {\n  --fa: \"\\f42b\"; }\n\n.fa-reddit-alien {\n  --fa: \"\\f281\"; }\n\n.fa-yahoo {\n  --fa: \"\\f19e\"; }\n\n.fa-dailymotion {\n  --fa: \"\\e052\"; }\n\n.fa-affiliatetheme {\n  --fa: \"\\f36b\"; }\n\n.fa-pied-piper-pp {\n  --fa: \"\\f1a7\"; }\n\n.fa-bootstrap {\n  --fa: \"\\f836\"; }\n\n.fa-odnoklassniki {\n  --fa: \"\\f263\"; }\n\n.fa-nfc-symbol {\n  --fa: \"\\e531\"; }\n\n.fa-mintbit {\n  --fa: \"\\e62f\"; }\n\n.fa-ethereum {\n  --fa: \"\\f42e\"; }\n\n.fa-speaker-deck {\n  --fa: \"\\f83c\"; }\n\n.fa-creative-commons-nc-eu {\n  --fa: \"\\f4e9\"; }\n\n.fa-patreon {\n  --fa: \"\\f3d9\"; }\n\n.fa-avianex {\n  --fa: \"\\f374\"; }\n\n.fa-ello {\n  --fa: \"\\f5f1\"; }\n\n.fa-gofore {\n  --fa: \"\\f3a7\"; }\n\n.fa-bimobject {\n  --fa: \"\\f378\"; }\n\n.fa-brave-reverse {\n  --fa: \"\\e63d\"; }\n\n.fa-facebook-f {\n  --fa: \"\\f39e\"; }\n\n.fa-square-google-plus {\n  --fa: \"\\f0d4\"; }\n\n.fa-google-plus-square {\n  --fa: \"\\f0d4\"; }\n\n.fa-web-awesome {\n  --fa: \"\\e682\"; }\n\n.fa-mandalorian {\n  --fa: \"\\f50f\"; }\n\n.fa-first-order-alt {\n  --fa: \"\\f50a\"; }\n\n.fa-osi {\n  --fa: \"\\f41a\"; }\n\n.fa-google-wallet {\n  --fa: \"\\f1ee\"; }\n\n.fa-d-and-d-beyond {\n  --fa: \"\\f6ca\"; }\n\n.fa-periscope {\n  --fa: \"\\f3da\"; }\n\n.fa-fulcrum {\n  --fa: \"\\f50b\"; }\n\n.fa-cloudscale {\n  --fa: \"\\f383\"; }\n\n.fa-forumbee {\n  --fa: \"\\f211\"; }\n\n.fa-mizuni {\n  --fa: \"\\f3cc\"; }\n\n.fa-schlix {\n  --fa: \"\\f3ea\"; }\n\n.fa-square-xing {\n  --fa: \"\\f169\"; }\n\n.fa-xing-square {\n  --fa: \"\\f169\"; }\n\n.fa-bandcamp {\n  --fa: \"\\f2d5\"; }\n\n.fa-wpforms {\n  --fa: \"\\f298\"; }\n\n.fa-cloudversify {\n  --fa: \"\\f385\"; }\n\n.fa-usps {\n  --fa: \"\\f7e1\"; }\n\n.fa-megaport {\n  --fa: \"\\f5a3\"; }\n\n.fa-magento {\n  --fa: \"\\f3c4\"; }\n\n.fa-spotify {\n  --fa: \"\\f1bc\"; }\n\n.fa-optin-monster {\n  --fa: \"\\f23c\"; }\n\n.fa-fly {\n  --fa: \"\\f417\"; }\n\n.fa-square-bluesky {\n  --fa: \"\\e6a3\"; }\n\n.fa-aviato {\n  --fa: \"\\f421\"; }\n\n.fa-itunes {\n  --fa: \"\\f3b4\"; }\n\n.fa-cuttlefish {\n  --fa: \"\\f38c\"; }\n\n.fa-blogger {\n  --fa: \"\\f37c\"; }\n\n.fa-flickr {\n  --fa: \"\\f16e\"; }\n\n.fa-viber {\n  --fa: \"\\f409\"; }\n\n.fa-soundcloud {\n  --fa: \"\\f1be\"; }\n\n.fa-digg {\n  --fa: \"\\f1a6\"; }\n\n.fa-tencent-weibo {\n  --fa: \"\\f1d5\"; }\n\n.fa-letterboxd {\n  --fa: \"\\e62d\"; }\n\n.fa-symfony {\n  --fa: \"\\f83d\"; }\n\n.fa-maxcdn {\n  --fa: \"\\f136\"; }\n\n.fa-etsy {\n  --fa: \"\\f2d7\"; }\n\n.fa-facebook-messenger {\n  --fa: \"\\f39f\"; }\n\n.fa-audible {\n  --fa: \"\\f373\"; }\n\n.fa-think-peaks {\n  --fa: \"\\f731\"; }\n\n.fa-bilibili {\n  --fa: \"\\e3d9\"; }\n\n.fa-erlang {\n  --fa: \"\\f39d\"; }\n\n.fa-x-twitter {\n  --fa: \"\\e61b\"; }\n\n.fa-cotton-bureau {\n  --fa: \"\\f89e\"; }\n\n.fa-dashcube {\n  --fa: \"\\f210\"; }\n\n.fa-42-group {\n  --fa: \"\\e080\"; }\n\n.fa-innosoft {\n  --fa: \"\\e080\"; }\n\n.fa-stack-exchange {\n  --fa: \"\\f18d\"; }\n\n.fa-elementor {\n  --fa: \"\\f430\"; }\n\n.fa-square-pied-piper {\n  --fa: \"\\e01e\"; }\n\n.fa-pied-piper-square {\n  --fa: \"\\e01e\"; }\n\n.fa-creative-commons-nd {\n  --fa: \"\\f4eb\"; }\n\n.fa-palfed {\n  --fa: \"\\f3d8\"; }\n\n.fa-superpowers {\n  --fa: \"\\f2dd\"; }\n\n.fa-resolving {\n  --fa: \"\\f3e7\"; }\n\n.fa-xbox {\n  --fa: \"\\f412\"; }\n\n.fa-square-web-awesome-stroke {\n  --fa: \"\\e684\"; }\n\n.fa-searchengin {\n  --fa: \"\\f3eb\"; }\n\n.fa-tiktok {\n  --fa: \"\\e07b\"; }\n\n.fa-square-facebook {\n  --fa: \"\\f082\"; }\n\n.fa-facebook-square {\n  --fa: \"\\f082\"; }\n\n.fa-renren {\n  --fa: \"\\f18b\"; }\n\n.fa-linux {\n  --fa: \"\\f17c\"; }\n\n.fa-glide {\n  --fa: \"\\f2a5\"; }\n\n.fa-linkedin {\n  --fa: \"\\f08c\"; }\n\n.fa-hubspot {\n  --fa: \"\\f3b2\"; }\n\n.fa-deploydog {\n  --fa: \"\\f38e\"; }\n\n.fa-twitch {\n  --fa: \"\\f1e8\"; }\n\n.fa-flutter {\n  --fa: \"\\e694\"; }\n\n.fa-ravelry {\n  --fa: \"\\f2d9\"; }\n\n.fa-mixer {\n  --fa: \"\\e056\"; }\n\n.fa-square-lastfm {\n  --fa: \"\\f203\"; }\n\n.fa-lastfm-square {\n  --fa: \"\\f203\"; }\n\n.fa-vimeo {\n  --fa: \"\\f40a\"; }\n\n.fa-mendeley {\n  --fa: \"\\f7b3\"; }\n\n.fa-uniregistry {\n  --fa: \"\\f404\"; }\n\n.fa-figma {\n  --fa: \"\\f799\"; }\n\n.fa-creative-commons-remix {\n  --fa: \"\\f4ee\"; }\n\n.fa-cc-amazon-pay {\n  --fa: \"\\f42d\"; }\n\n.fa-dropbox {\n  --fa: \"\\f16b\"; }\n\n.fa-instagram {\n  --fa: \"\\f16d\"; }\n\n.fa-cmplid {\n  --fa: \"\\e360\"; }\n\n.fa-upwork {\n  --fa: \"\\e641\"; }\n\n.fa-facebook {\n  --fa: \"\\f09a\"; }\n\n.fa-gripfire {\n  --fa: \"\\f3ac\"; }\n\n.fa-jedi-order {\n  --fa: \"\\f50e\"; }\n\n.fa-uikit {\n  --fa: \"\\f403\"; }\n\n.fa-fort-awesome-alt {\n  --fa: \"\\f3a3\"; }\n\n.fa-phabricator {\n  --fa: \"\\f3db\"; }\n\n.fa-ussunnah {\n  --fa: \"\\f407\"; }\n\n.fa-earlybirds {\n  --fa: \"\\f39a\"; }\n\n.fa-trade-federation {\n  --fa: \"\\f513\"; }\n\n.fa-autoprefixer {\n  --fa: \"\\f41c\"; }\n\n.fa-whatsapp {\n  --fa: \"\\f232\"; }\n\n.fa-square-upwork {\n  --fa: \"\\e67c\"; }\n\n.fa-slideshare {\n  --fa: \"\\f1e7\"; }\n\n.fa-google-play {\n  --fa: \"\\f3ab\"; }\n\n.fa-viadeo {\n  --fa: \"\\f2a9\"; }\n\n.fa-line {\n  --fa: \"\\f3c0\"; }\n\n.fa-google-drive {\n  --fa: \"\\f3aa\"; }\n\n.fa-servicestack {\n  --fa: \"\\f3ec\"; }\n\n.fa-simplybuilt {\n  --fa: \"\\f215\"; }\n\n.fa-bitbucket {\n  --fa: \"\\f171\"; }\n\n.fa-imdb {\n  --fa: \"\\f2d8\"; }\n\n.fa-deezer {\n  --fa: \"\\e077\"; }\n\n.fa-raspberry-pi {\n  --fa: \"\\f7bb\"; }\n\n.fa-jira {\n  --fa: \"\\f7b1\"; }\n\n.fa-docker {\n  --fa: \"\\f395\"; }\n\n.fa-screenpal {\n  --fa: \"\\e570\"; }\n\n.fa-bluetooth {\n  --fa: \"\\f293\"; }\n\n.fa-gitter {\n  --fa: \"\\f426\"; }\n\n.fa-d-and-d {\n  --fa: \"\\f38d\"; }\n\n.fa-microblog {\n  --fa: \"\\e01a\"; }\n\n.fa-cc-diners-club {\n  --fa: \"\\f24c\"; }\n\n.fa-gg-circle {\n  --fa: \"\\f261\"; }\n\n.fa-pied-piper-hat {\n  --fa: \"\\f4e5\"; }\n\n.fa-kickstarter-k {\n  --fa: \"\\f3bc\"; }\n\n.fa-yandex {\n  --fa: \"\\f413\"; }\n\n.fa-readme {\n  --fa: \"\\f4d5\"; }\n\n.fa-html5 {\n  --fa: \"\\f13b\"; }\n\n.fa-sellsy {\n  --fa: \"\\f213\"; }\n\n.fa-square-web-awesome {\n  --fa: \"\\e683\"; }\n\n.fa-sass {\n  --fa: \"\\f41e\"; }\n\n.fa-wirsindhandwerk {\n  --fa: \"\\e2d0\"; }\n\n.fa-wsh {\n  --fa: \"\\e2d0\"; }\n\n.fa-buromobelexperte {\n  --fa: \"\\f37f\"; }\n\n.fa-salesforce {\n  --fa: \"\\f83b\"; }\n\n.fa-octopus-deploy {\n  --fa: \"\\e082\"; }\n\n.fa-medapps {\n  --fa: \"\\f3c6\"; }\n\n.fa-ns8 {\n  --fa: \"\\f3d5\"; }\n\n.fa-pinterest-p {\n  --fa: \"\\f231\"; }\n\n.fa-apper {\n  --fa: \"\\f371\"; }\n\n.fa-fort-awesome {\n  --fa: \"\\f286\"; }\n\n.fa-waze {\n  --fa: \"\\f83f\"; }\n\n.fa-bluesky {\n  --fa: \"\\e671\"; }\n\n.fa-cc-jcb {\n  --fa: \"\\f24b\"; }\n\n.fa-snapchat {\n  --fa: \"\\f2ab\"; }\n\n.fa-snapchat-ghost {\n  --fa: \"\\f2ab\"; }\n\n.fa-fantasy-flight-games {\n  --fa: \"\\f6dc\"; }\n\n.fa-rust {\n  --fa: \"\\e07a\"; }\n\n.fa-wix {\n  --fa: \"\\f5cf\"; }\n\n.fa-square-behance {\n  --fa: \"\\f1b5\"; }\n\n.fa-behance-square {\n  --fa: \"\\f1b5\"; }\n\n.fa-supple {\n  --fa: \"\\f3f9\"; }\n\n.fa-webflow {\n  --fa: \"\\e65c\"; }\n\n.fa-rebel {\n  --fa: \"\\f1d0\"; }\n\n.fa-css3 {\n  --fa: \"\\f13c\"; }\n\n.fa-staylinked {\n  --fa: \"\\f3f5\"; }\n\n.fa-kaggle {\n  --fa: \"\\f5fa\"; }\n\n.fa-space-awesome {\n  --fa: \"\\e5ac\"; }\n\n.fa-deviantart {\n  --fa: \"\\f1bd\"; }\n\n.fa-cpanel {\n  --fa: \"\\f388\"; }\n\n.fa-goodreads-g {\n  --fa: \"\\f3a9\"; }\n\n.fa-square-git {\n  --fa: \"\\f1d2\"; }\n\n.fa-git-square {\n  --fa: \"\\f1d2\"; }\n\n.fa-square-tumblr {\n  --fa: \"\\f174\"; }\n\n.fa-tumblr-square {\n  --fa: \"\\f174\"; }\n\n.fa-trello {\n  --fa: \"\\f181\"; }\n\n.fa-creative-commons-nc-jp {\n  --fa: \"\\f4ea\"; }\n\n.fa-get-pocket {\n  --fa: \"\\f265\"; }\n\n.fa-perbyte {\n  --fa: \"\\e083\"; }\n\n.fa-grunt {\n  --fa: \"\\f3ad\"; }\n\n.fa-weebly {\n  --fa: \"\\f5cc\"; }\n\n.fa-connectdevelop {\n  --fa: \"\\f20e\"; }\n\n.fa-leanpub {\n  --fa: \"\\f212\"; }\n\n.fa-black-tie {\n  --fa: \"\\f27e\"; }\n\n.fa-themeco {\n  --fa: \"\\f5c6\"; }\n\n.fa-python {\n  --fa: \"\\f3e2\"; }\n\n.fa-android {\n  --fa: \"\\f17b\"; }\n\n.fa-bots {\n  --fa: \"\\e340\"; }\n\n.fa-free-code-camp {\n  --fa: \"\\f2c5\"; }\n\n.fa-hornbill {\n  --fa: \"\\f592\"; }\n\n.fa-js {\n  --fa: \"\\f3b8\"; }\n\n.fa-ideal {\n  --fa: \"\\e013\"; }\n\n.fa-git {\n  --fa: \"\\f1d3\"; }\n\n.fa-dev {\n  --fa: \"\\f6cc\"; }\n\n.fa-sketch {\n  --fa: \"\\f7c6\"; }\n\n.fa-yandex-international {\n  --fa: \"\\f414\"; }\n\n.fa-cc-amex {\n  --fa: \"\\f1f3\"; }\n\n.fa-uber {\n  --fa: \"\\f402\"; }\n\n.fa-github {\n  --fa: \"\\f09b\"; }\n\n.fa-php {\n  --fa: \"\\f457\"; }\n\n.fa-alipay {\n  --fa: \"\\f642\"; }\n\n.fa-youtube {\n  --fa: \"\\f167\"; }\n\n.fa-skyatlas {\n  --fa: \"\\f216\"; }\n\n.fa-firefox-browser {\n  --fa: \"\\e007\"; }\n\n.fa-replyd {\n  --fa: \"\\f3e6\"; }\n\n.fa-suse {\n  --fa: \"\\f7d6\"; }\n\n.fa-jenkins {\n  --fa: \"\\f3b6\"; }\n\n.fa-twitter {\n  --fa: \"\\f099\"; }\n\n.fa-rockrms {\n  --fa: \"\\f3e9\"; }\n\n.fa-pinterest {\n  --fa: \"\\f0d2\"; }\n\n.fa-buffer {\n  --fa: \"\\f837\"; }\n\n.fa-npm {\n  --fa: \"\\f3d4\"; }\n\n.fa-yammer {\n  --fa: \"\\f840\"; }\n\n.fa-btc {\n  --fa: \"\\f15a\"; }\n\n.fa-dribbble {\n  --fa: \"\\f17d\"; }\n\n.fa-stumbleupon-circle {\n  --fa: \"\\f1a3\"; }\n\n.fa-internet-explorer {\n  --fa: \"\\f26b\"; }\n\n.fa-stubber {\n  --fa: \"\\e5c7\"; }\n\n.fa-telegram {\n  --fa: \"\\f2c6\"; }\n\n.fa-telegram-plane {\n  --fa: \"\\f2c6\"; }\n\n.fa-old-republic {\n  --fa: \"\\f510\"; }\n\n.fa-odysee {\n  --fa: \"\\e5c6\"; }\n\n.fa-square-whatsapp {\n  --fa: \"\\f40c\"; }\n\n.fa-whatsapp-square {\n  --fa: \"\\f40c\"; }\n\n.fa-node-js {\n  --fa: \"\\f3d3\"; }\n\n.fa-edge-legacy {\n  --fa: \"\\e078\"; }\n\n.fa-slack {\n  --fa: \"\\f198\"; }\n\n.fa-slack-hash {\n  --fa: \"\\f198\"; }\n\n.fa-medrt {\n  --fa: \"\\f3c8\"; }\n\n.fa-usb {\n  --fa: \"\\f287\"; }\n\n.fa-tumblr {\n  --fa: \"\\f173\"; }\n\n.fa-vaadin {\n  --fa: \"\\f408\"; }\n\n.fa-quora {\n  --fa: \"\\f2c4\"; }\n\n.fa-square-x-twitter {\n  --fa: \"\\e61a\"; }\n\n.fa-reacteurope {\n  --fa: \"\\f75d\"; }\n\n.fa-medium {\n  --fa: \"\\f23a\"; }\n\n.fa-medium-m {\n  --fa: \"\\f23a\"; }\n\n.fa-amilia {\n  --fa: \"\\f36d\"; }\n\n.fa-mixcloud {\n  --fa: \"\\f289\"; }\n\n.fa-flipboard {\n  --fa: \"\\f44d\"; }\n\n.fa-viacoin {\n  --fa: \"\\f237\"; }\n\n.fa-critical-role {\n  --fa: \"\\f6c9\"; }\n\n.fa-sitrox {\n  --fa: \"\\e44a\"; }\n\n.fa-discourse {\n  --fa: \"\\f393\"; }\n\n.fa-joomla {\n  --fa: \"\\f1aa\"; }\n\n.fa-mastodon {\n  --fa: \"\\f4f6\"; }\n\n.fa-airbnb {\n  --fa: \"\\f834\"; }\n\n.fa-wolf-pack-battalion {\n  --fa: \"\\f514\"; }\n\n.fa-buy-n-large {\n  --fa: \"\\f8a6\"; }\n\n.fa-gulp {\n  --fa: \"\\f3ae\"; }\n\n.fa-creative-commons-sampling-plus {\n  --fa: \"\\f4f1\"; }\n\n.fa-strava {\n  --fa: \"\\f428\"; }\n\n.fa-ember {\n  --fa: \"\\f423\"; }\n\n.fa-canadian-maple-leaf {\n  --fa: \"\\f785\"; }\n\n.fa-teamspeak {\n  --fa: \"\\f4f9\"; }\n\n.fa-pushed {\n  --fa: \"\\f3e1\"; }\n\n.fa-wordpress-simple {\n  --fa: \"\\f411\"; }\n\n.fa-nutritionix {\n  --fa: \"\\f3d6\"; }\n\n.fa-wodu {\n  --fa: \"\\e088\"; }\n\n.fa-google-pay {\n  --fa: \"\\e079\"; }\n\n.fa-intercom {\n  --fa: \"\\f7af\"; }\n\n.fa-zhihu {\n  --fa: \"\\f63f\"; }\n\n.fa-korvue {\n  --fa: \"\\f42f\"; }\n\n.fa-pix {\n  --fa: \"\\e43a\"; }\n\n.fa-steam-symbol {\n  --fa: \"\\f3f6\"; }\n:root, :host {\n  --fa-style-family-classic: 'Font Awesome 6 Free';\n  --fa-font-regular: normal 400 1em/1 'Font Awesome 6 Free'; }\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: block;\n  src: url(\"../webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-regular-400.ttf\") format(\"truetype\"); }\n\n.far,\n.fa-regular {\n  font-weight: 400; }\n:root, :host {\n  --fa-style-family-classic: 'Font Awesome 6 Free';\n  --fa-font-solid: normal 900 1em/1 'Font Awesome 6 Free'; }\n\n@font-face {\n  font-family: 'Font Awesome 6 Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: block;\n  src: url(\"../webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../webfonts/fa-solid-900.ttf\") format(\"truetype\"); }\n\n.fas,\n.fa-solid {\n  font-weight: 900; }\n@font-face {\n  font-family: 'Font Awesome 5 Brands';\n  font-display: block;\n  font-weight: 400;\n  src: url(\"../webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-brands-400.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-display: block;\n  font-weight: 900;\n  src: url(\"../webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../webfonts/fa-solid-900.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'Font Awesome 5 Free';\n  font-display: block;\n  font-weight: 400;\n  src: url(\"../webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-regular-400.ttf\") format(\"truetype\"); }\n@font-face {\n  font-family: 'FontAwesome';\n  font-display: block;\n  src: url(\"../webfonts/fa-solid-900.woff2\") format(\"woff2\"), url(\"../webfonts/fa-solid-900.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'FontAwesome';\n  font-display: block;\n  src: url(\"../webfonts/fa-brands-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-brands-400.ttf\") format(\"truetype\"); }\n\n@font-face {\n  font-family: 'FontAwesome';\n  font-display: block;\n  src: url(\"../webfonts/fa-regular-400.woff2\") format(\"woff2\"), url(\"../webfonts/fa-regular-400.ttf\") format(\"truetype\");\n  unicode-range: U+F003,U+F006,U+F014,U+F016-F017,U+F01A-F01B,U+F01D,U+F022,U+F03E,U+F044,U+F046,U+F05C-F05D,U+F06E,U+F070,U+F087-F088,U+F08A,U+F094,U+F096-F097,U+F09D,U+F0A0,U+F0A2,U+F0A4-F0A7,U+F0C5,U+F0C7,U+F0E5-F0E6,U+F0EB,U+F0F6-F0F8,U+F10C,U+F114-F115,U+F118-F11A,U+F11C-F11D,U+F133,U+F147,U+F14E,U+F150-F152,U+F185-F186,U+F18E,U+F190-F192,U+F196,U+F1C1-F1C9,U+F1D9,U+F1DB,U+F1E3,U+F1EA,U+F1F7,U+F1F9,U+F20A,U+F247-F248,U+F24A,U+F24D,U+F255-F25B,U+F25D,U+F271-F274,U+F278,U+F27B,U+F28C,U+F28E,U+F29C,U+F2B5,U+F2B7,U+F2BA,U+F2BC,U+F2BE,U+F2C0-F2C1,U+F2C3,U+F2D0,U+F2D2,U+F2D4,U+F2DC; }\n\n@font-face {\n  font-family: 'FontAwesome';\n  font-display: block;\n  src: url(\"../webfonts/fa-v4compatibility.woff2\") format(\"woff2\"), url(\"../webfonts/fa-v4compatibility.ttf\") format(\"truetype\");\n  unicode-range: U+F041,U+F047,U+F065-F066,U+F07D-F07E,U+F080,U+F08B,U+F08E,U+F090,U+F09A,U+F0AC,U+F0AE,U+F0B2,U+F0D0,U+F0D6,U+F0E4,U+F0EC,U+F10A-F10B,U+F123,U+F13E,U+F148-F149,U+F14C,U+F156,U+F15E,U+F160-F161,U+F163,U+F175-F178,U+F195,U+F1F8,U+F219,U+F27A; }\n","@import 'font-awesome-css';\n\nhtml {\n    font-size: 14px;\n}\n\n.text-larger {\n    font-size: larger;\n}\n\n@media(min-width: 640px) {\n    .text-larger\\@s {\n        font-size: larger;\n    }\n}\n\n@media(min-width: 960px) {\n    html {\n        font-size: 0.75rem;\n    }\n\n    .text-larger\\@m {\n        font-size: larger;\n    }\n}\n\n@media(min-width: 1200px) {\n    .text-larger\\@l {\n        font-size: larger;\n    }\n}\n\n@media(min-width: 1600px) {\n    html {\n        font-size: 1.0rem;\n    }\n\n    .text-larger\\@xl {\n        font-size: larger;\n    }\n}\n","@side-menu-width-l: 250px;\n@side-menu-width-xl: 250px;\n@side-menu-width-minimized: 50px;\n\n.site-header {\n    height: 70px;\n\n    .site-header-logo {\n        img {\n            max-height: 60px;\n            padding: 0;\n            margin-left: 15px;\n        }\n\n        h1 {\n            display: inline-block;\n            margin: 0;\n            margin-left: 10px;\n            color: @cor-primaria;\n            font-size: 1.8em;\n        }\n    }\n\n    .uk-navbar-container:not(.uk-navbar-transparent) {\n        background-color: #ffffff;\n    }\n\n    .uk-navbar-nav > li > a {\n        min-height: 70px;\n    }\n\n    .icone-offcanvas {\n        margin-left: 15px;\n        margin-right: -5px;\n    }\n\n    .uk-offcanvas-bar {\n        .uk-navbar-dropdown-nav > li > a,\n        .uk-nav.uk-nav-parent-icon a {\n            color: black;\n        }\n\n        .uk-navbar-nav > li > a {\n            color: black;\n        }\n    }\n\n        .uk-offcanvas-bar .uk-nav-default .uk-nav-sub li.uk-active > a {\n            color: black;\n            background: #e1e1e1;\n        }\n\n    .site-header-usuario {\n        margin-top: 20px;\n\n        .uk-subnav > * > :first-child {\n            text-transform: none;\n        }\n\n        .uk-dropdown {\n            padding: 10px 20px;\n            min-width: 150px;\n\n            a {\n                justify-content: flex-end;\n                text-transform: none;\n            }\n        }\n    }\n\n    @media (max-width: 1199px) {\n        // The environment row and a wrapped user name must contribute to sticky height.\n        height: auto;\n\n        > nav > [uk-navbar] {\n            gap: 8px;\n        }\n\n        .uk-navbar-left {\n            flex-shrink: 0;\n        }\n\n        .site-header-usuario {\n            flex: 1 1 0;\n            min-width: 0;\n            margin-top: 0;\n            margin-right: 12px !important;\n\n            nav {\n                width: 100%;\n                min-width: 0;\n            }\n\n            .uk-subnav {\n                margin: 0;\n                gap: 8px;\n                flex-wrap: nowrap;\n                justify-content: flex-end;\n\n                > li {\n                    min-width: 0;\n                    padding-left: 0;\n                }\n\n                > li:last-child {\n                    flex: 0 1 auto;\n                }\n\n                > li > a {\n                    display: block;\n                    white-space: normal;\n                    overflow-wrap: anywhere;\n                    text-align: right;\n\n                    .uk-icon {\n                        flex-shrink: 0;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.side-menu {\n    position: fixed;\n    top: 70px;\n    z-index: 999;\n    background-color: #fff;\n    overflow-x: hidden;\n    overflow-y: auto;\n    scrollbar-width: thin;\n    padding: 15px;\n    transition: all .1s linear;\n\n    .uk-nav-default, .uk-nav-default .uk-nav-sub {\n        font-size: 14px;\n    }\n\n    .uk-nav.uk-nav-divider > :not(.uk-nav-header,.uk-nav-divider) + :not(.uk-nav-header,.uk-nav-divider) {\n        margin-top: 0;\n        padding-top: 0;\n        border-top: 1px solid #e5e5e5\n    }\n\n    .uk-nav .uk-nav-divider {\n        margin-top: 0;\n        padding-top: 0;\n    }\n\n    .uk-nav-default > li > a, .uk-nav-default .uk-nav-sub a {\n        color: black;\n        line-height: 30px;\n        padding-top: 10px;\n        padding-bottom: 10px;\n    }\n\n    .uk-nav-default .uk-nav-sub a {\n        padding-left: 10px;\n    }\n\n        .uk-nav-default > li > a:hover, .uk-nav-default .uk-nav-sub a:hover {\n            background-color: #e1e1e1;\n        }\n\n    .uk-nav-default > li.uk-active > a, .uk-nav-default .uk-nav-sub li.uk-active > a {\n        background-color: #003768;\n        color: white;\n    }\n\n    .uk-nav-default.uk-nav-divider.uk-nav {\n        margin-top: 0;\n        margin-bottom: 0;\n    }\n\n    .uk-nav .uk-nav-divider {\n        margin-bottom: 0;\n    }\n\n    .uk-nav-sub.uk-nav {\n        padding-left: 55px\n    }\n\n    .side-menu-icone {\n        line-height: 20px;\n    }\n\n    .side-menu-descricao {\n        display: block;\n        margin-left: 5px;\n        text-overflow: ellipsis;\n        line-height: 20px;\n    }\n\n    .side-menu-icone-parent {\n        display: block;\n        line-height: 20px;\n    }\n\n    .uk-nav-sub {\n        display: block;\n        padding-right: 0 !important;\n        padding-bottom: 0 !important;\n    }\n\n    li > a {\n        justify-content: left;\n    }\n\n    .side-menu-logo {\n        border-top: 1px solid #e5e5e5;\n        display: none;\n        margin-left: -15px;\n        margin-top: 5px;\n        padding: 20px;\n        text-align: center;\n\n        img {\n            display: block;\n            height: auto;\n            margin: 0 auto;\n            max-height: 180px;\n            max-width: 100%;\n            object-fit: contain;\n        }\n    }\n}\n\n.side-menu-fixed {\n\n    .side-menu {\n        .side-menu-logo {\n            display: block;\n        }\n    }\n\n    @media (min-width: 1200px) {\n        .side-menu {\n            width: @side-menu-width-l;\n\n            .side-menu-descricao {\n                max-width: 150px;\n            }\n        }\n\n        .side-menu-margin {\n            margin-left: @side-menu-width-l;\n        }\n    }\n\n    @media(min-width: 1600px) {\n        .side-menu {\n            width: @side-menu-width-xl;\n\n            .side-menu-descricao {\n                max-width: 190px;\n            }\n        }\n\n        .side-menu-margin {\n            margin-left: @side-menu-width-xl;\n        }\n    }\n}\n\n.side-menu-auto {\n\n    .side-menu {\n        width: @side-menu-width-minimized;\n        transition: all .1s linear;\n        text-align: center;\n\n        .side-menu-descricao {\n            display: none;\n        }\n\n        .side-menu-icone-parent {\n            display: none;\n        }\n\n        .uk-nav-sub {\n            display: none;\n        }\n\n        li > a {\n            justify-content: center;\n        }\n    }\n\n    .side-menu-margin {\n        margin-left: @side-menu-width-minimized;\n    }\n\n    .side-menu:hover {\n        text-align: left;\n\n        .side-menu-descricao {\n            display: block;\n        }\n\n        .side-menu-icone-parent {\n            display: block;\n        }\n\n        .uk-nav-sub {\n            display: block;\n        }\n\n        li > a {\n            justify-content: left;\n        }\n\n        .side-menu-logo {\n            display: block;\n        }\n\n        .uk-nav-sub {\n            display: block;\n        }\n    }\n\n    @media (min-width: 1200px) {\n        .side-menu:hover {\n            width: @side-menu-width-l;\n\n            .side-menu-descricao {\n                max-width: 150px;\n            }\n        }\n    }\n\n    @media(min-width: 1600px) {\n        .side-menu:hover {\n            width: @side-menu-width-xl;\n\n            .side-menu-descricao {\n                max-width: 190px;\n            }\n        }\n    }\n}\n\n@media (max-width: 1199px) {\n    .side-menu-margin {\n        margin-left: 0 !important;\n    }\n}\n","@media (max-width: 960px) {\n    .height-auto {\n        height: auto;\n    }\n}\n","@media (min-width: 640px) {\n    .margin-small-left\\@s {\n        margin-left: 10px !important;\n    }\n    .margin-remove-top\\@s {\n        margin-top: 0 !important;\n    }\n    .margin-remove\\@s {\n        margin: 0 !important;\n    }\n}\n\n@media (min-width: 960px) {\n    .margin-remove-top\\@m {\n        margin-top: 0 !important;\n    }\n    .margin-remove\\@m {\n        margin: 0 !important;\n    }\n}\n\n@media (min-width: 1200px) {\n    .margin-remove-top\\@l {\n        margin-top: 0 !important;\n    }\n    .margin-remove\\@l {\n        margin: 0 !important;\n    }\n}\n\n@media (min-width: 1600px) {\n    .margin-remove-top\\@xl {\n        margin-top: 0 !important;\n    }\n    .margin-remove\\@xl {\n        margin: 0 !important;\n    }\n}\n",".base-padding(@padding) {\n    padding: @padding;\n}\n\n@none: 0 0 0 0;\n@nano: 5px 5px 5px 5px;\n@nano-top: 5px 0 0 0;\n@nano-right: 0 5px 0 0;\n@nano-bottom: 0 0 5px 0;\n@nano-left: 0 0 0 5px;\n@nano-vertical: 5px 0;\n@nano-horizontal: 0 5px;\n\n@micro: 10px 10px 10px 10px;\n@micro-top: 10px 0 0 0;\n@micro-right: 0 10px 0 0;\n@micro-bottom: 0 0 10px 0;\n@micro-left: 0 0 0 10px;\n@micro-vertical: 10px 0;\n@micro-horizontal: 0 10px;\n\n@small: 15px 15px 15px 15px;\n@small-top: 15px 0 0 0;\n@small-right: 0 15px 0 0;\n@small-bottom: 0 0 15px 0;\n@small-left: 0 0 0 15px;\n@small-vertical: 15px 0;\n@small-horizontal: 0 15px;\n\n@medium: 30px 30px 30px 30px;\n@medium-top: 30px 0 0 0;\n@medium-right: 0 30px 0 0;\n@medium-bottom: 0 0 30px 0;\n@medium-left: 0 0 0 30px;\n@medium-vertical: 30px 0;\n@medium-horizontal: 0 30px;\n\n@large: 50px 50px 50px 50px;\n@large-top: 50px 0 0 0;\n@large-right: 0 50px 0 0;\n@large-bottom: 0 0 50px 0;\n@large-left: 0 0 0 50px;\n@large-vertical: 50px 0;\n@large-horizontal: 0 50px;\n\n//padding-nano\n.padding-remove { .base-padding(@none); }\n.padding-remove-top { padding-top: 0; }\n.padding-nano { .base-padding(@nano); }\n.padding-nano-top { .base-padding(@nano-top); }\n.padding-nano-right { .base-padding(@nano-right); }\n.padding-nano-bottom { .base-padding(@nano-bottom); }\n.padding-nano-left { .base-padding(@nano-left); }\n.padding-nano-vertical { .base-padding(@nano-vertical); }\n.padding-nano-horizontal { .base-padding(@nano-horizontal); }\n\n.padding-micro { .base-padding(@micro); }\n.padding-micro-top { .base-padding(@micro-top); }\n.padding-micro-right { .base-padding(@micro-right); }\n.padding-micro-bottom { .base-padding(@micro-bottom); }\n.padding-micro-left { .base-padding(@micro-left); }\n.padding-micro-vertical { .base-padding(@micro-vertical); }\n.padding-micro-horizontal { .base-padding(@micro-horizontal); }\n\n.padding-small { .base-padding(@small); }\n.padding-small-top { .base-padding(@small-top); }\n.padding-small-right { .base-padding(@small-right); }\n.padding-small-bottom { .base-padding(@small-bottom); }\n.padding-small-left { .base-padding(@small-left); }\n.padding-small-vertical { .base-padding(@small-vertical); }\n.padding-small-horizontal { .base-padding(@small-horizontal); }\n\n.padding-medium { .base-padding(@medium); }\n.padding-medium-top { .base-padding(@medium-top); }\n.padding-medium-right { .base-padding(@medium-right); }\n.padding-medium-bottom { .base-padding(@medium-bottom); }\n.padding-medium-left { .base-padding(@medium-left); }\n.padding-medium-vertical { .base-padding(@medium-vertical); }\n.padding-medium-horizontal { .base-padding(@medium-horizontal); }\n\n.padding-large { .base-padding(@large); }\n.padding-large-top { .base-padding(@large-top); }\n.padding-large-right { .base-padding(@large-right); }\n.padding-large-bottom { .base-padding(@large-bottom); }\n.padding-large-left { .base-padding(@large-left); }\n.padding-large-vertical { .base-padding(@large-vertical); }\n.padding-large-horizontal { .base-padding(@large-horizontal); }\n\n.padding-letter-top {\n    padding-top: 21px;\n}\n\n@media(min-width: 435px) {\n    .padding-remove\\@xs { .base-padding(@none); }\n    .padding-nano\\@xs { .base-padding(@nano); }\n    .padding-nano-top\\@xs { .base-padding(@nano-top); }\n    .padding-nano-right\\@xs { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@xs { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@xs { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@xs { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@xs { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@xs { .base-padding(@micro); }\n    .padding-micro-top\\@xs { .base-padding(@micro-top); }\n    .padding-micro-right\\@xs { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@xs { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@xs { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@xs { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@xs { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@xs { .base-padding(@small); }\n    .padding-small-top\\@xs { .base-padding(@small-top); }\n    .padding-small-right\\@xs { .base-padding(@small-right); }\n    .padding-small-bottom\\@xs { .base-padding(@small-bottom); }\n    .padding-small-left\\@xs { .base-padding(@small-left); }\n    .padding-small-vertical\\@xs { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@xs { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@xs { .base-padding(@medium); }\n    .padding-medium-top\\@xs { .base-padding(@medium-top); }\n    .padding-medium-right\\@xs { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@xs { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@xs { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@xs { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@xs { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@xs { .base-padding(@large); }\n    .padding-large-top\\@xs { .base-padding(@large-top); }\n    .padding-large-right\\@xs { .base-padding(@large-right); }\n    .padding-large-bottom\\@xs { .base-padding(@large-bottom); }\n    .padding-large-left\\@xs { .base-padding(@large-left); }\n    .padding-large-vertical\\@xs { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@xs { .base-padding(@large-horizontal); }\n}\n\n@media(min-width: 640px) {\n    .padding-remove\\@s { .base-padding(@none); }\n    .padding-nano\\@s { .base-padding(@nano); }\n    .padding-nano-top\\@s { .base-padding(@nano-top); }\n    .padding-nano-right\\@s { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@s { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@s { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@s { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@s { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@s { .base-padding(@micro); }\n    .padding-micro-top\\@s { .base-padding(@micro-top); }\n    .padding-micro-right\\@s { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@s { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@s { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@s { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@s { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@s { .base-padding(@small); }\n    .padding-small-top\\@s { .base-padding(@small-top); }\n    .padding-small-right\\@s { .base-padding(@small-right); }\n    .padding-small-bottom\\@s { .base-padding(@small-bottom); }\n    .padding-small-left\\@s { .base-padding(@small-left); }\n    .padding-small-vertical\\@s { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@s { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@s { .base-padding(@medium); }\n    .padding-medium-top\\@s { .base-padding(@medium-top); }\n    .padding-medium-right\\@s { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@s { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@s { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@s { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@s { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@s { .base-padding(@large); }\n    .padding-large-top\\@s { .base-padding(@large-top); }\n    .padding-large-right\\@s { .base-padding(@large-right); }\n    .padding-large-bottom\\@s { .base-padding(@large-bottom); }\n    .padding-large-left\\@s { .base-padding(@large-left); }\n    .padding-large-vertical\\@s { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@s { .base-padding(@large-horizontal); }\n}\n\n@media(min-width: 960px) {\n    .padding-remove\\@m { .base-padding(@none); }\n    .padding-nano\\@m { .base-padding(@nano); }\n    .padding-nano-top\\@m { .base-padding(@nano-top); }\n    .padding-nano-right\\@m { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@m { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@m { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@m { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@m { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@m { .base-padding(@micro); }\n    .padding-micro-top\\@m { .base-padding(@micro-top); }\n    .padding-micro-right\\@m { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@m { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@m { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@m { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@m { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@m { .base-padding(@small); }\n    .padding-small-top\\@m { .base-padding(@small-top); }\n    .padding-small-right\\@m { .base-padding(@small-right); }\n    .padding-small-bottom\\@m { .base-padding(@small-bottom); }\n    .padding-small-left\\@m { .base-padding(@small-left); }\n    .padding-small-vertical\\@m { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@m { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@m { .base-padding(@medium); }\n    .padding-medium-top\\@m { .base-padding(@medium-top); }\n    .padding-medium-right\\@m { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@m { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@m { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@m { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@m { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@m { .base-padding(@large); }\n    .padding-large-top\\@m { .base-padding(@large-top); }\n    .padding-large-right\\@m { .base-padding(@large-right); }\n    .padding-large-bottom\\@m { .base-padding(@large-bottom); }\n    .padding-large-left\\@m { .base-padding(@large-left); }\n    .padding-large-vertical\\@m { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@m { .base-padding(@large-horizontal); }\n\n    .padding-letter-top {\n        padding-top: 18px;\n    }\n}\n\n@media(min-width: 1200px) {\n    .padding-remove\\@l { .base-padding(@none); }\n    .padding-nano\\@l { .base-padding(@nano); }\n    .padding-nano-top\\@l { .base-padding(@nano-top); }\n    .padding-nano-right\\@l { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@l { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@l { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@l { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@l { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@l { .base-padding(@micro); }\n    .padding-micro-top\\@l { .base-padding(@micro-top); }\n    .padding-micro-right\\@l { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@l { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@l { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@l { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@l { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@l { .base-padding(@small); }\n    .padding-small-top\\@l { .base-padding(@small-top); }\n    .padding-small-right\\@l { .base-padding(@small-right); }\n    .padding-small-bottom\\@l { .base-padding(@small-bottom); }\n    .padding-small-left\\@l { .base-padding(@small-left); }\n    .padding-small-vertical\\@l { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@l { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@l { .base-padding(@medium); }\n    .padding-medium-top\\@l { .base-padding(@medium-top); }\n    .padding-medium-right\\@l { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@l { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@l { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@l { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@l { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@l { .base-padding(@large); }\n    .padding-large-top\\@l { .base-padding(@large-top); }\n    .padding-large-right\\@l { .base-padding(@large-right); }\n    .padding-large-bottom\\@l { .base-padding(@large-bottom); }\n    .padding-large-left\\@l { .base-padding(@large-left); }\n    .padding-large-vertical\\@l { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@l { .base-padding(@large-horizontal); }\n}\n\n@media(min-width: 1600px) {\n    .padding-remove\\@xl { .base-padding(@none); }\n    .padding-nano\\@xl { .base-padding(@nano); }\n    .padding-nano-top\\@xl { .base-padding(@nano-top); }\n    .padding-nano-right\\@xl { .base-padding(@nano-right); }\n    .padding-nano-bottom\\@xl { .base-padding(@nano-bottom); }\n    .padding-nano-left\\@xl { .base-padding(@nano-left); }\n    .padding-nano-vertical\\@xl { .base-padding(@nano-vertical); }\n    .padding-nano-horizontal\\@xl { .base-padding(@nano-horizontal); }\n\n    .padding-micro\\@xl { .base-padding(@micro); }\n    .padding-micro-top\\@xl { .base-padding(@micro-top); }\n    .padding-micro-right\\@xl { .base-padding(@micro-right); }\n    .padding-micro-bottom\\@xl { .base-padding(@micro-bottom); }\n    .padding-micro-left\\@xl { .base-padding(@micro-left); }\n    .padding-micro-vertical\\@xl { .base-padding(@micro-vertical); }\n    .padding-micro-horizontal\\@xl { .base-padding(@micro-horizontal); }\n\n    .padding-small\\@xl { .base-padding(@small); }\n    .padding-small-top\\@xl { .base-padding(@small-top); }\n    .padding-small-right\\@xl { .base-padding(@small-right); }\n    .padding-small-bottom\\@xl { .base-padding(@small-bottom); }\n    .padding-small-left\\@xl { .base-padding(@small-left); }\n    .padding-small-vertical\\@xl { .base-padding(@small-vertical); }\n    .padding-small-horizontal\\@xl { .base-padding(@small-horizontal); }\n\n    .padding-medium\\@xl { .base-padding(@medium); }\n    .padding-medium-top\\@xl { .base-padding(@medium-top); }\n    .padding-medium-right\\@xl { .base-padding(@medium-right); }\n    .padding-medium-bottom\\@xl { .base-padding(@medium-bottom); }\n    .padding-medium-left\\@xl { .base-padding(@medium-left); }\n    .padding-medium-vertical\\@xl { .base-padding(@medium-vertical); }\n    .padding-medium-horizontal\\@xl { .base-padding(@medium-horizontal); }\n\n    .padding-large\\@xl { .base-padding(@large); }\n    .padding-large-top\\@xl { .base-padding(@large-top); }\n    .padding-large-right\\@xl { .base-padding(@large-right); }\n    .padding-large-bottom\\@xl { .base-padding(@large-bottom); }\n    .padding-large-left\\@xl { .base-padding(@large-left); }\n    .padding-large-vertical\\@xl { .base-padding(@large-vertical); }\n    .padding-large-horizontal\\@xl { .base-padding(@large-horizontal); }\n\n    .padding-letter-top {\n        padding-top: 24px;\n    }\n}\n",".switch-mixin(@width, @height, @background-color: #ccc, @checked-color: #10be2d) {\n    width: @width;\n    height: @height;\n    position: relative;\n    display: inline-block;\n    border-radius: calc(@height / 2);\n\n    input {\n        opacity: 0;\n        width: 0;\n        height: 0;\n    }\n\n    .slider {\n        position: absolute;\n        cursor: pointer;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        background-color: @background-color;\n        transition: .4s;\n        border-radius: calc(@height / 2);\n\n        &:before {\n            position: absolute;\n            content: \"\";\n            height: calc(@height - 8px);\n            width: calc(@height - 8px);\n            left: 4px;\n            bottom: 4px;\n            background-color: white;\n            transition: .4s;\n            border-radius: 50%;\n        }\n    }\n\n    input:checked+.slider {\n        background-color: @checked-color;\n    }\n\n    input:focus+.slider {\n        box-shadow: 0 0 1px @checked-color;\n    }\n\n    input:checked+.slider:before {\n        transform: translateX(@width - @height);\n    }\n}\n\n.switch-micro {\n    .switch-mixin(30px, 15px);\n}\n\n.switch-small {\n    .switch-mixin(40px, 20px);\n}\n\n.switch-medium {\n    .switch-mixin(60px, 34px);\n}\n\n.switch-large {\n    .switch-mixin(80px, 44px);\n}\n",".width-small-medium { width: 200; }\n.width-micro { width: 100px; }\n.width-nano { width: 50px; }\n\n@media(min-width: 960px) {\n    .width-large\\@m { width: 338px; }\n    .width-medium\\@m { width: 225px; }\n    .width-small-medium\\@m { width: 150px; }\n    .width-small\\@m { width: 112px; }\n    .width-micro\\@m { width: 75px; }\n    .width-nano\\@m { width: 38px; }\n}\n\n@media(min-width: 1600px) {\n    .width-large\\@m { width: 450px; }\n    .width-medium\\@m { width: 300px; }\n    .width-small-medium\\@m {width: 200px; }\n    .width-small\\@m { width: 150px; }\n    .width-micro\\@m { width: 100px; }\n    .width-nano\\@m { width: 50px; }\n}\n\n// width fixos\n.base-width(@width) {\n    width: @width;\n}\n\n.width-25 { .base-width(25px); }\n.width-50 { .base-width(50px); }\n.width-75 { .base-width(75px); }\n.width-100 { .base-width(100px); }\n.width-125 { .base-width(125px); }\n.width-150 { .base-width(150px); }\n.width-175 { .base-width(175px); }\n.width-185 { .base-width(185px); }\n.width-200 { .base-width(200px); }\n.width-250 { .base-width(250px); }\n.width-275 { .base-width(275px); }\n.width-300 { .base-width(300px); }\n.width-350 { .base-width(350px); }\n.width-400 { .base-width(400px); }\n\n@media (min-width: 640px) {\n    .width-25\\@s { .base-width(25px); }\n    .width-50\\@s { .base-width(50px); }\n    .width-75\\@s { .base-width(75px); }\n    .width-100\\@s { .base-width(100px); }\n    .width-125\\@s { .base-width(125px); }\n    .width-150\\@s { .base-width(150px); }\n    .width-175\\@s { .base-width(175px); }\n    .width-200\\@s { .base-width(200px); }\n    .width-250\\@s { .base-width(250px); }\n    .width-275\\@s { .base-width(275px); }\n    .width-300\\@s { .base-width(300px); }\n    .width-350\\@s { .base-width(350px); }\n    .width-400\\@s { .base-width(400px); }\n}\n\n@media (min-width: 640px) {\n    .width-25\\@s { .base-width(25px); }\n    .width-50\\@s { .base-width(50px); }\n    .width-75\\@s { .base-width(75px); }\n    .width-100\\@s { .base-width(100px); }\n    .width-125\\@s { .base-width(125px); }\n    .width-150\\@s { .base-width(150px); }\n    .width-175\\@s { .base-width(175px); }\n    .width-185\\@s { .base-width(185px); }\n    .width-200\\@s { .base-width(200px); }\n    .width-250\\@s { .base-width(250px); }\n    .width-300\\@s { .base-width(300px); }\n}\n\n@media (min-width: 960px) {\n    .width-25\\@m { .base-width(25px); }\n    .width-50\\@m { .base-width(50px); }\n    .width-75\\@m { .base-width(75px); }\n    .width-100\\@m { .base-width(100px); }\n    .width-125\\@m { .base-width(125px); }\n    .width-150\\@m { .base-width(150px); }\n    .width-175\\@m { .base-width(175px); }\n    .width-185\\@m { .base-width(185px); }\n    .width-200\\@m { .base-width(200px); }\n    .width-250\\@m { .base-width(250px); }\n    .width-275\\@m { .base-width(275px); }\n    .width-300\\@m { .base-width(300px); }\n    .width-350\\@m { .base-width(350px); }\n    .width-400\\@m { .base-width(400px); }\n}\n\n@media (min-width: 1200px) {\n    .width-25\\@l { .base-width(25px); }\n    .width-50\\@l { .base-width(50px); }\n    .width-75\\@l { .base-width(75px); }\n    .width-100\\@l { .base-width(100px); }\n    .width-110\\@l { .base-width(110px); }\n    .width-125\\@l { .base-width(125px); }\n    .width-150\\@l { .base-width(150px); }\n    .width-175\\@l { .base-width(175px); }\n    .width-185\\@l { .base-width(185px); }\n    .width-200\\@l { .base-width(200px); }\n    .width-250\\@l { .base-width(250px); }\n    .width-275\\@l { .base-width(275px); }\n    .width-300\\@l { .base-width(300px); }\n    .width-350\\@l { .base-width(350px); }\n    .width-400\\@l { .base-width(400px); }\n}\n\n@media (min-width: 1600px) {\n    .width-25\\@xl { .base-width(25px); }\n    .width-50\\@xl { .base-width(50px); }\n    .width-75\\@xl { .base-width(75px); }\n    .width-100\\@xl { .base-width(100px); }\n    .width-125\\@xl { .base-width(125px); }\n    .width-150\\@xl { .base-width(150px); }\n    .width-175\\@xl { .base-width(175px); }\n    .width-185\\@xl { .base-width(185px); }\n    .width-200\\@xl { .base-width(200px); }\n    .width-250\\@xl { .base-width(250px); }\n    .width-275\\@xl { .base-width(275px); }\n    .width-300\\@xl { .base-width(300px); }\n    .width-350\\@xl { .base-width(350px); }\n    .width-400\\@xl { .base-width(400px); }\n}\n\n//grid\n.generate-grid-classes(@columns, @suffix) when (@suffix =null) {\n    .loop-grid-classes(@index) when (@index > 0) {\n        .width-@{index}-@{columns} {\n            width: percentage((@index / @columns));\n        }\n\n        .loop-grid-classes(@index - 1);\n    }\n\n    .loop-grid-classes(@columns);\n}\n\n.generate-grid-classes(@columns, @suffix) when not (@suffix =null) {\n    .loop-grid-classes(@index) when (@index > 0) {\n        .width-@{index}-@{columns}@{suffix} {\n            width: percentage((@index / @columns));\n        }\n\n        .loop-grid-classes(@index - 1);\n    }\n\n    .loop-grid-classes(@columns);\n}\n\n.generate-grid-classes(12, null);\n@media (min-width: 640px) { .generate-grid-classes(12, \\@s); }\n@media (min-width: 960px) { .generate-grid-classes(12, \\@m); }\n@media (min-width: 1200px) { .generate-grid-classes(12, \\@l); }\n@media (min-width: 1600px) { .generate-grid-classes(12, \\@xl); }\n\n.generate-grid-classes(20, null);\n@media (min-width: 640px) { .generate-grid-classes(20, \\@s); }\n@media (min-width: 960px) { .generate-grid-classes(20, \\@m); }\n@media (min-width: 1200px) { .generate-grid-classes(20, \\@l); }\n@media (min-width: 1600px) { .generate-grid-classes(20, \\@xl); }\n",".botao-excel {\n    background-color: #007F00 !important;\n    white-space: nowrap;\n    color: white !important;\n\n    &:hover {\n        background-color: #33a033 !important;\n    }\n\n    .icone-excel {\n        display: inline-block;\n        width: 17px !important;\n        height: 17px !important;\n        background-size: cover;\n        background-repeat: no-repeat;\n        background-position: center;\n        background-image: url(./images/excel-branco.svg) !important;\n        margin-right: 5px;\n        float: left;\n    }\n}\n\n.botao-pdf {\n    background-color: #B30B00 !important;\n    white-space: nowrap;\n    color: white !important;\n\n    &:hover {\n        background-color: #c7160a !important;\n    }\n\n    .icone-pdf {\n        font-size: 0.9em;\n        margin-right: 2px;\n    }\n}\n",".ghost {\n    opacity: 0.4;\n    background-color: #f0f0f0;\n    border: 1px dashed #ccc;\n}\n\n.dragging {\n    opacity: 0;\n}\n",".button-ia {\n    padding: 4px 6px !important;\n    margin: 0 5px 2px 5px;\n    font-size: 0.75rem !important;\n    line-height: 1 !important;\n    min-height: auto !important;\n    border-radius: 3px !important;\n    background-color: #222 !important;\n    color: white;\n    border: 1px solid transparent;\n    opacity: 0.5;\n\n    &:hover {\n        opacity: 1;\n    }\n}\n","// Estilo global para botões de IA (aprimorar texto)\n// Mantém formato quadrado e tamanho compacto para caber nos inputs\n\n.button-ia {\n    padding: 4px 6px !important;\n    margin: 0 5px 2px 5px;\n    font-size: 0.75rem !important;\n    line-height: 1 !important;\n    min-height: auto !important;\n    border-radius: 3px !important;\n    background-color: #222 !important;\n    color: white;\n    border: 1px solid transparent;\n    opacity: 0.5;\n}\n",".options-menu {\n    max-width: 125px !important;\n    min-width: 125px !important;\n    width: 125px !important;\n}","@import 'font.less';\n@import 'header.less';\n@import 'height.less';\n@import 'margin.less';\n@import 'padding.less';\n@import 'switch.less';\n@import 'width.less';\n@import 'icones.less';\n@import \"drag-drop.less\";\n@import \"buttons.less\";\n@import \"button-ia.less\";\n@import \"options-menu.less\";\n\n@cor-primaria: #003768;\n@cor-primaria-hover: #003768;\n@cor-secundaria: rgb(238, 216, 52);\n@cor-secundaria-hover: rgb(209, 179, 5);\n@cor-cinza: rgb(180, 180, 180);\n@cor-cinza-hover: rgb(150, 150, 150);\n@cor-laranja: #ff9d53;\n@cor-laranja-hover: #d88647;\n\nhtml {\n    color: black;\n}\n\nbody {\n    background-color: #F2F2F2;\n}\n\n.uk-form-controls.error > .uk-icon {\n    padding-bottom: 18px;\n}\n\n.banner-ambiente {\n    position: fixed;\n    top: 0;\n    background-color: @cor-primaria;\n    color: white;\n    padding: 5px 10px;\n    font-weight: bold;\n    font-size: 12px;\n    width: 25%;\n    border-radius: 0 0 25px 25px;\n\n    & .uk-icon {\n        color: white;\n    }\n\n    @media (max-width: 1199px) {\n        // Keep the environment visible in its own row above the mobile navbar.\n        position: static;\n        box-sizing: border-box;\n        border-radius: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 100%;\n    }\n}\n\n.info-container {\n    &.uk-navbar-right {\n        gap: 0;\n    }\n\n    .info-data-text {\n        font-weight: bold;\n    }\n}\n\n.uk-button-primary {\n    background-color: @cor-primaria;\n\n    &:hover,\n    &:active {\n        background-color: @cor-primaria-hover;\n    }\n}\n\n.uk-button-secundary {\n    color: white;\n    background-color: @cor-cinza;\n\n    &:hover,\n    &:active {\n        background-color: @cor-cinza-hover;\n    }\n}\n\n.chart-button {\n    background-color: @cor-laranja;\n\n    &:hover,\n    &:active {\n        background-color: @cor-laranja-hover;\n    }\n}\n\n.uk-offcanvas-bar {\n    & .uk-nav {\n        z-index: 2;\n    }\n}\n\n.uk-heading-divider {\n    border-bottom: 1.5px solid @cor-primaria;\n}\n\n.border-vertical {\n    border-bottom: 1px solid #e5e5e5;\n    border-top: 1px solid #e5e5e5;\n}\n\n.esfera-alerta {\n    width: 10px;\n    height: 10px;\n    background-color: #ff0066;\n    border-radius: 50%;\n    display: inline-block;\n}\n\n.border-bottom {\n    border-bottom: 1px solid #e5e5e5;\n}\n\n.label-muted {\n    background-color: #f8f8f8;\n    color: #666;\n}\n\n.scroll-up {\n    position: fixed;\n    bottom: 5%;\n    right: 5%;\n    z-index: 9999;\n}\n\n.uk-tab>li>a {\n    padding-bottom: 13px;\n}\n\n.uk-subnav-pill>.uk-active>a {\n    background-color: @cor-primaria-hover;\n    color: #fff;\n    font-weight: bolder;\n}\n\n.uk-subnav-pill>*>:first-child {\n    padding: 5px 10px;\n    background: 0 0;\n    color: #666;\n    border-color: #b2b2b2;\n}\n\n.uk-button-height {\n    line-height: 25px;\n    border-color: #b2b2b2;\n    color: #666;\n\n    &:hover {\n        background-color: #f8f8f8;\n        color: #666;\n    }\n}\n\n.label-neutral {\n    background-color: #b2b2b2;\n    color: #fff;\n}\n\n.ui-datepicker {\n    z-index: 1000 !important;\n}\n\n.uk-tab>.uk-active>a {\n    border-color: @cor-primaria;\n}\n\n.botao-danger {\n    background-color: transparent !important;\n    color: #f0506e !important;\n    border: 1px solid #f0506e !important;\n}\n\n@media(max-width: 400px) {\n    .response-button-inputs>div {\n        width: 100%;\n        padding-bottom: 3px;\n    }\n\n    .response-button-inputs>div>* {\n        width: 100%;\n    }\n\n    .text-nowrap\\@s {\n        white-space: normal !important;\n    }\n}\n\n@media(min-width: 640px) {\n    .padding-small-right\\@s {\n        padding-right: 15px;\n    }\n}\n\n@media(max-width: 680px) {\n    .uk-container {\n        padding: 0 !important;\n    }\n\n    .response-button-inputs>div {\n        padding-bottom: 3px;\n    }\n}\n\n@media(min-width: 960px) {\n    .padding-small-left\\@m {\n        padding-left: 30px;\n    }\n}\n\n@media(min-width: 1200px) {\n    .uk-text-normal\\@l {\n        font-weight: 400;\n    }\n\n    .padding-large-left\\@l {\n        padding-left: 50px;\n    }\n\n    .padding-large-right\\@l {\n        padding-right: 50px;\n    }\n}\n\n@keyframes spin {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n.spin {\n    animation: spin 1s linear infinite;\n}\n\na[disabled] {\n    pointer-events: none;\n    cursor: default;\n    color: #999;\n}\n\n.uk-modal-title{\n    font-size:22px;\n}\n\nselect[readonly] {\n    background: #f8f8f8;\n    pointer-events: none;\n    touch-action: none;\n}\n\ninput[readonly] {\n    background: #f8f8f8;\n}\n\n.uk-form-label,\n.uk-description-list > dt {\n    font-weight: 700;\n    color: #003768;\n}\n\n.uk-table th {\n    font-weight: 700;\n    color: #003768;\n    text-transform: none;\n}\n\n.uk-card-title,\n.uk-card-default,\n.uk-tab > .uk-active > a,\n.uk-subnav > * > :first-child,\n.uk-input, .uk-select, .uk-textarea,\n.uk-select:not([multiple]):not([size]) option,\n.uk-input:disabled, .uk-select:disabled, .uk-textarea:disabled,\n.uk-input:focus, .uk-select:focus, .uk-textarea:focus {\n    color: black;\n}\n\n.uk-tab > * > a {\n    color: #303030;\n}\n\n.uk-description-list > dt {\n    color: #003768;\n    font-size: 1rem;\n    font-weight: 500;\n    text-transform: none;\n    margin-bottom: 4px;\n}\n\n.uk-description-list > dd {\n    color: black;\n    background-color: #fbfbfb;\n    border: 1px solid #e5e5e5;\n    padding: 10px;\n}\n\n.uk-dropdown-nav > li > a {\n    color: black;\n}\n\n.uk-dropdown-nav > li:hover > a {\n    //font-weight: 700;\n    color: #003768;\n}\n\n.uk-notification {\n    z-index: 99999;\n}\n\n.uk-form-label,\n.uk-description-list > dt {\n    font-weight: 700;\n    color: #003768;\n}\n\n.uk-table th {\n    font-weight: 700;\n    color: #003768;\n    text-transform: none;\n}\n\n.uk-card-title,\n.uk-card-default,\n.uk-tab > .uk-active > a,\n.uk-subnav > * > :first-child,\n.uk-input, .uk-select, .uk-textarea,\n.uk-select:not([multiple]):not([size]) option,\n.uk-input:disabled, .uk-select:disabled, .uk-textarea:disabled,\n.uk-input:focus, .uk-select:focus, .uk-textarea:focus {\n    color: black;\n}\n\n.uk-tab > * > a {\n    color: #303030;\n}\n\n.uk-description-list > dt {\n    color: #003768;\n    font-size: 1rem;\n    font-weight: 500;\n    text-transform: none;\n    margin-bottom: 4px;\n}\n\n.uk-description-list > dd {\n    color: black;\n    background-color: #fbfbfb;\n    border: 1px solid #e5e5e5;\n    padding: 10px;\n}\n\n.uk-dropdown-nav > li > a {\n    color: black;\n}\n\n.uk-dropdown-nav > li:hover > a {\n    //font-weight: 700;\n    color: #003768;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
